/**
 * A function to create a log object for the 'applyToDiscovery' event (evid: 101)
 *
 * Event description: when restaurant applied to discovery mode
 *
 * @param {applyToDiscoveryParams} params - The parameters for this event
 * @property {string} moderationStatus - IN_MODERATION/APPROVED/REJECTED,
 * @property {string} discoveryStatus - discovery_status
 * @property {string} discoverySuspended - NO/AUTO/MODERATOR
 * @return {LogObject<applyToDiscoveryParams>} LogObject<applyToDiscoveryParams>
 */
export function applyToDiscovery(params) {
    return { evid: 101, src: 132, endpoint: '', params };
}
/**
 * A function to create a log object for the 'yourRestaurantsJoinWithInviteCode' event (evid: 223)
 *
 * Event description: when the user clicks on 'join with invite code' in your restaurants section
 *
 * @param {yourRestaurantsJoinWithInviteCodeParams} params - The parameters for this event
 * @property {string} screen_name - screen name
 * @return {LogObject<yourRestaurantsJoinWithInviteCodeParams>} LogObject<yourRestaurantsJoinWithInviteCodeParams>
 */
export function yourRestaurantsJoinWithInviteCode(params) {
    return { evid: 223, src: 132, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSaveItem' event (evid: 1)
 *
 * Event description: User clicked on save item, and got a response from the server if it was saved successfuly or not
 *
 * @param {menusSaveItemParams} params - The parameters for this event
 * @property {boolean} inStock - Is the item in stock
 * @property {string} name - name
 * @property {string} priceString - The price in string format. When the price is null it mean this item has Price Variations!
 * @property {number} numOfPriceVariations - The number of price variations
 * @property {string} maxPriceVariationString - The maximum price variation
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} description - the description the user inputed
 * @property {string} imagesUrls - an array of image urls URLs . The first image url represents the main image URL
 * @property {boolean} isOrdersAvailable - Is orders attributes available for this site while the item is being saved
 * @property {string} taxGroupId - the tax group id of the item
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {string} minPriceVariationString - The minimum price variation
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {boolean} allowSpecialRequestes - Is the item allowing speciel requests
 * @property {GUID} itemId - Item ID. Unique id in a site level
 * @property {boolean} isVisible - True if the item is shown. False if the item is hidden
 * @property {string} currency - currency type
 * @property {string} customLabels - an array of label ids that are attached to this item
 * @property {string} pageName - page_name
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {string} priceVariations - The json array containing all the modifiers ids + their price in this item. Notice that the order of variants matter
 * @property {string} modifierGroups - array of modifier group ids
 * @return {LogObject<menusSaveItemParams>} LogObject<menusSaveItemParams>
 */
export function menusSaveItem(params) {
    return { evid: 1, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsUouPageStartedLoading' event (evid: 10)
 *
 * Event description: Widget of a restaurants' app started loading (live site/ site builder)
 *
 * @param {restaurantsUouPageStartedLoadingParams} params - The parameters for this event
 * @property {string} widgetId - The ID of the widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - The name of the widget, for example menus
 * @property {string} pageName - name of the page
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} hosting - was the page loaded from editor window, inside the BM, Editor x etc...
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsUouPageStartedLoadingParams>} LogObject<restaurantsUouPageStartedLoadingParams>
 */
export function restaurantsUouPageStartedLoading(params) {
    return { evid: 10, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forTestingPurposesAutoButtonClickBiEventSrc159Evid1000' event (evid: 1000)
 *
 * Event description: A generic BI event for button clicks as part of auto BI project
 *
 * @param {forTestingPurposesAutoButtonClickBiEventSrc159Evid1000Params} params - The parameters for this event
 * @property {string} pageName - the page the button is in
 * @property {string} buttonName - the name of the button (given by the dev)
 * @return {LogObject<forTestingPurposesAutoButtonClickBiEventSrc159Evid1000Params>} LogObject<forTestingPurposesAutoButtonClickBiEventSrc159Evid1000Params>
 */
export function forTestingPurposesAutoButtonClickBiEventSrc159Evid1000(params) {
    return { evid: 1000, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forTestingGenericClickEventSrc159Evid10000' event (evid: 10000)
 *
 * Event description: For phase 2 of platformized BI effort
 *
 * @param {forTestingGenericClickEventSrc159Evid10000Params} params - The parameters for this event
 * @property {string} path - data attribute
 * @property {string} componentType - widget/modal/etc
 * @return {LogObject<forTestingGenericClickEventSrc159Evid10000Params>} LogObject<forTestingGenericClickEventSrc159Evid10000Params>
 */
export function forTestingGenericClickEventSrc159Evid10000(params) {
    return { evid: 10000, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forTestingGenericLoadEventSrc159Evid10001' event (evid: 10001)
 *
 * Event description: For phase 2 of platformized BI effort
 *
 * @param {forTestingGenericLoadEventSrc159Evid10001Params} params - The parameters for this event
 * @property {string} path - data attribute
 * @property {string} componentType - widget/modal/etc
 * @property {string} origin - origin of load
 * @return {LogObject<forTestingGenericLoadEventSrc159Evid10001Params>} LogObject<forTestingGenericLoadEventSrc159Evid10001Params>
 */
export function forTestingGenericLoadEventSrc159Evid10001(params) {
    return { evid: 10001, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forTestingGenericCloseEventSrc159Evid10002' event (evid: 10002)
 *
 * Event description: For phase 2 of platformized BI effort
 *
 * @param {forTestingGenericCloseEventSrc159Evid10002Params} params - The parameters for this event
 * @property {string} path - data attribute
 * @property {string} componentType - widget/modal/etc
 * @return {LogObject<forTestingGenericCloseEventSrc159Evid10002Params>} LogObject<forTestingGenericCloseEventSrc159Evid10002Params>
 */
export function forTestingGenericCloseEventSrc159Evid10002(params) {
    return { evid: 10002, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forTestingGenericSelectEventSrc159Evid10003' event (evid: 10003)
 *
 * Event description: For phase 2 of platformized BI effort
 *
 * @param {forTestingGenericSelectEventSrc159Evid10003Params} params - The parameters for this event
 * @property {string} path - data attribute
 * @property {string} componentType - widget/modal/etc
 * @property {string} selectedValue - ID/boolean (as str)
 * @property {string} selectedLabel - optional
 * @property {string} previousValue - ID/boolean (as str)
 * @property {string} previousLabel - optional
 * @return {LogObject<forTestingGenericSelectEventSrc159Evid10003Params>} LogObject<forTestingGenericSelectEventSrc159Evid10003Params>
 */
export function forTestingGenericSelectEventSrc159Evid10003(params) {
    return { evid: 10003, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forTestingGenericErrorEventSrc159Evid10004' event (evid: 10004)
 *
 * Event description: For phase 2 of platformized BI effort
 *
 * @param {forTestingGenericErrorEventSrc159Evid10004Params} params - The parameters for this event
 * @property {string} path - data attribute
 * @property {string} componentType - widget/modal/etc
 * @property {string} message - error message
 * @property {string} errorType - error type
 * @return {LogObject<forTestingGenericErrorEventSrc159Evid10004Params>} LogObject<forTestingGenericErrorEventSrc159Evid10004Params>
 */
export function forTestingGenericErrorEventSrc159Evid10004(params) {
    return { evid: 10004, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forTestingPurposesAutoPopoverMenuLoadedBiEventSrc159Evid1001' event (evid: 1001)
 *
 * Event description: A generic BI event for Popover menu Loaded as part of auto BI project
 *
 * @param {forTestingPurposesAutoPopoverMenuLoadedBiEventSrc159Evid1001Params} params - The parameters for this event
 * @property {string} clickableOptions - list of items that can be clicked
 * @property {string} options - list of items
 * @property {string} menuName - the name of the menu
 * @property {string} pageName - the name of the page the menu is on
 * @return {LogObject<forTestingPurposesAutoPopoverMenuLoadedBiEventSrc159Evid1001Params>} LogObject<forTestingPurposesAutoPopoverMenuLoadedBiEventSrc159Evid1001Params>
 */
export function forTestingPurposesAutoPopoverMenuLoadedBiEventSrc159Evid1001(params) {
    return { evid: 1001, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationInstallAppsSrc159Evid1002' event (evid: 1002)
 *
 * Event description: For migration purposes - sent when we manually install apps on a users' site
 *
 * @param {migrationInstallAppsSrc159Evid1002Params} params - The parameters for this event
 * @property {string} appIds - list of app ids installed
 * @return {LogObject<migrationInstallAppsSrc159Evid1002Params>} LogObject<migrationInstallAppsSrc159Evid1002Params>
 */
export function migrationInstallAppsSrc159Evid1002(params) {
    return { evid: 1002, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationUninstallAppsSrc159Evid1003' event (evid: 1003)
 *
 * Event description: For migration purposes - sent when we manually uninstall apps on a users' site
 *
 * @param {migrationUninstallAppsSrc159Evid1003Params} params - The parameters for this event
 * @property {string} appIds - list of app ids installed
 * @return {LogObject<migrationUninstallAppsSrc159Evid1003Params>} LogObject<migrationUninstallAppsSrc159Evid1003Params>
 */
export function migrationUninstallAppsSrc159Evid1003(params) {
    return { evid: 1003, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationReadyForOptimusSrc159Evid1004' event (evid: 1004)
 *
 * Event description: for migration purposes - Server migration "run" stage happend successfully/failed.
 * Run stage - Installed new OLO, and copy old olo settings to new olo.
 *
 * @param {migrationReadyForOptimusSrc159Evid1004Params} params - The parameters for this event
 * @property {string} additionalInfo - optional
 * @property {string} migrationDate - migration time
 * @property {boolean} isSuccess - process succeed/ failed
 * @property {string} migrationType - -
 * @property {string} population - migrated population group name
 * @return {LogObject<migrationReadyForOptimusSrc159Evid1004Params>} LogObject<migrationReadyForOptimusSrc159Evid1004Params>
 */
export function migrationReadyForOptimusSrc159Evid1004(params) {
    return { evid: 1004, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationClientMigrationStepSrc159Evid1005' event (evid: 1005)
 *
 * Event description: General event for migration steps
 *
 * @param {migrationClientMigrationStepSrc159Evid1005Params} params - The parameters for this event
 * @property {string} migrationStep - what step of the migration
 * @property {string} additionalInfo - optional
 * @return {LogObject<migrationClientMigrationStepSrc159Evid1005Params>} LogObject<migrationClientMigrationStepSrc159Evid1005Params>
 */
export function migrationClientMigrationStepSrc159Evid1005(params) {
    return { evid: 1005, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationMigrationStepErrorSrc159Evid1006' event (evid: 1006)
 *
 * Event description: General error event for migration
 *
 * @param {migrationMigrationStepErrorSrc159Evid1006Params} params - The parameters for this event
 * @property {string} migrationStep - what step of the migration
 * @property {string} additionalInfo - optional
 * @property {string} migrationType - -
 * @return {LogObject<migrationMigrationStepErrorSrc159Evid1006Params>} LogObject<migrationMigrationStepErrorSrc159Evid1006Params>
 */
export function migrationMigrationStepErrorSrc159Evid1006(params) {
    return { evid: 1006, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationServerMigrationShutdownStepHappenedCloseOrderingToggleSrc159Evid1007' event (evid: 1007)
 *
 * Event description: for migration purposes - Server migration "shutdown" stage happend successfully/failed.
 * shutdown stage - Close ordering toggle
 *
 * @param {migrationServerMigrationShutdownStepHappenedCloseOrderingToggleSrc159Evid1007Params} params - The parameters for this event
 * @property {string} additionalInfo - optional
 * @property {string} migrationDate - migration time
 * @property {boolean} isSuccess - process succeed/ failed
 * @property {string} population - migrated population group name
 * @return {LogObject<migrationServerMigrationShutdownStepHappenedCloseOrderingToggleSrc159Evid1007Params>} LogObject<migrationServerMigrationShutdownStepHappenedCloseOrderingToggleSrc159Evid1007Params>
 */
export function migrationServerMigrationShutdownStepHappenedCloseOrderingToggleSrc159Evid1007(params) {
    return { evid: 1007, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationMenusMenusPageCounterSrc159Evid1008' event (evid: 1008)
 *
 * Event description: For migration purposes - if more than one menu pages exists on msid
 *
 * @param {migrationMenusMenusPageCounterSrc159Evid1008Params} params - The parameters for this event
 * @property {GUID} appId - on which app  the script ran
 * @property {boolean} hasMoreThanOneMenuPage - -
 * @property {GUID} msid - -
 * @property {number} menuPagesCount - -
 * @return {LogObject<migrationMenusMenusPageCounterSrc159Evid1008Params>} LogObject<migrationMenusMenusPageCounterSrc159Evid1008Params>
 */
export function migrationMenusMenusPageCounterSrc159Evid1008(params) {
    return { evid: 1008, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSaveSection' event (evid: 101)
 *
 * Event description: User clicked on save section, and got a response from the server if it was saved successfuly or not
 *
 * @param {menusSaveSectionParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} description - the description the user inputed
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {GUID} sectionId - Section ID. Unique id in a site level
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {string} imagesUrls - an array of image urls URLs . The first image url represents the main image URL
 *
 * @property {boolean} isVisible - True if the item is shown. False if the item is hidden
 *
 * @return {LogObject<menusSaveSectionParams>} LogObject<menusSaveSectionParams>
 */
export function menusSaveSection(params) {
    return { evid: 101, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSaveMenu' event (evid: 102)
 *
 * Event description: User clicked on save Menu, and got a response from the server if it was saved successfuly or not
 *
 * @param {menusSaveMenuParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} description - the description the user inputed
 * @property {boolean} isDraft - As default the checkbox is clicked (true), this field is similar to is_visible
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {GUID} menuId - Menu ID. Unique id site in a site level
 * @property {GUID} locationId - -
 * @return {LogObject<menusSaveMenuParams>} LogObject<menusSaveMenuParams>
 */
export function menusSaveMenu(params) {
    return { evid: 102, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusOpenSidePanel' event (evid: 103)
 *
 * Event description: User opened a side panel inside one of menus app in the business manager. Notice that there is the isOrdersAvailable field, indicating if the user has the orders app features inside the side panel editing options. This event also happens in the parallel screens in the owners app
 *
 * @param {menusOpenSidePanelParams} params - The parameters for this event
 * @property {boolean} isOrdersAvailable - Are Online Ordering editing option available for the user?
 * @property {string} panelName - panel name
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @return {LogObject<menusOpenSidePanelParams>} LogObject<menusOpenSidePanelParams>
 */
export function menusOpenSidePanel(params) {
    return { evid: 103, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusCloseSidePanel' event (evid: 104)
 *
 * Event description: User Closed a side panel inside one of menus app in the business manager.Notice that when a user tries to close the panel while in the middle of editing it opens a 'discard changes modal'. When this happens, this event should not fire! Only once the modal closes this event fires, and if it occures after the user clicked on discard changes, then the origin will be 'discard changes modal'. These can also happen in the owners app parallel screens
 *
 * @param {menusCloseSidePanelParams} params - The parameters for this event
 * @property {string} panelName - panel name
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @return {LogObject<menusCloseSidePanelParams>} LogObject<menusCloseSidePanelParams>
 */
export function menusCloseSidePanel(params) {
    return { evid: 104, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSidePanelClick' event (evid: 105)
 *
 * Event description: User made a made a change in a side panel inside one of menus app in the business manager. Before saving the changes. These can also happen in the owners app parallel screens
 *
 * @param {menusSidePanelClickParams} params - The parameters for this event
 * @property {string} field - represents the title of the field being edited. For example if a user writes a description for a menu it will return 'description'
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {boolean} isOrdersAvailable - Is orders attributes available in the panel
 * @property {GUID} id - The id of the object being edited.
 * @property {string} panelName - panel name
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @property {string} value - most commonly paired with a field column, and the value is the acutal value related to that field
 * @return {LogObject<menusSidePanelClickParams>} LogObject<menusSidePanelClickParams>
 */
export function menusSidePanelClick(params) {
    return { evid: 105, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusPageFinishedLoading' event (evid: 106)
 *
 * Event description: a menu inside the menus page finished loading. This event contains extra data regarding menus related information such as number of items loaded in a page (not including collapsed items), total items in a page (including collapsed items) etc
 *
 * @param {menusPageFinishedLoadingParams} params - The parameters for this event
 * @property {string} pageName - name of the page
 * @property {GUID} menuId - Menu ID. Unique id site in a site level
 * @property {number} loadedItems - number of items loaded. does not include collapsed items. pair with total Items to find the amount of collapsed items
 * @return {LogObject<menusPageFinishedLoadingParams>} LogObject<menusPageFinishedLoadingParams>
 */
export function menusPageFinishedLoading(params) {
    return { evid: 106, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusMoreButtonAction' event (evid: 107)
 *
 * Event description: User clicked on an option inside of the more button clickable list
 *
 * @param {menusMoreButtonActionParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} action - The specific action
 * @return {LogObject<menusMoreButtonActionParams>} LogObject<menusMoreButtonActionParams>
 */
export function menusMoreButtonAction(params) {
    return { evid: 107, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusAddObjectClick' event (evid: 108)
 *
 * Event description: User clicked on an add object(menu,section,item,etc...) button
 *
 * @param {menusAddObjectClickParams} params - The parameters for this event
 * @property {GUID} id - id. if its modifiers so midifier_group_id
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @property {GUID} locationId - -
 * @return {LogObject<menusAddObjectClickParams>} LogObject<menusAddObjectClickParams>
 */
export function menusAddObjectClick(params) {
    return { evid: 108, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDeleteObject' event (evid: 109)
 *
 * Event description: User deleted an object (item/section/menu) from the menus app. Most commonly through one of the delete object modals. NOTICE this event fires only when the user pressed the delete button. If an entity was deleted as result of a deletion of a parent entity this event will not fire. For example, if a section was deleted, and all of it's items were deleted with it, it will not fire this event for each item
 *
 * @param {menusDeleteObjectParams} params - The parameters for this event
 * @property {boolean} itemsDeletes - rue if the user marked check to delete all items in section/ items in menu
 * @property {boolean} itemsDeleted - rue if the user marked check to delete all items in section/ items in menu
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {number} numberItems - if items in object were deleted, how many
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item/section/menu/label etc
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @return {LogObject<menusDeleteObjectParams>} LogObject<menusDeleteObjectParams>
 */
export function menusDeleteObject(params) {
    return { evid: 109, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsUouPageFinishedLoading' event (evid: 11)
 *
 * Event description: Widget of a restaurants' app finished loading (live site/ site builder)
 *
 * @param {restaurantsUouPageFinishedLoadingParams} params - The parameters for this event
 * @property {string} widgetId - An ID for the widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - The widget's name
 * @property {number} loadingTime - load time in miliseconds
 * @property {boolean} isMenusDefaultPage - Is this the default page menus widget is installed on?
 * @property {string} pageName - name of the page
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} hosting - editor/editor X/viewer(live site desktop)/ mobile(live site, mobile web). NOTICE you can use view_mode to aggregate live site(both mobile web and desktopn)
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId - -
 * @property {boolean} isOoi - indicates if the builder is OOI (or blocks)
 * @property {GUID} menuId - -
 * @return {LogObject<restaurantsUouPageFinishedLoadingParams>} LogObject<restaurantsUouPageFinishedLoadingParams>
 */
export function restaurantsUouPageFinishedLoading(params) {
    return { evid: 11, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditButtonClick' event (evid: 110)
 *
 * Event description: User clicked the edit button of an object inside the menus app to start editing it
 *
 * @param {menusEditButtonClickParams} params - The parameters for this event
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @return {LogObject<menusEditButtonClickParams>} LogObject<menusEditButtonClickParams>
 */
export function menusEditButtonClick(params) {
    return { evid: 110, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloMultiLocationMigrationStatusSrc159Evid1100' event (evid: 1100)
 *
 * Event description: bi events for multi location migration status check
 *
 * @param {oloMultiLocationMigrationStatusSrc159Evid1100Params} params - The parameters for this event
 * @property {string} msid - -
 * @property {string} menuAppInstallationStatus - menu App Installation Status
 * @property {string} ordersAppInstallationStatus - orders App Installation Status
 * @property {boolean} LocationInconsistencyInMOS - has Location Inconsistency In Menu Order Settings And Operation
 * @property {boolean} MenuMissingLocation - has Menu With Missing Location
 * @property {boolean} MenuInvalidLocation - has Menu With Invalid Location
 * @property {boolean} OperationInvalidLocation - has Operation With Invalid Location
 * @property {boolean} MissingOperationForOperationGroup - has Missing Operation For Operation Group
 * @property {number} numOperations - number of operations
 * @property {string} menuOriginInstanceId - -
 * @property {string} ordersOriginInstanceId - -
 * @return {LogObject<oloMultiLocationMigrationStatusSrc159Evid1100Params>} LogObject<oloMultiLocationMigrationStatusSrc159Evid1100Params>
 */
export function oloMultiLocationMigrationStatusSrc159Evid1100(params) {
    return { evid: 1100, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusCollapseAllSections' event (evid: 111)
 *
 * Event description: User clicked on collapse all sections. Events sent after they were collapsed.
 *
 * @param {menusCollapseAllSectionsParams} params - The parameters for this event
 * @property {number} numOfSections - number of section
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {GUID} menuId - Menu ID. Unique id site in a site level
 * @return {LogObject<menusCollapseAllSectionsParams>} LogObject<menusCollapseAllSectionsParams>
 */
export function menusCollapseAllSections(params) {
    return { evid: 111, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusCollapseSectionClick' event (evid: 112)
 *
 * Event description: User clicked on collapse/un collapse button of a specific section. The status field states the status after the click
 *
 * @param {menusCollapseSectionClickParams} params - The parameters for this event
 * @property {string} state - the last state after the click
 * @property {number} numOfItems - number of items
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {GUID} sectionId - Section ID. Unique id in a site level
 * @property {string} pageName - name of the page
 * @property {GUID} menuId - Menu ID. Unique id site in a site level
 * @return {LogObject<menusCollapseSectionClickParams>} LogObject<menusCollapseSectionClickParams>
 */
export function menusCollapseSectionClick(params) {
    return { evid: 112, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDeleteButtonClick' event (evid: 113)
 *
 * Event description: User clicked the delete button of an object inside the menus app to start deleting it
 *
 * @param {menusDeleteButtonClickParams} params - The parameters for this event
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @return {LogObject<menusDeleteButtonClickParams>} LogObject<menusDeleteButtonClickParams>
 */
export function menusDeleteButtonClick(params) {
    return { evid: 113, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusBulkDelete' event (evid: 114)
 *
 * Event description: When a user uses the bulk delete in order to delete multiple objects (Of the same type)
 *
 * @param {menusBulkDeleteParams} params - The parameters for this event
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} idsArray - array of all the ids that were deleted with the section
 * @property {string} pageName - name of the page
 * @property {string} type - the type of objects deleted
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @return {LogObject<menusBulkDeleteParams>} LogObject<menusBulkDeleteParams>
 */
export function menusBulkDelete(params) {
    return { evid: 114, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorElementsPanelCheckboxAction' event (evid: 115)
 *
 * Event description: User clicked on a button inside the elements panel that made a difference in the design. for example clicked a checkbox of section title. NOTICE there is more than one elements panel. for example you can arrive at the "menu section elements" panel when clicking inside at the section are of the menus widget
 *
 * @param {menusEditorElementsPanelCheckboxActionParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Menus
 * @property {string} panelName - The panel name: menu elements/menu section elements/etc...
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} visibleElementsArray - an array of all the elements that are visible (aka those that are checked) after the click
 * @property {GUID} msid - msid
 * @property {string} elementName - the name of the element that was checked/unchecked
 * @property {string} action - check / uncheck
 * @return {LogObject<menusEditorElementsPanelCheckboxActionParams>} LogObject<menusEditorElementsPanelCheckboxActionParams>
 */
export function menusEditorElementsPanelCheckboxAction(params) {
    return { evid: 115, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorMenuSettingsPanelAction' event (evid: 116)
 *
 * Event description: User clicked on a button inside the menu settings button that made a difference in the design.
 * For example clicked on a menu checkbox
 *
 * @param {menusEditorMenuSettingsPanelActionParams} params - The parameters for this event
 * @property {string} visibleMenusArray - an array of all the menus that are visible (aka those that are checked) after the click
 * @property {string} widgetId - an id for the specific widget
 * @property {string} field - menu picking/ create new menu page
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {boolean} isMenusDefaultPage - Is this the default page menus widget is installed on?
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @property {string} value - visible/hidden/show all/reorder
 * @return {LogObject<menusEditorMenuSettingsPanelActionParams>} LogObject<menusEditorMenuSettingsPanelActionParams>
 */
export function menusEditorMenuSettingsPanelAction(params) {
    return { evid: 116, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSaveMenuItemLabel' event (evid: 117)
 *
 * Event description: User clicked on save Label, and got a response from the server if it was saved successfully or not. Including add/edit Item Label
 *
 * @param {menusSaveMenuItemLabelParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin, can be: save button-edit label modal
 * @property {GUID} labelId - Label ID. Unique id site in a site level
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {string} imageUrl - the url of the icon
 * @return {LogObject<menusSaveMenuItemLabelParams>} LogObject<menusSaveMenuItemLabelParams>
 */
export function menusSaveMenuItemLabel(params) {
    return { evid: 117, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDeleteMenuWithAllSections' event (evid: 118)
 *
 * Event description: User deleted a menu and chose to delete all the sections inside of it. (deleting the items inside those sections as well) Might only be relevant for menu showcase V1
 *
 * @param {menusDeleteMenuWithAllSectionsParams} params - The parameters for this event
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @property {string} sectionsArray - array of all the sections that were deleted with the section
 * @property {GUID} menuId - menu Id
 * @return {LogObject<menusDeleteMenuWithAllSectionsParams>} LogObject<menusDeleteMenuWithAllSectionsParams>
 */
export function menusDeleteMenuWithAllSections(params) {
    return { evid: 118, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusManageLabelsButtonClick' event (evid: 119)
 *
 * Event description: User clicked a Manage Labels button - opening the manage labels modal
 *
 * @param {menusManageLabelsButtonClickParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the action occurred in
 * @return {LogObject<menusManageLabelsButtonClickParams>} LogObject<menusManageLabelsButtonClickParams>
 */
export function menusManageLabelsButtonClick(params) {
    return { evid: 119, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsEditorPanelLoad' event (evid: 12)
 *
 * Event description: User loads a widget editing panel inside the editor of a restaurants app
 *
 * @param {restaurantsEditorPanelLoadParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Name of the widget, for example menus
 * @property {string} panelName - panel name
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {boolean} isOoi - indicates if the builder is OOI (or blocks)
 *
 * @return {LogObject<restaurantsEditorPanelLoadParams>} LogObject<restaurantsEditorPanelLoadParams>
 */
export function restaurantsEditorPanelLoad(params) {
    return { evid: 12, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusModalAction' event (evid: 120)
 *
 * Event description: User made a made a change in a modal inside one of menus app in the business manager. Before saving the changes
 *
 * @param {menusModalActionParams} params - The parameters for this event
 * @property {string} field - represents the title of the field being edited. For example if a user writes a description for a menu it will return 'description'
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @property {string} modalName - modal name
 * @property {string} value - most commonly paired with a field column, and the value is the acutal value related to that field
 * @return {LogObject<menusModalActionParams>} LogObject<menusModalActionParams>
 */
export function menusModalAction(params) {
    return { evid: 120, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusReOrderObject' event (evid: 121)
 *
 * Event description: User reordered an object, for example, if a user reorders items inside of a section, the type will be item. IF YOU WANT THE LAST ORDER, USE SERVER EVENTS WHEN POSSIBLE
 *
 * @param {menusReOrderObjectParams} params - The parameters for this event
 * @property {GUID} id - an id of an object. Should be connected to a type field that states which object
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item/section/menu/label etc
 * @property {string} orderArray - An array of the objects, with the new order
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @return {LogObject<menusReOrderObjectParams>} LogObject<menusReOrderObjectParams>
 */
export function menusReOrderObject(params) {
    return { evid: 121, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusOwnersAppEntryPointClick' event (evid: 122)
 *
 * Event description: User clicked on one of menus app entry points
 *
 * @param {menusOwnersAppEntryPointClickParams} params - The parameters for this event
 * @property {string} destinationPageName - The page that the user is about to land in, for example menus/items etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @return {LogObject<menusOwnersAppEntryPointClickParams>} LogObject<menusOwnersAppEntryPointClickParams>
 */
export function menusOwnersAppEntryPointClick(params) {
    return { evid: 122, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusRemoveItemFromSection' event (evid: 123)
 *
 * Event description: User removed an item from a section. This event also checks with the server that the change was made
 *
 * @param {menusRemoveItemFromSectionParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the removal was not successful send the. error description
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the removal occurred successfully
 * @return {LogObject<menusRemoveItemFromSectionParams>} LogObject<menusRemoveItemFromSectionParams>
 */
export function menusRemoveItemFromSection(params) {
    return { evid: 123, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusNavigationClick' event (evid: 124)
 *
 * Event description: User clicked on a navigation button (any button in the menus app that links to a different page)
 *
 * @param {menusNavigationClickParams} params - The parameters for this event
 * @property {string} destinationPageName - The page that the user is about to land in, for example menus/items etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {GUID} locationId - -
 * @return {LogObject<menusNavigationClickParams>} LogObject<menusNavigationClickParams>
 */
export function menusNavigationClick(params) {
    return { evid: 124, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDuplicateObjectClick' event (evid: 125)
 *
 * Event description: User clicked on a duplicate object(menu,section,item,etc...) button. This does not include server save, only the start of the duplication flow.
 *
 * @param {menusDuplicateObjectClickParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @property {string} originId - the id of the object that is the origin of the duplication
 * @return {LogObject<menusDuplicateObjectClickParams>} LogObject<menusDuplicateObjectClickParams>
 */
export function menusDuplicateObjectClick(params) {
    return { evid: 125, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSaveModifierOrPriceVariant' event (evid: 126)
 *
 * Event description: User clicked on save item, and in that save there were modifiers/price variants that were saved. The user got a response from the server if it was saved successfully or not
 *
 * @param {menusSaveModifierOrPriceVariantParams} params - The parameters for this event
 * @property {boolean} isPreselected - true/false
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {GUID} id - Modifier id
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {GUID} itemId - Item ID of the item the modifier were saved in
 * @property {string} pageName - name of the page
 * @property {string} type - variation/individual_modifier/etc...
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @return {LogObject<menusSaveModifierOrPriceVariantParams>} LogObject<menusSaveModifierOrPriceVariantParams>
 */
export function menusSaveModifierOrPriceVariant(params) {
    return { evid: 126, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSaveModifierGroup' event (evid: 127)
 *
 * Event description: User clicked on save item, and in that save there were modifier groups that were saved.The user got a response from the server if it was saved successfully or not
 *
 * @param {menusSaveModifierGroupParams} params - The parameters for this event
 * @property {string} name - name of the price variant
 * @property {boolean} isMandatory - true/false
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate / Reusable etc
 * @property {number} maxSelections - max_selections
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {GUID} id - Modifier group id
 * @property {string} modifierGroupId - only if it’s not null (in the updates)
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} modifiers - json array of modifiers
 * @property {number} minSelections - min_selections
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {GUID} itemId - Item ID of the item the modifier were saved in
 * @property {string} pageName - name of the page
 * @property {number} numPreselectedModifiers - num preselected modifiers
 * @property {string} type - optional/mandatory sinces Nov23. before - SINGLE_SELECT/ MULTI_SELECT/UNSPECIFIED_RULE_TYPE
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {boolean} isNoLimit - true/false
 * @property {number} maxChoices - maximum number of extras the customer can choose. Relevant to mulitSelection only
 * @property {string} itemmIds -  list of al item ids that use this modifier group
 *
 * @property {number} numOfItemsInUse - the number of all the items that use this modifier group
 * @property {string} changedFields - what fields were changed in this “update” event?
 * @return {LogObject<menusSaveModifierGroupParams>} LogObject<menusSaveModifierGroupParams>
 */
export function menusSaveModifierGroup(params) {
    return { evid: 127, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusRemoveModifierFromModifierGroup' event (evid: 128)
 *
 * Event description: User removed a modifier from a modifier group. This event also checks with the server that the change was made
 *
 * @param {menusRemoveModifierFromModifierGroupParams} params - The parameters for this event
 * @property {string} modifierId - modifierId
 * @property {boolean} isPreselected - Ture/False
 * @property {string} modifierGroupId - modifierGroupId
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the removal was not successful send the. error description
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the removal occurred successfully
 * @return {LogObject<menusRemoveModifierFromModifierGroupParams>} LogObject<menusRemoveModifierFromModifierGroupParams>
 */
export function menusRemoveModifierFromModifierGroup(params) {
    return { evid: 128, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusRemoveModifierGroupFromItem' event (evid: 129)
 *
 * Event description: User removed a modifier group from an item . This event also checks with the server that the change was made
 *
 * @param {menusRemoveModifierGroupFromItemParams} params - The parameters for this event
 * @property {boolean} isMandatory - true/false
 * @property {string} flowType - new/edit
 * @property {number} maxSelections - max_selection number
 * @property {number} minChoices - min_selection number
 * @property {string} modifierGroupId - modifierGroupId
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {number} minSelections - min_selection number
 * @property {string} errorDescription - If the removal was not successful send the. error description
 * @property {string} itemId - itemId
 * @property {string} pageName - name of the page
 * @property {number} numPreselectedModifiers - # of preselected modifiers
 * @property {boolean} isSuccessful - Did the removal occurred successfully
 * @property {boolean} isNoLimit - true/false
 * @return {LogObject<menusRemoveModifierGroupFromItemParams>} LogObject<menusRemoveModifierGroupFromItemParams>
 */
export function menusRemoveModifierGroupFromItem(params) {
    return { evid: 129, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsEditorPanelClose' event (evid: 13)
 *
 * Event description: User closes a widget editing panel inside the editor of a restaurants app
 *
 * @param {restaurantsEditorPanelCloseParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} buttonType - The specific button clicked
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Name of the widget, for example menus
 * @property {string} panelName - panel name
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsEditorPanelCloseParams>} LogObject<restaurantsEditorPanelCloseParams>
 */
export function restaurantsEditorPanelClose(params) {
    return { evid: 13, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusOrdersAttributesChange' event (evid: 130)
 *
 * Event description: User clicked on one of the buttons that trigger the hide/show orders attribute for menus app.
 *
 * @param {menusOrdersAttributesChangeParams} params - The parameters for this event
 * @property {string} lastState - hide/show
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @return {LogObject<menusOrdersAttributesChangeParams>} LogObject<menusOrdersAttributesChangeParams>
 */
export function menusOrdersAttributesChange(params) {
    return { evid: 130, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusLiveSiteEditorPreviewNavigationClick' event (evid: 131)
 *
 * Event description: User clicked on a navigation button in the live site/preview mode of the menus app widget. This navigation switches between different menus in the in the widget.
 *
 * @param {menusLiveSiteEditorPreviewNavigationClickParams} params - The parameters for this event
 * @property {string} widgetId - An ID for the widget
 * @property {number} navigationType - Tabs / Dropdown
 * @property {number} numMenus - The number of menus presented in the horizontal menu
 * @property {string} widgetName - The widget's name
 * @property {string} menuNavigation - Tabs / Dropdown
 * @property {string} pageName - name of the page in live site/editor
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {boolean} isOoi - -
 * @return {LogObject<menusLiveSiteEditorPreviewNavigationClickParams>} LogObject<menusLiveSiteEditorPreviewNavigationClickParams>
 */
export function menusLiveSiteEditorPreviewNavigationClick(params) {
    return { evid: 131, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusMoveItem' event (evid: 132)
 *
 * Event description: User moves an item from one section to another. Can happen between menus as well.
 *
 * @param {menusMoveItemParams} params - The parameters for this event
 * @property {string} error_type - validation/server/etc...
 * @property {string} originSectionId - origin sectionId, where the item was moved from
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the move was not successful send the. error description
 * @property {string} itemId - itemId
 * @property {string} originMenuId - origin menuId, where the item was moved from
 * @property {string} targetMenuId - target menuId, where the item is moved to
 * @property {string} targetSectionId - target sectionId, where the item is moved to
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the move occurred successfully
 * @return {LogObject<menusMoveItemParams>} LogObject<menusMoveItemParams>
 */
export function menusMoveItem(params) {
    return { evid: 132, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusMoveSection' event (evid: 133)
 *
 * Event description: User moves a section from one menu to another. This moves the entire section and all of the items inside of it to the new menu
 *
 * @param {menusMoveSectionParams} params - The parameters for this event
 * @property {string} error_type - validation/server/etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - If the move was not successful send the. error description
 * @property {string} sectionId - sectionId
 * @property {string} originMenuId - origin menuId, where the section was moved from
 * @property {string} targetMenuId - target menuId, where the section is moved to
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the move occurred successfully
 * @return {LogObject<menusMoveSectionParams>} LogObject<menusMoveSectionParams>
 */
export function menusMoveSection(params) {
    return { evid: 133, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusMoveItemModalMenuDrilldownClick' event (evid: 134)
 *
 * Event description: The user clicked on one of the menus inside the move item modal, this click is a drilldown
 *
 * @param {menusMoveItemModalMenuDrilldownClickParams} params - The parameters for this event
 * @property {string} chosenMenuId - menuId of the menu chosen
 * @property {number} numberOfSections - Number of section in the chosen menu (should be 0 if empty)
 * @property {boolean} isCurrentMenu - Is the menu clicked, the current menu of the item
 * @property {string} itemId - itemId that is being moved
 * @property {string} pageName - name of the page
 * @return {LogObject<menusMoveItemModalMenuDrilldownClickParams>} LogObject<menusMoveItemModalMenuDrilldownClickParams>
 */
export function menusMoveItemModalMenuDrilldownClick(params) {
    return { evid: 134, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorMenuLayoutPick' event (evid: 135)
 *
 * Event description: User clicked on a menu layout option. In the fields below there is a field stating if the layout allows images allow_images
 *
 * @param {menusEditorMenuLayoutPickParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {boolean} allowImages - If the layout allows images, as only some of the layouts have the option to display images
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} layout - layout id/ layout name
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @return {LogObject<menusEditorMenuLayoutPickParams>} LogObject<menusEditorMenuLayoutPickParams>
 */
export function menusEditorMenuLayoutPick(params) {
    return { evid: 135, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusTabSwitch' event (evid: 136)
 *
 * Event description: User clicked on a different tab inside one of menus page.
 * For example: user clicked on the variants tab inside the items page
 *
 * @param {menusTabSwitchParams} params - The parameters for this event
 * @property {string} destinationTab - The tab that the user is about to land in, for example items/variants/modifiers etc...
 * @property {string} currentTab - The tab that the user was in before the click, for example items/variants/modifiers etc...
 * @property {string} pageName - name of the page
 * @return {LogObject<menusTabSwitchParams>} LogObject<menusTabSwitchParams>
 */
export function menusTabSwitch(params) {
    return { evid: 136, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusItemsPageHover' event (evid: 137)
 *
 * Event description: User hovered on an item/modifier/variant inside the items page
 *
 * @param {menusItemsPageHoverParams} params - The parameters for this event
 * @property {number} numberOfEntities - The number of different entities inside the hover. For example, if the hover is on the "included in" column, then it wil be the number of items the modifier/variant is included in
 * @property {string} hoverContent - The hover content
 * @property {string} id - the id of the item/variant/modifier (should use with the type field)
 * @property {string} column_title - The column the user is hovering on : menus/included in/etc...
 * @property {string} type - item/variant/modifier
 * @return {LogObject<menusItemsPageHoverParams>} LogObject<menusItemsPageHoverParams>
 */
export function menusItemsPageHover(params) {
    return { evid: 137, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDuplicateMenu' event (evid: 138)
 *
 * Event description: User duplicates menu.
 * This event includes data on the sections and items that are duplicated as result as well
 *
 * @param {menusDuplicateMenuParams} params - The parameters for this event
 * @property {string} errorDescription - If the deletion was not succesful send the. error description
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the deletion occurred successfully
 * @property {string} sectionsArray - array of all the section ids that were duplicated with the menu
 * @property {GUID} menuId - menu Id after the duplication
 * @property {string} itemsArray - array of all the Item ids that were duplicated with the menu
 * @property {string} menuItems - copy / shared
 * @property {string} menuIds - for example in duplicate menu to more than one location flow
 * @return {LogObject<menusDuplicateMenuParams>} LogObject<menusDuplicateMenuParams>
 */
export function menusDuplicateMenu(params) {
    return { evid: 138, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorShowHidePlaceholderImage' event (evid: 139)
 *
 * Event description: User clicked on a button regarding showing or hiding placeholder images
 *
 * @param {menusEditorShowHidePlaceholderImageParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} menusShowImage - array of menu ids of menus that show the placeholder image
 * @property {string} sectionsShowImage - array of section ids of sections that show the placeholder image
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @property {string} action - The type of action occurring related to placeholder image such as : "disable on all menus", "enable on all menus"etc...""
 * @return {LogObject<menusEditorShowHidePlaceholderImageParams>} LogObject<menusEditorShowHidePlaceholderImageParams>
 */
export function menusEditorShowHidePlaceholderImage(params) {
    return { evid: 139, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsEditorPanelNavigationClick' event (evid: 14)
 *
 * Event description: Restaurants -> Editor -> Panel Navigation Click.
 *
 * @param {restaurantsEditorPanelNavigationClickParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} lastLevel - The last and most detailed level , i.e : color picker/ fonts/themes/etc…
 * If there is only a first level then the last and first level will send the same value.
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Name of the widget, for example menus
 * @property {string} panelName - panel name
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} firstLevel - The first navigation level, i.e : menu title/ section title/ labels/ etc…
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} fullPath - The complete level path for example : fill color & opacity, background, color picker
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsEditorPanelNavigationClickParams>} LogObject<restaurantsEditorPanelNavigationClickParams>
 */
export function restaurantsEditorPanelNavigationClick(params) {
    return { evid: 14, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorPlaceholderImageDesignAction' event (evid: 140)
 *
 * Event description: User clicked on a button regarding the design of placeholder images, for example, changing the image
 *
 * @param {menusEditorPlaceholderImageDesignActionParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {string} imageUrl - The placeholder image url
 * @property {GUID} msid - msid
 * @property {string} action - The type of action occurring related to placeholder image such as : change image, reset image, adjust image, etc
 * @return {LogObject<menusEditorPlaceholderImageDesignActionParams>} LogObject<menusEditorPlaceholderImageDesignActionParams>
 */
export function menusEditorPlaceholderImageDesignAction(params) {
    return { evid: 140, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsReservationsPageTabSelected' event (evid: 1406)
 *
 * Event description: when users click on the reservations / requests tab
 *
 * @param {tableReservationsReservationsPageTabSelectedParams} params - The parameters for this event
 * @property {number} rowsNumberSource - number of reservations / requests in the source tab
 * @property {string} tabName - reservations / requests
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_view / reservations_list_view
 * @property {string} rest_id - -
 * @property {number} rowsNumberTarget - number of reservations / requests in the target tab
 * @return {LogObject<tableReservationsReservationsPageTabSelectedParams>} LogObject<tableReservationsReservationsPageTabSelectedParams>
 */
export function tableReservationsReservationsPageTabSelected(params) {
    return { evid: 1406, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsBoClickAddNewReservation' event (evid: 1407)
 *
 * Event description: in the table reservations bo page, when a user clicks on create reservation and then on reservation/ walk in
 *
 * @param {tableReservationsBoClickAddNewReservationParams} params - The parameters for this event
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_view / reservations_list_view / mobile_dashboard_view
 * @property {string} origin - reservations_list / floor_plan_popover / header / footer / widget
 * @property {GUID} locationId - -
 * @property {string} reservationType - reservation / walk_in
 * @return {LogObject<tableReservationsBoClickAddNewReservationParams>} LogObject<tableReservationsBoClickAddNewReservationParams>
 */
export function tableReservationsBoClickAddNewReservation(params) {
    return { evid: 1407, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsBoReservationRequestAction' event (evid: 1408)
 *
 * Event description: After the user open the reservation request modal, this event will send if he clicked accept / declined.
 *
 * @param {tableReservationsBoReservationRequestActionParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_view / reservations_list_view
 * @property {GUID} locationId - -
 * @property {string} action - accept / decline
 * @property {string} placement - placement
 * @return {LogObject<tableReservationsBoReservationRequestActionParams>} LogObject<tableReservationsBoReservationRequestActionParams>
 */
export function tableReservationsBoReservationRequestAction(params) {
    return { evid: 1408, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorSeoAction' event (evid: 141)
 *
 * Event description: User clicked/typed something inside the SEO tab in the editor
 *
 * @param {menusEditorSeoActionParams} params - The parameters for this event
 * @property {string} tabName - for example seo basics
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} errorType - server/validation/etc...
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} errorDescription - detailed description of error
 * @property {boolean} isSuccessful - was the action completed successfully
 * @property {GUID} msid - msid
 * @property {string} value - The value if there is any, for example the slug that was inputed by the user
 * @property {string} action - slug change etc...
 * @return {LogObject<menusEditorSeoActionParams>} LogObject<menusEditorSeoActionParams>
 */
export function menusEditorSeoAction(params) {
    return { evid: 141, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowMenuInstalledSrc159Evid142' event (evid: 142)
 *
 * Event description: when the chat AI installed new menu
 *
 * @param {menusChatAiInstallationFlowMenuInstalledSrc159Evid142Params} params - The parameters for this event
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {boolean} isSuccessful - True/false
 * @return {LogObject<menusChatAiInstallationFlowMenuInstalledSrc159Evid142Params>} LogObject<menusChatAiInstallationFlowMenuInstalledSrc159Evid142Params>
 */
export function menusChatAiInstallationFlowMenuInstalledSrc159Evid142(params) {
    return { evid: 142, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsClickOnDiscardSpecificSectionChanges' event (evid: 1420)
 *
 * Event description: when the user clicks on discard on the top of the page of each of the sections (table management/availability/notifications/reservation form)
 *
 * @param {tableReservationSettingsClickOnDiscardSpecificSectionChangesParams} params - The parameters for this event
 * @property {string} settingsSection - table_management / online_reservations / reservation_form/ notifications / manual_approval
 * @property {GUID} reservationLocationId - -
 * @property {string} locationGuid - -
 * @property {string} currentToggle - toggle_off/ toggle_on
 * @return {LogObject<tableReservationSettingsClickOnDiscardSpecificSectionChangesParams>} LogObject<tableReservationSettingsClickOnDiscardSpecificSectionChangesParams>
 */
export function tableReservationSettingsClickOnDiscardSpecificSectionChanges(params) {
    return { evid: 1420, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsTableManagementSettingsIsLoadedSrc159Evid1422' event (evid: 1422)
 *
 * Event description: when the page of table management loaded has ended. triggered on any tab (table / table combinations)
 *
 * @param {tableReservationSettingsTableManagementSettingsIsLoadedSrc159Evid1422Params} params - The parameters for this event
 * @property {number} numObjects - num of tables in tables tab or num of tables combinations in table combinations tab
 * @property {number} numTablesCombinations - number of table combinations (null if it is tables tab)
 * @property {number} numOfOnlineObjects - only online tables / combinations
 * @property {number} numSeats - total number of seats
 * @property {string} tablesList - json of of [table name: X, min:1, max:5] , [table name:y , min:6 , max: 7 ]...
 * @property {number} numTables - total number of 'regular' tables
 * @property {string} tabName - tabels / table_combinations
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationId - -
 * @return {LogObject<tableReservationSettingsTableManagementSettingsIsLoadedSrc159Evid1422Params>} LogObject<tableReservationSettingsTableManagementSettingsIsLoadedSrc159Evid1422Params>
 */
export function tableReservationSettingsTableManagementSettingsIsLoadedSrc159Evid1422(params) {
    return { evid: 1422, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsClicks' event (evid: 1423)
 *
 * Event description: when the user clicks on buttons inside any settings page
 *
 * @param {tableReservationSettingsClicksParams} params - The parameters for this event
 * @property {string} tabName - if there are no tabs then null
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationId - -
 * @property {string} actionName - duplicate / delete / online_availability / top_add_table_button / bottom_add_table_button etc.
 * @property {string} pageName - notifications / reservations_form / online_reservations / table_management
 * @property {boolean} isTablet - true/false
 * @return {LogObject<tableReservationSettingsClicksParams>} LogObject<tableReservationSettingsClicksParams>
 */
export function tableReservationSettingsClicks(params) {
    return { evid: 1423, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsAvailabilityPageClickSaveSrc159Evid1427' event (evid: 1427)
 *
 * Event description: when the user save the availability settings page (event will be send after response from the server)
 *
 * @param {tableReservationSettingsAvailabilityPageClickSaveSrc159Evid1427Params} params - The parameters for this event
 * @property {boolean} manualApproval - true if toggle is on. false if toggle is off
 * @property {string} availabilityHoursList - son - (for example: Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
 * @property {number} partiesMinutes - right now should be 15
 * @property {number} guestsPacing - -
 * @property {string} advancedNoticeNum - -
 * @property {number} partiesPacing - -
 * @property {number} minPartySize - -
 * @property {number} numNewEvents - number of new events at the availability modal
 * @property {number} manualApprovalMinParty - required party size for manual approval
 * @property {number} numExistingEvents - number of events that were existing before this saving
 * @property {string} durationRulesList - json list of the rules
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {string} defaultTime - of reservation duration
 * @property {string} restId - -
 * @property {string} advancedNoticeType - minuted / hours/ days
 * @property {string} scheduleType - opening_hours / custom
 * @property {number} maxPartySize - -
 * @property {string} displayPhoneCheckbox - check/ uncheck
 * @property {number} guestsMinutes - right now should be 15
 * @property {string} pageName - availability_settings
 * @property {boolean} isSuccessful - True/false
 * @property {number} timeSlotInterval - default time slot interval is 15. if the user has changed it this will send the new time interval
 * @property {number} numTurnoverRules - how many rules of turnover are exist at the loading
 * @property {string} approvalMode - -
 * @return {LogObject<tableReservationSettingsAvailabilityPageClickSaveSrc159Evid1427Params>} LogObject<tableReservationSettingsAvailabilityPageClickSaveSrc159Evid1427Params>
 */
export function tableReservationSettingsAvailabilityPageClickSaveSrc159Evid1427(params) {
    return { evid: 1427, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsReservationSchedulePageClickSaveSrc159Evid1428' event (evid: 1428)
 *
 * Event description: when the user save the reservation schedule page.
 *
 * @param {tableReservationSettingsReservationSchedulePageClickSaveSrc159Evid1428Params} params - The parameters for this event
 * @property {string} availabilityHoursList - son - (for example: Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
 * @property {number} numExistingEvents - number of events that were existing before this saving
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {boolean} isSuccessful - True/false
 * @property {number} numNewEvents - -
 * @property {string} events - string of all the events (special days) and their info
 * @return {LogObject<tableReservationSettingsReservationSchedulePageClickSaveSrc159Evid1428Params>} LogObject<tableReservationSettingsReservationSchedulePageClickSaveSrc159Evid1428Params>
 */
export function tableReservationSettingsReservationSchedulePageClickSaveSrc159Evid1428(params) {
    return { evid: 1428, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowDeletedMenuDefaultDataSrc159Evid143' event (evid: 143)
 *
 * Event description: when the chat AI Deleted menu deafult data
 *
 * @param {menusChatAiInstallationFlowDeletedMenuDefaultDataSrc159Evid143Params} params - The parameters for this event
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {boolean} isSuccessful - True/false
 * @return {LogObject<menusChatAiInstallationFlowDeletedMenuDefaultDataSrc159Evid143Params>} LogObject<menusChatAiInstallationFlowDeletedMenuDefaultDataSrc159Evid143Params>
 */
export function menusChatAiInstallationFlowDeletedMenuDefaultDataSrc159Evid143(params) {
    return { evid: 143, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsBoChangeView' event (evid: 1430)
 *
 * Event description: when users click on the floor plan view / back to list view.
 *
 * @param {tableReservationsBoChangeViewParams} params - The parameters for this event
 * @property {string} viewName - floor_plan_view / list_view
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - manage_screen/ shortcut
 * @property {GUID} locationId - -
 * @return {LogObject<tableReservationsBoChangeViewParams>} LogObject<tableReservationsBoChangeViewParams>
 */
export function tableReservationsBoChangeView(params) {
    return { evid: 1430, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsClicks' event (evid: 1431)
 *
 * Event description: when users click on any general clicks in the bo.
 *
 * @param {tableReservationsClicksParams} params - The parameters for this event
 * @property {string} tabName - reservation / requests , tables/table_combinations , if there are no tabs on this pagethen null
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationId - -
 * @property {string} actionName - table / + /- / edit_floor_plan / legend /  duplicate / delete / online_availability / top_add_table_button / bottom_add_table_button etc.
 * @property {string} pageName - -
 * @property {string} placement - button placement name
 * @property {boolean} isTablet - true/false
 * @return {LogObject<tableReservationsClicksParams>} LogObject<tableReservationsClicksParams>
 */
export function tableReservationsClicks(params) {
    return { evid: 1431, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsSettingsReservationsPaymentsModal' event (evid: 1432)
 *
 * Event description: When a user clicks on any action inside the 'set reservation payment' modal
 *
 * @param {tableReservationsSettingsReservationsPaymentsModalParams} params - The parameters for this event
 * @property {string} actionName - close / guests_number / fee_per_guest / cancel / save
 * @property {GUID} locationId - -
 * @property {GUID} reservationLocationId - -
 * @property {string} prepaymentType - per guest/per party
 * @property {number} inputValue - the value sent in the action
 * @return {LogObject<tableReservationsSettingsReservationsPaymentsModalParams>} LogObject<tableReservationsSettingsReservationsPaymentsModalParams>
 */
export function tableReservationsSettingsReservationsPaymentsModal(params) {
    return { evid: 1432, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsSettingsReservationsPaymentsClickSave' event (evid: 1433)
 *
 * Event description: when the user click on save inside the reservations payments modal
 *  (event will be send after response from the server)
 *
 *
 * @param {tableReservationsSettingsReservationsPaymentsClickSaveParams} params - The parameters for this event
 * @property {boolean} is_successful - True/false
 * @property {GUID} locationId - -
 * @property {GUID} reservationLocationId - -
 * @property {number} partySize - number of guests the payment will apply from
 * @property {number} chargeFee - fee per guests the payment will be calculated based on
 * @property {string} prepaymentType - prepaymentType
 * @return {LogObject<tableReservationsSettingsReservationsPaymentsClickSaveParams>} LogObject<tableReservationsSettingsReservationsPaymentsClickSaveParams>
 */
export function tableReservationsSettingsReservationsPaymentsClickSave(params) {
    return { evid: 1433, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsReservationActionClickSrc159Evid1434' event (evid: 1434)
 *
 * Event description: when users click on any of the options in the clickable options in the reservation
 *
 * @param {tableReservationsReservationActionClickSrc159Evid1434Params} params - The parameters for this event
 * @property {string} tabName - reservation / requests
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationId - -
 * @property {string} actionName - view request / view reservation / message guest / view order
 * @property {string} pageName - -
 * @property {string} modalType - reservation/request
 * @property {string} placement - element placement
 * @property {boolean} isTablet - true/false
 * @return {LogObject<tableReservationsReservationActionClickSrc159Evid1434Params>} LogObject<tableReservationsReservationActionClickSrc159Evid1434Params>
 */
export function tableReservationsReservationActionClickSrc159Evid1434(params) {
    return { evid: 1434, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'trMobileModalLoadedSrc159Evid1435' event (evid: 1435)
 *
 * Event description: send when modal loaded in owner app (reservation actions and etc)
 *
 * @param {trMobileModalLoadedSrc159Evid1435Params} params - The parameters for this event
 * @property {GUID} locationId - location id
 * @property {GUID} reservationLocationId - reservation location id
 * @property {string} pageName - pageName
 * @property {string} modalName - modal name
 * @return {LogObject<trMobileModalLoadedSrc159Evid1435Params>} LogObject<trMobileModalLoadedSrc159Evid1435Params>
 */
export function trMobileModalLoadedSrc159Evid1435(params) {
    return { evid: 1435, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowCreatedCustomMenuSrc159Evid144' event (evid: 144)
 *
 * Event description: when the chat AI Created custom menu
 *
 * @param {menusChatAiInstallationFlowCreatedCustomMenuSrc159Evid144Params} params - The parameters for this event
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} menuId - -
 * @return {LogObject<menusChatAiInstallationFlowCreatedCustomMenuSrc159Evid144Params>} LogObject<menusChatAiInstallationFlowCreatedCustomMenuSrc159Evid144Params>
 */
export function menusChatAiInstallationFlowCreatedCustomMenuSrc159Evid144(params) {
    return { evid: 144, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsTableManagementClickSave' event (evid: 1443)
 *
 * Event description: click on save changes in table management settings.
 *
 * Please notice the field 'table_management_mode' that determine if the site is using table and in which mode, and then the other fields if relevant.
 *
 * @param {tableReservationSettingsTableManagementClickSaveParams} params - The parameters for this event
 * @property {number} totalSeats - -
 * @property {number} numTables - -
 * @property {number} numNewCombinations - only the new tables from this session
 * @property {GUID} reservationLocationId - -
 * @property {number} numDuplicatedTablesInSession - -
 * @property {string} tablesListActions - json of {action:.. , before:.., after:...,} action can be “change”/”add”/”delete” and before and after are the names of the table +min and max party size
 * @property {GUID} locationId - -
 * @property {number} numNewTables - only the new tables from this session
 * @property {boolean} isSuccessful - true / false
 * @property {number} numCombinations - -
 * @property {number} numOnlineTables - -
 * @property {number} totalNewSeats - only the new tables from this session
 * @property {number} numOnlineCombinations - -
 * @property {string} tableManagementMode - on/ off/ in_house_only
 * @return {LogObject<tableReservationSettingsTableManagementClickSaveParams>} LogObject<tableReservationSettingsTableManagementClickSaveParams>
 */
export function tableReservationSettingsTableManagementClickSave(params) {
    return { evid: 1443, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowCreatedCustomSectionsSrc159Evid145' event (evid: 145)
 *
 * Event description: when the chat AI Created custom sections
 *
 * @param {menusChatAiInstallationFlowCreatedCustomSectionsSrc159Evid145Params} params - The parameters for this event
 * @property {number} numSections - -
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {string} sectionsIds - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} menuId - -
 * @return {LogObject<menusChatAiInstallationFlowCreatedCustomSectionsSrc159Evid145Params>} LogObject<menusChatAiInstallationFlowCreatedCustomSectionsSrc159Evid145Params>
 */
export function menusChatAiInstallationFlowCreatedCustomSectionsSrc159Evid145(params) {
    return { evid: 145, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationCreateReservationSucceedSrc159Evid1450' event (evid: 1450)
 *
 * Event description: create reservation succeeds
 *
 * @param {tableReservationCreateReservationSucceedSrc159Evid1450Params} params - The parameters for this event
 * @property {boolean} isTableOverbooked - true/false (only for user reservations)
 * @property {string} paymentStatus - "UNKNOWN" for live site, "FREE"/"NOT_PAID" for BM during reservation creation, "PAID"/... for BM during reservation edit
 * @property {string} assignTableNames - array of table names in combination
 * @property {GUID} reservationId - -
 * @property {DateTime} reservationStartDate - start time of the reservation
 * @property {string} additionalDetails - json of the additional fields
 * @property {number} numAdditionalDetailsMandatory - -
 * @property {GUID} reservationLocationId - -
 * @property {string} statusBefore - null / RESERVED / HELD / SEATED etc.
 * @property {string} origin - preview_mode/ live_site_mode / business_manager_mode
 * @property {GUID} locationId - -
 * @property {boolean} mailChecked - when the uou is check/uncheck this checkbox
 * @property {GUID} contactId - -
 * @property {number} numGuestDetailEmpty - -
 * @property {DateTime} creationDate - creation time of the event
 * @property {number} numAdditionalDetailsEmpty - -
 * @property {boolean} teamMessageEmpty - True if its empty and false if not
 * @property {string} reservationType - reservation/walk_in
 * @property {number} numAdditionalDetailsFull - -
 * @property {DateTime} reservationDuration - the duration of the reservation - in A milli second
 * @property {string} statusCurrent - RESERVED / HELD / SEATED / PAYMENT_PENDING etc.
 * @property {string} assignTableIds - array
 * @property {number} partySize - -
 * @property {number} numGuestDetailFull - -
 * @property {string} teamMessage - json of the text
 * @property {string} saveType - created/edit
 * @property {boolean} isCardTokenization - is reservation use card Tokenization
 * @return {LogObject<tableReservationCreateReservationSucceedSrc159Evid1450Params>} LogObject<tableReservationCreateReservationSucceedSrc159Evid1450Params>
 */
export function tableReservationCreateReservationSucceedSrc159Evid1450(params) {
    return { evid: 1450, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsPageToggleActionSrc159Evid1451' event (evid: 1451)
 *
 * Event description: when the user clicks on the toggle (toggle - if online reservations are on)
 * action type - what is the toggle status after the user action
 * last toggle state - the toggle status before the user action
 *
 * @param {tableReservationSettingsPageToggleActionSrc159Evid1451Params} params - The parameters for this event
 * @property {string} previousToggleState - toggle_off/ toggle_on
 * @property {GUID} reservationLocationId - -
 * @property {string} actionType - toggle_off/ toggle_on
 * @property {GUID} locationId - -
 * @return {LogObject<tableReservationSettingsPageToggleActionSrc159Evid1451Params>} LogObject<tableReservationSettingsPageToggleActionSrc159Evid1451Params>
 */
export function tableReservationSettingsPageToggleActionSrc159Evid1451(params) {
    return { evid: 1451, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsReservationFormClickSave' event (evid: 1453)
 *
 * Event description: click on save changes on reservation form settings, event will be send after a response from the server.
 *
 * @param {tableReservationSettingsReservationFormClickSaveParams} params - The parameters for this event
 * @property {string} emailMarketingCheckByDeafult - checked / unchecked
 * @property {string} privacyPolicyType - text/url/null
 * @property {string} customFieldsText - json with the text and +mandatory if it is
 * @property {string} customMessageToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {string} customMessageText - json
 * @property {string} emailMandatoryToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {number} numMandatoryFileds - -
 * @property {string} reservationPoliciesToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {GUID} reservationLocationId - -
 * @property {number} numCustomFields - -
 * @property {string} privacyPolicy - checked / unchecked
 * @property {string} lastNameMandatoryToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {string} termsCondType - text/url/null
 * @property {GUID} locationId - -
 * @property {string} termsAndConditionsText - json of the text
 * @property {string} emailMarketingCheckboxToggle - toggle_on / toggle_off (value after the user clicked)
 * @property {string} privacyPolicyText - json of the text
 * @property {boolean} isSuccessful - true / false
 * @property {string} policiesTermsCond - checked / unchecked
 * @return {LogObject<tableReservationSettingsReservationFormClickSaveParams>} LogObject<tableReservationSettingsReservationFormClickSaveParams>
 */
export function tableReservationSettingsReservationFormClickSave(params) {
    return { evid: 1453, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsCancelationSucceed' event (evid: 1454)
 *
 * Event description: reservation cancelation succeed by UoU
 *
 * @param {tableReservationsCancelationSucceedParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {DateTime} datetime - -
 * @property {GUID} reservationLocationId - -
 * @property {string} reservationStatus - HELD / REQUESTED / RESERVED
 * @property {string} origin - preview / live_site
 * @property {GUID} locationId - -
 * @property {number} partySize - -
 * @return {LogObject<tableReservationsCancelationSucceedParams>} LogObject<tableReservationsCancelationSucceedParams>
 */
export function tableReservationsCancelationSucceed(params) {
    return { evid: 1454, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsClickOnReservationsAttribute' event (evid: 1455)
 *
 * Event description: UoU clicked on any of the reservation fields
 *
 * @param {tableReservationsClickOnReservationsAttributeParams} params - The parameters for this event
 * @property {GUID} reservationLocationId - -
 * @property {string} fieldName - time / date / party_size / location
 * @property {string} origin - live_site_mode / preview_mode
 * @property {GUID} locationId - -
 * @property {boolean} isAddOn - true / false
 * @property {string} type - for example -page/widget/ mobile_section
 * @property {boolean} isMultiLocation - true if the site has more than one location
 * @return {LogObject<tableReservationsClickOnReservationsAttributeParams>} LogObject<tableReservationsClickOnReservationsAttributeParams>
 */
export function tableReservationsClickOnReservationsAttribute(params) {
    return { evid: 1455, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsBoReservationsModalOpenedSrc159Evid1456' event (evid: 1456)
 *
 * Event description: modal of creating reservations is opened (loaded)
 *
 * @param {tableReservationsBoReservationsModalOpenedSrc159Evid1456Params} params - The parameters for this event
 * @property {string} modalType - reservation/request
 * @property {GUID} reservationId - null if there is no reservation id
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_view / reservations_list_view
 * @property {GUID} locationId - -
 * @property {string} reservationType - reservation / walk_in
 * @property {string} type - create / edit
 * @property {string} referralSource - source the tab was opened from
 * @return {LogObject<tableReservationsBoReservationsModalOpenedSrc159Evid1456Params>} LogObject<tableReservationsBoReservationsModalOpenedSrc159Evid1456Params>
 */
export function tableReservationsBoReservationsModalOpenedSrc159Evid1456(params) {
    return { evid: 1456, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalSrc159Evid1459' event (evid: 1459)
 *
 * Event description: when the modal is loaded when user tries to move to another tab after he made changes and didn't save
 *
 * @param {restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalSrc159Evid1459Params} params - The parameters for this event
 * @property {string} tabName - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationId - -
 * @return {LogObject<restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalSrc159Evid1459Params>} LogObject<restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalSrc159Evid1459Params>
 */
export function restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalSrc159Evid1459(params) {
    return { evid: 1459, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowCreatedCustomItemsSrc159Evid146' event (evid: 146)
 *
 * Event description: when the chat AI Created custom items
 *
 * @param {menusChatAiInstallationFlowCreatedCustomItemsSrc159Evid146Params} params - The parameters for this event
 * @property {number} numSections - -
 * @property {string} errorMessage - if there are some errors
 * @property {GUID} flowId - -
 * @property {number} numItems - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} menuId - -
 * @property {string} itemsIds - -
 * @return {LogObject<menusChatAiInstallationFlowCreatedCustomItemsSrc159Evid146Params>} LogObject<menusChatAiInstallationFlowCreatedCustomItemsSrc159Evid146Params>
 */
export function menusChatAiInstallationFlowCreatedCustomItemsSrc159Evid146(params) {
    return { evid: 146, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsTableManagementTableObjectCreatedSrc159Evid1460' event (evid: 1460)
 *
 * Event description: when the user creases new object of table/ table combination. triggered after a response from the server if successful or not.
 *
 * @param {restaurantsTableReservationsSettingsTableManagementTableObjectCreatedSrc159Evid1460Params} params - The parameters for this event
 * @property {number} minSeats - -
 * @property {GUID} reservationLocationId - -
 * @property {string} viewType - floor_plan_editor / table_management
 * @property {boolean} isAvailableOnline - true / false
 * @property {GUID} locationId - -
 * @property {string} objectId - tabel id or combination id
 * @property {string} type - tables / tables_combination
 * @property {boolean} isSuccessful - true / false
 * @property {number} maxSeats - -
 * @property {number} numTablesInCombination - number of tables inside the combination
 * @property {string} objectName - table / combination name
 * @property {boolean} isTablet - true/false
 * @return {LogObject<restaurantsTableReservationsSettingsTableManagementTableObjectCreatedSrc159Evid1460Params>} LogObject<restaurantsTableReservationsSettingsTableManagementTableObjectCreatedSrc159Evid1460Params>
 */
export function restaurantsTableReservationsSettingsTableManagementTableObjectCreatedSrc159Evid1460(params) {
    return { evid: 1460, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationMoreButtonActionSrc159Evid1461' event (evid: 1461)
 *
 * Event description: User clicked on an option inside of the more button clickable list
 *
 * @param {tableReservationMoreButtonActionSrc159Evid1461Params} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} action - The specific action
 * @return {LogObject<tableReservationMoreButtonActionSrc159Evid1461Params>} LogObject<tableReservationMoreButtonActionSrc159Evid1461Params>
 */
export function tableReservationMoreButtonActionSrc159Evid1461(params) {
    return { evid: 1461, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusImportMenusActions' event (evid: 147)
 *
 * Event description: when a user clicks on one of the buttons in the import menu from old menus app flow.
 *
 * @param {menusImportMenusActionsParams} params - The parameters for this event
 * @property {string} origin - if the import still in progress - 'import menus' , if there was an error - 'import menus error'
 * @property {string} pageName - -
 * @property {string} action - the specific action was made
 * @property {string} modalState - indicates the step of the modal in the flow
 * @return {LogObject<menusImportMenusActionsParams>} LogObject<menusImportMenusActionsParams>
 */
export function menusImportMenusActions(params) {
    return { evid: 147, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusShowHideItemAction' event (evid: 148)
 *
 * Event description: User clicked on show or hide item
 *
 * @param {menusShowHideItemActionParams} params - The parameters for this event
 * @property {string} name - item name
 * @property {string} origin - a button/area from where the action originated from.
 * @property {string} errorDescription - text that describes the error reason
 * @property {GUID} sectionId - Section ID. Unique id in a site level
 * @property {GUID} itemId - Item ID. Unique id in a site level
 * @property {string} pageName - -
 * @property {boolean} isSharedItem - -
 * @property {boolean} isSuccessful - states if the save was successful.
 * @property {string} action - show/hide
 * @return {LogObject<menusShowHideItemActionParams>} LogObject<menusShowHideItemActionParams>
 */
export function menusShowHideItemAction(params) {
    return { evid: 148, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsLiveSiteEditorPreviewLocationNavigationClickSrc159Evid149' event (evid: 149)
 *
 * Event description: User clicked on a navigation button in the live site/preview mode of the menus app widget. This navigation switches between locations .
 *
 * @param {restaurantsLiveSiteEditorPreviewLocationNavigationClickSrc159Evid149Params} params - The parameters for this event
 * @property {string} widgetId - An ID for the widget
 * @property {number} numMenus - The number of menus presented in the horizontal menu
 * @property {string} widgetName - The widget's name
 * @property {string} menuNavigation - Tabs / Dropdown
 * @property {string} pageName - name of the page in live site/editor
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {number} numberOfLocations - only what available on the location picker
 * @property {boolean} isDefultLocation - is the selected location the user clicked on is the default location
 * @property {GUID} locationId - the location the user clicked on
 * @property {GUID} previousLocationId - the current location_id (from where the user did the select location click)
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {string} locationName - the name of the target location
 * @property {string} previousLocationName - -
 * @property {boolean} isOoi - -
 * @return {LogObject<restaurantsLiveSiteEditorPreviewLocationNavigationClickSrc159Evid149Params>} LogObject<restaurantsLiveSiteEditorPreviewLocationNavigationClickSrc159Evid149Params>
 */
export function restaurantsLiveSiteEditorPreviewLocationNavigationClickSrc159Evid149(params) {
    return { evid: 149, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsEditorPanelEditAction' event (evid: 15)
 *
 * Event description: User makes a change in the design of a restaurants editor widget, this event sends data of the full path of the desired change in design
 *
 * @param {restaurantsEditorPanelEditActionParams} params - The parameters for this event
 * @property {string} widgetId - an id for the specific widget
 * @property {string} lastLevel - The last and most detailed level , i.e : color picker/ fonts/themes/etc…
 * If there is only a first level then the last and first level will send the same value.
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} widgetName - widget_name
 * @property {string} panelName - panel name
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {string} firstLevel - The first navigation level, i.e : menu title/ section title/ labels/ etc…
 * @property {string} widgetInstanceId - Id of the widget inside editor or live site. This id is supposed to be unique for a site and widget
 * @property {GUID} msid - msid
 * @property {string} value - most commonly paired with a field column, and the value is the acutal value related to that field
 * @property {string} fullPath - The complete level path for example : fill color & opacity, background, color picker
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsEditorPanelEditActionParams>} LogObject<restaurantsEditorPanelEditActionParams>
 */
export function restaurantsEditorPanelEditAction(params) {
    return { evid: 15, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsUouStartOfReservationFunnelClickOnFindATable' event (evid: 1506)
 *
 * Event description: clicks of UoU in the beginning of the funnel
 *
 * @param {tableReservationsUouStartOfReservationFunnelClickOnFindATableParams} params - The parameters for this event
 * @property {DateTime} datetime - -
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - previe_mode/live_site_mode
 * @property {GUID} locationId - -
 * @property {boolean} isAddOn - true if its a click from the add on and false if not
 * @property {number} partySize - -
 * @property {boolean} isMultiLocation - consider only live site available locations
 * @return {LogObject<tableReservationsUouStartOfReservationFunnelClickOnFindATableParams>} LogObject<tableReservationsUouStartOfReservationFunnelClickOnFindATableParams>
 */
export function tableReservationsUouStartOfReservationFunnelClickOnFindATable(params) {
    return { evid: 1506, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusModifierGroupModalIsOpened' event (evid: 151)
 *
 * Event description: Modifier Group modal is opened
 *
 * @param {menusModifierGroupModalIsOpenedParams} params - The parameters for this event
 * @property {string} name - name of the modifier group
 * @property {boolean} isMandatory - true/false
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate etc
 * @property {number} maxSelections - max_selections
 * @property {string} errorType - The type of the error - validtion/ server/ etc...
 * @property {GUID} id - Modifier group id
 * @property {string} modifierGroupId - only if it’s not null (in the updates)
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} modifiers - json array of modifiers
 * @property {number} minSelections - min_selections
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {GUID} itemId - Item ID of the item the modifier were saved in
 * @property {string} pageName - name of the page
 * @property {number} numPreselectedModifiers - num preselected modifiers
 * @property {string} type - optional/mandatory sinces Nov23. before - SINGLE_SELECT/ MULTI_SELECT/UNSPECIFIED_RULE_TYPE
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {boolean} isNoLimit - true/false
 * @property {number} maxChoices - maximum number of extras the customer can choose. Relevant to mulitSelection only
 * @return {LogObject<menusModifierGroupModalIsOpenedParams>} LogObject<menusModifierGroupModalIsOpenedParams>
 */
export function menusModifierGroupModalIsOpened(params) {
    return { evid: 151, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnCompleteReservation' event (evid: 1515)
 *
 * Event description: click on complete reservation - in order to make sure that reservations was done use condition - "num_invalid_fields = 0"
 *
 * @param {tableReservationsUouClickOnCompleteReservationParams} params - The parameters for this event
 * @property {string} mailCheckbox - check/uncheck
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - previe_mode/live_site_mode
 * @property {GUID} locationId - -
 * @property {number} numInvaldFields - -
 * @property {string} contactId - -
 * @property {number} partySize - -
 * @property {number} numValidFields - -
 * @property {DateTime} dateTimeValue - of the reservation
 * @property {string} areaCode - -
 * @return {LogObject<tableReservationsUouClickOnCompleteReservationParams>} LogObject<tableReservationsUouClickOnCompleteReservationParams>
 */
export function tableReservationsUouClickOnCompleteReservation(params) {
    return { evid: 1515, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusItemModifierGroupsModalSaveReorder' event (evid: 152)
 *
 * Event description: when the user changes the order of the modifier groups in the item
 *
 * @param {menusItemModifierGroupsModalSaveReorderParams} params - The parameters for this event
 * @property {string} idsOrderListAfterChange - list of ids
 * @property {number} numModifierGroups - -
 * @property {string} orderListBeforeChange - list of modifier groups names
 * @property {string} orderListAfterChange - list of modifier groups names
 * @property {string} idsOrderListBeforeChange - list of ids
 * @return {LogObject<menusItemModifierGroupsModalSaveReorderParams>} LogObject<menusItemModifierGroupsModalSaveReorderParams>
 */
export function menusItemModifierGroupsModalSaveReorder(params) {
    return { evid: 152, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnReserveNow' event (evid: 1524)
 *
 * Event description: in the reservations page, event is triggered when UoU click on “reserve now” button that triggered the next page / or in members app on the requested time
 *
 * @param {tableReservationsUouClickOnReserveNowParams} params - The parameters for this event
 * @property {GUID} reservationLocationId - -
 * @property {DateTime} requestedDate - timestamp contains date and time.
 * @property {string} origin - previe_mode/live_site_mode
 * @property {GUID} locationId - -
 * @property {number} partySize - -
 * @return {LogObject<tableReservationsUouClickOnReserveNowParams>} LogObject<tableReservationsUouClickOnReserveNowParams>
 */
export function tableReservationsUouClickOnReserveNow(params) {
    return { evid: 1524, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoaded' event (evid: 1525)
 *
 * Event description: when the UoU see the reservations page/widget
 *
 * @param {tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoadedParams} params - The parameters for this event
 * @property {string} origin - previe_mode/live_site_mode
 * @property {boolean} isAddOn - true if its a click from the add on and false if not. for mobile - null
 * @property {string} type - page/widget/ mobile_section
 * @return {LogObject<tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoadedParams>} LogObject<tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoadedParams>
 */
export function tableReservationsUouStartOfReservationFunnelReservationPageWidgetIsLoaded(params) {
    return { evid: 1525, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnChangeReservationDetails' event (evid: 1526)
 *
 * Event description: after UoU pressed on reserve, he pressed on the 'change' the reservation details option
 *
 * @param {tableReservationsUouClickOnChangeReservationDetailsParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {GUID} reservationLocationId - -
 * @property {string} reservationStatus - 'HELD'- reservation | 'null' - request
 * @property {string} origin - preview / live_site
 * @property {GUID} locationId - -
 * @return {LogObject<tableReservationsUouClickOnChangeReservationDetailsParams>} LogObject<tableReservationsUouClickOnChangeReservationDetailsParams>
 */
export function tableReservationsUouClickOnChangeReservationDetails(params) {
    return { evid: 1526, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnAddToCalendar' event (evid: 1527)
 *
 * Event description: when UoU pressed on add reservation to calendar, after response from the server if the save was successful
 *
 * @param {tableReservationsUouClickOnAddToCalendarParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - preview / live_site_mode / spaces_app / branded_app / dine
 * @property {GUID} locationId - -
 * @property {boolean} isSuccessful - true if the reservation was saved in calendar successfully
 * @return {LogObject<tableReservationsUouClickOnAddToCalendarParams>} LogObject<tableReservationsUouClickOnAddToCalendarParams>
 */
export function tableReservationsUouClickOnAddToCalendar(params) {
    return { evid: 1527, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsUouClickOnRestaurantDetailsLink' event (evid: 1528)
 *
 * Event description: after the UoU has completed the reservation, fires when he clicks on one of the restaurant details links
 *
 * @param {tableReservationsUouClickOnRestaurantDetailsLinkParams} params - The parameters for this event
 * @property {GUID} reservationId - -
 * @property {GUID} reservationLocationId - -
 * @property {string} origin - preview / live_site_mode / spaces_app / branded_app / dine
 * @property {GUID} locationId - -
 * @property {string} action - website / phone / location
 * @return {LogObject<tableReservationsUouClickOnRestaurantDetailsLinkParams>} LogObject<tableReservationsUouClickOnRestaurantDetailsLinkParams>
 */
export function tableReservationsUouClickOnRestaurantDetailsLink(params) {
    return { evid: 1528, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusItemPageAddExistingModifierGroupToItem' event (evid: 153)
 *
 * Event description: when user use the reusable feature and add existing modifier group to an item
 *
 * @param {menusItemPageAddExistingModifierGroupToItemParams} params - The parameters for this event
 * @property {number} numModifierGroupsAdded - -
 * @property {string} itemId - -
 * @property {string} modifierGroupList - -
 * @property {string} itemName - -
 * @property {string} modifierGroupIds - -
 * @return {LogObject<menusItemPageAddExistingModifierGroupToItemParams>} LogObject<menusItemPageAddExistingModifierGroupToItemParams>
 */
export function menusItemPageAddExistingModifierGroupToItem(params) {
    return { evid: 153, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorMenuNavigationPanelAction' event (evid: 154)
 *
 * Event description: User clicked on a button inside the choose menu navigation panel that made a difference in the menu navigation design.
 *
 * @param {menusEditorMenuNavigationPanelActionParams} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} widgetInstanceId - -
 * @property {string} action - Tabs / Dropdown
 * @return {LogObject<menusEditorMenuNavigationPanelActionParams>} LogObject<menusEditorMenuNavigationPanelActionParams>
 */
export function menusEditorMenuNavigationPanelAction(params) {
    return { evid: 154, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusGenericEventInMobileSrc159Evid155' event (evid: 155)
 *
 * Event description: some general clicks inside the menu mobile pages
 *
 * @param {menusGenericEventInMobileSrc159Evid155Params} params - The parameters for this event
 * @property {string} field - -
 * @property {string} actionType - scroll/click / modal_load/start_typing
 * @property {string} pageName - name of the page
 * @property {string} refferal_info - additional info that required sometimes
 * @property {string} value - -
 * @property {string} origin - a button/area from where the action originated from
 * @property {string} menuId - -
 * @property {string} sectionId - -
 * @property {string} itemId - -
 * @return {LogObject<menusGenericEventInMobileSrc159Evid155Params>} LogObject<menusGenericEventInMobileSrc159Evid155Params>
 */
export function menusGenericEventInMobileSrc159Evid155(params) {
    return { evid: 155, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusMainPageAddObjectClickSrc159Evid156' event (evid: 156)
 *
 * Event description: User clicked on the option to add a new object
 *
 * @param {menusMainPageAddObjectClickSrc159Evid156Params} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} type - menu /item etc.
 * @property {string} pageName - name of the page
 * @return {LogObject<menusMainPageAddObjectClickSrc159Evid156Params>} LogObject<menusMainPageAddObjectClickSrc159Evid156Params>
 */
export function menusMainPageAddObjectClickSrc159Evid156(params) {
    return { evid: 156, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSaveModifierSrc159Evid157' event (evid: 157)
 *
 * Event description: User clicked on save modifier.
 * The user got a response from the server if it was saved successfully or not
 *
 * @param {menusSaveModifierSrc159Evid157Params} params - The parameters for this event
 * @property {string} name - name of the modifier
 * @property {string} flowType - which flow type the modal/panel is at. New/Edit/Duplicate / Reusable etc
 * @property {string} modifierGroupId - only if it’s not null (in the updates)
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} errorDescription - text that describes the error reason
 *
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - states if the save was succesful. if not there sould be an error description column
 * @property {GUID} modifierId - -
 * @property {string} changedFields - what fields were changed in this “update” event?
 * @property {boolean} inStock - Is the modifier in stock
 *
 * @return {LogObject<menusSaveModifierSrc159Evid157Params>} LogObject<menusSaveModifierSrc159Evid157Params>
 */
export function menusSaveModifierSrc159Evid157(params) {
    return { evid: 157, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusBulkOutOfStockSrc159Evid158' event (evid: 158)
 *
 * Event description: When a user uses the bulk out of stock / back in stock in order to change this status for  multiple items
 *
 * @param {menusBulkOutOfStockSrc159Evid158Params} params - The parameters for this event
 * @property {string} pageName - name of the page
 * @property {string} itemsIds - array of all the ids that were deleted with the bulk
 * @property {string} action - out of stock/ in stock
 * @property {number} itemsCount - -
 * @property {boolean} isSuccessful - -
 * @return {LogObject<menusBulkOutOfStockSrc159Evid158Params>} LogObject<menusBulkOutOfStockSrc159Evid158Params>
 */
export function menusBulkOutOfStockSrc159Evid158(params) {
    return { evid: 158, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusInlineActionSrc159Evid159' event (evid: 159)
 *
 * Event description: User trigger an action 'inline' an object
 *
 * @param {menusInlineActionSrc159Evid159Params} params - The parameters for this event
 * @property {string} pageName - name of the page
 * @property {string} action - the specific action was made - for example
 * @property {string} type - the type of object, for example: item,section,menu etc
 * @property {boolean} isSuccessful - -
 * @return {LogObject<menusInlineActionSrc159Evid159Params>} LogObject<menusInlineActionSrc159Evid159Params>
 */
export function menusInlineActionSrc159Evid159(params) {
    return { evid: 159, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsModalLoad' event (evid: 16)
 *
 * Event description: A modal loaded inside one of restaurants' apps
 *
 * @param {restaurantsModalLoadParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} refferal_info - additional data that you want to send and don't have a field for that
 * @property {string} modalName - modal name, naming convention: product.modal-name for example, menus.delete-section
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId - locationId
 * @property {boolean} isDeletedLocation - isDeletedLocation
 * @property {string} operationStatus - hidden/visible.
 * the status before the status update approval
 * @property {string} operationId - operationId
 * @property {GUID} operationGroup - operationGroup
 * @property {boolean} isDefaultLocation - isDefaultLocation
 * @return {LogObject<restaurantsModalLoadParams>} LogObject<restaurantsModalLoadParams>
 */
export function restaurantsModalLoad(params) {
    return { evid: 16, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusBulkAssignItemsToMenuSrc159Evid160' event (evid: 160)
 *
 * Event description: When a user uses the bulk assign to section in a menu of several items
 *
 * @param {menusBulkAssignItemsToMenuSrc159Evid160Params} params - The parameters for this event
 * @property {string} errorDescription - If the action failed. error description
 * @property {string} itemsIds - array of all the ids that were assigned
 * @property {string} pageName - name of the page
 * @property {boolean} isSuccessful - Did the action occurred successfully
 * @property {string} sectionId - selected section by the user
 * @property {string} menuId - selected menu by the user
 * @property {number} itemsCount - number of items in the bulk action
 * @return {LogObject<menusBulkAssignItemsToMenuSrc159Evid160Params>} LogObject<menusBulkAssignItemsToMenuSrc159Evid160Params>
 */
export function menusBulkAssignItemsToMenuSrc159Evid160(params) {
    return { evid: 160, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusAssignItemsModalSrc159Evid161' event (evid: 161)
 *
 * Event description: this event is trigger from the assign item to menu modal
 *
 * @param {menusAssignItemsModalSrc159Evid161Params} params - The parameters for this event
 * @property {string} itemId - the selected item. if multiple then null
 * @property {boolean} isBulk - -
 * @property {string} itemsIds - the selected items. if one then null
 * @property {string} action - back/ cancel / x / save/ section / menu
 * @property {string} modalName - assign to menu / assign to section
 * @property {string} sectionId - the selected section. null if it is the menu stage
 * @property {string} sectionName - the selected section. null if it is the menu stage
 * @property {string} menuId - the selected menu
 * @property {string} menuName - the selected menu
 * @return {LogObject<menusAssignItemsModalSrc159Evid161Params>} LogObject<menusAssignItemsModalSrc159Evid161Params>
 */
export function menusAssignItemsModalSrc159Evid161(params) {
    return { evid: 161, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusLimitationModalSrc159Evid162' event (evid: 162)
 *
 * Event description: this event is trigger once the limitation modal has opened
 *
 * @param {menusLimitationModalSrc159Evid162Params} params - The parameters for this event
 * @property {string} sectionId - the selected section. if multiple then null
 * @property {string} modalName - item limit modal / section limit modal
 * @property {string} menuId - the selected menu
 * @property {string} referralInfo - the entry point the object was added from - move section / move item / inline / add new header
 * @property {string} object - item/ section
 * @property {string} pageName - menu / items
 * @return {LogObject<menusLimitationModalSrc159Evid162Params>} LogObject<menusLimitationModalSrc159Evid162Params>
 */
export function menusLimitationModalSrc159Evid162(params) {
    return { evid: 162, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusShowHideSectionActionSrc159Evid163' event (evid: 163)
 *
 * Event description: User clicked on show or hide section
 *
 * @param {menusShowHideSectionActionSrc159Evid163Params} params - The parameters for this event
 * @property {string} name - section name
 * @property {string} origin - section more actions / section header
 * @property {string} errorDescription - text that describes the error reason
 * @property {GUID} sectionId - Section ID. Unique id in a site level
 * @property {string} pageName - -
 * @property {boolean} isSuccessful - states if the save was successful.
 * @property {string} action - show/hide
 * @property {GUID} menuId - -
 * @return {LogObject<menusShowHideSectionActionSrc159Evid163Params>} LogObject<menusShowHideSectionActionSrc159Evid163Params>
 */
export function menusShowHideSectionActionSrc159Evid163(params) {
    return { evid: 163, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSortFilterActionSrc159Evid164' event (evid: 164)
 *
 * Event description: User clicked on sort by / filter by. Event will be sent when the user has changed the value and set a new one.
 *
 * @param {menusSortFilterActionSrc159Evid164Params} params - The parameters for this event
 * @property {string} sortBy - oldest/newest/name ascending/ name descending
 * @property {string} pageName - -
 * @property {string} filterBy - all menus / deaft/publish
 * @property {GUID} locationId - -
 * @property {string} action - sort/filter
 * @return {LogObject<menusSortFilterActionSrc159Evid164Params>} LogObject<menusSortFilterActionSrc159Evid164Params>
 */
export function menusSortFilterActionSrc159Evid164(params) {
    return { evid: 164, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationEditorDisplayTabSrc159Evid1642' event (evid: 1642)
 *
 * Event description: User Open the Display tab in the table reservations page settings in the editor.
 * Event is being sent when tab is closed with the changes the user has set.
 *
 * @param {tableReservationEditorDisplayTabSrc159Evid1642Params} params - The parameters for this event
 * @property {string} action - field name - title / description / none / null (user hasn't change anything)
 * @property {string} slotsBeahvior - deprecated
 * @property {boolean} is_add_on - is add on panel / reservations page panel
 * @property {string} value - value of action
 * @return {LogObject<tableReservationEditorDisplayTabSrc159Evid1642Params>} LogObject<tableReservationEditorDisplayTabSrc159Evid1642Params>
 */
export function tableReservationEditorDisplayTabSrc159Evid1642(params) {
    return { evid: 1642, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusItemsPageHoverCopySrc159Evid165' event (evid: 165)
 *
 * Event description: User click on one of the clickable options in the items page.
 *
 * @param {menusItemsPageHoverCopySrc159Evid165Params} params - The parameters for this event
 * @property {string} id - the id of the item/variant/modifier (should use with the type field)
 * @property {string} action - edit variant / delete variant etc.
 * @property {string} tabName - items/variants/modifier groups/ modifiers
 * @return {LogObject<menusItemsPageHoverCopySrc159Evid165Params>} LogObject<menusItemsPageHoverCopySrc159Evid165Params>
 */
export function menusItemsPageHoverCopySrc159Evid165(params) {
    return { evid: 165, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorSettingsPanelActionSrc159Evid166' event (evid: 166)
 *
 * Event description: User clicked on a button inside the manage menus tab in the editor settings panel
 *
 * @param {menusEditorSettingsPanelActionSrc159Evid166Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} widgetInstanceId - -
 * @property {string} action - -
 * @property {string} tabName - -
 * @return {LogObject<menusEditorSettingsPanelActionSrc159Evid166Params>} LogObject<menusEditorSettingsPanelActionSrc159Evid166Params>
 */
export function menusEditorSettingsPanelActionSrc159Evid166(params) {
    return { evid: 166, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorSettingsPanelTabSwitchSrc159Evid167' event (evid: 167)
 *
 * Event description: User clicked on one of the tabs inside the settings panel.
 *
 * @param {menusEditorSettingsPanelTabSwitchSrc159Evid167Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} currentTab - -
 * @property {string} targetTab - -
 * @return {LogObject<menusEditorSettingsPanelTabSwitchSrc159Evid167Params>} LogObject<menusEditorSettingsPanelTabSwitchSrc159Evid167Params>
 */
export function menusEditorSettingsPanelTabSwitchSrc159Evid167(params) {
    return { evid: 167, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorSettingsPanelLayoutTabSrc159Evid168' event (evid: 168)
 *
 * Event description: User edited the layout tab. The event will be triggered when the user switch tab/ closed the panel, with the current state.
 *
 * @param {menusEditorSettingsPanelLayoutTabSrc159Evid168Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} widgetInstanceId - -
 * @property {string} layoutName - grid / columns/ center
 * @property {string} menusListNavigation - -
 * @property {string} menuLayout - -
 * @property {string} layoutSettings - -
 * @property {string} sectionLayout - -
 * @property {string} itemLayout - -
 * @property {string} itemImage - -
 * @property {string} imagePosition - right/left
 * @return {LogObject<menusEditorSettingsPanelLayoutTabSrc159Evid168Params>} LogObject<menusEditorSettingsPanelLayoutTabSrc159Evid168Params>
 */
export function menusEditorSettingsPanelLayoutTabSrc159Evid168(params) {
    return { evid: 168, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorSettingsPanelMenusTabSrc159Evid169' event (evid: 169)
 *
 * Event description: User clicked on the options to display specific menus inside the panel. Please trigger the bi event when the panel is closed/ moved to another tab.
 *
 * @param {menusEditorSettingsPanelMenusTabSrc159Evid169Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} menusDisplay - show all menus / show specific menus
 * @property {string} menusIds - -
 * @property {string} numberOfVisibleMenus - -
 * @return {LogObject<menusEditorSettingsPanelMenusTabSrc159Evid169Params>} LogObject<menusEditorSettingsPanelMenusTabSrc159Evid169Params>
 */
export function menusEditorSettingsPanelMenusTabSrc159Evid169(params) {
    return { evid: 169, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsModalClose' event (evid: 17)
 *
 * Event description: A user closed one of restaurants modals
 *
 * @param {restaurantsModalCloseParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} modalName - modal name, naming convention: product.modal-name for example, menus.delete-section
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsModalCloseParams>} LogObject<restaurantsModalCloseParams>
 */
export function restaurantsModalClose(params) {
    return { evid: 17, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusInstallationSrc159Evid170' event (evid: 170)
 *
 * Event description: BI-event is trigger when the app is installed
 *
 * @param {menusInstallationSrc159Evid170Params} params - The parameters for this event
 * @property {boolean} isOoi - -
 * @property {boolean} isSuccessful - -
 * @property {GUID} msid - -
 * @property {string} flow - null / upgrade to OOI / add page
 * @return {LogObject<menusInstallationSrc159Evid170Params>} LogObject<menusInstallationSrc159Evid170Params>
 */
export function menusInstallationSrc159Evid170(params) {
    return { evid: 170, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusUpgradeToOoiClickSrc159Evid171' event (evid: 171)
 *
 * Event description: BI-event is trigger when the user has pressed on upgrade to the new OOI app.
 *
 * @param {menusUpgradeToOoiClickSrc159Evid171Params} params - The parameters for this event
 * @property {boolean} isSuccessful - -
 * @property {GUID} msid - -
 * @property {string} failReason - -
 * @return {LogObject<menusUpgradeToOoiClickSrc159Evid171Params>} LogObject<menusUpgradeToOoiClickSrc159Evid171Params>
 */
export function menusUpgradeToOoiClickSrc159Evid171(params) {
    return { evid: 171, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorSettingsPanelDisplayTabSrc159Evid172' event (evid: 172)
 *
 * Event description: User clicked on the options to display specific menus inside the panel. Please trigger the bi event when the panel is closed/ moved to another tab.
 *
 * @param {menusEditorSettingsPanelDisplayTabSrc159Evid172Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {boolean} isMenuNavigation - -
 * @property {string} displayValues - string of the checked name and descriptions by object
 * @property {boolean} isPricingOptions - is toggle on
 * @property {boolean} isPlaceholderImage - is toggle on
 * @return {LogObject<menusEditorSettingsPanelDisplayTabSrc159Evid172Params>} LogObject<menusEditorSettingsPanelDisplayTabSrc159Evid172Params>
 */
export function menusEditorSettingsPanelDisplayTabSrc159Evid172(params) {
    return { evid: 172, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiGenerateOptionsSrc159Evid173' event (evid: 173)
 *
 * Event description: User clicked on the generate option of the style AI after filling the menu style description.
 *
 * @param {menusEditorStyleAiGenerateOptionsSrc159Evid173Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} menusIds - -
 * @property {boolean} keepSiteTheme - if the user chose to keep the site theme (palete)
 * @property {string} userDescription - free text the user wrote (the prompt)
 * @property {string} promptIds - string of up to three prompts
 * @property {string} inputsForFirstPrompt - -
 * @property {string} inputsForSecondPrompt - -
 * @property {string} inputsForThirdPrompt - -
 * @property {GUID} styleAiFlowId - -
 * @return {LogObject<menusEditorStyleAiGenerateOptionsSrc159Evid173Params>} LogObject<menusEditorStyleAiGenerateOptionsSrc159Evid173Params>
 */
export function menusEditorStyleAiGenerateOptionsSrc159Evid173(params) {
    return { evid: 173, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiOptionsLoadedSrc159Evid174' event (evid: 174)
 *
 * Event description: modal with the style ai options was loaded
 *
 * @param {menusEditorStyleAiOptionsLoadedSrc159Evid174Params} params - The parameters for this event
 * @property {string} firstPromptOutputFirstPart - -
 * @property {string} firstPromptOutputSecondPart - -
 * @property {string} firstPromptOutputThirdPart - -
 * @property {string} secondPromptOutputFirstPart - -
 * @property {string} secondPromptOutputSecondPart - -
 * @property {string} secondPromptOutputThirdPart - -
 * @property {string} thirdPromptOutputFirstPart - -
 * @property {string} thirdPromptOutputSecondPart - -
 * @property {string} thirdPromptOutputThirdPart - -
 * @property {string} error - -
 * @property {string} menuIds - -
 * @property {GUID} styleAiFlowId - -
 * @return {LogObject<menusEditorStyleAiOptionsLoadedSrc159Evid174Params>} LogObject<menusEditorStyleAiOptionsLoadedSrc159Evid174Params>
 */
export function menusEditorStyleAiOptionsLoadedSrc159Evid174(params) {
    return { evid: 174, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiGenerateMenuActionSrc159Evid175' event (evid: 175)
 *
 * Event description: This event is trigger on the modal with the options of the style AI, when the user click on Done
 *
 * @param {menusEditorStyleAiGenerateMenuActionSrc159Evid175Params} params - The parameters for this event
 * @property {string} selectedPrompt_id - -
 * @property {string} menuIds - -
 * @property {GUID} styleAiFlowId - -
 * @return {LogObject<menusEditorStyleAiGenerateMenuActionSrc159Evid175Params>} LogObject<menusEditorStyleAiGenerateMenuActionSrc159Evid175Params>
 */
export function menusEditorStyleAiGenerateMenuActionSrc159Evid175(params) {
    return { evid: 175, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiActionInModalSrc159Evid176' event (evid: 176)
 *
 * Event description: User clicked on any of the options in the style AI modal
 *
 * @param {menusEditorStyleAiActionInModalSrc159Evid176Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} menusIds - -
 * @property {GUID} styleAiFlowId - -
 * @property {string} modalState - indicates the step of the modal in the flow
 * @property {string} action - -
 * @return {LogObject<menusEditorStyleAiActionInModalSrc159Evid176Params>} LogObject<menusEditorStyleAiActionInModalSrc159Evid176Params>
 */
export function menusEditorStyleAiActionInModalSrc159Evid176(params) {
    return { evid: 176, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusAppInEditorIndicatorSrc159Evid177' event (evid: 177)
 *
 * Event description: BI-event indicated is the app is OOI /blocks.
 *
 * @param {menusAppInEditorIndicatorSrc159Evid177Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {GUID} msid - -
 * @return {LogObject<menusAppInEditorIndicatorSrc159Evid177Params>} LogObject<menusAppInEditorIndicatorSrc159Evid177Params>
 */
export function menusAppInEditorIndicatorSrc159Evid177(params) {
    return { evid: 177, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsToastLoad' event (evid: 18)
 *
 * Event description: Toast Loaded inside one of restaurants apps (BM/Owners app)
 *
 * @param {restaurantsToastLoadParams} params - The parameters for this event
 * @property {string} toastColor - color of the toast
 * @property {string} toastText - the text that is sent inside the toast
 * @property {boolean} hasCTA - states if the toast contains a CTA button inside of it
 * @property {string} pageName - name of the page
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {string} trigger - what triggered the action. for example an error the triggered a toast load
 * @return {LogObject<restaurantsToastLoadParams>} LogObject<restaurantsToastLoadParams>
 */
export function restaurantsToastLoad(params) {
    return { evid: 18, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsToastClose' event (evid: 19)
 *
 * Event description: User closed a Toast inside one of restaurants apps (BM/Owners app) To trigger this event the user must press actively on a button that closes the toast. It will not fire when the toast closes automatically
 *
 * @param {restaurantsToastCloseParams} params - The parameters for this event
 * @property {string} toastColor - color of the toast
 * @property {string} toastText - the text that is sent inside the toast
 * @property {boolean} hasCTA - states if the toast contains a CTA button inside of it
 * @property {string} pageName - name of the page
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {string} trigger - what triggered the action. for example an error the triggered a toast load
 * @return {LogObject<restaurantsToastCloseParams>} LogObject<restaurantsToastCloseParams>
 */
export function restaurantsToastClose(params) {
    return { evid: 19, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsToastCtaClick' event (evid: 20)
 *
 * Event description: User clicked on a CTA button placed inside a banner in a restaurants' page. Not all banners containg a CTA button
 *
 * @param {restaurantsToastCtaClickParams} params - The parameters for this event
 * @property {string} toastColor - color of the toast
 * @property {string} ctaText - the text that is written on the cta button
 * @property {string} toastText - the text that is sent inside the toast
 * @property {string} pageName - name of the page
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {string} trigger - what triggered the action. for example an error the triggered a toast load
 * @property {GUID} locationId - locationId
 * @return {LogObject<restaurantsToastCtaClickParams>} LogObject<restaurantsToastCtaClickParams>
 */
export function restaurantsToastCtaClick(params) {
    return { evid: 20, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiTestSrc159Evid200' event (evid: 200)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiTestSrc159Evid200Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} settingsValues - Menus
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @return {LogObject<menusEditorStyleAiTestSrc159Evid200Params>} LogObject<menusEditorStyleAiTestSrc159Evid200Params>
 */
export function menusEditorStyleAiTestSrc159Evid200(params) {
    return { evid: 200, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thermalPrintingPageLoad' event (evid: 2001)
 *
 * Event description: A screen related to thermal printing  was loaded
 *
 * @param {thermalPrintingPageLoadParams} params - The parameters for this event
 * @property {boolean} isEmptyState - If the page is in empty state
 * @property {GUID} triggerAppId - The app id of the app that triggered this page load
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} triggerApp - The name of the app that triggered the page load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @return {LogObject<thermalPrintingPageLoadParams>} LogObject<thermalPrintingPageLoadParams>
 */
export function thermalPrintingPageLoad(params) {
    return { evid: 2001, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thermalPrintingSetupScreensNavigationClicks' event (evid: 2002)
 *
 * Event description: User clicked on a navigation action inside the setup process (back,next,done,etc)
 *
 * @param {thermalPrintingSetupScreensNavigationClicksParams} params - The parameters for this event
 * @property {string} buttonType - close,next/back/done/etc...
 * @property {GUID} triggerAppId - The app id of the app that triggered this page load
 * @property {string} destinationPageName - The name of the page the user is directed to from the button action
 * @property {string} triggerApp - The name of the app that triggered the page load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @return {LogObject<thermalPrintingSetupScreensNavigationClicksParams>} LogObject<thermalPrintingSetupScreensNavigationClicksParams>
 */
export function thermalPrintingSetupScreensNavigationClicks(params) {
    return { evid: 2002, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thermalPrintingSetupPickPrinterClick' event (evid: 2003)
 *
 * Event description: User clicked on a printer in the list of available printers
 *
 * @param {thermalPrintingSetupPickPrinterClickParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {number} numOfAvailablePrinters - number of available printers
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @return {LogObject<thermalPrintingSetupPickPrinterClickParams>} LogObject<thermalPrintingSetupPickPrinterClickParams>
 */
export function thermalPrintingSetupPickPrinterClick(params) {
    return { evid: 2003, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thermalPrintingSetupPrinterConnection' event (evid: 2004)
 *
 * Event description: After the user chooses the printer it wants to connect and presses next, this event fires after getting the response from the printer if it succeeded to connect
 *
 * @param {thermalPrintingSetupPrinterConnectionParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {string} errorType - type of error: server/printer/etc...
 * @property {string} errorDescription - if there is a more detailed explanation to the error, it will appear here
 * @property {boolean} isSuccessful - did the connection succeed
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @property {string} origin - stores/rest
 * @return {LogObject<thermalPrintingSetupPrinterConnectionParams>} LogObject<thermalPrintingSetupPrinterConnectionParams>
 */
export function thermalPrintingSetupPrinterConnection(params) {
    return { evid: 2004, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thermalPrintingPrintTestOrder' event (evid: 2005)
 *
 * Event description: User tried to make a test print
 *
 * @param {thermalPrintingPrintTestOrderParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {string} triggerAppId - the app id of the app that this action occurred in
 * @property {string} errorType - type of error: server/printer/etc...
 * @property {string} origin - The origin of the click, for example 'finish setup'
 * @property {string} errorDescription - if there is a more detailed explanation to the error, it will appear here
 * @property {string} triggerApp - the app name of the app that this action occurred in
 * @property {string} pageName - The screen that the action occured in
 * @property {boolean} isSuccessful - did the print succeed
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @return {LogObject<thermalPrintingPrintTestOrderParams>} LogObject<thermalPrintingPrintTestOrderParams>
 */
export function thermalPrintingPrintTestOrder(params) {
    return { evid: 2005, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thermalPrintingPrint' event (evid: 2006)
 *
 * Event description: Print was made, from all sources (except for test prints)
 *
 * @param {thermalPrintingPrintParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {string} errorType - type of error: server/printer/etc...
 * @property {string} id - This id should be paired with the "type" field
 * @property {string} errorDescription - if there is a more detailed explanation to the error, it will appear here
 * @property {string} type - The type of object being printed. For example: "order"
 * @property {string} appId - app id of the the app that triggered the print
 * @property {boolean} isSuccessful - did the print succeed
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field. For example for restaurants there can be printType in the extra params that says if it was manually or auto printed
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @property {string} origin - stores/rest
 * @return {LogObject<thermalPrintingPrintParams>} LogObject<thermalPrintingPrintParams>
 */
export function thermalPrintingPrint(params) {
    return { evid: 2006, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thermalPrintingKbLinkClick' event (evid: 2007)
 *
 * Event description: User clicked on a link to one of the thermal printing KBs
 *
 * @param {thermalPrintingKbLinkClickParams} params - The parameters for this event
 * @property {string} destinationUrl - The url of the KB that the user is being directed to
 * @property {string} origin - the area from which the KB was triggered from
 * @property {string} pageName - name of the screen the link appeared in
 * @property {GUID} appId - app id of an app that is associated with this KB, for example restaurants' orders app id can appear here if the KB is related to it
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @return {LogObject<thermalPrintingKbLinkClickParams>} LogObject<thermalPrintingKbLinkClickParams>
 */
export function thermalPrintingKbLinkClick(params) {
    return { evid: 2007, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thermalPrintingPrinterUnpair' event (evid: 2008)
 *
 * Event description: The user manually unpaired his printer, when combined with evid = 2004 we can check whether there is a printer connected
 *
 * @param {thermalPrintingPrinterUnpairParams} params - The parameters for this event
 * @property {string} printerId - The id of the printer that was chosen
 * @property {string} printerModel - The full printer model name
 * @property {string} extraParams - A json for extra parameters that were not defined. Not a necessary field
 * @property {string} printerBrand - Brand of the printer chosen
 * @property {string} connectionType - bluetooth/wifi
 * @return {LogObject<thermalPrintingPrinterUnpairParams>} LogObject<thermalPrintingPrinterUnpairParams>
 */
export function thermalPrintingPrinterUnpair(params) {
    return { evid: 2008, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiTestCopySrc159Evid201' event (evid: 201)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiTestCopySrc159Evid201Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} settingsValues - Menus
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @return {LogObject<menusEditorStyleAiTestCopySrc159Evid201Params>} LogObject<menusEditorStyleAiTestCopySrc159Evid201Params>
 */
export function menusEditorStyleAiTestCopySrc159Evid201(params) {
    return { evid: 201, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationDataBiEvent' event (evid: 2010)
 *
 * Event description: this event is fired for all sites installed restaurant once
 * location_id
 * is_order_pacing_enabled (toggle on)
 * is_sms_validation_enabled (under advanced page)
 * is_recieved_order_notifications_enabled (at least one enabled notification true/falase)
 * is_recieved_order_notifications_config ((at least one configured notification true/falase) true/falase)
 * recieved_order_type_list
 * is_unhandled_order_notifications_enabled (at least one enabled notification true/falase)
 * is_unhandled_order_notifications_config (at least one configured notification true/false)
 * unhandled_order_type_list
 *
 * @param {migrationDataBiEventParams} params - The parameters for this event
 * @property {boolean} isUnhandledOrderNotificationsEnabled - -
 * @property {boolean} isRecivedOrderNotificationsEnabled - -
 * @property {string} recievedOrderTypeListNotification - -
 * @property {boolean} isOrderPacingEnabled - tur/false
 * @property {boolean} isRecivedOrderNotificationConfig - -
 * @property {boolean} isUnhandledOrderNotificationsConfigured - -
 * @property {boolean} isSmsValidationEnabled - -
 * @property {GUID} locationId - -
 * @property {string} unhandledOrderTypeListNotification - -
 * @property {GUID} msid - -
 * @return {LogObject<migrationDataBiEventParams>} LogObject<migrationDataBiEventParams>
 */
export function migrationDataBiEvent(params) {
    return { evid: 2010, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusCloseAddInlineComponent' event (evid: 2011)
 *
 * Event description: User Closed a side panel inside one of menus app in the business manager.Notice that when a user tries to close the panel while in the middle of editing it opens a 'discard changes modal'. When this happens, this event should not fire! Only once the modal closes this event fires, and if it occures after the user clicked on discard changes, then the origin will be 'discard changes modal'. These can also happen in the owners app parallel screens
 *
 * @param {menusCloseAddInlineComponentParams} params - The parameters for this event
 * @property {string} panelName - panel name
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @return {LogObject<menusCloseAddInlineComponentParams>} LogObject<menusCloseAddInlineComponentParams>
 */
export function menusCloseAddInlineComponent(params) {
    return { evid: 2011, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsCreateOrUpdateReservationSrc159Evid2015' event (evid: 2015)
 *
 * Event description: when a reservation is created or edited or deleted or its status is changed
 *
 *
 * @param {restaurantsTableReservationsCreateOrUpdateReservationSrc159Evid2015Params} params - The parameters for this event
 * @property {DateTime} createdDate - the date when the reservations created for the first time
 * @property {number} customFieldsFilledLength - -
 * @property {DateTime} endDateTs - -
 * @property {boolean} isTeamMessageEmpty - -
 * @property {GUID} locationId - -
 * @property {GUID} reservationLocationId - -
 * @property {boolean} marketingConsent - true/false
 * @property {GUID} meta_site_id - -
 * @property {number} partySize - -
 * @property {GUID} reservationId - -
 * @property {GUID} reserveeContactId - -
 * @property {string} saveType - (“create” (predefine in server autaomatically when user download the app) | “edit” when user edit settings)
 * @property {string} source - OFFLINE/ONLINE/WALK_IN/UNKNOWN
 * @property {DateTime} startDateTs - -
 * @property {string} statusBefore -  (null | “reserved” | “held” | “no_show” | etc.)
 * @property {string} statusCurrent - (“reserved” | “held” | “no_show” | etc.)
 * @property {string} tableIds - list of all the tables that reserved in the reservation
 * @property {number} tableIdsLength - -
 * @property {DateTime} updatedDate -  the time that the action happened on the server
 * @property {string} paymentStatusBefore - 'null' / 'FREE' / 'PAID' / 'NOT_PAID'
 * @property {string} paymentStatusCurrent - 'null' / 'FREE' / 'PAID' / 'NOT_PAID'
 * @property {number} reservationPayment - null if the msid not use 'payment'
 * @return {LogObject<restaurantsTableReservationsCreateOrUpdateReservationSrc159Evid2015Params>} LogObject<restaurantsTableReservationsCreateOrUpdateReservationSrc159Evid2015Params>
 */
export function restaurantsTableReservationsCreateOrUpdateReservationSrc159Evid2015(params) {
    return { evid: 2015, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiTestSrc159Evid202' event (evid: 202)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiTestSrc159Evid202Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} settingsValues - Menus
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @return {LogObject<menusEditorStyleAiTestSrc159Evid202Params>} LogObject<menusEditorStyleAiTestSrc159Evid202Params>
 */
export function menusEditorStyleAiTestSrc159Evid202(params) {
    return { evid: 202, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid203' event (evid: 203)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid203Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} settingsValues1 - Style values part 1
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} settingsValues2 - Style values part 2
 * @property {string} extra - Extra data if needed
 * @return {LogObject<menusEditorStyleAiSrc159Evid203Params>} LogObject<menusEditorStyleAiSrc159Evid203Params>
 */
export function menusEditorStyleAiSrc159Evid203(params) {
    return { evid: 203, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid204' event (evid: 204)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid204Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} settingsValuesFirst - Style values part 1
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} settingsValuesSecond - Style values part 2
 * @property {string} extra - Extra data if needed
 * @return {LogObject<menusEditorStyleAiSrc159Evid204Params>} LogObject<menusEditorStyleAiSrc159Evid204Params>
 */
export function menusEditorStyleAiSrc159Evid204(params) {
    return { evid: 204, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid205' event (evid: 205)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid205Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} settings1 - Style values part 1
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} settings2 - Style values part 2
 * @property {string} extra - Extra data if needed
 * @return {LogObject<menusEditorStyleAiSrc159Evid205Params>} LogObject<menusEditorStyleAiSrc159Evid205Params>
 */
export function menusEditorStyleAiSrc159Evid205(params) {
    return { evid: 205, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid206' event (evid: 206)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid206Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} extra - Extra data if needed
 * @property {string} settingsValuesFirst - Style values part 1
 * @property {string} settingsValuesSecond - Style values part 2
 * @return {LogObject<menusEditorStyleAiSrc159Evid206Params>} LogObject<menusEditorStyleAiSrc159Evid206Params>
 */
export function menusEditorStyleAiSrc159Evid206(params) {
    return { evid: 206, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid207' event (evid: 207)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid207Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} settingsValuesFirst - Style values part 1
 * @property {string} settingsValuesSecond - Style values part 2
 * @property {string} extra - Extra data if needed
 * @return {LogObject<menusEditorStyleAiSrc159Evid207Params>} LogObject<menusEditorStyleAiSrc159Evid207Params>
 */
export function menusEditorStyleAiSrc159Evid207(params) {
    return { evid: 207, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid208' event (evid: 208)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid208Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} settingsValuesFirst - Style values part 1
 * @property {string} settingsValuesSecond - Style values part 2
 * @property {string} extra - Extra data if needed
 * @property {string} settingsValuesThird - Style values part 2
 * @return {LogObject<menusEditorStyleAiSrc159Evid208Params>} LogObject<menusEditorStyleAiSrc159Evid208Params>
 */
export function menusEditorStyleAiSrc159Evid208(params) {
    return { evid: 208, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid209' event (evid: 209)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid209Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} settingsValuesFirst - Style values part 1
 * @property {string} settingsValuesSecond - Style values part 2
 * @property {string} extra - Extra data if needed
 * @property {string} settingsValuesThird - Style values part 3
 * @return {LogObject<menusEditorStyleAiSrc159Evid209Params>} LogObject<menusEditorStyleAiSrc159Evid209Params>
 */
export function menusEditorStyleAiSrc159Evid209(params) {
    return { evid: 209, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsMoreButtonClick' event (evid: 21)
 *
 * Event description: User Clicked on a more button (most commonly seen with a 3 dots design) the event specifis the location it occured in, and send clickable options
 *
 * @param {restaurantsMoreButtonClickParams} params - The parameters for this event
 * @property {string} clickableOptions - an array containing all the clickable option that open when you click on a more button. This does not include gray buttons that are unclickable
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId - -
 * @property {boolean} isDefaultLocation - isDefaultLocation
 * @property {boolean} isDeletedLocation - isDeletedLocation
 * @return {LogObject<restaurantsMoreButtonClickParams>} LogObject<restaurantsMoreButtonClickParams>
 */
export function restaurantsMoreButtonClick(params) {
    return { evid: 21, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid210' event (evid: 210)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid210Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} settingsValuesFirst - Style values part 1
 * @property {string} settingsValuesSecond - Style values part 2
 * @property {string} extra - Extra data if needed
 * @property {string} settingsValuesThird - Style values part 2
 * @property {string} timeTakenToGenerate - Time took to generate the style
 * @return {LogObject<menusEditorStyleAiSrc159Evid210Params>} LogObject<menusEditorStyleAiSrc159Evid210Params>
 */
export function menusEditorStyleAiSrc159Evid210(params) {
    return { evid: 210, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid211' event (evid: 211)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid211Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} settingsValuesFirst - Style values part 1
 * @property {string} settingsValuesSecond - Style values part 2
 * @property {string} extra - Extra data if needed
 * @property {string} settingsValuesThird - Style values part 2
 * @property {string} timeTakenToGenerate - Time took to generate the style
 * @property {string} errors - The errors
 * @return {LogObject<menusEditorStyleAiSrc159Evid211Params>} LogObject<menusEditorStyleAiSrc159Evid211Params>
 */
export function menusEditorStyleAiSrc159Evid211(params) {
    return { evid: 211, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiSrc159Evid212' event (evid: 212)
 *
 * Event description: User used Style AI
 *
 * @param {menusEditorStyleAiSrc159Evid212Params} params - The parameters for this event
 * @property {string} promptId - -
 * @property {boolean} isMenuDescriptionUsed - -
 * @property {string} liveSiteUrl - -
 * @property {string} userInstructions - -
 * @property {boolean} hasError - If an error ocuured
 * @property {string} tag - For filtering
 * @property {string} settingsValuesFirst - Style values part 1
 * @property {string} settingsValuesSecond - Style values part 2
 * @property {string} extra - Extra data if needed
 * @property {string} settingsValuesThird - Style values part 2
 * @property {string} timeTakenToGenerate - Time took to generate the style
 * @property {string} errors - The errors
 * @property {string} numOfKeysWereSet - Number of keys were returned by AI and set
 * @return {LogObject<menusEditorStyleAiSrc159Evid212Params>} LogObject<menusEditorStyleAiSrc159Evid212Params>
 */
export function menusEditorStyleAiSrc159Evid212(params) {
    return { evid: 212, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsBmPageStartedLoading' event (evid: 219)
 *
 * Event description: Page in restaurants app started load loaded
 *
 * @param {restaurantsBmPageStartedLoadingParams} params - The parameters for this event
 * @property {string} referralInfo - The specific trigger that made triggered the page load
 * @property {string} previousPage - The page that was loaded before this one
 * @property {string} pageName - name of the page
 * @property {string} hosting - describes the source the page loaded in, with the following format: the source|site builder type. for example: editor|WIX means that the page was loaded inside the editor pop up window, and the site uses regular editor. For devs: hosting: `${viewMode}|${brand}`                                    viewMode: mobile = native mobile, dashboard = BM, onbaording = ADI, editor = editor.                                                         brand: Wix = ADI/editor, EditorX = EditorX
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<restaurantsBmPageStartedLoadingParams>} LogObject<restaurantsBmPageStartedLoadingParams>
 */
export function restaurantsBmPageStartedLoading(params) {
    return { evid: 219, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsToggleClick' event (evid: 22)
 *
 * Event description: when a user clicks on a toggle and turns it off or turns it on.
 *
 * @param {restaurantsToggleClickParams} params - The parameters for this event
 * @property {string} toggleName - the description of what the toggle is related to
 * @property {string} actionType - toggle_on / toggle_off (value after the user clicked)
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {GUID} locationId
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @return {LogObject<restaurantsToggleClickParams>} LogObject<restaurantsToggleClickParams>
 */
export function restaurantsToggleClick(params) {
    return { evid: 22, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardPageLoadSrc159Evid220' event (evid: 220)
 *
 * Event description: Page in the restaurants app loaded.Note: Owners' app may send parallel pages with the same name. Use browser_family = 'NativeMobile' for Owners' data.
 *
 * @param {dashboardPageLoadSrc159Evid220Params} params - The parameters for this event
 * @property {string} referralInfo - The specific trigger that made triggered the page load
 * @property {string} previousPage - The page that was loaded before this one
 * @property {number} loadingTime - load time in miliseconds
 * @property {string} category - acts like the product field. Legacy from the old events (is inside dashboard page load)
 * @property {string} pageName - name of the page
 * @property {string} hosting - describes the source the page loaded in, with the following format: the source|site builder type. for example: editor|WIX means that the page was loaded inside the editor pop up window, and the site uses regular editor. For devs:  hosting: `${viewMode}|${brand}`.                                      viewMode: mobile = native mobile, dashboard = BM, onbaording = ADI, editor = editor.                                                         brand: Wix = ADI/editor, EditorX = EditorX
 * @property {GUID} locationId - locationId
 * @property {boolean} isDefaultLocation - isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationGroup - operationGroup
 * @property {GUID} operationId - operationId
 * @property {boolean} isDeletedLocation - is deleted location were opened in the page loaded (mainly kanban)
 * @property {number} numoflocations - number of total locations (include hidden and archived)
 *
 * @return {LogObject<dashboardPageLoadSrc159Evid220Params>} LogObject<dashboardPageLoadSrc159Evid220Params>
 */
export function dashboardPageLoadSrc159Evid220(params) {
    return { evid: 220, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTooltipLoad' event (evid: 23)
 *
 * Event description: A Tooltip loaded inside one of restaurants' apps
 *
 * @param {restaurantsTooltipLoadParams} params - The parameters for this event
 * @property {string} tooltipText - What is written inside the tooltip
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a tooltip load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the tooltip loaded in
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsTooltipLoadParams>} LogObject<restaurantsTooltipLoadParams>
 */
export function restaurantsTooltipLoad(params) {
    return { evid: 23, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTooltipCloseClick' event (evid: 24)
 *
 * Event description: User closed a tooltip  inside one of restaurants' apps
 *
 * @param {restaurantsTooltipCloseClickParams} params - The parameters for this event
 * @property {string} tooltipText - What is written inside the tooltip
 * @property {string} pageName - name of the page the tooltip loaded in
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsTooltipCloseClickParams>} LogObject<restaurantsTooltipCloseClickParams>
 */
export function restaurantsTooltipCloseClick(params) {
    return { evid: 24, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsHover' event (evid: 25)
 *
 * Event description: when the user hover on a tooltips / alerts etc.
 *
 * @param {restaurantsHoverParams} params - The parameters for this event
 * @property {string} tabName - if there are no tabs then null
 * @property {string} hoverType - the name of the hover button
 * @property {string} pageName - name of the page the hover is in
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsHoverParams>} LogObject<restaurantsHoverParams>
 */
export function restaurantsHover(params) {
    return { evid: 25, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsBannerLoad' event (evid: 26)
 *
 * Event description: A Banner loaded inside one of restaurants' apps
 *
 * @param {restaurantsBannerLoadParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page the modal loaded in
 * @property {string} bannerName - banner name, naming convention: product.banner-name for example, menus.delete-section
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsBannerLoadParams>} LogObject<restaurantsBannerLoadParams>
 */
export function restaurantsBannerLoad(params) {
    return { evid: 26, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsLiveSiteErrors' event (evid: 27)
 *
 * Event description: when there are errors in live site
 *
 * @param {restaurantsLiveSiteErrorsParams} params - The parameters for this event
 * @property {string} screenName - -
 * @property {string} errorMessage - -
 * @property {string} context - depends on what the dev wants to put here
 * @property {string} operationId - -
 * @return {LogObject<restaurantsLiveSiteErrorsParams>} LogObject<restaurantsLiveSiteErrorsParams>
 */
export function restaurantsLiveSiteErrors(params) {
    return { evid: 27, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiGenerateOptionsCopySrc159Evid273' event (evid: 273)
 *
 * Event description: User clicked on the generate option of the style AI after filling the menu style description.
 *
 * @param {menusEditorStyleAiGenerateOptionsCopySrc159Evid273Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} menusIds - -
 * @property {boolean} keepSiteTheme - if the user chose to keep the site theme (palete)
 * @property {string} userDescription - free text the user wrote (the prompt)
 * @property {string} promptIds - string of up to three prompts
 * @property {string} inputsForFirstPrompt - -
 * @property {string} inputsForSecondPrompt - -
 * @property {string} inputsForThirdPrompt - -
 * @property {GUID} styleAiFlowId - -
 * @property {string} inputsForForthPrompt - -
 * @property {string} inputsForFifthPrompt - -
 * @return {LogObject<menusEditorStyleAiGenerateOptionsCopySrc159Evid273Params>} LogObject<menusEditorStyleAiGenerateOptionsCopySrc159Evid273Params>
 */
export function menusEditorStyleAiGenerateOptionsCopySrc159Evid273(params) {
    return { evid: 273, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiOptionsLoadedCopySrc159Evid274' event (evid: 274)
 *
 * Event description: modal with the style ai options was loaded
 *
 * @param {menusEditorStyleAiOptionsLoadedCopySrc159Evid274Params} params - The parameters for this event
 * @property {string} firstPromptOutputFirstPart - -
 * @property {string} firstPromptOutputSecondPart - -
 * @property {string} firstPromptOutputThirdPart - -
 * @property {string} secondPromptOutputFirstPart - -
 * @property {string} secondPromptOutputSecondPart - -
 * @property {string} secondPromptOutputThirdPart - -
 * @property {string} thirdPromptOutputFirstPart - -
 * @property {string} thirdPromptOutputSecondPart - -
 * @property {string} thirdPromptOutputThirdPart - -
 * @property {string} error - -
 * @property {string} menuIds - -
 * @property {GUID} styleAiFlowId - -
 * @property {string} forthPromptOutputFirstPart - -
 * @property {string} forthPromptOutputThirdPart - -
 * @property {string} forthPromptOutputSecondPart - -
 * @property {string} fifthPromptOutputFirstPart - -
 * @property {string} fifthPromptOutputThirdPart - -
 * @property {string} fifthPromptOutputSecondPart - -
 * @return {LogObject<menusEditorStyleAiOptionsLoadedCopySrc159Evid274Params>} LogObject<menusEditorStyleAiOptionsLoadedCopySrc159Evid274Params>
 */
export function menusEditorStyleAiOptionsLoadedCopySrc159Evid274(params) {
    return { evid: 274, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiActionInModalCopySrc159Evid276' event (evid: 276)
 *
 * Event description: User clicked on any of the options in the style AI modal
 *
 * @param {menusEditorStyleAiActionInModalCopySrc159Evid276Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} menusIds - -
 * @property {GUID} styleAiFlowId - -
 * @property {string} modalState - indicates the step of the modal in the flow
 * @property {string} action - -
 * @return {LogObject<menusEditorStyleAiActionInModalCopySrc159Evid276Params>} LogObject<menusEditorStyleAiActionInModalCopySrc159Evid276Params>
 */
export function menusEditorStyleAiActionInModalCopySrc159Evid276(params) {
    return { evid: 276, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsEditorSitePagesAndMenuTabSelection' event (evid: 28)
 *
 * Event description: When a restaurants' tab is loaded inside the Site pages and Menu side panel inside the Editor, this event fires.
 * For example, if a user clicks on one of the site's pages, and gets inside the SEO Basics, the event will fire, and point in the tabName field "seo basics"
 *
 * @param {restaurantsEditorSitePagesAndMenuTabSelectionParams} params - The parameters for this event
 * @property {string} tabName - The editor tab name, for example SEO basic
 * @property {string} pageId - The id of the site builder page the action occurred in
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} sitePageName - Name of the page inside the live site/editor. This is something the user can edit
 * @property {GUID} msid - msid
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {boolean} isOoi - -
 * @return {LogObject<restaurantsEditorSitePagesAndMenuTabSelectionParams>} LogObject<restaurantsEditorSitePagesAndMenuTabSelectionParams>
 */
export function restaurantsEditorSitePagesAndMenuTabSelection(params) {
    return { evid: 28, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsEditorSitePagesAndMenuDeletePageAndApp' event (evid: 29)
 *
 * Event description: When a restaurants' tab is loaded inside the Site pages and Menu side panel inside the Editor, and the user press on delete the app from.
 *
 * @param {restaurantsEditorSitePagesAndMenuDeletePageAndAppParams} params - The parameters for this event
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {GUID} msid - msid
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @return {LogObject<restaurantsEditorSitePagesAndMenuDeletePageAndAppParams>} LogObject<restaurantsEditorSitePagesAndMenuDeletePageAndAppParams>
 */
export function restaurantsEditorSitePagesAndMenuDeletePageAndApp(params) {
    return { evid: 29, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsUpgradeToPremiumClick' event (evid: 30)
 *
 * Event description: When the user clicked on the 'upgrade' option which leads him to the premium packages page. Please notice this evid is relevant for internal restaurants addition and not to the BM banner.
 *
 * @param {restaurantsUpgradeToPremiumClickParams} params - The parameters for this event
 * @property {string} origin - main page click / after hover and click from the modal that opened
 * @property {string} pageName - -
 * @property {string} product - -
 * @return {LogObject<restaurantsUpgradeToPremiumClickParams>} LogObject<restaurantsUpgradeToPremiumClickParams>
 */
export function restaurantsUpgradeToPremiumClick(params) {
    return { evid: 30, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusGenericEventSrc159Evid31' event (evid: 31)
 *
 * Event description: some general clicks inside the menus product.
 *
 *
 * @param {menusGenericEventSrc159Evid31Params} params - The parameters for this event
 * @property {string} field - what is the area of the clicks? page/scheuling_type_section / asap_only/preorder_only
 * @property {string} actionType - scroll/click / modal_load/start_typing
 * @property {string} pageName - menus / menu / items
 * @property {string} refferal_info - additional info that required sometimes
 * @property {string} value - what is the value (button name/ value) of the click.
 * @property {GUID} locationId - -
 * @property {boolean} isDefaultLocation - -
 * @property {string} modalType - -
 * @return {LogObject<menusGenericEventSrc159Evid31Params>} LogObject<menusGenericEventSrc159Evid31Params>
 */
export function menusGenericEventSrc159Evid31(params) {
    return { evid: 31, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyName' event (evid: 3100)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 3100, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc159Evid3101' event (evid: 3101)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc159Evid3101Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc159Evid3101Params>} LogObject<dummyNameSrc159Evid3101Params>
 */
export function dummyNameSrc159Evid3101(params) {
    return { evid: 3101, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowMenuInstalled' event (evid: 3142)
 *
 * Event description: when the chat AI installed new menu
 *
 * @param {menusChatAiInstallationFlowMenuInstalledParams} params - The parameters for this event
 * @property {string} errorMessage - if there are some errors
 * @property {string} flowId - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} msid - -
 * @property {boolean} isScala - -
 * @return {LogObject<menusChatAiInstallationFlowMenuInstalledParams>} LogObject<menusChatAiInstallationFlowMenuInstalledParams>
 */
export function menusChatAiInstallationFlowMenuInstalled(params) {
    return { evid: 3142, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowDeletedMenuDefaultData' event (evid: 3143)
 *
 * Event description: when the chat AI Deleted menu deafult data
 *
 * @param {menusChatAiInstallationFlowDeletedMenuDefaultDataParams} params - The parameters for this event
 * @property {string} errorMessage - if there are some errors
 * @property {string} flowId - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} msid - -
 * @property {boolean} isScala - -
 * @return {LogObject<menusChatAiInstallationFlowDeletedMenuDefaultDataParams>} LogObject<menusChatAiInstallationFlowDeletedMenuDefaultDataParams>
 */
export function menusChatAiInstallationFlowDeletedMenuDefaultData(params) {
    return { evid: 3143, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowCreatedCustomMenu' event (evid: 3144)
 *
 * Event description: when the chat AI Created custom menu
 *
 * @param {menusChatAiInstallationFlowCreatedCustomMenuParams} params - The parameters for this event
 * @property {string} errorMessage - if there are some errors
 * @property {string} flowId - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} menuId - -
 * @property {GUID} msid - -
 * @property {boolean} isScala - -
 * @return {LogObject<menusChatAiInstallationFlowCreatedCustomMenuParams>} LogObject<menusChatAiInstallationFlowCreatedCustomMenuParams>
 */
export function menusChatAiInstallationFlowCreatedCustomMenu(params) {
    return { evid: 3144, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowCreatedCustomSections' event (evid: 3145)
 *
 * Event description: when the chat AI Created custom sections
 *
 * @param {menusChatAiInstallationFlowCreatedCustomSectionsParams} params - The parameters for this event
 * @property {number} numSections - -
 * @property {string} errorMessage - if there are some errors
 * @property {string} flowId - -
 * @property {string} sectionsIds - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} menuId - -
 * @property {GUID} msid - -
 * @property {boolean} isScala - -
 * @return {LogObject<menusChatAiInstallationFlowCreatedCustomSectionsParams>} LogObject<menusChatAiInstallationFlowCreatedCustomSectionsParams>
 */
export function menusChatAiInstallationFlowCreatedCustomSections(params) {
    return { evid: 3145, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusChatAiInstallationFlowCreatedCustomItems' event (evid: 3146)
 *
 * Event description: when the chat AI Created custom items
 *
 * @param {menusChatAiInstallationFlowCreatedCustomItemsParams} params - The parameters for this event
 * @property {number} numSections - -
 * @property {string} errorMessage - if there are some errors
 * @property {string} flowId - -
 * @property {number} numItems - -
 * @property {boolean} isSuccessful - True/false
 * @property {GUID} menuId - -
 * @property {GUID} msid - -
 * @property {string} itemsIds - -
 * @property {boolean} isScala - -
 * @return {LogObject<menusChatAiInstallationFlowCreatedCustomItemsParams>} LogObject<menusChatAiInstallationFlowCreatedCustomItemsParams>
 */
export function menusChatAiInstallationFlowCreatedCustomItems(params) {
    return { evid: 3146, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverImportMenusFromOldMenusAppServerless' event (evid: 3150)
 *
 * Event description: Fires each time a user start the process of import a menu / menus from the old app
 *
 * @param {serverImportMenusFromOldMenusAppServerlessParams} params - The parameters for this event
 * @property {number} menusCount - how many menus were impoert
 * @property {string} menuIds - array of the menu ids that were import (old menus ids)
 * @property {string} failReason - if import succeeded then null
 * @property {string} organizationId - from the old menu app
 * @property {boolean} isSuccessful - true if the import process ended successfully. false if it failed
 * @property {GUID} msid - -
 * @return {LogObject<serverImportMenusFromOldMenusAppServerlessParams>} LogObject<serverImportMenusFromOldMenusAppServerlessParams>
 */
export function serverImportMenusFromOldMenusAppServerless(params) {
    return { evid: 3150, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsChangesChangesOnlySrc159Evid3601' event (evid: 3601)
 *
 * Event description: all changes in the settings of table reservations will be sent in this event. fields that didn't changed will be null.
 *
 * @param {restaurantsTableReservationsSettingsChangesChangesOnlySrc159Evid3601Params} params - The parameters for this event
 * @property {boolean} manualApproval - true if toggle is on. false if toggle is off.
 * @property {string} privacyPolicyType - url / text/null
 * @property {GUID} seatingMapId - map id is unique for location. Null for no connected seating map
 * @property {boolean} marketingConsentEnabled - true/false/null
 * @property {boolean} partyPacingEnabled - true/false/null
 * @property {string} minReservationNoticeUnit - (minutes / days/hours)
 * @property {number} partyPacing - -
 * @property {number} numSeats - total max seats
 * @property {number} minPartiesSize - -
 * @property {number} seatPacing - (guests pacing)
 * @property {number} numTables - total
 * @property {GUID} meta_site_id - -
 * @property {boolean} submitMessageExists - true (if its not null ) /false (otherwise)
 * @property {GUID} reservationLocationId - -
 * @property {number} minReservationNoticeNumber - -
 * @property {boolean} seatPacingEnabled - (guests pacing) true/false/null
 * @property {string} tableCombinations - combinations of more than one table fro reservations. Array of {id, table_ids: string[], seats_min, seats_max}
 * @property {boolean} showPhoneNumber - true/false
 * @property {number} maxPartiesSize - -
 * @property {boolean} policiesEnabled - true/false
 * @property {number} manualApprovalPartySize - the minimum party size that requires manual approval
 * @property {GUID} locationId - -
 * @property {string} termsAndConditionsType - url / text/null
 * @property {number} customFieldsLength - how many custom fields
 * @property {boolean} termsAndConditions - true/false/null. (can be saved as false also when the toggle is off and also can be null if the user never turn on the toggle)
 * @property {boolean} onlineReservationsEnabled - true/false
 * @property {boolean} lastNameRequired - true/false
 * @property {boolean} marketingConsentEnabledByDefault - (it will be false also when the user enabled the marketing for the first time but doesn’t click on the checkbox )
 * @property {boolean} emailRequired - true/false
 * @property {number} defualtTurnoverTime - -
 * @property {string} availabilityType - “opening_hours” | “custom_hours”
 * @property {number} numCombinations - -
 * @property {string} scheduleList - when choosing custom hours -there will be array of such objects {"openDay":"SUNDAY","openTime":"00:00","closeDay":"MONDAY","closeTime":"00:00"}
 * @property {number} numOnlineTables - -
 * @property {DateTime} updatedDate - the time that the action actually changed on the server side
 * @property {string} tables - -
 * @property {boolean} reservationPrivacyPolicy - true/false/null
 * @property {number} numOnlineCombinations - -
 * @property {number} reservationPaymentValue - the fee requires per guest. 'null' if payment feature is not defined.
 * @property {number} reservationPaymentMinPartySize - the minimum party size that requires a payment. 'null' if payment feature is not defined.
 * @property {string} currency - currency for payment feature
 * @return {LogObject<restaurantsTableReservationsSettingsChangesChangesOnlySrc159Evid3601Params>} LogObject<restaurantsTableReservationsSettingsChangesChangesOnlySrc159Evid3601Params>
 */
export function restaurantsTableReservationsSettingsChangesChangesOnlySrc159Evid3601(params) {
    return { evid: 3601, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsChangesWholePictureOfSettings' event (evid: 3602)
 *
 * Event description: all changes in the settings of table reservations will be sent in this event and also the whole picture of all the fields event if they didn't changed
 *
 * @param {restaurantsTableReservationsSettingsChangesWholePictureOfSettingsParams} params - The parameters for this event
 * @property {boolean} manualApproval - true if toggle is on. false if toggle is off.
 * @property {string} privacyPolicyType - -
 * @property {GUID} seatingMapId - map id is unique for location. Null for no connected seating map
 * @property {boolean} marketingConsentEnabled - -
 * @property {boolean} partyPacingEnabled - -
 * @property {string} minReservationNoticeUnit - (minutes / days/hours)
 * @property {number} partyPacing - -
 * @property {number} numSeats - total max seats
 * @property {number} minPartiesSize - -
 * @property {number} seatPacing - (guests pacing)
 * @property {number} numTables - total
 * @property {GUID} meta_site_id - -
 * @property {boolean} submitMessageExists - True (if its not null ) /false (otherwise)
 * @property {GUID} reservationLocationId - -
 * @property {number} minReservationNoticeNumber - -
 * @property {boolean} seatPacingEnabled - (guests pacing) true/false/null
 * @property {string} tableCombinations - combinations of more than one table fro reservations. Array of {id, table_ids: string[], seats_min, seats_max}
 * @property {boolean} showPhoneNumber - true/false
 * @property {number} maxPartiesSize - -
 * @property {boolean} policiesEnabled - true/false
 * @property {number} manualApprovalPartySize - the minimum party size that requires manual approval
 * @property {GUID} locationId - -
 * @property {string} termsAndConditionsType - url / text/null
 * @property {number} customFieldsLength - how many custom fields
 * @property {boolean} termsAndConditions - true/false/null. (can be saved as false also when the toggle is off and also can be null if the user never turn on the toggle)
 * @property {boolean} onlineReservationsEnabled - true/false
 * @property {boolean} lastNameRequired - -
 * @property {boolean} marketingConsentEnabledByDefault - -
 * @property {boolean} emailRequired - true/false
 * @property {number} defualtTurnoverTime - in minutes
 * @property {string} availabilityType - “opening_hours” | “custom_hours”
 * @property {number} numCombinations - -
 * @property {string} scheduleList - when choosing custom hours - there will be array of such objects {"openDay":"SUNDAY","openTime":"00:00","closeDay":"MONDAY","closeTime":"00:00"}
 * @property {number} numOnlineTables - -
 * @property {DateTime} updatedDate - the time that the action actually changed on the server side
 * @property {string} tables - -
 * @property {boolean} reservationPrivacyPolicy - true/false/null
 * @property {DateTime} createdDate - the time settings created behind the scene when the user downloaded the app
 * @property {number} numOnlineCombinations - -
 * @property {number} reservationPaymentMinPartySize - the minimum party size that requires a payment. 'null' if payment feature is not defined.
 *
 * @property {number} reservationPaymentValue - the fee requires per guest. 'null' if payment feature is not defined.
 *
 * @property {string} currency - currency for payment feature
 * @return {LogObject<restaurantsTableReservationsSettingsChangesWholePictureOfSettingsParams>} LogObject<restaurantsTableReservationsSettingsChangesWholePictureOfSettingsParams>
 */
export function restaurantsTableReservationsSettingsChangesWholePictureOfSettings(params) {
    return { evid: 3602, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc159Evid3603' event (evid: 3603)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc159Evid3603Params} params - The parameters for this event
 * @property {DateTime} endDateTs - end_date_ts
 * @property {number} customFieldsFilledLength - custom_fields_filled_length
 * @property {GUID} reservationId - reservation_guid
 * @property {boolean} isTeamMessageEmpty - is_team_message_empty
 * @property {string} tableIds - table_ids
 * @property {DateTime} startDateTs - start_date_ts
 * @property {GUID} meta_site_id - msid
 * @property {GUID} reservationLocationId - reservation_location_id
 * @property {string} statusBefore - status_before
 * @property {GUID} locationId - locationid
 * @property {GUID} reserveeContactId - reservee_contact_id
 * @property {number} tableIdsLength - table_ids_length
 * @property {string} statusCurrent - status_current
 * @property {number} partySize - party_size
 * @property {DateTime} updatedDate - updated_date
 * @property {boolean} marketingConsent - marketing_consent
 * @property {string} saveType - save_type
 * @property {DateTime} createdDate - created_date
 * @return {LogObject<dummyNameSrc159Evid3603Params>} LogObject<dummyNameSrc159Evid3603Params>
 */
export function dummyNameSrc159Evid3603(params) {
    return { evid: 3603, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsSettingsMigrationPictureOfSettings' event (evid: 3604)
 *
 * Event description: Fires once a site from the old app is being migrated to the new app with the whole picture of the settings in the new app (for ready sites).
 * This event will send fields that are relevant in the old app.
 *
 * @param {tableReservationsSettingsMigrationPictureOfSettingsParams} params - The parameters for this event
 * @property {boolean} manualApproval - true if toggle is on. false if toggle is off.
 * @property {string} privacyPolicyType - -
 * @property {GUID} seatingMapId - -
 * @property {boolean} marketingConsentEnabled - -
 * @property {boolean} partyPacingEnabled - -
 * @property {string} minReservationNoticeUnit - (minutes / days/hours)
 * @property {number} partyPacing - -
 * @property {number} numSeats - -
 * @property {number} minPartiesSize - -
 * @property {number} seatPacing - (guests pacing)
 * @property {number} numTables - -
 * @property {GUID} meta_site_id - msid
 * @property {boolean} submitMessageExists - True (if its not null ) /False (otherwise)
 * @property {GUID} reservationLocationId - -
 * @property {number} minReservationNoticeNumber - -
 * @property {boolean} seatPacingEnabled - (guests pavcng) true/false/null
 * @property {string} tableCombinations - combinations of more than one table fro reservations. Array of {id, table_ids: string[], seats_min, seats_max}
 * @property {boolean} showPhoneNumber - -
 * @property {number} maxPartiesSize - -
 * @property {boolean} policiesEnabled - -
 * @property {number} manualApprovalPartySize - the minimum party size that requires manual approval
 * @property {GUID} locationId - -
 * @property {string} termsAndConditionsType - url / text/null
 * @property {number} customFieldsLength - how many custom fields
 * @property {boolean} termsAndConditions - true/false/null. (can be saved as false also when the toggle is off and also can be null if the user never turn on the toggle)
 * @property {boolean} onlineReservationsEnabled - -
 * @property {boolean} lastNameRequired - true/ false
 * @property {boolean} marketingConsentEnabledByDefault - -
 * @property {boolean} emailRequired - true/ false
 * @property {number} defualtTurnoverTime - in minutes
 * @property {string} availabilityType - “opening_hours” | “custom_hours”
 * @property {number} numCombinations - -
 * @property {string} scheduleList - when choosing custom hours - there will be array of such objects {"openDay":"SUNDAY","openTime":"00:00","closeDay":"MONDAY","closeTime":"00:00"}
 * @property {number} numOnlineTables - -
 * @property {DateTime} updatedDate - -
 * @property {string} tables - -
 * @property {boolean} reservationPrivacyPolicy - true/false/null
 * @property {number} numOnlineCombinations - -
 * @return {LogObject<tableReservationsSettingsMigrationPictureOfSettingsParams>} LogObject<tableReservationsSettingsMigrationPictureOfSettingsParams>
 */
export function tableReservationsSettingsMigrationPictureOfSettings(params) {
    return { evid: 3604, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiGenerateOptionsSrc159Evid373' event (evid: 373)
 *
 * Event description: User clicked on the generate option of the style AI after filling the menu style description.
 *
 * @param {menusEditorStyleAiGenerateOptionsSrc159Evid373Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} menusIds - -
 * @property {boolean} keepSiteTheme - if the user chose to keep the site theme (palete)
 * @property {string} userDescription - free text the user wrote (the prompt)
 * @property {string} promptIds - string of up to three prompts
 * @property {string} inputsForFirstPrompt - -
 * @property {string} inputsForSecondPrompt - -
 * @property {string} inputsForThirdPrompt - -
 * @property {GUID} styleAiFlowId - -
 * @property {string} inputsForForthPrompt - -
 * @property {string} inputsForFifthPrompt - -
 * @return {LogObject<menusEditorStyleAiGenerateOptionsSrc159Evid373Params>} LogObject<menusEditorStyleAiGenerateOptionsSrc159Evid373Params>
 */
export function menusEditorStyleAiGenerateOptionsSrc159Evid373(params) {
    return { evid: 373, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiOptionLoadedSrc159Evid374' event (evid: 374)
 *
 * Event description: modal with the style ai options was loaded
 *
 * @param {menusEditorStyleAiOptionLoadedSrc159Evid374Params} params - The parameters for this event
 * @property {string} promptOutputFirstPart - -
 * @property {string} promptOutputSecondPart - -
 * @property {string} promptOutputThirdPart - -
 * @property {string} error - -
 * @property {string} menuIds - -
 * @property {GUID} styleAiFlowId - -
 * @property {string} promptId - _
 * @property {string} timeTaken - -
 * @return {LogObject<menusEditorStyleAiOptionLoadedSrc159Evid374Params>} LogObject<menusEditorStyleAiOptionLoadedSrc159Evid374Params>
 */
export function menusEditorStyleAiOptionLoadedSrc159Evid374(params) {
    return { evid: 374, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusEditorStyleAiActionSrc159Evid376' event (evid: 376)
 *
 * Event description: User clicked on any of the options in the style AI modal
 *
 * @param {menusEditorStyleAiActionSrc159Evid376Params} params - The parameters for this event
 * @property {string} widgetId - -
 * @property {string} pageId - -
 * @property {string} widgetName - Menus
 * @property {string} sitePageName - -
 * @property {string} menusIds - -
 * @property {GUID} styleAiFlowId - -
 * @property {string} modalState - indicates the step of the modal in the flow
 * @property {string} action - -
 * @return {LogObject<menusEditorStyleAiActionSrc159Evid376Params>} LogObject<menusEditorStyleAiActionSrc159Evid376Params>
 */
export function menusEditorStyleAiActionSrc159Evid376(params) {
    return { evid: 376, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc159Evid3900' event (evid: 3900)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc159Evid3900Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc159Evid3900Params>} LogObject<dummyNameSrc159Evid3900Params>
 */
export function dummyNameSrc159Evid3900(params) {
    return { evid: 3900, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverCreateMenuItem' event (evid: 401)
 *
 * Event description: Fires each time a menu item is created
 *
 * @param {serverCreateMenuItemParams} params - The parameters for this event
 * @property {string} name - name
 * @property {number} numOfPriceVariations - number of price variations
 * @property {string} source - the source the save action was made from
 * @property {number} maxPriceVariation - maximum price variation
 * @property {string} itemLabels - an array of all the item labels. What is called in the API item tags
 * @property {string} description - description
 * @property {number} price - price in local currency. Notice it is multiplied by 100. need to get currency from site properties
 * @property {number} minPriceVariation - minimum price variation
 * @property {string} itemFullJson - The full json containing the entire item object from the API
 * @property {string} itemId - item id - unique in a site level
 * @property {boolean} isVisible - is the item shown in the live site
 * @property {string} additionalImageUrls - an array of image urls URLs
 * @property {string} imageUrl - main image
 * @property {string} priceVariations - The json array containing all the modifiers ids + their price in this item. Notice that the order of variants matter
 * @property {string} modifierGroups - Json array of all the modifier groups and their modifiers and prices. Notice that there is additional information in the modifier group object
 * @property {GUID} locationId - -
 * @property {string} locationIds - -
 * @return {LogObject<serverCreateMenuItemParams>} LogObject<serverCreateMenuItemParams>
 */
export function serverCreateMenuItem(params) {
    return { evid: 401, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverDeleteMenuItem' event (evid: 402)
 *
 * Event description: Fires each time a menu item is Deleted
 *
 * @param {serverDeleteMenuItemParams} params - The parameters for this event
 * @property {string} name - name
 * @property {number} numOfPriceVariations - number of price variations
 * @property {number} maxPriceVariation - maximum price variation
 * @property {string} itemLabels - an array of all the item labels. What is called in the API item tags
 * @property {string} description - description
 * @property {number} price - price in local currency. Notice it is multiplied by 100. need to get currency from site properties
 * @property {number} minPriceVariation - minimum price variation
 * @property {string} itemFullJson - The full json containing the entire item object from the API
 * @property {string} itemId - item id - unique in a site level
 * @property {boolean} isVisible - is the item shown in the live site
 * @property {string} additionalImageUrls - an array of image urls URLs
 * @property {string} imageUrl - Main image
 * @property {string} priceVariations - The json array containing all the modifiers ids + their price in this item. Notice that the order of variants matter
 * @property {string} modifierGroups - Json array of all the modifier groups and their modifiers and prices. Notice that there is additional information in the modifier group object
 * @return {LogObject<serverDeleteMenuItemParams>} LogObject<serverDeleteMenuItemParams>
 */
export function serverDeleteMenuItem(params) {
    return { evid: 402, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverUpdateMenuItem' event (evid: 403)
 *
 * Event description: Fires each time a menu item is updated. Which means each time the item API is updated
 *
 * @param {serverUpdateMenuItemParams} params - The parameters for this event
 * @property {string} itemChangedFields - Json of all the changed fields
 * @property {string} name - name
 * @property {number} numOfPriceVariations - number of price variations
 * @property {string} source - -
 * @property {number} maxPriceVariation - maximum price variation
 * @property {string} itemLabels - an array of all the item labels. What is called in the API item tags
 * @property {string} description - description
 * @property {number} price - price in local currency. Notice it is multiplied by 100. need to get currency from site properties.
 * @property {number} minPriceVariation - minimum price variation
 * @property {string} itemPrevJson - Json of the item before the update
 * @property {string} itemFullJson - The full json containing the entire item object from the API
 * @property {string} itemId - item id - unique in a site level
 * @property {boolean} isVisible - if the item shown in the live site
 * @property {string} additionalImageUrls - an array of image urls URLs
 * @property {string} imageUrl - main image
 * @property {string} priceVariations - The json array containing all the modifiers ids + their price in this item. Notice that the order of variants matter
 * @property {string} modifierGroups - Json array of all the modifier groups and their modifiers and prices. Notice that there is additional information in the modifier group object
 * @return {LogObject<serverUpdateMenuItemParams>} LogObject<serverUpdateMenuItemParams>
 */
export function serverUpdateMenuItem(params) {
    return { evid: 403, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverImportMenuFromFileSrc159Evid404' event (evid: 404)
 *
 * Event description: Fires each time a user start the process of import a menu from importing a file using AI.
 *
 * @param {serverImportMenuFromFileSrc159Evid404Params} params - The parameters for this event
 * @property {string} failReason - if import succeeded then null
 * @property {string} name - name of the file
 * @property {GUID} menuId - -
 * @property {boolean} isSuccessful - true if the import process ended successfully
 * @property {number} sectionsCount - how many sections were import
 * @property {string} sectionsIds - -
 * @property {number} itemsCount - -
 * @property {string} itemsIds - -
 * @property {GUID} jobId - -
 * @property {string} originalImageId - -
 * @return {LogObject<serverImportMenuFromFileSrc159Evid404Params>} LogObject<serverImportMenuFromFileSrc159Evid404Params>
 */
export function serverImportMenuFromFileSrc159Evid404(params) {
    return { evid: 404, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverExtractMenuFromFileSrc159Evid405' event (evid: 405)
 *
 * Event description: Fires each time a user start the process of import a menu from importing a file using AI.  This event is trigger after the import process but before the menu was saved by the user. (the following event in the flow is 159:404)
 *
 * @param {serverExtractMenuFromFileSrc159Evid405Params} params - The parameters for this event
 * @property {string} failReason - if import succeeded then null
 * @property {number} cost - cost of the process in microcents
 * @property {string} fileType - pdf / jpeg / png
 * @property {number} executionTime - -
 * @property {boolean} isSuccessful - -
 * @property {GUID} jobId - -
 * @property {string} originalImageId - -
 * @property {string} originalImageUrl - -
 * @property {string} model - -
 * @return {LogObject<serverExtractMenuFromFileSrc159Evid405Params>} LogObject<serverExtractMenuFromFileSrc159Evid405Params>
 */
export function serverExtractMenuFromFileSrc159Evid405(params) {
    return { evid: 405, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverCreateMenuSection' event (evid: 411)
 *
 * Event description: Fires each time a menu section is created
 *
 * @param {serverCreateMenuSectionParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} description - description
 * @property {string} itemIds - Array of item ids in this section in the correct order!
 * @property {string} sectionId - section id - unique in a site level
 * @property {boolean} isVisible - is the item shown in the live site
 * @property {string} sectionFullJson - The full json containing the entire section object from the API
 * @property {string} additionalImageUrls - an array of image urls URLs
 * @property {string} imageUrl - Main image
 * @return {LogObject<serverCreateMenuSectionParams>} LogObject<serverCreateMenuSectionParams>
 */
export function serverCreateMenuSection(params) {
    return { evid: 411, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverDeleteMenuSection' event (evid: 412)
 *
 * Event description: Fires each time a menu section is deleted.
 *
 * @param {serverDeleteMenuSectionParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} description - description
 * @property {string} itemIds - Array of item ids in this section in the correct order!
 * @property {string} sectionId - section id - unique in a site level
 * @property {boolean} isVisible - is the item shown in the live site
 * @property {string} sectionFullJson - The full json containing the entire section object from the API
 * @property {string} additionalImageUrls - an array of image urls URLs
 * @property {string} imageUrl - Main image
 * @return {LogObject<serverDeleteMenuSectionParams>} LogObject<serverDeleteMenuSectionParams>
 */
export function serverDeleteMenuSection(params) {
    return { evid: 412, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverUpdateMenuSection' event (evid: 413)
 *
 * Event description: Fires each time a menu section is updated, aka each time the API of a specific section is updated. Including actions like reorder items
 *
 * @param {serverUpdateMenuSectionParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} sectionChangedFields - Json of all the changed fields
 * @property {string} description - description
 * @property {string} sectionPrevJson - Json of the section before the update
 * @property {string} itemIds - Array of item ids in this section in the correct order!
 * @property {string} sectionId - section id - unique in a site level
 * @property {boolean} isVisible - is the item shown in the live site
 * @property {string} sectionFullJson - The full json containing the entire section object from the API
 * @property {string} additionalImageUrls - an array of image urls URLs
 * @property {string} imageUrl - Main image
 * @return {LogObject<serverUpdateMenuSectionParams>} LogObject<serverUpdateMenuSectionParams>
 */
export function serverUpdateMenuSection(params) {
    return { evid: 413, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverCreateMenu' event (evid: 421)
 *
 * Event description: Fires each time a menu is created
 *
 * @param {serverCreateMenuParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} imageUrls - an array of image urls URLs
 * @property {string} sectionIds - Array of section ids in this section in the correct order!
 * @property {string} menuFullJson - The full json containing the entire menu object from the API
 * @property {string} description - description
 * @property {boolean} isVisible - is the menu shown in the live site
 * @property {string} additionalImageUrls - an array of image urls URLs
 * @property {GUID} menuId - menu id - unique in a site level
 * @property {string} imageUrl - Main image
 * @return {LogObject<serverCreateMenuParams>} LogObject<serverCreateMenuParams>
 */
export function serverCreateMenu(params) {
    return { evid: 421, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverDeleteMenu' event (evid: 422)
 *
 * Event description: Fires each time a menu is deleted
 *
 * @param {serverDeleteMenuParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} sectionIds - Array of section ids in this section in the correct order!
 * @property {string} menuFullJson - The full json containing the entire menu object from the API
 * @property {string} description - description
 * @property {boolean} isVisible - is the menu shown in the live site
 * @property {string} additionalImageUrls - an array of image urls URLs
 * @property {GUID} menuId - menu id - unique in a site level
 * @property {string} imageUrl - Main image
 * @return {LogObject<serverDeleteMenuParams>} LogObject<serverDeleteMenuParams>
 */
export function serverDeleteMenu(params) {
    return { evid: 422, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverUpdateMenu' event (evid: 423)
 *
 * Event description: Fires each time a menu is updated. Each API change
 *
 * @param {serverUpdateMenuParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} sectionIds - Array of section ids in this section in the correct order!
 * @property {string} menuFullJson - The full json containing the entire menu object from the API
 * @property {string} description - description
 * @property {string} menuPrevJson - Json of the menu before the update
 * @property {boolean} isVisible - is the menu shown in the live site
 * @property {string} additionalImageUrls - an array of image urls URLs
 * @property {GUID} menuId - menu id - unique in a site level
 * @property {string} imageUrl - Main image
 * @property {string} menuChangedFields - Json of all the changed fields
 * @return {LogObject<serverUpdateMenuParams>} LogObject<serverUpdateMenuParams>
 */
export function serverUpdateMenu(params) {
    return { evid: 423, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverImportMenusFromOldMenusApp' event (evid: 424)
 *
 * Event description: Fires each time a user start the process of import a menu / menus from the old app
 *
 * @param {serverImportMenusFromOldMenusAppParams} params - The parameters for this event
 * @property {number} menusCount - how many menus were impoert
 * @property {string} menuIds - array of the menu ids that were import
 * @property {string} failReason - if import succeeded then null
 * @property {string} organizationId - from the old menu app
 * @property {boolean} isSuccessful - true if the import process ended successfully. false if it failed
 * @return {LogObject<serverImportMenusFromOldMenusAppParams>} LogObject<serverImportMenusFromOldMenusAppParams>
 */
export function serverImportMenusFromOldMenusApp(params) {
    return { evid: 424, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverCreateMenuItemLabel' event (evid: 431)
 *
 * Event description: Fires each time an item label is created
 *
 * @param {serverCreateMenuItemLabelParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} labelFullJson - The full json containing the entire label object from the API
 * @property {GUID} labelId - label id - unique in a site level
 * @property {string} imageUrl - Icon image URL
 * @return {LogObject<serverCreateMenuItemLabelParams>} LogObject<serverCreateMenuItemLabelParams>
 */
export function serverCreateMenuItemLabel(params) {
    return { evid: 431, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverDeleteMenuItemLabel' event (evid: 432)
 *
 * Event description: Fires each time an item label is deleted
 *
 * @param {serverDeleteMenuItemLabelParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} labelFullJson - The full json containing the entire label object from the API
 * @property {GUID} labelId - label id - unique in a site level
 * @property {string} imageUrl - Icon image URL
 * @return {LogObject<serverDeleteMenuItemLabelParams>} LogObject<serverDeleteMenuItemLabelParams>
 */
export function serverDeleteMenuItemLabel(params) {
    return { evid: 432, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverUpdateMenuItemLabel' event (evid: 433)
 *
 * Event description: Fires each time an item label is updated
 *
 * @param {serverUpdateMenuItemLabelParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} labelFullJson - The full json containing the entire label object from the API
 * @property {string} labelPrevJson - Json of the label before the update
 * @property {GUID} labelId - label id - unique in a site level
 * @property {string} imageUrl - Icon image URL
 * @property {string} labelChangedFields - Json of all the changed fields
 * @return {LogObject<serverUpdateMenuItemLabelParams>} LogObject<serverUpdateMenuItemLabelParams>
 */
export function serverUpdateMenuItemLabel(params) {
    return { evid: 433, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverCreateItemModifier' event (evid: 441)
 *
 * Event description: Fires each time an item modifier is created(happens after an item is saved).
 * As of 11.6, there is no way of editing or deleting a modifier.
 * After the modifiers tab will be added, it should be possible.
 *
 * @param {serverCreateItemModifierParams} params - The parameters for this event
 * @property {string} modifierId - modifier id
 * @property {string} modifierFullJson - The full json containing the entire modifier object from the API
 * @property {string} name - name
 * @property {boolean} isOutOfStock - is the modifier out of stock
 * @property {string} type - variation/individual_modifier/etc...
 * @return {LogObject<serverCreateItemModifierParams>} LogObject<serverCreateItemModifierParams>
 */
export function serverCreateItemModifier(params) {
    return { evid: 441, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverUpdateItemModifier' event (evid: 442)
 *
 * Event description: Fires each time an item modifier is updated(happens after an item is saved).
 *
 * @param {serverUpdateItemModifierParams} params - The parameters for this event
 * @property {string} modifierId - modifier id
 * @property {string} modifierFullJson - The full json containing the entire modifier object from the API
 * @property {string} name - name
 * @property {string} changedFields - The fields changed after the update
 * @property {boolean} isOutOfStock - is the modifier out of stock
 * @property {string} type - variation/individual_modifier/etc...
 * @return {LogObject<serverUpdateItemModifierParams>} LogObject<serverUpdateItemModifierParams>
 */
export function serverUpdateItemModifier(params) {
    return { evid: 442, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusItemVariantsSaved' event (evid: 443)
 *
 * Event description: when variants was saved
 *
 * @param {menusItemVariantsSavedParams} params - The parameters for this event
 * @property {string} variantId - -
 * @property {string} name - -
 * @property {string} variantFullJson - -
 * @property {string} changedFields - -
 * @property {string} type - updaged/created
 * @property {string} origin - -
 * @property {string} pageName - -
 * @return {LogObject<menusItemVariantsSavedParams>} LogObject<menusItemVariantsSavedParams>
 */
export function menusItemVariantsSaved(params) {
    return { evid: 443, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverCreateModifierGroup' event (evid: 451)
 *
 * Event description: Fires each time an item modifier group is created(happens after an item is saved).
 *
 * @param {serverCreateModifierGroupParams} params - The parameters for this event
 * @property {string} name - name
 * @property {boolean} isMandatory - Is the modifier group mandatory for the UoU
 * @property {number} minChoices - minimum number of extras the customer must choose. Relevant to mulitSelection only
 * @property {string} modifierGroupId - modifier group id
 * @property {string} modifiers - array of modifier ids
 * @property {string} type - single select/ multi select/ etc...
 * @property {number} freeSelections - number of selections that are given to the customer for free. Relevant to mulitSelection only
 * @property {string} modifierGroupFullJson - The full json containing the entire modifier group object from the API
 * @property {number} maxChoices - maximum number of extras the customer can choose. Relevant to mulitSelection only
 * @return {LogObject<serverCreateModifierGroupParams>} LogObject<serverCreateModifierGroupParams>
 */
export function serverCreateModifierGroup(params) {
    return { evid: 451, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverUpdateModifierGroup' event (evid: 452)
 *
 * Event description: Fires each time an item modifier group is updated(happens after an item is saved).
 *
 * @param {serverUpdateModifierGroupParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} changedFields - Json containing al the fields that were changed in this update
 * @property {boolean} isMandatory - Is the modifier group mandatory for the UoU
 * @property {string} modifierGroupId - modifier group id
 * @property {string} modifiers - array of modifier ids
 * @property {string} type - single select/ multi select/ etc...
 * @property {number} freeSelections - number of selections that are given to the customer for free. Relevant to mulitSelection only
 * @property {string} modifierGroupFullJson - The full json containing the entire modifier group object from the API
 * @return {LogObject<serverUpdateModifierGroupParams>} LogObject<serverUpdateModifierGroupParams>
 */
export function serverUpdateModifierGroup(params) {
    return { evid: 452, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverMenusOrdersAttributesState' event (evid: 461)
 *
 * Event description: The OLO attributes were enabled/disables for the site menus app.
 *
 * @param {serverMenusOrdersAttributesStateParams} params - The parameters for this event
 * @property {boolean} isEnabled - Is the olo attributes enabled. enabled = true
 * @property {number} revision - Number of times the attributes were changed
 * @return {LogObject<serverMenusOrdersAttributesStateParams>} LogObject<serverMenusOrdersAttributesStateParams>
 */
export function serverMenusOrdersAttributesState(params) {
    return { evid: 461, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloSettingsSchedulingPagePageLoad' event (evid: 500)
 *
 * Event description: when the scheduling page in OLO Settings was loaded
 *
 * @param {oloSettingsSchedulingPagePageLoadParams} params - The parameters for this event
 * @property {string} preorderType - 'timeBounded' | 'weekly'
 * @property {string} referralInfo - The specific trigger that made triggered the page load
 * @property {string} asapFutureHandlingType - "no_future_handling" | "business_days_ahead_handling"
 * @property {number} weeklyTimeOfDayMinutes - -
 * @property {number} atMostInAdvancedValue - (preorders fields only)
 * @property {string} atLeastInAdvancedTimeUnit - (preorders fields only)
 * @property {string} asapType - max/range (asap fields only)
 * @property {boolean} allowOrdersForLaterToday - true/false (asap fields only)
 * @property {number} rangeMinDuration - in minutes (asap fields only)
 * @property {string} schedulingType - asap / preorders_only
 * @property {number} rangeMaxDuration - in minutes (asap fields only)
 * @property {GUID} defaultOperationId - the default operation id that we see on page load
 * @property {number} asapFutureBusinessDays - 0,7,30 or null if not same day
 * @property {number} windowsTimeValue - in minutes (preorders fields only)
 * @property {number} numOperations - the number of the operations that this site has
 * @property {string} operationIds - the operation ids of this site
 * @property {string} windowsTimeUnit - hours/minutes (preorders fields only)
 * @property {string} atMostInAdvancedTimeUnit - (preorders fields only)
 * @property {string} previousPage - The page that was loaded before this one
 * @property {boolean} isTablet - null- no information. true or false when we do know the information
 * @property {string} schedulingValue - asap / preorders_only
 * @property {string} weeklyDayOfWeek - SUNDAY', 'MONDAY', 'TUESDAY', ...
 * @property {number} weeklyTimeOfDayHours - -
 * @property {string} category - settings
 * @property {number} atLeastInAdvancedValue - (preorders fields only)
 * @property {string} pageName - olo_settings_scheduling
 * @property {boolean} operationEnabled - true/false - olo main toggle of enable online orders or not
 * @property {number} maxOptionDuration - in minutes (asap fields only)
 * @property {string} product - olo
 * @property {number} loading_time - load time in milliseconds
 * @property {GUID} locationId - locaion id
 * @property {string} operationStatus - visible/hidden
 * @property {boolean} isDefaultLocation - is_default_location
 * @property {boolean} isDeletedLocation - of the location is archived
 * @property {string} operationId - operation_id
 * @property {GUID} operationGroup - operation  group
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloSettingsSchedulingPagePageLoadParams>} LogObject<oloSettingsSchedulingPagePageLoadParams>
 */
export function oloSettingsSchedulingPagePageLoad(params) {
    return { evid: 500, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dontUse' event (evid: 5000)
 *
 * Event description: dummy-name.
 *
 * @param {dontUseParams} params - The parameters for this event
 * @property {string} dummy_var - dummy var
 * @property {string} dummy_var3 - dummy var3
 * @return {LogObject<dontUseParams>} LogObject<dontUseParams>
 */
export function dontUse(params) {
    return { evid: 5000, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dontUse1' event (evid: 5001)
 *
 * Event description: when the widget of created service fee is shown to the user in the conversation with the AI assistant.
 *
 * @param {dontUse1Params} params - The parameters for this event
 * @property {string} refferal_info - all the datat we have
 * @return {LogObject<dontUse1Params>} LogObject<dontUse1Params>
 */
export function dontUse1(params) {
    return { evid: 5001, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dontUse2' event (evid: 5002)
 *
 * Event description: when the service fee was created by the ai assistant
 *
 * @param {dontUse2Params} params - The parameters for this event
 * @property {boolean} isSuccess - -
 * @property {string} refferal_info - all the datat we have
 * @property {GUID} ruleId - service fee if
 * @return {LogObject<dontUse2Params>} LogObject<dontUse2Params>
 */
export function dontUse2(params) {
    return { evid: 5002, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloClicks' event (evid: 501)
 *
 * Event description: some general clicks inside the olo product.
 * pages that are included: scheduling, settings lobby, pickup and delivery
 *
 * @param {oloClicksParams} params - The parameters for this event
 * @property {string} field - what is the area of the clicks? page/scheuling_type_section / asap_only/preorder_only
 * @property {string} actionType - scroll/click / modal_load/start_typing
 * @property {boolean} isTablet - null- no information. true or false when we do know the information
 * @property {string} operationsIds - if its for example settings page with not only one id
 * @property {string} pageName - settings_scheduling....
 * @property {string} refferal_info - additional info that required sometimes
 * @property {string} value - what is the value (button name/ value) of the click. for example  asap / pre_orders_only / learn_how / max_option_range_option / max_option_arrows etc..
 * @property {string} product - olo
 * @property {GUID} locationId
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {boolean} isDefaultLocation
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<oloClicksParams>} LogObject<oloClicksParams>
 */
export function oloClicks(params) {
    return { evid: 501, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc159Evid5010' event (evid: 5010)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc159Evid5010Params} params - The parameters for this event
 * @property {string} dummy_var - dummy var
 * @property {string} dummy_var2 - dummy var2
 * @return {LogObject<dummyNameSrc159Evid5010Params>} LogObject<dummyNameSrc159Evid5010Params>
 */
export function dummyNameSrc159Evid5010(params) {
    return { evid: 5010, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloServiceFeeAiAssistantCreateServiceFeeWidgetIsShowed' event (evid: 5011)
 *
 * Event description: when the widget of created service fee is shown to the user in the conversation with the AI assistant.
 *
 * @param {oloServiceFeeAiAssistantCreateServiceFeeWidgetIsShowedParams} params - The parameters for this event
 * @property {string} refferal_info - all the datat we have
 * @return {LogObject<oloServiceFeeAiAssistantCreateServiceFeeWidgetIsShowedParams>} LogObject<oloServiceFeeAiAssistantCreateServiceFeeWidgetIsShowedParams>
 */
export function oloServiceFeeAiAssistantCreateServiceFeeWidgetIsShowed(params) {
    return { evid: 5011, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloServiceFeeAiAssistantServiceFeeWasCreatedByAiAssistant' event (evid: 5012)
 *
 * Event description: when the service fee was created by the ai assistant
 *
 * @param {oloServiceFeeAiAssistantServiceFeeWasCreatedByAiAssistantParams} params - The parameters for this event
 * @property {boolean} isSuccess - -
 * @property {string} refferal_info - all the datat we have
 * @property {GUID} ruleId - service fee if
 * @return {LogObject<oloServiceFeeAiAssistantServiceFeeWasCreatedByAiAssistantParams>} LogObject<oloServiceFeeAiAssistantServiceFeeWasCreatedByAiAssistantParams>
 */
export function oloServiceFeeAiAssistantServiceFeeWasCreatedByAiAssistant(params) {
    return { evid: 5012, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloSettingsSchedulingPageSave' event (evid: 502)
 *
 * Event description: triggered after a response from the server.when saving the schedule page.
 * when the page is saved as asap, preorder values will be null and vice versa.
 *
 * @param {oloSettingsSchedulingPageSaveParams} params - The parameters for this event
 * @property {string} preorderType - 'timeBounded' | 'weekly'
 * @property {string} asapFutureHandlingType - "no_future_handling" | "business_days_ahead_handling
 * @property {string} errorNumber - number of error if exists, only if there is an error
 * @property {number} weeklyTimeOfDayMinutes - -
 * @property {number} atMostInAdvancedValue - in minutes (preorders fields only)
 * @property {string} atLeastInAdvancedTimeUnit - minutes/hours.. (preorders fields only)
 * @property {string} asapType - max/ range (asap fields only)
 * @property {boolean} allowOrdersForLaterToday - true when toggle on or false when toggle off
 * @property {number} rangeMinDuration - in minutes (asap fields only)
 * @property {string} schedulingType - asap/pre-orders
 * @property {number} rangeMaxDuration - in minutes (asap fields only)
 * @property {number} asapFutureBusinessDays - 0,7,30 or null if its asap only
 * @property {number} windowsTimeValue - in minutes, (preorders fields only)
 * @property {string} fieldMask - string of all the fields that were changed in this "save"
 * @property {GUID} operationId - operation id
 * @property {string} windowsTimeUnit - hours/minutes, (preorders fields only)
 * @property {string} errorType - The type of the error - validtion/ server/ etc.. only if there is an error
 * @property {string} atMostInAdvancedTimeUnit - minutes/hours.. (preorders fields only)
 * @property {boolean} isTablet - null- no information. true or false when we do know the information
 * @property {string} weeklyDayOfWeek - 'SUNDAY', 'MONDAY', 'TUESDAY', ...
 * @property {string} errorDescription - erorr_message, only if there is an error
 * @property {number} weeklyTimeOfDayHours - -
 * @property {number} atLeastInAdvancedValue - in minutes (preorders fields only)
 * @property {boolean} isSuccessful - True/ false
 * @property {boolean} operationEnable - true if olo toggle is on and false if olo toggle is off
 * @property {number} maxOptionDuration - in minutes (asap fields only)
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - visible/hidden
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab -  is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloSettingsSchedulingPageSaveParams>} LogObject<oloSettingsSchedulingPageSaveParams>
 */
export function oloSettingsSchedulingPageSave(params) {
    return { evid: 502, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrdersPageLoad' event (evid: 503)
 *
 * Event description: when the page is loaded and also the tab, we will distinguish between tab and page by the field “origin”. only kanban view!
 *
 * @param {oloOrdersPageLoadParams} params - The parameters for this event
 * @property {number} numOrdersInAccepted - -
 * @property {boolean} isAcceptedDisplay - display on the view
 * @property {number} numOrdersOurForDelivery - -
 * @property {number} numOrdersInPending - -
 * @property {boolean} isOutForDeliveryDisplay - display on the view
 * @property {GUID} operationId - -
 * @property {number} numColumns - num columns that are displayed on the orders page
 * @property {string} previousPage - The page that was loaded before this one
 * @property {boolean} isTablet - -
 * @property {number} loadingTime - load time in milliseconds
 * @property {boolean} isPendingApprovalDisplay - display on the view
 * @property {boolean} enableOrdersStatus - true or false (like old olo toggle)
 * @property {string} pageName - orders_page_kanban_view / orders_page_calendar_view
 * @property {number} numOrdersInReady - -
 * @property {string} refferal_info - The specific trigger that made triggered the page load
 * @property {boolean} isDefaultOperation - True / false - s it the default operation when the page is loaded?
 * @property {boolean} isReadyDisplay - display on the view
 * @property {string} product - OLO
 * @property {string} currentStatus - current restaurant status
 * @property {string} operatinID
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDeletedLocation
 * @return {LogObject<oloOrdersPageLoadParams>} LogObject<oloOrdersPageLoadParams>
 */
export function oloOrdersPageLoad(params) {
    return { evid: 503, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrdersCalendarViewTabLoad' event (evid: 504)
 *
 * Event description: when the page is loaded and also the tab, we will distinguish between tab and page by the field “origin”. only calendar view!
 *
 * @param {oloOrdersCalendarViewTabLoadParams} params - The parameters for this event
 * @property {GUID} operationId - -
 * @property {string} previousPage - The page that was loaded before this one
 * @property {boolean} isTablet - -
 * @property {number} loadingTime - load time in milliseconds
 * @property {number} totalWeeklyNumOrders - how many orders in all week?
 * @property {DateTime} dateWithMaxNumOrders - the day with the maximum number of orders. null if this is more than one date
 * @property {boolean} enableOrdersStatus - true or false (like old olo toggle)
 * @property {string} pageName - orders_page_kanban_view / orders_page_calendar_view
 * @property {string} refferal_info - The specific trigger that made triggered the page load
 * @property {boolean} isDefaultOperation - True / false - s it the default operation when the page is loaded?
 * @property {number} numOrdersOfMaxColumn - the number of orders in the day with the maximum number of orders.
 * @property {string} product - OLO
 * @property {string} currentStatus - current restaurant status
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<oloOrdersCalendarViewTabLoadParams>} LogObject<oloOrdersCalendarViewTabLoadParams>
 */
export function oloOrdersCalendarViewTabLoad(params) {
    return { evid: 504, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrdersPageMeaningfulAction' event (evid: 505)
 *
 * Event description: all the meaningful actions like: accept, mark as ready, mark as fulfilled, picked up, print, reject and more..
 *
 * @param {oloOrdersPageMeaningfulActionParams} params - The parameters for this event
 * @property {string} field - what is the area of the clicks? ןin kanba V1 - 3 dots  or primary_action_button .
 * @property {string} orderId - -
 * @property {number} deliveryCostInUsd - delivery_cost_in_usd
 * @property {GUID} operationId - -
 * @property {boolean} isTablet - true/false
 * @property {string} pageName - orders_kanban_view / orders_calendar_view
 * @property {string} fulfillmentType - pickup/delivery
 * @property {boolean} isSuccessful - did we get a success response from the server?
 * @property {string} value - the action itself like print, accept, mark as ready, reject and more
 * @property {string} product - olo
 * @property {string} currentStatus - the status before the action. For example, order was pending and then I click on accept so value = “accept” and current_status = ‘pending’
 * @property {GUID} operationGroup - operationGroup
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation - action happen on site's default location
 * locationId
 * @property {GUID} locationId - locationId
 * @property {boolean} isDeletedLocation - action happened on deleted location
 * @property {string} deliveryPartner - If the order connected to a delivery partner such as doordash it will send 'doordash'. Otherwise null
 * @property {string} contact_id - contact id if the user clicked on the order's contact
 * @property {string} thirdPartyAppId - thirdPartyAppId in cases that third party app added order action slot in kanban(and user used it)
 * @property {DateTime} dueDateFrom - the date that order should be ready (the range if between from to "to" so this is the from value)
 * @property {string} source - where is the order from? Manually? POS?
 * @property {DateTime} dueDateTo - (the range if between from to "to" so this is the "to" value)
 * @property {string} operationName - -
 * @property {string} errorMessages - -
 * @return {LogObject<oloOrdersPageMeaningfulActionParams>} LogObject<oloOrdersPageMeaningfulActionParams>
 */
export function oloOrdersPageMeaningfulAction(params) {
    return { evid: 505, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrderingStatusComponentIsLoaded' event (evid: 506)
 *
 * Event description: when the component in the right corner in the top part of the page of ordering status is loaded (its loading is separate from the page load)
 *
 * @param {oloOrderingStatusComponentIsLoadedParams} params - The parameters for this event
 * @property {boolean} successfully - true/false
 * @property {string} orderingStatus - unable_to_accept_orders / ready_to_accept_orders
 * @property {number} loadingTime - in miliseconds
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @return {LogObject<oloOrderingStatusComponentIsLoadedParams>} LogObject<oloOrderingStatusComponentIsLoadedParams>
 */
export function oloOrderingStatusComponentIsLoaded(params) {
    return { evid: 506, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrderingStatusComponentClicks' event (evid: 507)
 *
 * Event description: The click on the status button itself and the clicks inside it
 *
 * @param {oloOrderingStatusComponentClicksParams} params - The parameters for this event
 * @property {string} buttonName - unable_to_accept_orders/ review_orderins_settings/ set_up_payment / upgrade_to_premium/ lear_more_test_order
 * @property {string} orderingStatus - unable_to_accept_orders / ready_to_accept_orders
 * @property {GUID} locationId - locationId
 * @property {boolean} isDefaultLocation - is_default Location
 * @property {boolean} isDeletedLocation - is deleted location
 * @return {LogObject<oloOrderingStatusComponentClicksParams>} LogObject<oloOrderingStatusComponentClicksParams>
 */
export function oloOrderingStatusComponentClicks(params) {
    return { evid: 507, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloLiveSiteItemModalOpened' event (evid: 508)
 *
 * Event description: Item Modal opened
 *
 * @param {oloLiveSiteItemModalOpenedParams} params - The parameters for this event
 * @property {number} minItemPrice - the minimum price if there is a price variation
 * @property {number} numPriceVariations - -
 * @property {number} numModifiers - -
 * @property {GUID} sectionId - won't be sent always- if it was opened from the cart it will be null. if it sent from the olo page it will send a value
 * @property {GUID} itemId - -
 * @property {number} numModifiersGroups - -
 * @property {string} itemName - -
 * @property {number} num_labels - -
 * @property {GUID} menuId - won't be sent always- if it was opened from the cart it will be null. if it sent from the olo page it will send a value
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isMenuItemAvailable - available / unavailable
 * @property {boolean} isItemInStock - in_stock / out_of_stock (added only on July 2024)
 * @property {string} operationId - -
 * @return {LogObject<oloLiveSiteItemModalOpenedParams>} LogObject<oloLiveSiteItemModalOpenedParams>
 */
export function oloLiveSiteItemModalOpened(params) {
    return { evid: 508, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloLiveSiteAddDishToCart' event (evid: 509)
 *
 * Event description: Add Dish To Cart
 *
 * @param {oloLiveSiteAddDishToCartParams} params - The parameters for this event
 * @property {string} priceVariationName - price_variation_name
 * @property {string} errorMessage - some error messages that are shown to the user
 * @property {string} selectedModifiersList - (‘extras: chips, tomatos…. Milk type: soy’) from 14.7 the data structure has changed
 * @property {number} amountOfItems - how many items from this dish the uou add?
 * @property {boolean} isSuccess - true/false
 * @property {number} itemPrice - -
 * @property {GUID} sectionId - -
 * @property {GUID} itemId - -
 * @property {string} itemName - -
 * @property {number} numSelectedModifiers - how many modofiers were selected?
 * @property {number} num_labels - -
 * @property {GUID} menuId - -
 * @property {string} labelsList - -
 * @property {string} priceOfItem - we should cast it into double in order to use it as. a string
 * @property {GUID} operaionGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operatinID - -
 * @property {string} operationId - -
 * @return {LogObject<oloLiveSiteAddDishToCartParams>} LogObject<oloLiveSiteAddDishToCartParams>
 */
export function oloLiveSiteAddDishToCart(params) {
    return { evid: 509, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrdersPageErrorWithPresentingOrdersSrc159Evid510' event (evid: 510)
 *
 * Event description: There is an issue with presenting specific order/s in olo orders page (kanban/calendar)
 *
 * @param {oloOrdersPageErrorWithPresentingOrdersSrc159Evid510Params} params - The parameters for this event
 * @property {string} orderIds - array of all relevant order IDs
 * @property {boolean} isOwnerApp - error presented in owner app true/false
 * @property {string} pageName - orders_kanban_view / orders_calendar_view
 * @property {string} product - olo
 * @property {number} numOrders - number of orders with issues
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDeletedLocation
 * @property {boolean} isDefaultLocation
 * @property {string} errorMessages - error string
 * @return {LogObject<oloOrdersPageErrorWithPresentingOrdersSrc159Evid510Params>} LogObject<oloOrdersPageErrorWithPresentingOrdersSrc159Evid510Params>
 */
export function oloOrdersPageErrorWithPresentingOrdersSrc159Evid510(params) {
    return { evid: 510, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloLiveSiteOloPageLoaded' event (evid: 511)
 *
 * Event description: when olo page in live site loaded to uou
 *
 * @param {oloLiveSiteOloPageLoadedParams} params - The parameters for this event
 * @property {boolean} isFreddDeliveryDisplayed - true/false
 * @property {number} freeDeliveryAboveValue - the value of free delivery above
 * @property {number} numSections - -
 * @property {number} deliveryFee - value or null
 * @property {string} statusDisplayed - accepting_orders / closed / temporary closed/ opening soon / closing soon etc....
 * @property {number} cartState - how many items in the cart when the page was loaded
 * @property {boolean} isFreddDeliveryAboveDisplayed - true/false
 * @property {boolean} isDeafultAddress - true/false
 * @property {boolean} isMinOrderDisplayed - true/false
 * @property {boolean} isDeliveryAvailable - at the time of the page load
 * @property {GUID} operationId - -
 * @property {string} defaultSelectedFulfillment - usually pickup but if its close and the users have delivery so delivery and if not so it will be null
 * @property {number} numMenus - -
 * @property {boolean} isPickupConfig - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {string} minOrderDisplayed - value or null
 * @property {string} mode - live site/ preview
 * @property {number} numDishes - -
 * @property {boolean} isDeliveryConfig - -
 * @property {string} defaultSelectedTimeSlot - -
 * @property {boolean} isPickupAvailable - at the time of the page load
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {GUID} locationId
 * @property {string} refferalInfo - is the uou came to the live site from Google? (order with google)?
 * @return {LogObject<oloLiveSiteOloPageLoadedParams>} LogObject<oloLiveSiteOloPageLoadedParams>
 */
export function oloLiveSiteOloPageLoaded(params) {
    return { evid: 511, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPickupDeliverySettingsPageLoaded' event (evid: 512)
 *
 * Event description: Pickup & Delivery Settings -> Page Loaded
 *
 * @param {oloPickupDeliverySettingsPageLoadedParams} params - The parameters for this event
 * @property {boolean} pickupLoadSuccess - -
 * @property {number} numEnabledDeliveries - -
 * @property {boolean} enablePickup - (toggle on- true. Toggle off- false)
 * @property {number} numDeliveries - -
 * @property {string} defaultFulfillmentType - pickup/delivery/ pickup_only/delivery_only / no_methods_enabled
 * @property {boolean} deliveriesLoadSuccess - -
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {GUID} operationGroup
 * @property {boolean} isDdPartnerEnabled - is door dash toggle is on/off/null because the site doesn't have DD.
 * @property {string} operationId - -
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab -  is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloPickupDeliverySettingsPageLoadedParams>} LogObject<oloPickupDeliverySettingsPageLoadedParams>
 */
export function oloPickupDeliverySettingsPageLoaded(params) {
    return { evid: 512, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaPageLoad' event (evid: 513)
 *
 * Event description: delivery area page load
 *
 * @param {oloDeliveryAreaPageLoadParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"end_time":"23:59","start_time":"00:00"}],"MONDAY":
 * @property {number} numTimeSlots - -
 * @property {boolean} isDefaultAddress - true/false - relevant only for radius
 * @property {number} orderMin - in order to get the accurate value divide by 100
 * @property {string} radiusUnit - -
 * @property {number} radius - only if chosen, if not so null
 * @property {boolean} isSuccess - page load success
 * @property {number} numOfAvailbaleDays - how many days are checked
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} numPostalCodes - -
 * @property {string} actionType - create/edit
 * @property {number} customAreaNumOfPoints - -
 * @property {string} postalCodeCountry - -
 * @property {GUID} fulfillmentId - when its delivery area or pickup
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, zip/postal codes , draw_on_map
 * @property {number} radiusDistance - -
 * @property {boolean} isEnabled - if toggle on then true  if toggle off then false
 * @property {number} numZipCodes - only if chosen, if not so null
 * @property {string} fulfillmentName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {string} deliveryPartner - Which delivery partner is used, for example 'doordash', notice if null there is no delivery partner
 * @property {boolean} isDdReadyMessageDisplayed - true/false/null. the green message of Doordash drive is ready to use
 * @property {string} errorMessage - if is_successful = false
 * @property {string} violationMessage - If the page was loaded successfully but something with the integration with DD is not working well.
 * @property {boolean} IsDdFirstFwStepDone - true/false/null
 * if all 3 steps are done = true so the FW won't appear anymore unless one of the steps is back to be not done.
 * @property {boolean} IsDdSecondFwStepDone - true/false/null
 * if all 3 steps are done = true so the FW won't appear anymore unless one of the steps is back to be not done.
 * @property {boolean} IsDdThirdFwStepDone - true/false/null
 * if all 3 steps are done = true so the FW won't appear anymore unless one of the steps is back to be not done.
 * @property {string} operationId - -
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloDeliveryAreaPageLoadParams>} LogObject<oloDeliveryAreaPageLoadParams>
 */
export function oloDeliveryAreaPageLoad(params) {
    return { evid: 513, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaSaved' event (evid: 514)
 *
 * Event description: delivery area saved
 *
 * @param {oloDeliveryAreaSavedParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"end_time":"23:59","start_time":"00:00"}],"MONDAY":
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - in order to get the accurate value divide by 100
 * @property {string} fieldMask - fields that were changed
 * @property {string} radiusUnit - -
 * @property {number} radius - Min radius chosen (if radius is chosen)
 * @property {boolean} isSuccess - is save success
 * @property {number} numOfAvailbaleDays - how many days are checked
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} numPostalCodes - -
 * @property {string} actionType - create/edit
 * @property {number} customAreaNumOfPoints - -
 * @property {string} postalCodeCountry - -
 * @property {GUID} fulfillmentId - when its delivery area or pickup
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, zip/postal codes , draw_on_map
 * @property {number} radiusDistance - Max raduis chosen
 * @property {boolean} isEnabled - if toggle on then true  if toggle off then false
 * @property {string} fulfillmentName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {string} deliveryPartner - 	Which delivery partner is used, for example 'doordash', notice if null there is no delivery partner
 * @property {string} postalCodesList - list of all postal codes
 * @property {boolean} isFirstOperationTab -  is it the first operation tab? which the page was opened on.
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @return {LogObject<oloDeliveryAreaSavedParams>} LogObject<oloDeliveryAreaSavedParams>
 */
export function oloDeliveryAreaSaved(params) {
    return { evid: 514, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaDeleted' event (evid: 515)
 *
 * Event description: OLO -> Delivery Area -> Dleted
 *
 * @param {oloDeliveryAreaDeletedParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} numOfAvailableDays - how many days are checkes
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"close":"23:59","open":"00:00"}],"MONDAY":[{"close":"23:59","open":"00
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - -
 * @property {string} radiusUnit - -
 * @property {boolean} isSuccess - -
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} numPostalCodes - -
 * @property {number} numOfPoints - -
 * @property {number} customAreaNumOfPoints - -
 * @property {string} postalCodeCountry - -
 * @property {string} fulfillmentId - -
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, postal codes , draw_on_map
 * @property {number} radiusDistance - -
 * @property {boolean} isEnabled - if toggle on then true if toggle off then false
 * @property {string} fulfillmentName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - new field .  is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloDeliveryAreaDeletedParams>} LogObject<oloDeliveryAreaDeletedParams>
 */
export function oloDeliveryAreaDeleted(params) {
    return { evid: 515, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPickupPageLoad' event (evid: 516)
 *
 * Event description: OLO -> Pickup Page -> Load
 *
 * @param {oloPickupPageLoadParams} params - The parameters for this event
 * @property {number} numOfAvailableDays - how many days are checked
 * @property {string} availableTimes - long json of all days and hours
 * @property {number} numTimeSlots - -
 * @property {boolean} isDefaultAddress - true/false
 * @property {number} orderMin - -
 * @property {string} fulfillmentId - -
 * @property {boolean} isEnabled - true/false
 * @property {number} numOfDays - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDeletedLocation -  if the location is archived
 * @property {boolean} isDefaultLanguage
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @return {LogObject<oloPickupPageLoadParams>} LogObject<oloPickupPageLoadParams>
 */
export function oloPickupPageLoad(params) {
    return { evid: 516, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPickupPageSaved' event (evid: 517)
 *
 * Event description: OLO -> Pickup Page -> Saved
 *
 * @param {oloPickupPageSavedParams} params - The parameters for this event
 * @property {number} numOfAvailableDays - how many days are checked
 * @property {string} availableTimes - json of days and hours
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - -
 * @property {boolean} isSuccess - true/false
 * @property {string} fulfillmentId - -
 * @property {boolean} isDefaultAddress - whether it's the default address we set for the user before he updates his business addresss
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @property {string} pickupInstructions - (string | null) the pickup instructions
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @return {LogObject<oloPickupPageSavedParams>} LogObject<oloPickupPageSavedParams>
 */
export function oloPickupPageSaved(params) {
    return { evid: 517, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPickupPageToggleAction' event (evid: 518)
 *
 * Event description: OLO -> Pickup Page - > Toggle action
 *
 * @param {oloPickupPageToggleActionParams} params - The parameters for this event
 * @property {number} numOfAvailableDays - -
 * @property {string} availableTimes - -
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - -
 * @property {boolean} isSuccess - ture false
 * @property {boolean} isCurrentEnabled - true/false - what was the status before the click
 * @property {string} fulfillmentId - -
 * @property {boolean} isEnabled - the click value
 * @property {number} numOfDays - -
 * @property {GUID} operationId - -
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloPickupPageToggleActionParams>} LogObject<oloPickupPageToggleActionParams>
 */
export function oloPickupPageToggleAction(params) {
    return { evid: 518, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOwnerAppOnlyActionSheetOpenedGenericEvent' event (evid: 519)
 *
 * Event description: All the action sheets that are opened after clicks on our pages (that act differently than the web and don't have an action sheet/modal on the web, it has just clicks on the web)
 *
 * @param {oloOwnerAppOnlyActionSheetOpenedGenericEventParams} params - The parameters for this event
 * @property {string} field - the area in the page that the click that opened that action sheet is. for example order preperation in scheduling page when the user choose order preparation time
 * @property {string} action_sheet_name - the name of the action sheet
 * @property {GUID} operationId - operation id
 * @property {boolean} isTablet - true/false
 * @property {string} operationsIds - if its for example settings page with not only one id
 * @property {string} pageName - the page name that the action sheet opened from
 * @property {string} defaultValue - what if the default value when the action sheet opened
 * @return {LogObject<oloOwnerAppOnlyActionSheetOpenedGenericEventParams>} LogObject<oloOwnerAppOnlyActionSheetOpenedGenericEventParams>
 */
export function oloOwnerAppOnlyActionSheetOpenedGenericEvent(params) {
    return { evid: 519, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloNavigationClick' event (evid: 520)
 *
 * Event description: User clicked on a navigation button (any button in the menus app that links to a different page)
 *
 * @param {oloNavigationClickParams} params - The parameters for this event
 * @property {string} destinationPageName - The page that the user is about to land in, for example menus/items etc...
 * @property {string} origin - a button/area from where the action originated from. for example an origin of a modal load can be a specific button that triggered it's load
 * @property {string} pageName - name of the page
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<oloNavigationClickParams>} LogObject<oloNavigationClickParams>
 */
export function oloNavigationClick(params) {
    return { evid: 520, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc159Evid5200' event (evid: 5200)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc159Evid5200Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc159Evid5200Params>} LogObject<dummyNameSrc159Evid5200Params>
 */
export function dummyNameSrc159Evid5200(params) {
    return { evid: 5200, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloFoodOrderingPageClickOnViewTab' event (evid: 521)
 *
 * Event description: click on status view or on calendar view
 *
 * @param {oloFoodOrderingPageClickOnViewTabParams} params - The parameters for this event
 * @property {number} numReadyOrders - -
 * @property {number} numWeeklyAsapOrders - -
 * @property {number} numWeeklyAcceptedOrders - -
 * @property {number} numPendingOrders - -
 * @property {number} numWeeklyReadyOrders - -
 * @property {number} numWeeklyOutForDeliveryOrders - -
 * @property {string} tabName - the name of the tab the user clicked on
 * @property {number} numWeeklyPendingOrders - -
 * @property {number} numAcceptedOrders - -
 * @property {number} numPreorders - -
 * @property {number} numWeeklyPreorders - -
 * @property {number} numWeeklyOrders - num total weekly orders that the use see
 * @property {number} numOutForDeliveryOrders - -
 * @property {string} currentTabName - current tab name
 * @property {number} numAsapOrders - -
 * @property {number} numOrders - -
 * @property {boolean} isDeletedLocation - isDeletedLocation
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId - location id
 * @property {GUID} operationId - operation id
 * @property {GUID} operationGroup - operation group
 * @property {boolean} isDefaultLocation - default location
 * @return {LogObject<oloFoodOrderingPageClickOnViewTabParams>} LogObject<oloFoodOrderingPageClickOnViewTabParams>
 */
export function oloFoodOrderingPageClickOnViewTab(params) {
    return { evid: 521, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloLiveSiteClickOnItem' event (evid: 522)
 *
 * Event description: click on item - live site
 *
 * @param {oloLiveSiteClickOnItemParams} params - The parameters for this event
 * @property {number} minItemPrice - the minimum price if there is a price variation (It's actually the default price when the item modal is opened, including preselected modifiers) *in cents (need to divide by 100 to get dollars)
 *
 * @property {GUID} sectionId - -
 * @property {GUID} itemId - -
 * @property {string} itemName - -
 * @property {GUID} menuId - -
 * @property {GUID} locationId - -
 * @property {GUID} operationGroup - -
 * @property {boolean} isDefaultLocation - -
 * @property {string} operationId - -
 * @property {boolean} isMenuItemAvailable - available / unavailable
 * @property {boolean} isItemInStock - in_stock / out_of_stock (added only on July 2024)
 * @return {LogObject<oloLiveSiteClickOnItemParams>} LogObject<oloLiveSiteClickOnItemParams>
 */
export function oloLiveSiteClickOnItem(params) {
    return { evid: 522, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloLiveSiteTrackerPageLoaded' event (evid: 523)
 *
 * Event description: when tracker page loaded
 *
 * @param {oloLiveSiteTrackerPageLoadedParams} params - The parameters for this event
 * @property {DateTime} pickupTime - if its pickup if not so null
 * @property {string} orderId - -
 * @property {DateTime} fulfilledTimeTo - date_time (its also for pickup!), will be null when it's same as the from and not between values
 * @property {string} schedulingType - asap/preorder
 * @property {string} orderStatus - current status that the uou is seeing on the page
 * @property {DateTime} fulfilledTimeFrom - date_time (its also for pickup!)- if the time is not between and its a specific hour so delivery time to will be null
 * @property {string} deliveryTime - if its delivery if not so null
 * @property {string} fulfillmentType - pickup/delivery
 * @property {string} fulfillmentName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationId - -
 * @return {LogObject<oloLiveSiteTrackerPageLoadedParams>} LogObject<oloLiveSiteTrackerPageLoadedParams>
 */
export function oloLiveSiteTrackerPageLoaded(params) {
    return { evid: 523, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaToggleAction' event (evid: 524)
 *
 * Event description: delivery area toggle action
 *
 * @param {oloDeliveryAreaToggleActionParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"end_time":"23:59","start_time":"00:00"}],"MONDAY":
 * @property {number} numOdPoints - only if chosen, if not so null (draw on map)
 * @property {number} zipCodeCountry - only if chosen, if not so null
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - in order to get the accurate value divide by 100
 * @property {string} radiusUnit - -
 * @property {number} radius - only if chosen, if not so null
 * @property {boolean} isSuccess - is save success
 * @property {number} numOfAvailbaleDays - how many days are checked
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} customAreaNumOfPoints - -
 * @property {boolean} isCurrentEnabled - what is the status before the click
 * @property {string} postalCodeCountry - -
 * @property {GUID} fulfillmentId - when its delivery area or pickup
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, zip/postal codes , draw_on_map
 * @property {number} radiusDistance - -
 * @property {boolean} isEnabled - the value of the click
 * @property {number} numZipCodes - only if chosen, if not so null
 * @property {string} fulfillmentName - -
 * @property {GUID} locationId
 * @property {GUID} operationId - -
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {string} operationName - =
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloDeliveryAreaToggleActionParams>} LogObject<oloDeliveryAreaToggleActionParams>
 */
export function oloDeliveryAreaToggleAction(params) {
    return { evid: 524, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePage' event (evid: 525)
 *
 * Event description: Click on the online orders button at the top of the page on the live site (the navigations buttons)
 *
 * @param {restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePageParams} params - The parameters for this event
 * @property {number} cartState - the number of items on the cart
 * @property {boolean} isMemberLoggedIn - true/false
 * @return {LogObject<restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePageParams>} LogObject<restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePageParams>
 */
export function restaurantsOloLiveSiteClickOnOnlineOrdersButtonAtTheTopOfThePage(params) {
    return { evid: 525, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteClickOnFulfillment' event (evid: 526)
 *
 * Event description: click on fulfillment (pickup/delivery) on the top of the online ordering page (or else - origin field) in a live site
 *
 * @param {restaurantsOloLiveSiteClickOnFulfillmentParams} params - The parameters for this event
 * @property {boolean} isPickupConfigured - is it even an option? is it configured but not available at the moment?
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the online ordering page?
 * @property {string} statusDisplayed - what is the status that displayed at the moment of the click
 * @property {number} cartState - the number of items on the cart
 * @property {string} selectedFulfillment - the fulfiilment that the user clicked on
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the online ordering page?
 * @property {GUID} operationId - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {string} origin - the origin of the click - fulfillment/ change and from where
 * @property {boolean} isDeliveryConfigured - is it even an option? is it configured but not available at the moment?
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the time of the click
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @property {GUID} defaultLocationID
 * @property {string} menuId - menu_id
 * @return {LogObject<restaurantsOloLiveSiteClickOnFulfillmentParams>} LogObject<restaurantsOloLiveSiteClickOnFulfillmentParams>
 */
export function restaurantsOloLiveSiteClickOnFulfillment(params) {
    return { evid: 526, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteErrorDisplayedInDispatchModal' event (evid: 527)
 *
 * Event description: online orders page on live site -> Error displayed inside the dispatch modal
 *
 * @param {restaurantsOloLiveSiteErrorDisplayedInDispatchModalParams} params - The parameters for this event
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the modal?
 * @property {string} statusDisplayed - what is the status that displayed at the moment of the click
 * @property {number} cartState - the number of items on the cart
 * @property {string} errorMessage - what is the error message? pickup isn’t available at the selected time / pickup isn’t available at the selected date etc….
 * @property {boolean} isPreorderDisplayed - is it displayed in the modal at the moment of the error? is it an option?
 * @property {string} errorField - pickup_later_today_time / pickup_preorder_time / pickup_preorder_time / delivery_address / delivery_late_today_time / delivery_preorder_time/ delivery_preorder_date
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the modal?
 * @property {GUID} operationId - -
 * @property {string} errorType - error type
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {boolean} isAsapDisplayed - is it displayed in the modal at the moment of the error? is it an option?
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the time of the error
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} defaultLocationID
 * @return {LogObject<restaurantsOloLiveSiteErrorDisplayedInDispatchModalParams>} LogObject<restaurantsOloLiveSiteErrorDisplayedInDispatchModalParams>
 */
export function restaurantsOloLiveSiteErrorDisplayedInDispatchModal(params) {
    return { evid: 527, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteFulfillmentChanged' event (evid: 528)
 *
 * Event description: online orders page on live site -> Fulfillment changed
 *
 * @param {restaurantsOloLiveSiteFulfillmentChangedParams} params - The parameters for this event
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the page?
 * @property {string} statusDisplayed - what is the status that displayed at the moment of the click
 * @property {DateTime} pickupTime - if its not asap so the datetime with the hour and the date of today/ of the preorder date
 * @property {number} cartState - the number of items on the cart
 * @property {boolean} isPreorderDisplayed - is it displayed on the page? is it an option?
 * @property {boolean} isSuccess - true/false
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the pagel?
 * @property {GUID} operationId - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {boolean} isAsapDisplayed - is it displayed of the page? is it an option?
 * @property {string} deliveryTime - -
 * @property {string} pickupTimingType - asap / later_today/preorder
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment before the change
 * @property {string} newFulfillment - what is the new fulfillment? delivery/pikcup
 * @return {LogObject<restaurantsOloLiveSiteFulfillmentChangedParams>} LogObject<restaurantsOloLiveSiteFulfillmentChangedParams>
 */
export function restaurantsOloLiveSiteFulfillmentChanged(params) {
    return { evid: 528, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteDispatchModalOpened' event (evid: 529)
 *
 * Event description: online orders page on live site -> Fulfillment changed
 *
 * @param {restaurantsOloLiveSiteDispatchModalOpenedParams} params - The parameters for this event
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the modal?
 * @property {DateTime} pickupTime - if its not asap so the datetime with the hour and the date of today/ of the preorder date
 * @property {number} cartState - the number of items on the cart
 * @property {boolean} isPreorderDisplayed - is it displayed on the modal? is it an option?
 * @property {number} businessDays - 0,7,30, null
 * @property {string} schedulingType - what is the shceduling type at the moment of the modal load?
 * @property {DateTime} fromDateAndTime - -
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the modal?
 * @property {GUID} operationId - -
 * @property {DateTime} untilDateAndTime - -
 * @property {boolean} isMemberLoggedIn - Ture.false
 * @property {boolean} isAsapDisplayed - is it displayed of the modal? is it an option?
 * @property {string} deliveryTime - -
 * @property {string} pickupTimingType - asap / later_today/preorder
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the moment of the modal load
 * @property {DateTime} dateAndTime - -
 * @property {string} selectedRadioButton - asap/future/null - send only for asap+future
 * @property {string} source - from were the user got to the dispatch - order_now/menu_item
 * @property {GUID} defultLocationId - the id of the defult location
 * @property {GUID} locationId - the location we are now at
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<restaurantsOloLiveSiteDispatchModalOpenedParams>} LogObject<restaurantsOloLiveSiteDispatchModalOpenedParams>
 */
export function restaurantsOloLiveSiteDispatchModalOpened(params) {
    return { evid: 529, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteClicksInsideDispatchModal' event (evid: 530)
 *
 * Event description: online orders page on live site -> Clicks inside dispatch modal
 *
 * @param {restaurantsOloLiveSiteClicksInsideDispatchModalParams} params - The parameters for this event
 * @property {string} buttonType - pickup / delivery/deliver_to / delivery_time / delivery_time_in_dropdown / pickup_in_30_mintues / pickup_schedule_for_late_today/pickup_time / pickup_time_in_dropdown / save / location
 * @property {boolean} isPreorder - is the click is preorder related or asap
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the moment of the modal load
 * @property {GUID} locationId - the selected location the user clicked on
 * @property {GUID} operationGroup - -
 * @property {GUID} previousLocation - the currennt location_id (from where the user did the select location click)
 * @property {GUID} defultLocationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationId - -
 * @return {LogObject<restaurantsOloLiveSiteClicksInsideDispatchModalParams>} LogObject<restaurantsOloLiveSiteClicksInsideDispatchModalParams>
 */
export function restaurantsOloLiveSiteClicksInsideDispatchModal(params) {
    return { evid: 530, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc159Evid5300' event (evid: 5300)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc159Evid5300Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc159Evid5300Params>} LogObject<dummyNameSrc159Evid5300Params>
 */
export function dummyNameSrc159Evid5300(params) {
    return { evid: 5300, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteDispatchModalClosed' event (evid: 531)
 *
 * Event description: online orders page on live site ->Dispatch modal closed
 *
 * @param {restaurantsOloLiveSiteDispatchModalClosedParams} params - The parameters for this event
 * @property {boolean} isDeliveryDisplayed - true/false - is it displayed on the modal?
 * @property {DateTime} pickupTime - if its not asap so the datetime with the hour and the date of today/ of the preorder date
 * @property {string} changedFields - all the fields that were changed on the save
 * @property {boolean} isPreorderDisplayed - is it displayed on the modal? is it an option?
 * @property {number} businessDays - -
 * @property {string} schedulingType - asap/asap+future/preorder/sameday
 * @property {DateTime} fromDateAndTime - -
 * @property {boolean} isPickupDisplayed - true/false - is it displayed on the modal?
 * @property {GUID} operationId - -
 * @property {DateTime} untilDateAndTime - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {boolean} isAsapDisplayed - is it displayed of the modal? is it an option?
 * @property {string} deliveryTime - -
 * @property {string} pickupTimingType - asap / later_today/preorder
 * @property {string} currentFulfillment - pickup/delivery- the chosen fulfillment at the moment of the modal load
 * @property {DateTime} dateAndTime - the date and time of the pickup/delivery
 * @property {string} selectedRadioButton - asap/future/null - send only for asap+future
 * @property {string} triggerName - save/ x_button/ click_outside_modal
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<restaurantsOloLiveSiteDispatchModalClosedParams>} LogObject<restaurantsOloLiveSiteDispatchModalClosedParams>
 */
export function restaurantsOloLiveSiteDispatchModalClosed(params) {
    return { evid: 531, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBar' event (evid: 532)
 *
 * Event description: online orders page on live site ->Online orders page > Clicks on menu bar
 *
 * @param {restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBarParams} params - The parameters for this event
 * @property {number} cartState - the number of items on the cart
 * @property {string} sectionName - the name of the section where clicked
 * @property {number} currentSectionNumber - the number of the section that the uou is see at the time of the click. is it the second one? the first_one?
 * @property {GUID} operationId - -
 * @property {boolean} isMemberLoggedIn - true/false
 * @property {string} sectionId - the id of the sections that was clicked
 * @property {number} numTotalSections - number of all the sections (including duplicates)
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBarParams>} LogObject<restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBarParams>
 */
export function restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBar(params) {
    return { evid: 532, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInside' event (evid: 533)
 *
 * Event description: online orders page on live site ->Online orders page > Clicks on menu dropdown and other menus inside when there is more than one menu
 *
 * @param {restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInsideParams} params - The parameters for this event
 * @property {number} menuNumber - the menu that was clickes -  starts from 0, the first menu will be 0 and the second will be 1 ...
 * @property {string} statusDisplayed - what is the status that displayed at the moment of the click
 * @property {string} currentMenuName - -
 * @property {string} menuName - the name of the menu that was clicked
 * @property {GUID} operationId - -
 * @property {number} currentMenuNumber - the number of the menu that the uou is see at the time of the click. is it the second one? the first_one? - starts from 0, the first menu will be 0 and the second will be 1 ...
 * @property {number} numTotalMenus - number of all the menus (including duplicates))
 * @property {string} buttonName - dropdown / or menu option
 * @property {string} menuId - the id of the menu that was clicked
 * @property {string} currentMenuId - -
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInsideParams>} LogObject<restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInsideParams>
 */
export function restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInside(params) {
    return { evid: 533, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloServiceFeePageLoad' event (evid: 534)
 *
 * Event description: when service fee page was loaded
 *
 * @param {oloServiceFeePageLoadParams} params - The parameters for this event
 * @property {string} refferal_info - what was the entry point for this page.
 * @property {number} numRules - how many rules are in the page? if 0 so 0
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @return {LogObject<oloServiceFeePageLoadParams>} LogObject<oloServiceFeePageLoadParams>
 */
export function oloServiceFeePageLoad(params) {
    return { evid: 534, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloServiceFeeGenericClicks' event (evid: 535)
 *
 * Event description: Generic clicks on the service page
 *
 * @param {oloServiceFeeGenericClicksParams} params - The parameters for this event
 * @property {string} name - name of the rule
 * @property {string} actionType - click/ modal_opened
 * @property {string} value - 3_dots, edit, click_on_rule, delete , delete_modal_opened , cancel_delete , delete_service_fee
 * @property {GUID} ruleId - -
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @return {LogObject<oloServiceFeeGenericClicksParams>} LogObject<oloServiceFeeGenericClicksParams>
 */
export function oloServiceFeeGenericClicks(params) {
    return { evid: 535, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloServiceFeeServiceFeeModalOpened' event (evid: 536)
 *
 * Event description: Service fee modal opened for edit or create
 *
 * @param {oloServiceFeeServiceFeeModalOpenedParams} params - The parameters for this event
 * @property {number} percentage - if it's edit type
 * @property {string} name - rule name if it's edit type
 * @property {number} subtotalMin - if it's edit type
 * @property {string} ruleType - if it's edit type
 * @property {number} amount - if it's edit type
 * @property {string} taxGroupId - if it's edit type
 * @property {number} subtotalMax - if it's edit type, and only if it's a range
 * @property {string} mode - the modal type edit/create
 * @property {GUID} ruleId - if it's edit type
 * @property {string} fulfillmentTypes - if it's edit type
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @return {LogObject<oloServiceFeeServiceFeeModalOpenedParams>} LogObject<oloServiceFeeServiceFeeModalOpenedParams>
 */
export function oloServiceFeeServiceFeeModalOpened(params) {
    return { evid: 536, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloServiceFeeSaveServiceFee' event (evid: 537)
 *
 * Event description: Save service fee (also create also edit)
 *
 * @param {oloServiceFeeSaveServiceFeeParams} params - The parameters for this event
 * @property {number} percentage - -
 * @property {string} name - -
 * @property {string} errorMessage - if is_success  = false
 * @property {number} subtotalMin - -
 * @property {string} fieldMask - list of fields that were changed
 * @property {boolean} isSuccess - true/false
 * @property {string} ruleType - percentage / amount
 * @property {number} amount - -
 * @property {string} taxGroupId - -
 * @property {number} subtotalMax - -
 * @property {string} mode - create/edit
 * @property {GUID} ruleId - -
 * @property {string} fulfillmentTypes - -
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<oloServiceFeeSaveServiceFeeParams>} LogObject<oloServiceFeeSaveServiceFeeParams>
 */
export function oloServiceFeeSaveServiceFee(params) {
    return { evid: 537, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloServiceFeeDeleteServiceFee' event (evid: 538)
 *
 * Event description: Delete service fee
 *
 * @param {oloServiceFeeDeleteServiceFeeParams} params - The parameters for this event
 * @property {number} percentage - -
 * @property {string} name - -
 * @property {string} errorMessage - if is_success  = false
 * @property {number} subtotalMin - -
 * @property {boolean} isSuccess - true/false
 * @property {string} ruleType - -
 * @property {number} amount - -
 * @property {string} taxGroupId - -
 * @property {number} subtotalMax - -
 * @property {GUID} ruleId - -
 * @property {string} fulfillmentTypes - -
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<oloServiceFeeDeleteServiceFeeParams>} LogObject<oloServiceFeeDeleteServiceFeeParams>
 */
export function oloServiceFeeDeleteServiceFee(params) {
    return { evid: 538, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloMovedToPickachuSecondStep' event (evid: 539)
 *
 * Event description: when the user create a manuall order. the first step is when user try to add an item and the modal is open. if the user choose an item with modifiers or variants that requires second step of choosing the modal will show the second step. and this event is fired when the second step options are shown to the user
 *
 * @param {oloMovedToPickachuSecondStepParams} params - The parameters for this event
 * @property {number} numModifiers - -
 * @property {string} sectionId - -
 * @property {string} itemId - -
 * @property {number} numModifiersGroups - -
 * @property {boolean} isSuccessful - true/false
 * @property {string} menuId - -
 * @property {number} numVariations - -
 * @property {string} origin - where the pickachu are used (POS/New Order)
 * Null = new order
 * @return {LogObject<oloMovedToPickachuSecondStepParams>} LogObject<oloMovedToPickachuSecondStepParams>
 */
export function oloMovedToPickachuSecondStep(params) {
    return { evid: 539, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloGenericDebugEvent' event (evid: 540)
 *
 * Event description: Generic Debug Events
 *
 * @param {oloGenericDebugEventParams} params - The parameters for this event
 * @property {string} subjectType - subject type
 * @property {string} hosting - editor/editorX/BM/studio/viewer
 * @property {string} value - JSON
 * @return {LogObject<oloGenericDebugEventParams>} LogObject<oloGenericDebugEventParams>
 */
export function oloGenericDebugEvent(params) {
    return { evid: 540, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloManualOrderFulfillmentModalContinueClick' event (evid: 541)
 *
 * Event description: User click on continue click inside Fulfillment Modal,and save fulfillment method of manual order. before the actual save of the full manual order
 *
 * @param {oloManualOrderFulfillmentModalContinueClickParams} params - The parameters for this event
 * @property {DateTime} orderTimeTo - the max in the range of pickup/delivery time
 * @property {string} currency - The type of currency
 * @property {DateTime} orderTimeFrom - the min in the range of pickup/delivery time
 * @property {string} fulfillmentMethod - delivery/pickup
 * @property {string} deliveryFeeString - Delivery fee in string format
 * @property {DateTime} futureOrderTime - If it is a future order, then what time is it for?
 * @property {boolean} isCustom - Is the fulfillment method a custom one, or a pre saved one
 * @property {GUID} operationId
 * @property {GUID} locationId
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @return {LogObject<oloManualOrderFulfillmentModalContinueClickParams>} LogObject<oloManualOrderFulfillmentModalContinueClickParams>
 */
export function oloManualOrderFulfillmentModalContinueClick(params) {
    return { evid: 541, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfuly' event (evid: 542)
 *
 * Event description: when user changes the default fulfillment or turns on/of one of the toggles and it affects the default fulfillment method(Changed Successfully)
 *
 * @param {oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfulyParams} params - The parameters for this event
 * @property {string} errorNumber - -
 * @property {string} operationIds - -
 * @property {string} currentDefaultFulfillmentStatus - current after change - pickup/delivery/ pickup_only/delivery_only / no_methods_enabled
 * @property {boolean} isAutomaticChange - true/false
 * @property {string} previousDefaultFulfillmentSatus - current after change - pickup/delivery/ pickup_only/delivery_only / no_methods_enabled
 * @property {string} errorDescription - -
 * @property {string} previousDefaultFulfillmentType - before change pickup/delivery
 * @property {string} currentDefaultFulfillmentType - current after change - pickup/delivery/
 * @property {boolean} isSuccessful - true/false
 * @property {GUID} locationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - -
 * @return {LogObject<oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfulyParams>} LogObject<oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfulyParams>
 */
export function oloPickupDeliveryPageDeafultFulfillmentChangedSuccesfuly(params) {
    return { evid: 542, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloEditorInstallationSteps' event (evid: 543)
 *
 * Event description: all the steps in the installations in Editor.In order to distinguish between olo/menu/ TR with the implicit app_id
 *
 * @param {oloEditorInstallationStepsParams} params - The parameters for this event
 * @property {boolean} isStudio - True/.false
 * @property {string} lightboxTitle - -
 * @property {string} step - which step in the installation flow is it?
 * @property {string} errorMessage - -
 * @property {boolean} isFirstInstall - True/false
 * @property {string} lightboxId - -
 * @property {GUID} appDefId - app_id that was installed
 * @property {boolean} isInstallationRetry - true/false
 * @property {string} lightboxLayout - -
 * @property {string} origin - -
 * @property {string} lightboxParentRef - -
 * @property {GUID} msid - msid
 * @property {string} value - -
 * @property {string} lightboxWidgetId - -
 * @return {LogObject<oloEditorInstallationStepsParams>} LogObject<oloEditorInstallationStepsParams>
 */
export function oloEditorInstallationSteps(params) {
    return { evid: 543, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloDoorDashSetupProcessClicks' event (evid: 544)
 *
 * Event description: All clicks in the doordash setup proccess: register, connect payments, enable tip.
 * Also includes uncollapse/collapse clicks
 *
 * @param {oloDoorDashSetupProcessClicksParams} params - The parameters for this event
 * @property {string} completedSteps - Comma separated string of the steps that were completed. for example if all steps were completed it will send: "register,payments,tips"
 * @property {string} field - register/payments/tips/collapse/uncollapse
 * @return {LogObject<oloDoorDashSetupProcessClicksParams>} LogObject<oloDoorDashSetupProcessClicksParams>
 */
export function oloDoorDashSetupProcessClicks(params) {
    return { evid: 544, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloDoorDashRegistrationModalSubmit' event (evid: 545)
 *
 * Event description: user clicked on submit in the doordash registration modal
 *
 * @param {oloDoorDashRegistrationModalSubmitParams} params - The parameters for this event
 * @property {string} errorDescription - if there was a problem, what caused it
 * @property {boolean} isSuccessful - After clicking register, we get a response from doordash if they created a pending status for this site. This does not mean the site got verification that it is Active!
 * @return {LogObject<oloDoorDashRegistrationModalSubmitParams>} LogObject<oloDoorDashRegistrationModalSubmitParams>
 */
export function oloDoorDashRegistrationModalSubmit(params) {
    return { evid: 545, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPickupDeliveryClosureDatesPageLoad' event (evid: 546)
 *
 * Event description: when closure dated page is loaded mobile+web
 *
 * @param {oloPickupDeliveryClosureDatesPageLoadParams} params - The parameters for this event
 * @property {number} pastClosureDates - -
 * @property {GUID} operationId - -
 * @property {number} numClosureDates - the amount of closure dated in the page from 0
 * @property {number} upcomingClosureDates - -
 * @property {string} operationName - -
 * @property {GUID} operationGroup
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation - if the location is archived
 * @property {boolean} isFirstOperationTab - is it the first operation tab? which the page was opened on.
 * @return {LogObject<oloPickupDeliveryClosureDatesPageLoadParams>} LogObject<oloPickupDeliveryClosureDatesPageLoadParams>
 */
export function oloPickupDeliveryClosureDatesPageLoad(params) {
    return { evid: 546, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloClosureDatesCreateEditClosureDateModalScreenLoad' event (evid: 547)
 *
 * Event description: when user opened closure date create/edit modal or the edit/create screen in the owner app load
 *
 * @param {oloClosureDatesCreateEditClosureDateModalScreenLoadParams} params - The parameters for this event
 * @property {string} name - -
 * @property {boolean} isAllDay - true./false
 * @property {GUID} closureDateId - -
 * @property {string} affectedMethods - string ('all_fulfillment_method' | 'all_delivery_fulfillment_methods' | 'all_pickup_fulfillment_methods' | 'specific_fulfillment_methods'
 * @property {GUID} operationId - -
 * @property {string} fulfillmentMethodIds - string/null (only relevant if the affectedMethods value is 'specific_fulfillment_methods', will be a list of ids - 'id-1,id-2,id-3'
 * @property {DateTime} end - the end date
 * @property {DateTime} start - the start date
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {string} operationName - -
 * @return {LogObject<oloClosureDatesCreateEditClosureDateModalScreenLoadParams>} LogObject<oloClosureDatesCreateEditClosureDateModalScreenLoadParams>
 */
export function oloClosureDatesCreateEditClosureDateModalScreenLoad(params) {
    return { evid: 547, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloClosureDateSaveSuccessFailure' event (evid: 548)
 *
 * Event description: is the closure date saved successfully or there was any error?
 *
 * @param {oloClosureDateSaveSuccessFailureParams} params - The parameters for this event
 * @property {string} name - -
 * @property {boolean} isAllDay - true./false
 * @property {GUID} closureDateId - -
 * @property {string} affectedMethods - string ('all_fulfillment_method' | 'all_delivery_fulfillment_methods' | 'all_pickup_fulfillment_methods' | 'specific_fulfillment_methods'
 * @property {GUID} operationId - -
 * @property {boolean} allDay - whether the closure spans across a full day or a time range
 * @property {string} errorDescription - -
 * @property {string} restaurantTimezone - -
 * @property {string} fulfillmentMethodIds - string/null (only relevant if the affectedMethods value is 'specific_fulfillment_methods', will be a list of ids - 'id-1,id-2,id-3'
 * @property {DateTime} end - the end date
 * @property {DateTime} start - the start date
 * @property {boolean} isSuccessful - true/false
 * @property {string} clientTimezone - -
 * @property {string} operationName - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @return {LogObject<oloClosureDateSaveSuccessFailureParams>} LogObject<oloClosureDateSaveSuccessFailureParams>
 */
export function oloClosureDateSaveSuccessFailure(params) {
    return { evid: 548, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloClosureDateDeleteSuccessFailure' event (evid: 549)
 *
 * Event description: is the closure date deleted successfully or there was any error?
 *
 * @param {oloClosureDateDeleteSuccessFailureParams} params - The parameters for this event
 * @property {string} name - -
 * @property {boolean} isAllDay - true./false
 * @property {GUID} closureDateId - -
 * @property {string} affectedMethods - string ('all_fulfillment_method' | 'all_delivery_fulfillment_methods' | 'all_pickup_fulfillment_methods' | 'specific_fulfillment_methods'
 * @property {GUID} operationId - -
 * @property {string} errorDescription - -
 * @property {string} fulfillmentMethodIds - string/null (only relevant if the affectedMethods value is 'specific_fulfillment_methods', will be a list of ids - 'id-1,id-2,id-3'
 * @property {DateTime} end - the end date
 * @property {DateTime} start - the start date
 * @property {boolean} isSuccessful - true/false
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {string} operationName - -
 * @property {boolean} isFirstOperationTab - is it the operations that the page opened on for the first time?
 * @return {LogObject<oloClosureDateDeleteSuccessFailureParams>} LogObject<oloClosureDateDeleteSuccessFailureParams>
 */
export function oloClosureDateDeleteSuccessFailure(params) {
    return { evid: 549, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloEditorMenuReorder' event (evid: 550)
 *
 * Event description: when the user drags a menu in settings in Editor and by that changes the order of the menus
 *
 * @param {oloEditorMenuReorderParams} params - The parameters for this event
 * @property {string} menuId - -
 * @property {string} menuName - -
 * @property {number} numMenus - -
 * @property {string} indexListBeforeChange - list of all menu ids and their index in the order of the menus
 * @property {string} indexListAfterChange - list of all menu ids and their index in the order of the menus
 * @return {LogObject<oloEditorMenuReorderParams>} LogObject<oloEditorMenuReorderParams>
 */
export function oloEditorMenuReorder(params) {
    return { evid: 550, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverOloDeliveryPartnersDeliveryEstimateSrc159Evid551' event (evid: 551)
 *
 * Event description: When a UoU is putting in it's address info while in the checkout flow, there are estimate calls preformed to see if the delivery partner is willing to accept the order.
 *
 * @param {serverOloDeliveryPartnersDeliveryEstimateSrc159Evid551Params} params - The parameters for this event
 * @property {string} type - the type of estimate preformed, as far as I know there are 3 types(dispatch modal, address details, submit order)
 * @property {boolean} isSuccessful - was the estimate approved, whether by DD or by our own estimation
 * @property {string} errorType - the type of error if there was a problem
 * @property {string} errorDescription - the full description the error
 * @property {string} deliveryPartner - Which delivery partner is related to the action
 * @property {boolean} isSandbox - we'd like to distinguish and monitor real cases vs our internal tests in a different way.
 * @property {string} meta_site_id - msid workaround
 * @return {LogObject<serverOloDeliveryPartnersDeliveryEstimateSrc159Evid551Params>} LogObject<serverOloDeliveryPartnersDeliveryEstimateSrc159Evid551Params>
 */
export function serverOloDeliveryPartnersDeliveryEstimateSrc159Evid551(params) {
    return { evid: 551, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverOloDeliveryPartnersAcceptOrderResponseSrc159Evid552' event (evid: 552)
 *
 * Event description: After an order has been submitted and the chosen courier is a delivery partner
 * The User needs to accept the order so the delivery partner will be notified. After the accept action, the delivery partner can still reject the order
 *
 * @param {serverOloDeliveryPartnersAcceptOrderResponseSrc159Evid552Params} params - The parameters for this event
 * @property {boolean} isSuccessful - was the estimate approved, whether by DD or by our own estimation
 * @property {string} errorType - the type of error if there was a problem
 * @property {string} errorDescription - the full description the error
 * @property {string} deliveryPartner - Which delivery partner is related to the action
 * @property {string} orderId - order Id
 * @property {boolean} isSandbox - we'd like to distinguish and monitor real cases vs our internal tests in a different way.
 * @property {number} fee - shipping fee (in "cents", need to *100)
 * @property {number} subtotal - price for all items in the order (in "cents", need to *100)
 * @property {string} currency - currency of order's subtotal and fee
 * @property {string} meta_site_id - msid workaround
 * @return {LogObject<serverOloDeliveryPartnersAcceptOrderResponseSrc159Evid552Params>} LogObject<serverOloDeliveryPartnersAcceptOrderResponseSrc159Evid552Params>
 */
export function serverOloDeliveryPartnersAcceptOrderResponseSrc159Evid552(params) {
    return { evid: 552, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverOloDeliveryPartnersCourierUpdateSrc159Evid553' event (evid: 553)
 *
 * Event description: After the order have been accepted by the delivery partner, the courier can send further updates on the delivery, including canceling it.
 *
 * @param {serverOloDeliveryPartnersCourierUpdateSrc159Evid553Params} params - The parameters for this event
 * @property {string} orderId - order Id
 * @property {string} deliveryPartner - the type of delivery partner
 * @property {string} updateType - the update type the courier has given. For example: order fulfilled, order canceled, etc...
 * @return {LogObject<serverOloDeliveryPartnersCourierUpdateSrc159Evid553Params>} LogObject<serverOloDeliveryPartnersCourierUpdateSrc159Evid553Params>
 */
export function serverOloDeliveryPartnersCourierUpdateSrc159Evid553(params) {
    return { evid: 553, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloSettingsPageSummaryCardPageLoadSrc159Evid554' event (evid: 554)
 *
 * Event description: we fire this bi event when we know if the summary card loaded successfully or not
 *
 * @param {oloSettingsPageSummaryCardPageLoadSrc159Evid554Params} params - The parameters for this event
 * @property {boolean} isSuccessful - true/false
 * @property {string} bannerType - upgrade_premium/ set_up_payment_method/upgrade premium set up payment/ null if there is no banner
 * @property {string} hours - json
 * @property {string} orderSchedulingTypeList - -
 * @property {string} schedulingTime - -
 * @property {string} menuIdsList - -
 * @property {number} numMenus - -
 * @property {number} isPickupEnabled - boolean. 1-true, 0-false
 * @property {number} hasEnabledDelivery - boolean. 1-true, 0-false
 * @property {string} fulfillmentMethodsIdsList - -
 * @property {string} operationId - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDeletedLocation - if the location is archived
 * @return {LogObject<oloSettingsPageSummaryCardPageLoadSrc159Evid554Params>} LogObject<oloSettingsPageSummaryCardPageLoadSrc159Evid554Params>
 */
export function oloSettingsPageSummaryCardPageLoadSrc159Evid554(params) {
    return { evid: 554, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloEditorViewOrderClickSrc159Evid555' event (evid: 555)
 *
 * Event description: when user clicks on the new button of "view order" that should open the mini cart.
 *
 * @param {oloEditorViewOrderClickSrc159Evid555Params} params - The parameters for this event
 * @property {boolean} isMemberLoggedIn - -
 * @property {number} cartState -  how many items in the cart when the button was clicked
 * @property {string} mode - preview/live site
 * @property {string} navigationTarget - full cart page or mini cart
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {GUID} locationId
 * @return {LogObject<oloEditorViewOrderClickSrc159Evid555Params>} LogObject<oloEditorViewOrderClickSrc159Evid555Params>
 */
export function oloEditorViewOrderClickSrc159Evid555(params) {
    return { evid: 555, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrderingTabInMenusPageOpenedSrc159Evid556' event (evid: 556)
 *
 * Event description: when the user edits menu details and opens the side panel. and the open ordering tab.
 *
 * @param {oloOrderingTabInMenusPageOpenedSrc159Evid556Params} params - The parameters for this event
 * @property {boolean} isSuccessful - -
 * @property {string} errorMessage - -
 * @property {string} menuId - -
 * @property {string} operationId - -
 * @property {boolean} isOnlineOrderingEnabled - -
 * @property {string} availabilityType - -
 * @property {string} availableTimes - -
 * @property {number} numOfAvailableDays - -
 * @property {number} numTimeSlots - -
 * @property {number} numOfInvalidTimeSlots - -
 * @property {string} timestampRanges - -
 * @property {string} operationName - -
 * @return {LogObject<oloOrderingTabInMenusPageOpenedSrc159Evid556Params>} LogObject<oloOrderingTabInMenusPageOpenedSrc159Evid556Params>
 */
export function oloOrderingTabInMenusPageOpenedSrc159Evid556(params) {
    return { evid: 556, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrderingTabInMenusPageSavedSrc159Evid557' event (evid: 557)
 *
 * Event description: when the user edits menu details and opens the side panel. and then edit the ordering tab and click on save.
 * If you want to know what changed in "save menu" you should use the menu id from "save info" bi event. check what events created at the same time or at the same minute. because save info fired separately from save ordering tab event.
 *
 * @param {oloOrderingTabInMenusPageSavedSrc159Evid557Params} params - The parameters for this event
 * @property {boolean} isSuccessful - -
 * @property {string} errorMessage - -
 * @property {string} menuId - -
 * @property {string} operationId - -
 * @property {boolean} isOnlineOrderingEnabled - -
 * @property {string} availabilityType - -
 * @property {string} availableTimes - -
 * @property {number} numOfAvailableDays - -
 * @property {number} numTimeSlots - -
 * @property {number} numOfInvalidTimeSlots - -
 * @property {string} timestampRanges - -
 * @property {string} changedFields - -
 * @property {string} operationName - -
 * @return {LogObject<oloOrderingTabInMenusPageSavedSrc159Evid557Params>} LogObject<oloOrderingTabInMenusPageSavedSrc159Evid557Params>
 */
export function oloOrderingTabInMenusPageSavedSrc159Evid557(params) {
    return { evid: 557, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloSettingsOrderWithGoogleStepsSectionsLoadSrc159Evid558' event (evid: 558)
 *
 * Event description: Steps sections load in the order with google page
 *
 * @param {oloSettingsOrderWithGoogleStepsSectionsLoadSrc159Evid558Params} params - The parameters for this event
 * @property {boolean} isFirstStepFinished - -
 * @property {boolean} isSecondStepFinished - -
 * @property {boolean} isThirdStepFinished - -
 * @property {boolean} isSuccessful - -
 * @property {boolean} isFirstStepError - -
 * @property {boolean} isSecondStepError - -
 * @property {boolean} isThirdStepError - -
 * @return {LogObject<oloSettingsOrderWithGoogleStepsSectionsLoadSrc159Evid558Params>} LogObject<oloSettingsOrderWithGoogleStepsSectionsLoadSrc159Evid558Params>
 */
export function oloSettingsOrderWithGoogleStepsSectionsLoadSrc159Evid558(params) {
    return { evid: 558, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloSettingsOrderWithGoogleLocationsSectionsLoadSrc159Evid559' event (evid: 559)
 *
 * Event description: Steps locations load in the order with google page
 *
 * @param {oloSettingsOrderWithGoogleLocationsSectionsLoadSrc159Evid559Params} params - The parameters for this event
 * @property {number} numTotalLocations - -
 * @property {number} numConnectedLocations - its verified on Google side and connected to OLO
 * @property {number} numNotConnectedLocations - its verified on Google side but not connected to OLO
 * @property {number} numUnverifiedLocations - all locations that are not verified in google side (closed, duplicated etc..)
 * @property {boolean} is_successful - -
 * @property {string} error_message - -
 * @return {LogObject<oloSettingsOrderWithGoogleLocationsSectionsLoadSrc159Evid559Params>} LogObject<oloSettingsOrderWithGoogleLocationsSectionsLoadSrc159Evid559Params>
 */
export function oloSettingsOrderWithGoogleLocationsSectionsLoadSrc159Evid559(params) {
    return { evid: 559, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrderWithGoogleOloLocationStatusUppdatedSrc159Evid560' event (evid: 560)
 *
 * Event description: when a location status is updated from our side  (not google side) it can be disconnect or connect, it can be manage in the future etc...
 *
 * @param {oloOrderWithGoogleOloLocationStatusUppdatedSrc159Evid560Params} params - The parameters for this event
 * @property {boolean} isSuccessful - -
 * @property {string} errorMessage - -
 * @property {string} previousOloStatus - its not the status on Google side that can be verified or unverified
 * @property {string} currentOloStatus - its not the status on Google side that can be verified or unverified
 * @property {string} googleLocationId - location id from Google side
 * @property {string} locationId - the location in in Wix
 * @property {string} featureId - the whole package of OLO feature with the google location_id, with the olo attributes etc..
 * @property {string} locationName - -
 * @property {string} locationStatus - from google side
 * @property {string} menuIds - -
 * @property {string} fulfillmentIds - -
 * @return {LogObject<oloOrderWithGoogleOloLocationStatusUppdatedSrc159Evid560Params>} LogObject<oloOrderWithGoogleOloLocationStatusUppdatedSrc159Evid560Params>
 */
export function oloOrderWithGoogleOloLocationStatusUppdatedSrc159Evid560(params) {
    return { evid: 560, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloEditorOrderPageWasAddedToEditorSrc159Evid561' event (evid: 561)
 *
 * Event description: when user add oerders page to editor
 *
 * @param {oloEditorOrderPageWasAddedToEditorSrc159Evid561Params} params - The parameters for this event
 * @property {GUID} operationId - -
 * @property {boolean} is_successful - -
 * @property {string} errorMessage - -
 * @property {boolean} isDuplicated - first step of creating the page
 * @property {boolean} isUpdated - second step of creating the page
 * @return {LogObject<oloEditorOrderPageWasAddedToEditorSrc159Evid561Params>} LogObject<oloEditorOrderPageWasAddedToEditorSrc159Evid561Params>
 */
export function oloEditorOrderPageWasAddedToEditorSrc159Evid561(params) {
    return { evid: 561, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloGenericEventClicksInsideModalSrc159Evid562' event (evid: 562)
 *
 * Event description: this is a generic bi event for all the clicks inside OLO's modals.
 * relevant for Editor, Live site and BM
 *
 * @param {oloGenericEventClicksInsideModalSrc159Evid562Params} params - The parameters for this event
 * @property {string} origin - Editor/Live site/Preview/BM
 * @property {string} pageName - -
 * @property {string} modalName - -
 * @property {string} buttonName - -
 * @property {string} operationId
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation - location_id, is_hidden, is_deleted, is_default_location, operation_id, operation_group
 * @property {string} operationStatus - hidden/visible
 * @property {string} msid - -
 * @return {LogObject<oloGenericEventClicksInsideModalSrc159Evid562Params>} LogObject<oloGenericEventClicksInsideModalSrc159Evid562Params>
 */
export function oloGenericEventClicksInsideModalSrc159Evid562(params) {
    return { evid: 562, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloEditorOrderPageWasDeletedFromEditorSrc159Evid563' event (evid: 563)
 *
 * Event description: when order page is deleted from Editor
 *
 * @param {oloEditorOrderPageWasDeletedFromEditorSrc159Evid563Params} params - The parameters for this event
 * @property {GUID} operationId - -
 * @property {boolean} is_successful - -
 * @property {string} errorMesage - -
 * @return {LogObject<oloEditorOrderPageWasDeletedFromEditorSrc159Evid563Params>} LogObject<oloEditorOrderPageWasDeletedFromEditorSrc159Evid563Params>
 */
export function oloEditorOrderPageWasDeletedFromEditorSrc159Evid563(params) {
    return { evid: 563, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloMultyPagesSwitchOperationSrc159Evid564' event (evid: 564)
 *
 * Event description: when user clicks on the tabs of multy operations  in the BM or switch it with the picker in the owner app.it can be in more than page in olo settings
 *
 * @param {oloMultyPagesSwitchOperationSrc159Evid564Params} params - The parameters for this event
 * @property {GUID} operationId - -
 * @property {string} operationName - -
 * @property {string} previousOperationId - -
 * @property {GUID} locationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {boolean} isDeletedLocation
 * @property {string} previousOperationName - summary_card / scheduling_page/ pickup_and_delivery_page/closure_dates
 * @property {string} locationName - operation location name
 * @property {string} previousLocationId - precious location id
 * @property {string} previousLocationName - precious location name
 * @property {string} location_Id - location_id
 * @property {string} operationStatus - hidden/visible
 * @property {string} pageName - -
 * @return {LogObject<oloMultyPagesSwitchOperationSrc159Evid564Params>} LogObject<oloMultyPagesSwitchOperationSrc159Evid564Params>
 */
export function oloMultyPagesSwitchOperationSrc159Evid564(params) {
    return { evid: 564, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrderWithGoogleRequestDataFromPromoteSrc159Evid565' event (evid: 565)
 *
 * Event description: when there is a data request from the promote side
 *
 * @param {oloOrderWithGoogleRequestDataFromPromoteSrc159Evid565Params} params - The parameters for this event
 * @property {boolean} isSuccessful - -
 * @property {string} errorDescription - -
 * @property {string} fulfillmentsIdList - -
 * @property {string} serviceFeesIdsList - -
 * @property {string} onlineOrderUrl - -
 * @property {string} menusIdsList - -
 * @return {LogObject<oloOrderWithGoogleRequestDataFromPromoteSrc159Evid565Params>} LogObject<oloOrderWithGoogleRequestDataFromPromoteSrc159Evid565Params>
 */
export function oloOrderWithGoogleRequestDataFromPromoteSrc159Evid565(params) {
    return { evid: 565, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloMultiplePagesSaveOrderPageSrc159Evid566' event (evid: 566)
 *
 * Event description: when user save an order page inside "manage orders pages" it can be that the users edited both paged and only one page.
 *
 * @param {oloMultiplePagesSaveOrderPageSrc159Evid566Params} params - The parameters for this event
 * @property {string} actionType - edit/create
 * @property {string} previousPageName - -
 * @property {string} currentPageName - -
 * @property {string} previousPageId - -
 * @property {string} currentPageId - -
 * @property {string} previousMenuIdsList - -
 * @property {string} CurrentMenuIdsList - -
 * @property {number} previousNumMenus - -
 * @property {number} currentNumMenus - -
 * @property {string} changedFields - -
 * @property {boolean} isSuccessful - true/false
 * @property {string} errorMessage - -
 * @property {string} operationID - -
 * @property {number} operationIndex - the index of the operation by the order of the tabs in Web Dashboard
 * @property {boolean} isDefaultLocation - is default location
 * @property {GUID} locationId - locationId
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationGroup - -
 * @return {LogObject<oloMultiplePagesSaveOrderPageSrc159Evid566Params>} LogObject<oloMultiplePagesSaveOrderPageSrc159Evid566Params>
 */
export function oloMultiplePagesSaveOrderPageSrc159Evid566(params) {
    return { evid: 566, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPosOrderPlacedSrc159Evid567' event (evid: 567)
 *
 * Event description: order placed using POS checkout - Mobile/Web
 *
 * @param {oloPosOrderPlacedSrc159Evid567Params} params - The parameters for this event
 * @property {GUID} orderId - ecom's orderid
 * @property {string} posType - mobile app/ web
 * @property {number} itemsQuantity - Orders total items (all items include non rest)
 * @return {LogObject<oloPosOrderPlacedSrc159Evid567Params>} LogObject<oloPosOrderPlacedSrc159Evid567Params>
 */
export function oloPosOrderPlacedSrc159Evid567(params) {
    return { evid: 567, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOrderReminderSoundSentSrc159Evid568' event (evid: 568)
 *
 * Event description: Reminder sound sent to user (reminder/new order alert)
 *
 * @param {oloOrderReminderSoundSentSrc159Evid568Params} params - The parameters for this event
 * @property {string} alertType - new order / unhandled reminder
 * @property {string} orderId - If ‘new order’ - order_id , else null.
 * @property {number} unhandledCount - If ‘unhandled reminder’ , amount of unhandled orders when sound sent, else null.
 * @property {boolean} is_default_location
 * @property {GUID} locationId - location id
 * @return {LogObject<oloOrderReminderSoundSentSrc159Evid568Params>} LogObject<oloOrderReminderSoundSentSrc159Evid568Params>
 */
export function oloOrderReminderSoundSentSrc159Evid568(params) {
    return { evid: 568, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPosItemsListViewSrc159Evid569' event (evid: 569)
 *
 * Event description: OLO POS items page view
 *
 * @param {oloPosItemsListViewSrc159Evid569Params} params - The parameters for this event
 * @property {number} num_of_items - Num of items loaded
 * @property {string} menus_ids - Menus are presented. “id1, id2”
 * @property {number} num_of_menus - Num of menus loaded
 * @property {string} selected_items - Item ids with amount of selected (if an item selected twice then 2) - JSON
 * @return {LogObject<oloPosItemsListViewSrc159Evid569Params>} LogObject<oloPosItemsListViewSrc159Evid569Params>
 */
export function oloPosItemsListViewSrc159Evid569(params) {
    return { evid: 569, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPosItemDetailsPageViewSrc159Evid570' event (evid: 570)
 *
 * Event description: OLO POS Item details page view
 *
 *
 *
 * @param {oloPosItemDetailsPageViewSrc159Evid570Params} params - The parameters for this event
 * @property {string} item_id - item_id
 * @property {string} menu_ids - Item Menus - “id1, id2”
 * @property {boolean} is_selected - Is the item already in the cart?
 * @property {string} origin - search/items list
 * @property {string} item_options - all item details presented to the user to edit
 * @return {LogObject<oloPosItemDetailsPageViewSrc159Evid570Params>} LogObject<oloPosItemDetailsPageViewSrc159Evid570Params>
 */
export function oloPosItemDetailsPageViewSrc159Evid570(params) {
    return { evid: 570, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloLiveSiteMenuUnavailableCardDisplayedCollapsedSrc159Evid571' event (evid: 571)
 *
 * Event description: Menu unavailable in live site, card displayed/collapsed in live site.
 *
 * @param {restaurantsOloLiveSiteMenuUnavailableCardDisplayedCollapsedSrc159Evid571Params} params - The parameters for this event
 * @property {string} cardDisplayed - displayed/collapsed
 * @property {string} pageName - olo page / dish modal
 * @property {string} menuId - The relevant menu the model is referred to
 * @property {string} operationId - Relevant operation_id
 * @property {string} mode - live site/ preview
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} isButtonDisplayed - null/false/true
 * @property {string} itemId - If relevant (dish modal)
 * @property {string} sectionId - If relevant (dish modal)
 * @return {LogObject<restaurantsOloLiveSiteMenuUnavailableCardDisplayedCollapsedSrc159Evid571Params>} LogObject<restaurantsOloLiveSiteMenuUnavailableCardDisplayedCollapsedSrc159Evid571Params>
 */
export function restaurantsOloLiveSiteMenuUnavailableCardDisplayedCollapsedSrc159Evid571(params) {
    return { evid: 571, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsSwitchLocationSrc159Evid572' event (evid: 572)
 *
 * Event description: User chose another location in the location picker.
 *
 * @param {restaurantsSwitchLocationSrc159Evid572Params} params - The parameters for this event
 * @property {string} pageName - name of the page
 * @property {string} product - the specific product this event is related to: menus/table reservations/orders etc
 * @property {string} operationID - destination operation
 * @property {string} operationGroup - -
 * @property {boolean} isDeletedLocation - is the selected location the user clicked on is deleted location
 * @property {GUID} previousLocationId - the currennt location_id (from where the user did the select location click)
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} locationId - the location the user clicked on
 * @property {boolean} isDefaultLocation - is the selected location the user clicked on is the default location
 * @property {boolean} isAllOperationsHiddens - is the selected location's operations are all hidden
 * @return {LogObject<restaurantsSwitchLocationSrc159Evid572Params>} LogObject<restaurantsSwitchLocationSrc159Evid572Params>
 */
export function restaurantsSwitchLocationSrc159Evid572(params) {
    return { evid: 572, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloInvalidAddressErrorMessageSrc159Evid573' event (evid: 573)
 *
 * Event description: When error shown in context modal for invalid address
 *
 * @param {restaurantsOloInvalidAddressErrorMessageSrc159Evid573Params} params - The parameters for this event
 * @property {GUID} locationId - the location id of that invalid location
 * @property {string} errorTypes - missing subdivision/missing country/ missing lat-long/formattedAddress/lat-long = 0-0/missing location/incomplete
 * @property {boolean} isDefaultLocation - is default location
 * @property {string} operationStatus - visible/hidden
 * @property {GUID} operationGroup - operation group
 * @property {string} operationId - operation id
 * @property {string} pageName - current page name
 * @return {LogObject<restaurantsOloInvalidAddressErrorMessageSrc159Evid573Params>} LogObject<restaurantsOloInvalidAddressErrorMessageSrc159Evid573Params>
 */
export function restaurantsOloInvalidAddressErrorMessageSrc159Evid573(params) {
    return { evid: 573, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloLiveSiteOperationDurationSrc159Evid578' event (evid: 578)
 *
 * Event description: Performance event for live site for APIs or business logic
 *
 * @param {oloLiveSiteOperationDurationSrc159Evid578Params} params - The parameters for this event
 * @property {GUID} locationId - -
 * @property {GUID} operationGroup - -
 * @property {boolean} isDefaultLocation - -
 * @property {string} appName - -
 * @property {string} eventName - API name / Business Logic
 * @property {number} duration - time in ms
 * @property {boolean} SSRCache - whether the data was exist in cache
 * @property {boolean} isSSRCall - whether the request called from SSR-Server or Browser
 * @property {string} extraFields - quantities for business logic, request data for APIs
 * @property {string} operationId - -
 * @return {LogObject<oloLiveSiteOperationDurationSrc159Evid578Params>} LogObject<oloLiveSiteOperationDurationSrc159Evid578Params>
 */
export function oloLiveSiteOperationDurationSrc159Evid578(params) {
    return { evid: 578, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOperationStatusChangeSuccessSrc159Evid580' event (evid: 580)
 *
 * Event description: When turning an operation to status: hide/visible
 *
 * @param {oloOperationStatusChangeSuccessSrc159Evid580Params} params - The parameters for this event
 * @property {boolean} isSuccessful - true/false
 * @property {string} operationID - -
 * @property {string} operationStatus - hidden/visible
 * @property {string} operationGroup - -
 * @property {GUID} locationId
 * @return {LogObject<oloOperationStatusChangeSuccessSrc159Evid580Params>} LogObject<oloOperationStatusChangeSuccessSrc159Evid580Params>
 */
export function oloOperationStatusChangeSuccessSrc159Evid580(params) {
    return { evid: 580, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloSettingsSchedulingPageSaveServer' event (evid: 601)
 *
 * Event description: When the server is saving the schedule page.
 * when the page is saved as asap, preorder values will be null and vice versa.
 *
 * @param {oloSettingsSchedulingPageSaveServerParams} params - The parameters for this event
 * @property {string} preorderType - 'timeBounded' | 'weekly'
 * @property {number} weeklyTimeOfDayMinutes - -
 * @property {number} atMostInAdvancedValue - in minutes (preorders fields only)
 * @property {string} atLeastInAdvancedTimeUnit - minutes/hours.. (preorders fields only)
 * @property {string} rangeMinUnit - minutes/hours/days
 * @property {string} asapType - max/ range (asap fields only)
 * @property {number} rangeMinDuration - in minutes (asap fields only)
 * @property {number} rangeMaxDuration - in minutes (asap fields only)
 * @property {string} fieldMask - string of all the fields that were changed in this "save"
 * @property {GUID} operationId - operation id
 * @property {string} rangeMaxUnit - minutes/hours/days
 * @property {string} atMostInAdvancedTimeUnit - minutes/hours.. (preorders fields only)
 * @property {string} actionType - create or update
 * @property {string} maxDurationUnit - minutes/hours/days
 * @property {number} windowValue - in minutes, (preorders fields only)
 * @property {string} scheduleType - asap/pre-orders
 * @property {string} weeklyDayOfWeek - 'SUNDAY', 'MONDAY', 'TUESDAY', ...
 * @property {boolean} allowOrdersLaterToday - true when toggle on or false when toggle off
 * @property {string} windowTimeUnit - hours/minutes, (preorders fields only)
 * @property {number} weeklyTimeOfDayHours - -
 * @property {number} atLeastInAdvancedValue - in minutes (preorders fields only)
 * @property {boolean} operationEnable - true if olo toggle is on and false if olo toggle is off
 * @property {number} maxOptionDuration - in minutes (asap fields only)
 * @property {GUID} locationId
 * @property {string} operationStatus - hidden/visible
 * @property {boolean} isDefaultLocation
 * @property {GUID} operationGroup
 * @return {LogObject<oloSettingsSchedulingPageSaveServerParams>} LogObject<oloSettingsSchedulingPageSaveServerParams>
 */
export function oloSettingsSchedulingPageSaveServer(params) {
    return { evid: 601, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaSavedServer' event (evid: 614)
 *
 * Event description: OLO -> Delivery Area -> Saved including toggle action change
 *
 * @param {oloDeliveryAreaSavedServerParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} numOfAvailableDays - how many days are checked
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"close":"23:59","open":"00:00"}],"MONDAY":[{"close":"23:59","open":"00:00"}]
 * @property {number} numOdPoints - only if chosen, if not so null (draw on map)
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - in order to get the accurate value divide by 100
 * @property {string} radiusUnit - -
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} numPostalCodes - only if chosen, if not so null
 * @property {string} actionType - create/edit
 * @property {number} customAreaNumOfPoints - -
 * @property {string} postalCodeCountry - -
 * @property {GUID} fulfillmentId - when its delivery area or pickup
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, zip/postal codes , draw_on_map
 * @property {number} radiusDistance - we need to divide by 100 on order o get the accurate value
 * @property {boolean} isEnabled - if toggle on then true  if toggle off then false
 * @property {string} fulfillmentName - -
 * @property {GUID} externalProviderId - -
 * @property {GUID} operationGroup
 * @property {GUID} locationId
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationId - -
 * @return {LogObject<oloDeliveryAreaSavedServerParams>} LogObject<oloDeliveryAreaSavedServerParams>
 */
export function oloDeliveryAreaSavedServer(params) {
    return { evid: 614, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloDeliveryAreaDeletedServer' event (evid: 615)
 *
 * Event description: OLO -> Delivery Area ->delete delivery area
 *
 * @param {oloDeliveryAreaDeletedServerParams} params - The parameters for this event
 * @property {number} freeDeliveryAboveValue - null if there is no value
 * @property {number} deliveryFee - -
 * @property {string} availableTimes - {"FRIDAY":[{"close":"23:59","open":"00:00"}],"MONDAY":[{"close":"23:59","open":"00:00"}]
 * @property {number} numOdPoints - only if chosen, if not so null (draw on map)
 * @property {number} zipCodeCountry - only if chosen, if not so null
 * @property {number} numTimeSlots - -
 * @property {number} orderMin - in order to get the accurate value divide by 100
 * @property {string} radiusUnit - -
 * @property {number} radius - only if chosen, if not so null
 * @property {number} numOfAvailbaleDays - how many days are checked
 * @property {boolean} offerFreeDelivery - true if checked and  false if uncheck.
 * @property {number} numPostalCodes - only if chosen, if not so null
 * @property {number} customAreaNumOfPoints - -
 * @property {string} postalCodeCountry - -
 * @property {GUID} fulfillmentId - when its delivery area or pickup
 * @property {number} deliveryTime - in minutes
 * @property {string} areaType - radius, zip/postal codes , draw_on_map
 * @property {number} radiusDistance - -
 * @property {boolean} isEnabled - if toggle on then true  if toggle off then false
 * @property {string} fulfillmentName - -
 * @property {GUID} category_external_id - -
 * @property {GUID} locationId
 * @property {GUID} operationId
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {string} operationStatus - hidden/visible
 * @return {LogObject<oloDeliveryAreaDeletedServerParams>} LogObject<oloDeliveryAreaDeletedServerParams>
 */
export function oloDeliveryAreaDeletedServer(params) {
    return { evid: 615, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPickupPageToggleActionSavedServer' event (evid: 617)
 *
 * Event description: OLO -> Pickup Page -> Saved and also toggle actions
 *
 * @param {oloPickupPageToggleActionSavedServerParams} params - The parameters for this event
 * @property {number} numOfAvailableDays - number of available days
 * @property {string} availableTimes - json of days and hours list of pickup available
 * @property {number} numTimeSlots - each day have at least one slots of hours, so its the total number of time slots
 * @property {number} orderMin - need to divide by 100
 * @property {GUID} fulfillmentId - -
 * @property {boolean} isEnabled - true/false toggle action
 * @property {GUID} operationId - -
 * @property {string} operationStatus - hidden/visible
 * @property {GUID} operationGroup
 * @property {boolean} isDefaultLocation
 * @property {GUID} locationId
 * @return {LogObject<oloPickupPageToggleActionSavedServerParams>} LogObject<oloPickupPageToggleActionSavedServerParams>
 */
export function oloPickupPageToggleActionSavedServer(params) {
    return { evid: 617, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPosItemEditedSrc159Evid671' event (evid: 671)
 *
 * Event description: Item details edited
 *
 * @param {oloPosItemEditedSrc159Evid671Params} params - The parameters for this event
 * @property {string} item_id - item_id
 * @property {string} menu_ids - Item Menus - “id1, id2”
 * @property {string} section_type - The section type the item was edited (e.g - modifier / variant /special request)
 * @property {string} section_name - Edited section name (e.g - toppings / protein / special request)
 * @property {string} old_value - What was the old value before change
 * @property {string} new_value - What is the new value after change
 * @return {LogObject<oloPosItemEditedSrc159Evid671Params>} LogObject<oloPosItemEditedSrc159Evid671Params>
 */
export function oloPosItemEditedSrc159Evid671(params) {
    return { evid: 671, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantStartDemoDataInjectionAttempt' event (evid: 720)
 *
 * Event description: Attempt for injecting demo data with app
 *
 * @param {aiAssistantStartDemoDataInjectionAttemptParams} params - The parameters for this event
 * @property {string} app_id - which app we inject demo data to
 * @property {string} ai_model - The model used by the service
 * @property {boolean} isScala - -
 * @return {LogObject<aiAssistantStartDemoDataInjectionAttemptParams>} LogObject<aiAssistantStartDemoDataInjectionAttemptParams>
 */
export function aiAssistantStartDemoDataInjectionAttempt(params) {
    return { evid: 720, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantCompletedDemoDataInjectionAttempt' event (evid: 729)
 *
 * Event description: AI Assistant - Completed Demo Data Injection Attempt
 *
 * @param {aiAssistantCompletedDemoDataInjectionAttemptParams} params - The parameters for this event
 * @property {number} work_time - time from request start to completion in ms
 * @property {string} ai_model - The model used by the service
 * @property {string} app_id - app we injected demo data into
 * @property {boolean} isScala - -
 * @return {LogObject<aiAssistantCompletedDemoDataInjectionAttemptParams>} LogObject<aiAssistantCompletedDemoDataInjectionAttemptParams>
 */
export function aiAssistantCompletedDemoDataInjectionAttempt(params) {
    return { evid: 729, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantOpenaiCall' event (evid: 797)
 *
 * Event description: -
 *
 * @param {aiAssistantOpenaiCallParams} params - The parameters for this event
 * @property {number} duration - milliseconds between start and finish of generation request to ai gateway
 * @property {boolean} isFallback - is_fallback
 * @property {string} inputText - input to prompt
 * @property {boolean} isError - is_error
 * @property {string} promptId - prompt id
 * @property {string} vendorId - vendorID of the call
 * @property {number} orderIndex - message order index in chat that was the last one in the chat in this prompt
 * @property {string} outputText - output from prompt
 * @property {GUID} msid - msid
 * @property {boolean} isScala - -
 * @return {LogObject<aiAssistantOpenaiCallParams>} LogObject<aiAssistantOpenaiCallParams>
 */
export function aiAssistantOpenaiCall(params) {
    return { evid: 797, src: 159, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusSectionCollapse' event (evid: 100)
 *
 * Event description: dashboard_menus_section_collapse
 *
 * @param {dashboardMenusSectionCollapseParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusSectionCollapseParams>} LogObject<dashboardMenusSectionCollapseParams>
 */
export function dashboardMenusSectionCollapse(params) {
    return { evid: 100, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderStatusChange' event (evid: 1001)
 *
 * Event description: the event will be sent each time the status of the order is changed
 *
 * @param {orderStatusChangeParams} params - The parameters for this event
 * @property {string} orderId - order ID
 * @property {string} restaurantId - rest ID
 * @property {string} orderStatus - accepted/ canceled/ fulfilled
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<orderStatusChangeParams>} LogObject<orderStatusChangeParams>
 */
export function orderStatusChange(params) {
    return { evid: 1001, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderCreated' event (evid: 1003)
 *
 * Event description: the event will be sent each time an order is created
 *
 * @param {orderCreatedParams} params - The parameters for this event
 * @property {number} abTestSum - always 1
 * @property {string} customerInfo - customer object
 * @property {string} orderId - order ID
 * @property {string} feeIds - -
 * @property {string} restaurantId - rest ID
 * @property {string} activities - activities object
 * @property {string} coupon - coupon object
 * @property {number} taxAmount - of the service fee
 * @property {string} paymentsInfo - payments array
 * @property {GUID} locationGuid - location ID
 * @property {string} fulfillment - fulfillment object
 * @property {string} lineItemsInfo - line items array
 * @property {string} comment - comment
 * @property {number} feesCount - -
 * @property {string} discountsInfo - discounts object
 * @property {string} currency - currency
 * @property {number} taxAndFeesAmount - of the service fee
 * @property {number} feesAmount - -
 * @property {GUID} msid - msid
 * @property {string} loyaltyInfo - loyalty info object
 * @property {string} channelInfo - sales channel that submitted the order
 * @property {string} totals - totals object
 * @return {LogObject<orderCreatedParams>} LogObject<orderCreatedParams>
 */
export function orderCreated(params) {
    return { evid: 1003, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsOwnerAppFiltersViewClickOnApply' event (evid: 1008)
 *
 * Event description: Click on Apply
 *
 * @param {restaurantsTableReservationsOwnerAppFiltersViewClickOnApplyParams} params - The parameters for this event
 * @property {string} filtersOn - -
 * @property {GUID} reservationsLocationId - -
 * @property {number} numRowsBeforeFilter - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - location_guid
 * @property {number} numFiltersOn - -
 * @return {LogObject<restaurantsTableReservationsOwnerAppFiltersViewClickOnApplyParams>} LogObject<restaurantsTableReservationsOwnerAppFiltersViewClickOnApplyParams>
 */
export function restaurantsTableReservationsOwnerAppFiltersViewClickOnApply(params) {
    return { evid: 1008, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsOwnerAppFiltersViewClickOnFilterCheckbox' event (evid: 1009)
 *
 * Event description: Click on filter checkbox
 *
 * @param {restaurantsTableReservationsOwnerAppFiltersViewClickOnFilterCheckboxParams} params - The parameters for this event
 * @property {string} actionStatus - true/false
 * @property {string} filtersName - -
 * @property {GUID} locationGuid - -
 * @return {LogObject<restaurantsTableReservationsOwnerAppFiltersViewClickOnFilterCheckboxParams>} LogObject<restaurantsTableReservationsOwnerAppFiltersViewClickOnFilterCheckboxParams>
 */
export function restaurantsTableReservationsOwnerAppFiltersViewClickOnFilterCheckbox(params) {
    return { evid: 1009, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusSectionExpand' event (evid: 101)
 *
 * Event description: dashboard_menus_section_expand
 *
 * @param {dashboardMenusSectionExpandParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusSectionExpandParams>} LogObject<dashboardMenusSectionExpandParams>
 */
export function dashboardMenusSectionExpand(params) {
    return { evid: 101, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsOwnerAppFiltersViewClickOnClearAllFilters' event (evid: 1010)
 *
 * Event description: Click on clear all filters
 *
 * @param {restaurantsTableReservationsOwnerAppFiltersViewClickOnClearAllFiltersParams} params - The parameters for this event
 * @property {GUID} reservationLocationId - -
 * @property {string} clearedFilters - list of filters
 * @property {GUID} locationGuid - -
 * @property {number} numClearedFilters - -
 * @return {LogObject<restaurantsTableReservationsOwnerAppFiltersViewClickOnClearAllFiltersParams>} LogObject<restaurantsTableReservationsOwnerAppFiltersViewClickOnClearAllFiltersParams>
 */
export function restaurantsTableReservationsOwnerAppFiltersViewClickOnClearAllFilters(params) {
    return { evid: 1010, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusChoiceReorder' event (evid: 102)
 *
 * Event description: dashboard_menus_choice_reorder
 *
 * @param {dashboardMenusChoiceReorderParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} position_after - --
 * @property {string} menu - --
 * @property {string} option - --
 * @property {string} position_before - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusChoiceReorderParams>} LogObject<dashboardMenusChoiceReorderParams>
 */
export function dashboardMenusChoiceReorder(params) {
    return { evid: 102, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishEditAutocompleteClick' event (evid: 104)
 *
 * Event description: dashboard_menus_dish_edit_autocomplete_click
 *
 * @param {dashboardMenusDishEditAutocompleteClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} text - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} selection - --
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishEditAutocompleteClickParams>} LogObject<dashboardMenusDishEditAutocompleteClickParams>
 */
export function dashboardMenusDishEditAutocompleteClick(params) {
    return { evid: 104, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishAddOption' event (evid: 105)
 *
 * Event description: dashboard_menus_dish_add_option
 *
 * @param {dashboardMenusDishAddOptionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishAddOptionParams>} LogObject<dashboardMenusDishAddOptionParams>
 */
export function dashboardMenusDishAddOption(params) {
    return { evid: 105, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishDeleteOption' event (evid: 106)
 *
 * Event description: dashboard_menus_dish_delete_option
 *
 * @param {dashboardMenusDishDeleteOptionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} option - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishDeleteOptionParams>} LogObject<dashboardMenusDishDeleteOptionParams>
 */
export function dashboardMenusDishDeleteOption(params) {
    return { evid: 106, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishEditOptionSetField' event (evid: 107)
 *
 * Event description: dashboard_menus_dish_edit_option_set_field
 *
 * @param {dashboardMenusDishEditOptionSetFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} field - --
 * @property {string} option - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {string} value - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishEditOptionSetFieldParams>} LogObject<dashboardMenusDishEditOptionSetFieldParams>
 */
export function dashboardMenusDishEditOptionSetField(params) {
    return { evid: 107, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishEditOptionFieldError' event (evid: 108)
 *
 * Event description: dashboard_menus_dish_edit_option_field_error
 *
 * @param {dashboardMenusDishEditOptionFieldErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} field - --
 * @property {string} option - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {string} value - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishEditOptionFieldErrorParams>} LogObject<dashboardMenusDishEditOptionFieldErrorParams>
 */
export function dashboardMenusDishEditOptionFieldError(params) {
    return { evid: 108, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishAddLabel' event (evid: 109)
 *
 * Event description: dashboard_menus_dish_add_label
 *
 * @param {dashboardMenusDishAddLabelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} label_name - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishAddLabelParams>} LogObject<dashboardMenusDishAddLabelParams>
 */
export function dashboardMenusDishAddLabel(params) {
    return { evid: 109, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishRemoveLabel' event (evid: 110)
 *
 * Event description: dashboard_menus_dish_remove_label
 *
 * @param {dashboardMenusDishRemoveLabelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} label_name - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishRemoveLabelParams>} LogObject<dashboardMenusDishRemoveLabelParams>
 */
export function dashboardMenusDishRemoveLabel(params) {
    return { evid: 110, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOverviewPageOloToggle' event (evid: 111)
 *
 * Event description: activate or disabling the OLO feature with toggle located in the overview page
 *
 * @param {dashboardOloOverviewPageOloToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location ID
 * @property {string} organization_id - guid
 * @property {string} value - the end state of the feature (active/paused)
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOverviewPageOloToggleParams>} LogObject<dashboardOloOverviewPageOloToggleParams>
 */
export function dashboardOloOverviewPageOloToggle(params) {
    return { evid: 111, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOverviewPageOpenEditModalOfFeatureActivation' event (evid: 112)
 *
 * Event description: open the edit modal of the feature activation or disabling  can be open after first time using the toggle or direct click on the title
 *
 * @param {dashboardOloOverviewPageOpenEditModalOfFeatureActivationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - toggle/title
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOverviewPageOpenEditModalOfFeatureActivationParams>} LogObject<dashboardOloOverviewPageOpenEditModalOfFeatureActivationParams>
 */
export function dashboardOloOverviewPageOpenEditModalOfFeatureActivation(params) {
    return { evid: 112, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOverviewPageEditModalApplyButton' event (evid: 113)
 *
 * Event description: user clicked on the apply button in the edit feature activation modal
 *
 * @param {dashboardOloOverviewPageEditModalApplyButtonParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} comment_added - true/false (bool)
 * @property {string} source - toggle/title
 * @property {GUID} site_id - guid
 * @property {string} time_limit - tells rather the user used the time limit (no limit/closing time)
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - the end state of the feature (active/paused)
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOverviewPageEditModalApplyButtonParams>} LogObject<dashboardOloOverviewPageEditModalApplyButtonParams>
 */
export function dashboardOloOverviewPageEditModalApplyButton(params) {
    return { evid: 113, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOverviewPageEditModalCancelButton' event (evid: 114)
 *
 * Event description: user clicked on the cancel button in the edit feature activation modal
 *
 * @param {dashboardOloOverviewPageEditModalCancelButtonParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - toggle/title
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - 'x' / cancel / other
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOverviewPageEditModalCancelButtonParams>} LogObject<dashboardOloOverviewPageEditModalCancelButtonParams>
 */
export function dashboardOloOverviewPageEditModalCancelButton(params) {
    return { evid: 114, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOverviewPageDisplayMenusCheckBox' event (evid: 115)
 *
 * Event description: user checked / unchecked one of the menus to be shown in the OLO
 *
 * @param {dashboardOloOverviewPageDisplayMenusCheckBoxParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - menu_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {number} active_menus - number of active menus after click
 * @property {number} inactive_menus - number of inactive menus after click
 * @property {string} organization_id - guid
 * @property {string} value - active/paused
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOverviewPageDisplayMenusCheckBoxParams>} LogObject<dashboardOloOverviewPageDisplayMenusCheckBoxParams>
 */
export function dashboardOloOverviewPageDisplayMenusCheckBox(params) {
    return { evid: 115, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloUpperTabClick' event (evid: 116)
 *
 * Event description: user navigates to one of the sections in the upper bar
 *
 * @param {dashboardOloUpperTabClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - the source section where the user navigated from
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - name of the section (delivery/overview_page..)
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloUpperTabClickParams>} LogObject<dashboardOloUpperTabClickParams>
 */
export function dashboardOloUpperTabClick(params) {
    return { evid: 116, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPickupPagePickupToggle' event (evid: 117)
 *
 * Event description: user changed the state of the toggle in the pickup section -not for the first time
 *
 * @param {dashboardOloPickupPagePickupToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - the end state of the feature (active/paused)
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPickupPagePickupToggleParams>} LogObject<dashboardOloPickupPagePickupToggleParams>
 */
export function dashboardOloPickupPagePickupToggle(params) {
    return { evid: 117, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPickupPageEditDeliveryHoursClickOnLink' event (evid: 118)
 *
 * Event description: user clicked on the button to edit pickup hours
 *
 * @param {dashboardOloPickupPageEditDeliveryHoursClickOnLinkParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPickupPageEditDeliveryHoursClickOnLinkParams>} LogObject<dashboardOloPickupPageEditDeliveryHoursClickOnLinkParams>
 */
export function dashboardOloPickupPageEditDeliveryHoursClickOnLink(params) {
    return { evid: 118, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPickupPageDeliveryHoursApplyChanges' event (evid: 119)
 *
 * Event description: user applied changes of the delivery hours
 *
 * @param {dashboardOloPickupPageDeliveryHoursApplyChangesParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPickupPageDeliveryHoursApplyChangesParams>} LogObject<dashboardOloPickupPageDeliveryHoursApplyChangesParams>
 */
export function dashboardOloPickupPageDeliveryHoursApplyChanges(params) {
    return { evid: 119, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSettingsOpen' event (evid: 12)
 *
 * Event description: menus_settings_open
 *
 * @param {menusSettingsOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - {guid}
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusSettingsOpenParams>} LogObject<menusSettingsOpenParams>
 */
export function menusSettingsOpen(params) {
    return { evid: 12, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOverviewPageCreateMenuLinkClick' event (evid: 121)
 *
 * Event description: create menu link click
 *
 * @param {dashboardOloOverviewPageCreateMenuLinkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOverviewPageCreateMenuLinkClickParams>} LogObject<dashboardOloOverviewPageCreateMenuLinkClickParams>
 */
export function dashboardOloOverviewPageCreateMenuLinkClick(params) {
    return { evid: 121, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPickupPagePickUpSettingsSave' event (evid: 122)
 *
 * Event description: user saved the changes in the page
 *
 * @param {dashboardOloPickupPagePickUpSettingsSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} curbsidePickupCheckBox - on/off
 * @property {GUID} site_id - guid
 * @property {boolean} availability_modified - true/false (relative to the previous state)
 * @property {string} error_desc - in case the result=failure
 * @property {number} minimumOrder - minimum order price *100
 * @property {string} result - success/failure
 * @property {string} availability - duringHours/Custom
 * @property {number} delivery_time - what is the delivery time the user inserted
 * @property {GUID} locationGuid - location_guid
 * @property {string} curbsidePickupContent - content
 * @property {string} organization_id - guid
 * @property {string} curbsidePickupAdditionalInformation - content/null
 * @property {string} validationError - filed name
 * @property {string} value - active/paused
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPickupPagePickUpSettingsSaveParams>} LogObject<dashboardOloPickupPagePickUpSettingsSaveParams>
 */
export function dashboardOloPickupPagePickUpSettingsSave(params) {
    return { evid: 122, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPickupPagePickupSettingsCancel' event (evid: 123)
 *
 * Event description: user cancel the changes made in the page
 *
 * @param {dashboardOloPickupPagePickupSettingsCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPickupPagePickupSettingsCancelParams>} LogObject<dashboardOloPickupPagePickupSettingsCancelParams>
 */
export function dashboardOloPickupPagePickupSettingsCancel(params) {
    return { evid: 123, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageOpenEditCreditCardModal' event (evid: 124)
 *
 * Event description: user clicked on the edit credit card
 *
 * @param {dashboardOloPaymentPageOpenEditCreditCardModalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - toggle/edit
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageOpenEditCreditCardModalParams>} LogObject<dashboardOloPaymentPageOpenEditCreditCardModalParams>
 */
export function dashboardOloPaymentPageOpenEditCreditCardModal(params) {
    return { evid: 124, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageCashToggle' event (evid: 125)
 *
 * Event description: user changes the state of the cash payment method toggle
 *
 * @param {dashboardOloPaymentPageCashToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - active/paused
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageCashToggleParams>} LogObject<dashboardOloPaymentPageCashToggleParams>
 */
export function dashboardOloPaymentPageCashToggle(params) {
    return { evid: 125, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageCreditCardToggle' event (evid: 126)
 *
 * Event description: user changes the state of the credit card payment method toggle (not in the first time)
 *
 * @param {dashboardOloPaymentPageCreditCardToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - active/paused - end state of the toggle
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageCreditCardToggleParams>} LogObject<dashboardOloPaymentPageCreditCardToggleParams>
 */
export function dashboardOloPaymentPageCreditCardToggle(params) {
    return { evid: 126, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageActivateCreditCardClick' event (evid: 127)
 *
 * Event description: user clicked on the activate button from the credit card edit modal
 *
 * @param {dashboardOloPaymentPageActivateCreditCardClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} payments_method - manual/online
 * @property {string} source - toggle/edit
 * @property {GUID} site_id - guid
 * @property {string} manual_collection_type - phone/fax/on_delivery..
 * @property {GUID} locationGuid - location_guid
 * @property {string} card_mandatory_fields - separated with commas
 * @property {string} organization_id - guid
 * @property {string} online_gateway - paybox...
 * @property {string} credit_cards - list of the credit cards separated with commas
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageActivateCreditCardClickParams>} LogObject<dashboardOloPaymentPageActivateCreditCardClickParams>
 */
export function dashboardOloPaymentPageActivateCreditCardClick(params) {
    return { evid: 127, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageCancelCreditCardActivation' event (evid: 128)
 *
 * Event description: user clicked on the cancel button from the credit card edit modal
 *
 * @param {dashboardOloPaymentPageCancelCreditCardActivationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - toggle/edit
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - cancel/'x'/esc
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageCancelCreditCardActivationParams>} LogObject<dashboardOloPaymentPageCancelCreditCardActivationParams>
 */
export function dashboardOloPaymentPageCancelCreditCardActivation(params) {
    return { evid: 128, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloReceivingOrdersSettingsSave' event (evid: 129)
 *
 * Event description: user saves settings of the receiving orders page
 *
 * @param {dashboardOloReceivingOrdersSettingsSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} notify_delay - the notify duration the user chose in minutes
 * @property {GUID} site_id - guid
 * @property {string} error_desc - error desc in case of failure
 * @property {string} receive_method - email/fax/system
 * @property {string} notify_method - email/fax/system
 * @property {string} result - success/failure
 * @property {string} notify_value - the value itself - email address, fax number..
 * @property {string} receive_value - the value itself - email address, fax number..
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloReceivingOrdersSettingsSaveParams>} LogObject<dashboardOloReceivingOrdersSettingsSaveParams>
 */
export function dashboardOloReceivingOrdersSettingsSave(params) {
    return { evid: 129, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSettingsLoad' event (evid: 13)
 *
 * Event description: menus_settings_load
 *
 * @param {menusSettingsLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - {guid}
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusSettingsLoadParams>} LogObject<menusSettingsLoadParams>
 */
export function menusSettingsLoad(params) {
    return { evid: 13, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloReceivingOrdersSettingsCancelClick' event (evid: 130)
 *
 * Event description: user cancel his changes in settings of the receiving orders page
 *
 * @param {dashboardOloReceivingOrdersSettingsCancelClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloReceivingOrdersSettingsCancelClickParams>} LogObject<dashboardOloReceivingOrdersSettingsCancelClickParams>
 */
export function dashboardOloReceivingOrdersSettingsCancelClick(params) {
    return { evid: 130, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryAddDeliveryAreaClick' event (evid: 131)
 *
 * Event description: use click on the add area button
 *
 * @param {dashboardOloDeliveryAddDeliveryAreaClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} buttonType - delivery_partner/no_areas_exist/erc..
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryAddDeliveryAreaClickParams>} LogObject<dashboardOloDeliveryAddDeliveryAreaClickParams>
 */
export function dashboardOloDeliveryAddDeliveryAreaClick(params) {
    return { evid: 131, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryEditDeliveryHoursClickOnLink' event (evid: 132)
 *
 * Event description: use click on the edit delivery hours link
 *
 * @param {dashboardOloDeliveryEditDeliveryHoursClickOnLinkParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryEditDeliveryHoursClickOnLinkParams>} LogObject<dashboardOloDeliveryEditDeliveryHoursClickOnLinkParams>
 */
export function dashboardOloDeliveryEditDeliveryHoursClickOnLink(params) {
    return { evid: 132, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryDeliveryHoursApplyChanges' event (evid: 133)
 *
 * Event description: User apply his changes in delivery hours
 *
 * @param {dashboardOloDeliveryDeliveryHoursApplyChangesParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryDeliveryHoursApplyChangesParams>} LogObject<dashboardOloDeliveryDeliveryHoursApplyChangesParams>
 */
export function dashboardOloDeliveryDeliveryHoursApplyChanges(params) {
    return { evid: 133, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryAreaSelectMethod' event (evid: 135)
 *
 * Event description: User changes the selection method of the delivery area - the event is being sent on choose (from the list of values)
 *
 * @param {dashboardOloDeliveryAreaSelectMethodParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - radius, postal, etc
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryAreaSelectMethodParams>} LogObject<dashboardOloDeliveryAreaSelectMethodParams>
 */
export function dashboardOloDeliveryAreaSelectMethod(params) {
    return { evid: 135, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryCancelDeliveryAreaWindow' event (evid: 136)
 *
 * Event description: User cancel his work and close the window
 *
 * @param {dashboardOloDeliveryCancelDeliveryAreaWindowParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - add/map/list
 * @property {string} integrationName - The delivery integration name
 * @property {GUID} site_id - guid
 * @property {GUID} configurationId - configurationId
 * @property {GUID} integrationAppId - integration_app_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - cancel/'x'/esc
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryCancelDeliveryAreaWindowParams>} LogObject<dashboardOloDeliveryCancelDeliveryAreaWindowParams>
 */
export function dashboardOloDeliveryCancelDeliveryAreaWindow(params) {
    return { evid: 136, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliverySaveDeliveryArea' event (evid: 137)
 *
 * Event description: User saves his work on specific area
 *
 * @param {dashboardOloDeliverySaveDeliveryAreaParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} areaName - name
 * @property {string} name - area name
 * @property {string} source - add/map/list
 * @property {string} integrationName - The delivery integration name
 * @property {string} deliveryAreaID - unique key per area
 * @property {string} state - active/paused (from toggle)
 * @property {GUID} site_id - guid
 * @property {GUID} configurationId - configurationId
 * @property {number} coverDeliveryFeeAmount - cover_delivery_fee_amount
 * @property {boolean} availability_modified - relative to the previous state
 * @property {string} maximumDeliveryTimeType - Minutes/ Hours/Days
 * @property {string} pickupInstructions - pickup_instructions
 * @property {string} error_desc - in case of failure
 * @property {string} deliveryMethod - doordash/uber_eats/etc...
 * @property {number} minimumOrder - minimum order
 * @property {string} result - success/failure
 * @property {GUID} integrationAppId - The delivery integration app id
 * @property {string} availability - openingHours/Custom
 * @property {boolean} isRadius - wether user saved with radius or draw your own
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} coverDeliveryFee - coverDeliveryFee
 * @property {number} maximumDeliveryTimeValue - time selected
 * @property {string} organization_id - guid
 * @property {number} deliveryCharges - delivery Charges
 * @property {string} coverDeliveryFeeCurrency - the currency in which the delivery fee is in
 * @property {string} selection_method - radius/postal/etc
 * @property {string} methodValue - Radius value / postal Code value
 * @property {number} index - index
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliverySaveDeliveryAreaParams>} LogObject<dashboardOloDeliverySaveDeliveryAreaParams>
 */
export function dashboardOloDeliverySaveDeliveryArea(params) {
    return { evid: 137, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryDeleteDeliveryArea' event (evid: 138)
 *
 * Event description: After the user delete delivery area (after the confirmation for the deletion in the modal)
 *
 * @param {dashboardOloDeliveryDeleteDeliveryAreaParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} areaName - delivery Area Name
 * @property {string} source - modal/list
 * @property {string} integrationName - The delivery integration name
 * @property {GUID} site_id - guid
 * @property {GUID} configurationId - configurationId
 * @property {GUID} integrationAppId - The delivery integration app id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {number} index - index
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryDeleteDeliveryAreaParams>} LogObject<dashboardOloDeliveryDeleteDeliveryAreaParams>
 */
export function dashboardOloDeliveryDeleteDeliveryArea(params) {
    return { evid: 138, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloClickOnSearch' event (evid: 139)
 *
 * Event description: User started searching in the Orders page
 *
 * @param {dashboardOloClickOnSearchParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - new_orders/accepted/all orders/etc...
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloClickOnSearchParams>} LogObject<dashboardOloClickOnSearchParams>
 */
export function dashboardOloClickOnSearch(params) {
    return { evid: 139, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloMoreClick' event (evid: 140)
 *
 * Event description: user click on one of the option on click more
 *
 * @param {dashboardOloMoreClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {string} clickType - click_type
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders/newOrder
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloMoreClickParams>} LogObject<dashboardOloMoreClickParams>
 */
export function dashboardOloMoreClick(params) {
    return { evid: 140, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloSearch' event (evid: 141)
 *
 * Event description: user search for an order
 *
 * @param {dashboardOloSearchParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - new_orders/accepted/all orders/etc...
 * @property {string} organization_id - guid
 * @property {string} type - the type of what the user searched for: phone/id/etc.
 * @property {string} value - what the user searched for
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloSearchParams>} LogObject<dashboardOloSearchParams>
 */
export function dashboardOloSearch(params) {
    return { evid: 141, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsChangesInCustomizeColumnsChangesSavedSuccessfully' event (evid: 1415)
 *
 * Event description: when the changes that the user made are saved successfully
 *
 * @param {tableReservationsChangesInCustomizeColumnsChangesSavedSuccessfullyParams} params - The parameters for this event
 * @property {number} numReservations - num reservations in the page
 * @property {GUID} biToken - -
 * @property {string} uuid - uuid
 * @property {GUID} reservationLocationId - -
 * @property {number} numColumns - -
 * @property {GUID} locationGuid - -
 * @property {string} columnsOrder - json of the order by the names
 * @return {LogObject<tableReservationsChangesInCustomizeColumnsChangesSavedSuccessfullyParams>} LogObject<tableReservationsChangesInCustomizeColumnsChangesSavedSuccessfullyParams>
 */
export function tableReservationsChangesInCustomizeColumnsChangesSavedSuccessfully(params) {
    return { evid: 1415, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationMainReservationSettingsPageClicks' event (evid: 1418)
 *
 * Event description: when the user clicks on buttons in the main settings page of the table reservation
 *
 * @param {tableReservationMainReservationSettingsPageClicksParams} params - The parameters for this event
 * @property {GUID} reservationLocationId - -
 * @property {string} locationGuid - -
 * @property {string} restId - -
 * @property {string} currentToggle - on or off
 * @property {string} buttonName - manage_reservation/ table_manage/availability/reservation_form/ notifications/
 * @return {LogObject<tableReservationMainReservationSettingsPageClicksParams>} LogObject<tableReservationMainReservationSettingsPageClicksParams>
 */
export function tableReservationMainReservationSettingsPageClicks(params) {
    return { evid: 1418, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOrdersCenterClickOnOrder' event (evid: 142)
 *
 * Event description: User click on an order to see more details
 *
 * @param {dashboardOloOrdersCenterClickOnOrderParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} order_id - order_id
 * @property {string} integrationName - The delivery integration name
 * @property {GUID} site_id - guid
 * @property {GUID} configurationId - configurationId
 * @property {GUID} integrationAppId - The delivery integration app id
 * @property {GUID} locationGuid - location_guid
 * @property {string} order_status - order status : active/new/...
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOrdersCenterClickOnOrderParams>} LogObject<dashboardOloOrdersCenterClickOnOrderParams>
 */
export function dashboardOloOrdersCenterClickOnOrder(params) {
    return { evid: 142, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsDiscardSpecificSectionChanges' event (evid: 1420)
 *
 * Event description: when the user clicks on discard on the top of the page of each of the sections (table management/availability/notifications/reservation form)
 *
 * @param {tableReservationSettingsDiscardSpecificSectionChangesParams} params - The parameters for this event
 * @property {string} settingsSection - table_manage/ availability/ reservation_form/ notifications
 * @property {GUID} reservationLocationId - -
 * @property {string} locationGuid - -
 * @property {string} restId - -
 * @property {string} currentToggle - toggle_off/ toggle_on
 * @return {LogObject<tableReservationSettingsDiscardSpecificSectionChangesParams>} LogObject<tableReservationSettingsDiscardSpecificSectionChangesParams>
 */
export function tableReservationSettingsDiscardSpecificSectionChanges(params) {
    return { evid: 1420, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsTableManagementSettingsIsLoaded' event (evid: 1422)
 *
 * Event description: when the page of table management is loaded
 *
 * @param {tableReservationSettingsTableManagementSettingsIsLoadedParams} params - The parameters for this event
 * @property {number} numTablesCombinations - num of table combinations
 * @property {number} numSeats - -
 * @property {string} tablesList - json of of [table name: X, min:1, max:5] , [table name:y , min:6 , max: 7 ]...
 * @property {number} numTables - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {string} restId - -
 * @property {string} pageName - table_management
 * @return {LogObject<tableReservationSettingsTableManagementSettingsIsLoadedParams>} LogObject<tableReservationSettingsTableManagementSettingsIsLoadedParams>
 */
export function tableReservationSettingsTableManagementSettingsIsLoaded(params) {
    return { evid: 1422, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsTableManagementSettingsClicks' event (evid: 1423)
 *
 * Event description: when the user clicks on buttons inside the table management page
 *
 * @param {tableReservationSettingsTableManagementSettingsClicksParams} params - The parameters for this event
 * @property {number} numObjects - at the time of the click
 * @property {number} numOfOnlineObjects - -
 * @property {number} numSeats - num of total seats
 * @property {number} maxGuests - max_guests
 * @property {string} tabName - -
 * @property {GUID} reservationLocationId - -
 * @property {boolean} isDuplicate - true if it is already a duplicated table (from the same session) and false otherwise
 * @property {GUID} locationGuid - -
 * @property {string} restId - -
 * @property {string} buttonName - duplicate / delete / online_availability / top_add_table_button / bottom_add_table_button
 * @property {GUID} objectId - table_id or combination_id
 * @property {number} minGuests - number of min guests of the duplicated table
 * @property {string} pageName - table_management
 * @property {string} objectName - table name or a combination name of the duplicate/deleted object
 * @return {LogObject<tableReservationSettingsTableManagementSettingsClicksParams>} LogObject<tableReservationSettingsTableManagementSettingsClicksParams>
 */
export function tableReservationSettingsTableManagementSettingsClicks(params) {
    return { evid: 1423, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsAvailabilityPageClickSave' event (evid: 1427)
 *
 * Event description: when the user save the availability settings page
 *
 * @param {tableReservationSettingsAvailabilityPageClickSaveParams} params - The parameters for this event
 * @property {string} availabilityHoursList - son - (for example:  Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
 * @property {number} partiesMinutes - right now should be 15
 * @property {number} guestsPacing - -
 * @property {string} advancedNoticeNum - -
 * @property {number} partiesPacing - -
 * @property {number} minPartySize - -
 * @property {number} numNewEvents - number of new events at the availability modal
 * @property {number} numExistingEvents - number of events that were existing before this saving
 * @property {string} durationRulesList - json list of the rules
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {string} defaultTime - of reservation duration
 * @property {string} restId - -
 * @property {string} advancedNoticeType - minuted / hours/ days
 * @property {string} scheduleType - opening_hours / custom
 * @property {number} maxPartySize - -
 * @property {string} displayPhoneCheckbox - check/ uncheck
 * @property {number} guestsMinutes - right now should be 15
 * @property {string} pageName - availability_settings
 * @property {number} numTurnoverRules - how many rules of turnover are exist at the loading
 * @return {LogObject<tableReservationSettingsAvailabilityPageClickSaveParams>} LogObject<tableReservationSettingsAvailabilityPageClickSaveParams>
 */
export function tableReservationSettingsAvailabilityPageClickSave(params) {
    return { evid: 1427, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloExternalClicks' event (evid: 143)
 *
 * Event description: User clicks on the
 *
 * @param {dashboardOloExternalClicksParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} order_id - order_id
 * @property {GUID} site_id - guid
 * @property {string} clickType - map/FB/e-mail/etc.
 * @property {GUID} locationGuid - location_guid
 * @property {string} order_status - order status : active/new/...
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloExternalClicksParams>} LogObject<dashboardOloExternalClicksParams>
 */
export function dashboardOloExternalClicks(params) {
    return { evid: 143, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOrdersCenterActionInOrderModal' event (evid: 144)
 *
 * Event description: user make an action in the order modal
 *
 * @param {dashboardOloOrdersCenterActionInOrderModalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} order_id - order_id
 * @property {string} rejectReason - reject reason as filled
 * @property {string} integrationName - The delivery integration name
 * @property {DateTime} pickupTime - The pickup time sent to TPA delivery integration
 * @property {GUID} site_id - guid
 * @property {GUID} configurationId - configurationId
 * @property {boolean} isOnline - One app field. Click done online True/False.
 * @property {boolean} isFuturePickup - is future pickup(request TPA delivery modal)
 * @property {GUID} integrationAppId - The delivery integration app id
 * @property {boolean} isFutureOrder - is future order
 * @property {number} order_age - in seconds
 * @property {GUID} locationGuid - location_id
 * @property {string} origin - origin
 * @property {string} organization_id - guid
 * @property {number} estimatedDeliveryTime - The estimated delivery time the UoU saw while ordering
 * @property {GUID} msid - msid
 * @property {string} value - print/accept/cancel/etc...
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOrdersCenterActionInOrderModalParams>} LogObject<dashboardOloOrdersCenterActionInOrderModalParams>
 */
export function dashboardOloOrdersCenterActionInOrderModal(params) {
    return { evid: 144, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsTableManagementClickOnSave' event (evid: 1443)
 *
 * Event description: click on save changes in table management settings
 *
 * @param {tableReservationSettingsTableManagementClickOnSaveParams} params - The parameters for this event
 * @property {GUID} instanceId - -
 * @property {number} totalSeats - -
 * @property {number} numTables - -
 * @property {number} numNewCombinations - only the new tables from this session
 * @property {string} tabName - tables / table_cobinations
 * @property {GUID} reservationLocationId - -
 * @property {number} numDuplicatedTablesInSession - -
 * @property {string} tablesListActions - json of {action:.. , before:.., after:...,} action can be “change”/”add”/”delete” and before and after are the names of the table +min and max party size
 * @property {GUID} locationGuid - -
 * @property {string} restId - -
 * @property {number} numNewTables - only the new tables from this session
 * @property {number} numCombinations - -
 * @property {number} numOnlineTables - -
 * @property {number} totalNewSeats - only the new tables from this session
 * @property {number} numOnlineCombinations - -
 * @return {LogObject<tableReservationSettingsTableManagementClickOnSaveParams>} LogObject<tableReservationSettingsTableManagementClickOnSaveParams>
 */
export function tableReservationSettingsTableManagementClickOnSave(params) {
    return { evid: 1443, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsTableManagementSaveChangesSuccess' event (evid: 1449)
 *
 * Event description: save changes success
 *
 * @param {tableReservationSettingsTableManagementSaveChangesSuccessParams} params - The parameters for this event
 * @property {boolean} success - true/false
 * @property {number} totalSeats - -
 * @property {number} numTables - -
 * @property {number} numNewCombinations - from the session
 * @property {string} tabName - -
 * @property {GUID} reservationLocationId - -
 * @property {number} numDuplicatedTablesInSession - -
 * @property {string} tablesListActions - json of {action:.. , before:.., after:...,is_dummy:...} action can be “change”/”add”/”delete”/"no change" and before and after are the names of the table +min and max party size. is_dummy means if its one of the dummy tables tables that we give the user -false will be if the users is already edit it or if its a new table
 * @property {GUID} locationGuid - -
 * @property {string} restId - -
 * @property {number} numNewTables - from the session
 * @property {number} numCombinations - -
 * @property {number} numOnlineTables - -
 * @property {number} totalNewSeats - from the session
 * @property {number} numOnlineCombinations - -
 * @return {LogObject<tableReservationSettingsTableManagementSaveChangesSuccessParams>} LogObject<tableReservationSettingsTableManagementSaveChangesSuccessParams>
 */
export function tableReservationSettingsTableManagementSaveChangesSuccess(params) {
    return { evid: 1449, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageSmsValidationToggle' event (evid: 145)
 *
 * Event description: user change the state of the SMS validation toggle (anti fraud)
 *
 * @param {dashboardOloPaymentPageSmsValidationToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - end state of the toggle
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageSmsValidationToggleParams>} LogObject<dashboardOloPaymentPageSmsValidationToggleParams>
 */
export function dashboardOloPaymentPageSmsValidationToggle(params) {
    return { evid: 145, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationCreateReservationSucceedSrc61Evid1450' event (evid: 1450)
 *
 * Event description: create reservation succeeds
 *
 * @param {tableReservationCreateReservationSucceedSrc61Evid1450Params} params - The parameters for this event
 * @property {string} assignTableNames - -
 * @property {DateTime} duration - the duration of the reservation - in A milli second
 * @property {string} name - -
 * @property {string} phoneNumber - -
 * @property {string} email - -
 * @property {boolean} isTableOverbooked - true/false
 * @property {string} biToken - -
 * @property {number} numDetailsEmpty - -
 * @property {string} uuid - -
 * @property {string} assignTableName - -
 * @property {DateTime} datetime - -
 * @property {string} addingTableID - -
 * @property {string} reservation__id - -
 * @property {string} additionalDetails - json of the additional fields
 * @property {string} mailCheckbox - when the uou is check/uncheck this checkbox
 * @property {string} assignTablesNames - -
 * @property {number} numDetailsMandatory - -
 * @property {GUID} reservationLocationId - -
 * @property {string} locationGuid - -
 * @property {string} origin - live_site_mode / preview_mode
 * @property {string} contactId - id if its from uou side
 * @property {DateTime} creationDate - -
 * @property {string} areaType - -
 * @property {boolean} teamMessageEmpty - True if its empty and false if not
 * @property {string} correlationId - -
 * @property {string} reservationType - who did the reservation uou or owenr?
 * @property {string} assignTableIds - -
 * @property {number} partySize - -
 * @property {string} teamMessage - json of the text
 * @property {number} numDetailsFull - -
 * @property {string} rest_id - --
 * @property {string} saveType - created/edit
 * @return {LogObject<tableReservationCreateReservationSucceedSrc61Evid1450Params>} LogObject<tableReservationCreateReservationSucceedSrc61Evid1450Params>
 */
export function tableReservationCreateReservationSucceedSrc61Evid1450(params) {
    return { evid: 1450, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsPageToggleAction' event (evid: 1451)
 *
 * Event description: when the user clicks on the toggle
 *
 * @param {tableReservationSettingsPageToggleActionParams} params - The parameters for this event
 * @property {GUID} reservationLocationId - -
 * @property {string} locationGuid - -
 * @property {string} restId - -
 * @property {string} action_type - toggle_off/ toggle_on
 * @return {LogObject<tableReservationSettingsPageToggleActionParams>} LogObject<tableReservationSettingsPageToggleActionParams>
 */
export function tableReservationSettingsPageToggleAction(params) {
    return { evid: 1451, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationSettingsAvailabilityPageChangesSavesSuccessfully' event (evid: 1452)
 *
 * Event description: changes saves successfully
 *
 * @param {tableReservationSettingsAvailabilityPageChangesSavesSuccessfullyParams} params - The parameters for this event
 * @property {string} availabilityHoursList - son - (for example:  Sunday: 24h, monday: 09:00-11:30, 14:00-15:30, tuesday:09:00p…)
 * @property {number} partiesMinutes - right now should be 15
 * @property {number} guestsPacing - -
 * @property {string} advancedNoticeNum - -
 * @property {number} partiesPacing - -
 * @property {number} minPartySize - -
 * @property {number} numNewEvents - number of new events at the availability modal
 * @property {number} numExistingEvents - number of events that were existing before this saving
 * @property {string} durationRulesList - json list of the rules
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {string} defaultTime - of reservation duration
 * @property {string} restId - -
 * @property {string} advancedNoticeType - minuted / hours/ days
 * @property {string} scheduleType - schedule_type
 * @property {number} maxPartySize - -
 * @property {string} displayPhoneCheckbox - check/ uncheck
 * @property {number} guestsMinutes - right now should be 15
 * @property {string} pageName - availability_settings
 * @property {number} numTurnoverRules - how many rules of turnover are exist at the loading
 * @return {LogObject<tableReservationSettingsAvailabilityPageChangesSavesSuccessfullyParams>} LogObject<tableReservationSettingsAvailabilityPageChangesSavesSuccessfullyParams>
 */
export function tableReservationSettingsAvailabilityPageChangesSavesSuccessfully(params) {
    return { evid: 1452, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsSettingsReservationFormSavePageSucceed' event (evid: 1453)
 *
 * Event description: click on save reservation form page
 *
 * @param {tableReservationsSettingsReservationFormSavePageSucceedParams} params - The parameters for this event
 * @property {string} emailMarketingCheckByDeafult - check/uncheck
 * @property {string} privacyPolicyType - text/url/null
 * @property {string} customFieldsText - json with the text and +mandatory if it is
 * @property {string} customMessageToggle - on/off
 * @property {string} customMessageText - json
 * @property {string} emailMandatoryToggle - on/off
 * @property {number} numMandatoryFileds - -
 * @property {string} reservationPoliciesToggle - on/off
 * @property {GUID} reservationLocationId - -
 * @property {number} numCustomFields - -
 * @property {string} privacyPolicy - check/uncheck
 * @property {string} phoneValidationToggle - on/off
 * @property {GUID} locationGuid - -
 * @property {string} restId - -
 * @property {string} lastNameMandatoryToggle - on/off
 * @property {string} termsCondType - text/url/null
 * @property {string} termsAndConditionsText - json of the text
 * @property {string} emailMarketingCheckboxToggle - on/off
 * @property {string} privacyPolicyText - json of the text
 * @property {string} policiesTermsCond - check/uncheck
 * @property {string} customFieldsToggle - on/off
 * @return {LogObject<tableReservationsSettingsReservationFormSavePageSucceedParams>} LogObject<tableReservationsSettingsReservationFormSavePageSucceedParams>
 */
export function tableReservationsSettingsReservationFormSavePageSucceed(params) {
    return { evid: 1453, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationCancelationSucceedSrc61Evid1454' event (evid: 1454)
 *
 * Event description: reservation cancelation succeed (uou and owner)
 *
 * @param {tableReservationCancelationSucceedSrc61Evid1454Params} params - The parameters for this event
 * @property {DateTime} duration - the duration of the reservation
 * @property {string} name - -
 * @property {string} phoneNumber - -
 * @property {string} email - -
 * @property {boolean} isTableOverbooked - true/false
 * @property {string} biToken - -
 * @property {number} numDetailsEmpty - -
 * @property {string} uuid - -
 * @property {string} assignTableName - -
 * @property {DateTime} datetime - -
 * @property {string} addingTableID - json of the additional fields
 * @property {string} reservation__id - -
 * @property {string} additionalDetailsJson - -
 * @property {string} mailCheckbox - -
 * @property {number} numDetailsMandatory - -
 * @property {GUID} reservationLocationId - -
 * @property {string} locationGuid - -
 * @property {string} origin - live_site / preview mode
 * @property {string} contactId - -
 * @property {string} createdBy - who cancel the reservations?
 * @property {DateTime} creationDate - -
 * @property {boolean} teamMessageEmpty - True if its empty and false if not
 * @property {string} reservationType - -
 * @property {number} partySize - -
 * @property {string} teamMessage - json of the text
 * @property {number} numDetailsFull - -
 * @property {string} rest_id - --
 * @property {string} areaCode - -
 * @return {LogObject<tableReservationCancelationSucceedSrc61Evid1454Params>} LogObject<tableReservationCancelationSucceedSrc61Evid1454Params>
 */
export function tableReservationCancelationSucceedSrc61Evid1454(params) {
    return { evid: 1454, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsClickOnReservationsAttributes' event (evid: 1455)
 *
 * Event description: uou clicked on any of the reservation settings
 *
 * @param {tableReservationsClickOnReservationsAttributesParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - location ID
 * @property {string} fieldName - Date/Time/Party Size/Location
 * @property {string} origin - live_site_mode / preview_mode
 * @property {string} organization_id - organization_id
 * @property {boolean} isAddOn - true/ false
 * @property {string} correlationId - -
 * @property {boolean} isMultiLocation - true if the site has more than one location
 * @property {GUID} instance_id - instance_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<tableReservationsClickOnReservationsAttributesParams>} LogObject<tableReservationsClickOnReservationsAttributesParams>
 */
export function tableReservationsClickOnReservationsAttributes(params) {
    return { evid: 1455, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsBoReservationsModalOpened' event (evid: 1456)
 *
 * Event description: modal of creating reservations is opened (loaded)
 *
 * @param {tableReservationsBoReservationsModalOpenedParams} params - The parameters for this event
 * @property {GUID} reservationsLocationId - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {GUID} locationId - -
 * @property {string} type - create / edit
 * @return {LogObject<tableReservationsBoReservationsModalOpenedParams>} LogObject<tableReservationsBoReservationsModalOpenedParams>
 */
export function tableReservationsBoReservationsModalOpened(params) {
    return { evid: 1456, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsTableManagementTabsLoaded' event (evid: 1457)
 *
 * Event description: when tables tab or tables combinations tab are loaded
 *
 * @param {restaurantsTableReservationsSettingsTableManagementTabsLoadedParams} params - The parameters for this event
 * @property {number} totalSeats - -
 * @property {number} numObjects - num of tables in tables tab or num of tables combinations in table combinations tab
 * @property {number} numOfOnlineObjects - only online tables and combinations
 * @property {string} tabName - tables/ tables_comnbinations
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @return {LogObject<restaurantsTableReservationsSettingsTableManagementTabsLoadedParams>} LogObject<restaurantsTableReservationsSettingsTableManagementTabsLoadedParams>
 */
export function restaurantsTableReservationsSettingsTableManagementTabsLoaded(params) {
    return { evid: 1457, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsTableManagementAvailableOnlineHover' event (evid: 1458)
 *
 * Event description: hover on "available online"
 *
 * @param {restaurantsTableReservationsSettingsTableManagementAvailableOnlineHoverParams} params - The parameters for this event
 * @property {number} totalSeats - -
 * @property {number} numObjects - -
 * @property {number} numOfOnlineObjects - -
 * @property {GUID} reservationsLocationId - -
 * @property {string} tabName - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @return {LogObject<restaurantsTableReservationsSettingsTableManagementAvailableOnlineHoverParams>} LogObject<restaurantsTableReservationsSettingsTableManagementAvailableOnlineHoverParams>
 */
export function restaurantsTableReservationsSettingsTableManagementAvailableOnlineHover(params) {
    return { evid: 1458, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModal' event (evid: 1459)
 *
 * Event description: when the modal is loaded when user tries to move to another tab after he made changes and didn't save
 *
 * @param {restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalParams} params - The parameters for this event
 * @property {GUID} reservationsLocationId - -
 * @property {string} tabName - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @return {LogObject<restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalParams>} LogObject<restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModalParams>
 */
export function restaurantsTableReservationsSettingsTableManagementClickOnTabWithoutSavingModal(params) {
    return { evid: 1459, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageAdvancedSettingsShow' event (evid: 146)
 *
 * Event description: user clicked on the advanced settings show button in payments page
 *
 * @param {dashboardOloPaymentPageAdvancedSettingsShowParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageAdvancedSettingsShowParams>} LogObject<dashboardOloPaymentPageAdvancedSettingsShowParams>
 */
export function dashboardOloPaymentPageAdvancedSettingsShow(params) {
    return { evid: 146, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsTableManagementTableObjectCreated' event (evid: 1460)
 *
 * Event description: Restaurants > Table reservations > Settings > Table Management > Table object created.
 *
 * @param {restaurantsTableReservationsSettingsTableManagementTableObjectCreatedParams} params - The parameters for this event
 * @property {number} minSeats - -
 * @property {GUID} reservationsLocationId - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {boolean} isAvailableOnline - true/false
 * @property {string} objectId - tabel id or combinationdid
 * @property {string} type - table/table combinations
 * @property {number} maxSeats - -
 * @property {number} numTablesInCombination - number of tables inside the combination
 * @property {string} objectName - table name / co
 * @return {LogObject<restaurantsTableReservationsSettingsTableManagementTableObjectCreatedParams>} LogObject<restaurantsTableReservationsSettingsTableManagementTableObjectCreatedParams>
 */
export function restaurantsTableReservationsSettingsTableManagementTableObjectCreated(params) {
    return { evid: 1460, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageSplitPayments' event (evid: 147)
 *
 * Event description: user change the state of the split payments check box
 *
 * @param {dashboardOloPaymentPageSplitPaymentsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - the end state of the check box
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageSplitPaymentsParams>} LogObject<dashboardOloPaymentPageSplitPaymentsParams>
 */
export function dashboardOloPaymentPageSplitPayments(params) {
    return { evid: 147, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryEditDeliveryArea' event (evid: 148)
 *
 * Event description: user open the edit page of delivery area
 *
 * @param {dashboardOloDeliveryEditDeliveryAreaParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} areaName - name
 * @property {string} source - map/list
 * @property {string} integrationName - The delivery integration name
 * @property {GUID} site_id - guid
 * @property {GUID} configurationId - configurationId
 * @property {GUID} integrationAppId - The delivery integration app id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {number} index - index
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryEditDeliveryAreaParams>} LogObject<dashboardOloDeliveryEditDeliveryAreaParams>
 */
export function dashboardOloDeliveryEditDeliveryArea(params) {
    return { evid: 148, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationUouStartOfReservationFunnelClickOnFindATable' event (evid: 1506)
 *
 * Event description: clicks of uou in the beginning of the funnel
 *
 * @param {tableReservationUouStartOfReservationFunnelClickOnFindATableParams} params - The parameters for this event
 * @property {GUID} visitorId - -
 * @property {DateTime} datetime - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {string} restId - -
 * @property {string} origin - previe_mode/live_site_mode
 * @property {string} contactId - -
 * @property {GUID} memberId - -
 * @property {boolean} isAddOn - true if its a click from the add on and false if not
 * @property {string} correlationId - -
 * @property {number} partySize - -
 * @property {boolean} isMultiLocation - -
 * @return {LogObject<tableReservationUouStartOfReservationFunnelClickOnFindATableParams>} LogObject<tableReservationUouStartOfReservationFunnelClickOnFindATableParams>
 */
export function tableReservationUouStartOfReservationFunnelClickOnFindATable(params) {
    return { evid: 1506, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloItemClick' event (evid: 151)
 *
 * Event description: Click on an item
 *
 * @param {liveSiteOloItemClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} item_id - item_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - cart / menu /...
 * @property {string} section_id - section_id
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloItemClickParams>} LogObject<liveSiteOloItemClickParams>
 */
export function liveSiteOloItemClick(params) {
    return { evid: 151, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationUouClickOnCompleteReservation' event (evid: 1515)
 *
 * Event description: click on complete reservation -  in order to make sure that reservations was done use condition - "num_invalid_fields = 0"
 *
 * @param {tableReservationUouClickOnCompleteReservationParams} params - The parameters for this event
 * @property {GUID} instanceId - -
 * @property {string} phoneNumber - -
 * @property {string} email - -
 * @property {string} mailCheckbox - check/uncheck
 * @property {GUID} reservationLocationId - -
 * @property {string} lastName - -
 * @property {string} firstName - -
 * @property {GUID} locationGuid - -
 * @property {string} restId - -
 * @property {string} origin - -
 * @property {number} numInvaldFields - -
 * @property {string} contactId - -
 * @property {number} partySize - -
 * @property {number} numValidFields - -
 * @property {DateTime} dateTimeValue - of the reservation
 * @property {string} areaCode - -
 * @return {LogObject<tableReservationUouClickOnCompleteReservationParams>} LogObject<tableReservationUouClickOnCompleteReservationParams>
 */
export function tableReservationUouClickOnCompleteReservation(params) {
    return { evid: 1515, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloAddToCart' event (evid: 152)
 *
 * Event description: Add to my order cart
 *
 * @param {liveSiteOloAddToCartParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} item_id - item_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - cart / menu /...
 * @property {string} section_id - section_id
 * @property {string} organization_id - guid
 * @property {string} special_requests - requests added by the UoU
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloAddToCartParams>} LogObject<liveSiteOloAddToCartParams>
 */
export function liveSiteOloAddToCart(params) {
    return { evid: 152, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationUouClickOnReserveNow' event (evid: 1524)
 *
 * Event description: when uou is clicking on “reserve now”
 *
 * @param {tableReservationUouClickOnReserveNowParams} params - The parameters for this event
 * @property {GUID} instanceId - -
 * @property {DateTime} requestedTime - -
 * @property {GUID} reservationLocationId - -
 * @property {DateTime} requestedDate - -
 * @property {GUID} locationGuid - -
 * @property {string} restId - -
 * @property {string} origin - preview_mode/live_site_mode
 * @property {string} contactId - -
 * @property {string} correlationId - -
 * @property {number} partySize - -
 * @return {LogObject<tableReservationUouClickOnReserveNowParams>} LogObject<tableReservationUouClickOnReserveNowParams>
 */
export function tableReservationUouClickOnReserveNow(params) {
    return { evid: 1524, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationUouStartOfReservationFunnelReservationPageWidgetISloaded' event (evid: 1525)
 *
 * Event description: when the uou see this page/widget
 *
 * @param {tableReservationUouStartOfReservationFunnelReservationPageWidgetISloadedParams} params - The parameters for this event
 * @property {GUID} visitorId - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {string} restId - -
 * @property {string} origin - previe_mode/live_site_mode
 * @property {string} contactId - -
 * @property {GUID} memberId - -
 * @property {boolean} isAddOn - true if its a click from the add on and false if not
 * @property {string} correlationId - -
 * @property {string} type - page/widget
 * @property {boolean} isMultiLocation - -
 * @return {LogObject<tableReservationUouStartOfReservationFunnelReservationPageWidgetISloadedParams>} LogObject<tableReservationUouStartOfReservationFunnelReservationPageWidgetISloadedParams>
 */
export function tableReservationUouStartOfReservationFunnelReservationPageWidgetISloaded(params) {
    return { evid: 1525, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloOrderNow' event (evid: 156)
 *
 * Event description: UoU click on Order Now from Cart
 *
 * @param {liveSiteOloOrderNowParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} kitchen_requests - the kitchen requests the user wrote
 * @property {number} num_items - number of items in the cart
 * @property {string} organization_id - guid
 * @property {string} currency - order currency
 * @property {number} subtotal - subtotal in cents (multiple by 100)
 * @property {string} order_method - pickup / delivery
 * @property {number} minimum_order - in cents (defined by the owner) - multiple by 100
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloOrderNowParams>} LogObject<liveSiteOloOrderNowParams>
 */
export function liveSiteOloOrderNow(params) {
    return { evid: 156, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloDeliveryPagePageLoad' event (evid: 157)
 *
 * Event description: Delivery page loaded
 *
 * @param {liveSiteOloDeliveryPagePageLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} order_method - pickup / delivery
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloDeliveryPagePageLoadParams>} LogObject<liveSiteOloDeliveryPagePageLoadParams>
 */
export function liveSiteOloDeliveryPagePageLoad(params) {
    return { evid: 157, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloDeliveryPageSwitchMethod' event (evid: 158)
 *
 * Event description: UoU change method in the delivery page
 *
 * @param {liveSiteOloDeliveryPageSwitchMethodParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} order_method - pickup / delivery (end state of the choice.)
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloDeliveryPageSwitchMethodParams>} LogObject<liveSiteOloDeliveryPageSwitchMethodParams>
 */
export function liveSiteOloDeliveryPageSwitchMethod(params) {
    return { evid: 158, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloDeliveryPageSetAddress' event (evid: 159)
 *
 * Event description: UoU sets his delivery address
 *
 * @param {liveSiteOloDeliveryPageSetAddressParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {boolean} isSuccess - Click on continue with success
 * @property {GUID} locationGuid - location_guid
 * @property {string} results - no address found, found but not in delivery area, found but not meets minimun, found but inactive, found
 * @property {string} organization_id - guid
 * @property {string} address - UoU address
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloDeliveryPageSetAddressParams>} LogObject<liveSiteOloDeliveryPageSetAddressParams>
 */
export function liveSiteOloDeliveryPageSetAddress(params) {
    return { evid: 159, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloContactsPageSetContact' event (evid: 162)
 *
 * Event description: UoU click the next button on contacts page
 *
 * @param {liveSiteOloContactsPageSetContactParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} first_name - UoU first name
 * @property {boolean} valid_email_address - true/false
 * @property {string} phone_number - UoU phone number
 * @property {string} email_address - UoU email_address
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} valid_first_name - true/false
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {boolean} valid_phone_number - true/false
 * @property {GUID} locationGuid - location_guid
 * @property {string} last_name - UoU last name
 * @property {string} organization_id - guid
 * @property {boolean} valid_last_name - true/false
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloContactsPageSetContactParams>} LogObject<liveSiteOloContactsPageSetContactParams>
 */
export function liveSiteOloContactsPageSetContact(params) {
    return { evid: 162, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloPaymentPageMethodSelected' event (evid: 165)
 *
 * Event description: User chose payment method in payment page
 *
 * @param {liveSiteOloPaymentPageMethodSelectedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {string} payment_index - in case of split payment
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} pmnt_method - payment_method
 * @property {GUID} bi_token - msid
 * @property {boolean} isPopup - UoU received popup payment option for credit card
 * @return {LogObject<liveSiteOloPaymentPageMethodSelectedParams>} LogObject<liveSiteOloPaymentPageMethodSelectedParams>
 */
export function liveSiteOloPaymentPageMethodSelected(params) {
    return { evid: 165, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloPaymentPageSplitPaymentClick' event (evid: 167)
 *
 * Event description: UoU clicked on split payment in payment page
 *
 * @param {liveSiteOloPaymentPageSplitPaymentClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {string} payment_index - in case of split payment
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloPaymentPageSplitPaymentClickParams>} LogObject<liveSiteOloPaymentPageSplitPaymentClickParams>
 */
export function liveSiteOloPaymentPageSplitPaymentClick(params) {
    return { evid: 167, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloPaymentPageCreditCardAdded' event (evid: 168)
 *
 * Event description: User added a credit card
 *
 * @param {liveSiteOloPaymentPageCreditCardAddedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {string} payment_index - in case of split payment
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {boolean} isCashier - card added through cashier
 * @property {GUID} bi_token - msid
 * @property {boolean} isPopup - UoU received popup payment option for credit card
 * @return {LogObject<liveSiteOloPaymentPageCreditCardAddedParams>} LogObject<liveSiteOloPaymentPageCreditCardAddedParams>
 */
export function liveSiteOloPaymentPageCreditCardAdded(params) {
    return { evid: 168, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloPaymentPageProceed' event (evid: 169)
 *
 * Event description: User clicked on Next button from the payment page
 *
 * @param {liveSiteOloPaymentPageProceedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} grand_total - the total amount of the order multiple by 100 (in cents)
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {number} total_paid - the total amount chose to be paid for the order (total of all payment methods)
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {boolean} isSuccess - whether the click takes the visitor to the confirm order page or not
 * @property {GUID} locationGuid - location_guid
 * @property {number} total_index_count - number of payment indexes (split payments)
 * @property {string} organization_id - guid
 * @property {string} currency - order currency
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloPaymentPageProceedParams>} LogObject<liveSiteOloPaymentPageProceedParams>
 */
export function liveSiteOloPaymentPageProceed(params) {
    return { evid: 169, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSettingsSetLayout' event (evid: 17)
 *
 * Event description: menus_settings_set_layout
 *
 * @param {menusSettingsSetLayoutParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - {guid}
 * @property {string} layout - {list,columns,centered,...}
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusSettingsSetLayoutParams>} LogObject<menusSettingsSetLayoutParams>
 */
export function menusSettingsSetLayout(params) {
    return { evid: 17, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloConfirmationPageConfirmOrderClick' event (evid: 172)
 *
 * Event description: User click on confirm order
 *
 * @param {liveSiteOloConfirmationPageConfirmOrderClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} grand_total - the total amount of the order multiple by 100 (in cents)
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {number} tax - tax amount in cents (multiple 100)
 * @property {string} couponCode - coupon code/null
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {boolean} isExpressCheckout - if users used express check out
 * @property {number} discount_subtotal - discount_subtotal
 * @property {boolean} nonContactDelivery - true/false
 * @property {string} couponSubtotal - $ of discount for coupon
 * @property {number} fixedItemNumDiscounts - # of discount for fixed_item option
 * @property {number} fixedOrderNumDiscounts - # of discount for fixed_order option
 * @property {number} screen_width - screen width to identify users' platform
 * @property {number} percentNumDiscounts - # of discount for percent option
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} isConsent - order submited with/without some type of consent (Terms/policy/etc)
 * @property {number} num_discount - num of discounts
 * @property {string} origin - from where the button was clicked
 * @property {number} percentDiscountSubtotal - $ of discount for percent option
 * @property {number} fixedItemDiscountSubtotal - $ of discount for fixed_item option
 * @property {number} num_items - number of items in the cart
 * @property {string} organization_id - guid
 * @property {string} currency - 3 letters currency
 * @property {number} subtotal - subtotal in cents (multiple by 100)
 * @property {string} requestId - In order to track evids: 172,174,178
 * @property {number} fixedOrderDiscountSubtotal - $ of discount for fixed_order option
 * @property {string} order_method - delivery / pickup
 * @property {boolean} isCashier - site with/without cashier
 * @property {number} delivery_charges - delivery charges amount in cents (multiple by 100)
 * @property {number} totalTip - $ of tip from total (* 100)
 * @property {boolean} isCheckBox - Wether the order done with check box or not
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloConfirmationPageConfirmOrderClickParams>} LogObject<liveSiteOloConfirmationPageConfirmOrderClickParams>
 */
export function liveSiteOloConfirmationPageConfirmOrderClick(params) {
    return { evid: 172, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloOrderSmsPageLoad' event (evid: 173)
 *
 * Event description: User click on Back button from confirmation page
 *
 * @param {liveSiteOloOrderSmsPageLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloOrderSmsPageLoadParams>} LogObject<liveSiteOloOrderSmsPageLoadParams>
 */
export function liveSiteOloOrderSmsPageLoad(params) {
    return { evid: 173, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloOrderSentPageLoad' event (evid: 174)
 *
 * Event description: Order sent confirmation modal view
 *
 * @param {liveSiteOloOrderSentPageLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {string} orderId - order id
 * @property {string} couponCode - coupon code
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} requestId - In order to track evids: 172,174,178
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloOrderSentPageLoadParams>} LogObject<liveSiteOloOrderSentPageLoadParams>
 */
export function liveSiteOloOrderSentPageLoad(params) {
    return { evid: 174, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloOrderErrorPageLoad' event (evid: 178)
 *
 * Event description: Order Error modal view
 *
 * @param {liveSiteOloOrderErrorPageLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {string} error_desc - error_desc
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} requestId - In order to track evids: 172,174,178
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloOrderErrorPageLoadParams>} LogObject<liveSiteOloOrderErrorPageLoadParams>
 */
export function liveSiteOloOrderErrorPageLoad(params) {
    return { evid: 178, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSettingsElementsToggle' event (evid: 18)
 *
 * Event description: menus_settings_elements_toggle and more toggle. a generic events for toggls. old future orders toggle changed to scheduleOrdersOtoggle. to find data o old future toggle use LIKE '%future%'
 *
 * @param {menusSettingsElementsToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} areaName - Delivery Area name
 * @property {GUID} configurationId - configurationId
 * @property {string} appName - app_name
 * @property {boolean} toggle - {1,0}
 * @property {string} element - {description,variations,price,specials, phone...}
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - {guid}
 * @property {GUID} msid - msid
 * @property {number} index - index
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusSettingsElementsToggleParams>} LogObject<menusSettingsElementsToggleParams>
 */
export function menusSettingsElementsToggle(params) {
    return { evid: 18, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteMenuPageLoad' event (evid: 181)
 *
 * Event description: The Menu page in the user site was loaded
 *
 * @param {liveSiteMenuPageLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - referral
 * @property {string} view_mode - view_mode
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - owner indicator
 * @property {number} zoomType - Field for ABC test- 0=Old version, 1=oldVersionHouseNumber, 2=New
 * @property {GUID} locationGuid - location ID
 * @property {string} organization_id - guid
 * @property {number} loadTime - loading time
 * @property {string} initialDispatchType - pickup/delivery
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteMenuPageLoadParams>} LogObject<liveSiteMenuPageLoadParams>
 */
export function liveSiteMenuPageLoad(params) {
    return { evid: 181, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsOwnerAppReservationPageClickOnCancelReservation' event (evid: 1811)
 *
 * Event description: when the user clicks on cancel reservation
 *
 * @param {tableReservationsOwnerAppReservationPageClickOnCancelReservationParams} params - The parameters for this event
 * @property {number} numNullCustomFields - -
 * @property {DateTime} endDate - -
 * @property {GUID} reservationId - -
 * @property {boolean} isLiveSiteReservation - -
 * @property {boolean} isTeamMessageFulfilled - -
 * @property {DateTime} reservationDate - -
 * @property {number} numMandatoryFileds - -
 * @property {GUID} reservationLocationId - -
 * @property {number} numCustomFields - -
 * @property {GUID} locationGuid - -
 * @property {string} tableName - -
 * @property {number} numFullCustomFields - -
 * @property {string} tableID - -
 * @property {number} partySize - -
 * @property {DateTime} startDate - -
 * @return {LogObject<tableReservationsOwnerAppReservationPageClickOnCancelReservationParams>} LogObject<tableReservationsOwnerAppReservationPageClickOnCancelReservationParams>
 */
export function tableReservationsOwnerAppReservationPageClickOnCancelReservation(params) {
    return { evid: 1811, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsOwnerAppCancellationOutput' event (evid: 1814)
 *
 * Event description: reservation Cancellation  succeed
 *
 * @param {tableReservationsOwnerAppCancellationOutputParams} params - The parameters for this event
 * @property {number} numNullCustomFields - -
 * @property {boolean} success - true/false
 * @property {DateTime} endDate - -
 * @property {GUID} reservationId - -
 * @property {boolean} isLiveSiteReservation - -
 * @property {boolean} isTeamMessageFulfilled - -
 * @property {DateTime} reservationDate - -
 * @property {number} numMandatoryFileds - -
 * @property {GUID} reservationLocationId - -
 * @property {number} numCustomFields - -
 * @property {GUID} locationGuid - -
 * @property {string} tableName - -
 * @property {number} numFullCustomFields - -
 * @property {string} tableID - -
 * @property {number} partySize - -
 * @property {DateTime} startDate - -
 * @return {LogObject<tableReservationsOwnerAppCancellationOutputParams>} LogObject<tableReservationsOwnerAppCancellationOutputParams>
 */
export function tableReservationsOwnerAppCancellationOutput(params) {
    return { evid: 1814, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationOwnerAppTryToCreateNewReservationClick' event (evid: 1815)
 *
 * Event description: when the user clicks on the button in order to create a new reservation and it leads him to the page of creating the reservation
 *
 * @param {tableReservationOwnerAppTryToCreateNewReservationClickParams} params - The parameters for this event
 * @property {number} numReservationsOnPage - the number of reservations on the page
 * @property {GUID} locationGuid - -
 * @property {DateTime} selectedDateOnPage - -
 * @return {LogObject<tableReservationOwnerAppTryToCreateNewReservationClickParams>} LogObject<tableReservationOwnerAppTryToCreateNewReservationClickParams>
 */
export function tableReservationOwnerAppTryToCreateNewReservationClick(params) {
    return { evid: 1815, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsOwnerAppCreateNewReservationClick' event (evid: 1816)
 *
 * Event description: when the user clicks on create after he filled all the new reservation details and want to create it
 *
 * @param {tableReservationsOwnerAppCreateNewReservationClickParams} params - The parameters for this event
 * @property {number} numNullCustomFields - -
 * @property {DateTime} endDate - -
 * @property {GUID} reservationId - -
 * @property {boolean} isLiveSiteReservation - not available
 * @property {boolean} isTeamMessageFulfilled - -
 * @property {DateTime} reservationDate - -
 * @property {number} numMandatoryFileds - -
 * @property {GUID} reservationLocationId - -
 * @property {number} numCustomFields - -
 * @property {GUID} locationGuid - -
 * @property {string} tableName - -
 * @property {number} numFullCustomFields - -
 * @property {string} tableID - -
 * @property {number} partySize - -
 * @property {DateTime} startDate - -
 * @return {LogObject<tableReservationsOwnerAppCreateNewReservationClickParams>} LogObject<tableReservationsOwnerAppCreateNewReservationClickParams>
 */
export function tableReservationsOwnerAppCreateNewReservationClick(params) {
    return { evid: 1816, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfTableReservationsOwnerAppCreateReservationSucceed' event (evid: 1817)
 *
 * Event description: Create reservation succeed
 *
 * @param {copyOfTableReservationsOwnerAppCreateReservationSucceedParams} params - The parameters for this event
 * @property {number} numNullCustomFields - -
 * @property {boolean} success - true/false
 * @property {DateTime} endDate - -
 * @property {GUID} reservationId - -
 * @property {boolean} isLiveSiteReservation - -
 * @property {boolean} isTeamMessageFulfilled - -
 * @property {DateTime} reservationDate - -
 * @property {number} numMandatoryFileds - -
 * @property {GUID} reservationLocationId - -
 * @property {number} numCustomFields - -
 * @property {GUID} locationGuid - -
 * @property {string} tableName - -
 * @property {number} numFullCustomFields - -
 * @property {string} tableID - -
 * @property {number} partySize - -
 * @property {DateTime} startDate - -
 * @return {LogObject<copyOfTableReservationsOwnerAppCreateReservationSucceedParams>} LogObject<copyOfTableReservationsOwnerAppCreateReservationSucceedParams>
 */
export function copyOfTableReservationsOwnerAppCreateReservationSucceed(params) {
    return { evid: 1817, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationsOwnerAppClickOnSettingsButton' event (evid: 1818)
 *
 * Event description: when the user clicks on the settings  icon  button
 *
 * @param {tableReservationsOwnerAppClickOnSettingsButtonParams} params - The parameters for this event
 * @property {number} numReservationsOnPage - -
 * @property {string} buttonType - settings/ search/ location / date
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {DateTime} selectedDateOnPage - -
 * @return {LogObject<tableReservationsOwnerAppClickOnSettingsButtonParams>} LogObject<tableReservationsOwnerAppClickOnSettingsButtonParams>
 */
export function tableReservationsOwnerAppClickOnSettingsButton(params) {
    return { evid: 1818, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationOwnerAppToggleClick' event (evid: 1819)
 *
 * Event description: when the user clicks on the toggle in the owner app
 *
 * @param {tableReservationOwnerAppToggleClickParams} params - The parameters for this event
 * @property {number} numSeats - -
 * @property {number} numTables - -
 * @property {GUID} reservationLocationId - -
 * @property {GUID} locationGuid - -
 * @property {string} action_type - toggle_on / toggle_off
 * @return {LogObject<tableReservationOwnerAppToggleClickParams>} LogObject<tableReservationOwnerAppToggleClickParams>
 */
export function tableReservationOwnerAppToggleClick(params) {
    return { evid: 1819, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuAdded3Dishes' event (evid: 182)
 *
 * Event description: 3 dishes were added to the menu - Completed
 *
 * @param {dashboardMenuAdded3DishesParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuAdded3DishesParams>} LogObject<dashboardMenuAdded3DishesParams>
 */
export function dashboardMenuAdded3Dishes(params) {
    return { evid: 182, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationOwnerAppSettingsPageIsLoaded' event (evid: 1820)
 *
 * Event description: when the table reservations settings page is loaded in owner app
 *
 * @param {tableReservationOwnerAppSettingsPageIsLoadedParams} params - The parameters for this event
 * @property {number} totalSeats - -
 * @property {GUID} reservationsLocationId - -
 * @property {number} numTables - -
 * @property {GUID} locationGuid - -
 * @property {string} action_type - toggle_on / toggle_off
 * @property {string} toggleStatus - -
 * @return {LogObject<tableReservationOwnerAppSettingsPageIsLoadedParams>} LogObject<tableReservationOwnerAppSettingsPageIsLoadedParams>
 */
export function tableReservationOwnerAppSettingsPageIsLoaded(params) {
    return { evid: 1820, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationOwnerAppLocationsModalClicks' event (evid: 1823)
 *
 * Event description: when the user clicks on a location
 *
 * @param {tableReservationOwnerAppLocationsModalClicksParams} params - The parameters for this event
 * @property {GUID} currentReservationsLocationGuid - -
 * @property {string} moveToLocationToggle - on/on. - the status of the toggle in the location that the user moved to
 * @property {boolean} currentReservationLocationToggle - -
 * @property {boolean} moveToReservationLocationToggle - -
 * @property {string} currentLocationToggle - on/on. - the status of the toggle in the current location
 * @property {GUID} currentLocationGuid - -
 * @property {GUID} moveToReservationLoctionID - -
 * @property {GUID} currentReservationLocationId - -
 * @return {LogObject<tableReservationOwnerAppLocationsModalClicksParams>} LogObject<tableReservationOwnerAppLocationsModalClicksParams>
 */
export function tableReservationOwnerAppLocationsModalClicks(params) {
    return { evid: 1823, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationOwnerAppLocationsModalIsOpened' event (evid: 1824)
 *
 * Event description: Locations modal is opened to the user
 *
 * @param {tableReservationOwnerAppLocationsModalIsOpenedParams} params - The parameters for this event
 * @property {GUID} currentReservationLocationGuid - -
 * @property {boolean} currentReservationLocationToggle - Treu/ false
 * @property {boolean} currentLocationToggle - -
 * @property {GUID} currentLocationGuid - -
 * @property {GUID} currentReservationLocationID - -
 * @return {LogObject<tableReservationOwnerAppLocationsModalIsOpenedParams>} LogObject<tableReservationOwnerAppLocationsModalIsOpenedParams>
 */
export function tableReservationOwnerAppLocationsModalIsOpened(params) {
    return { evid: 1824, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuFbConnectOnSet' event (evid: 183)
 *
 * Event description: User click on an option from the search bar - to connect his page
 *
 * @param {dashboardMenuFbConnectOnSetParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_auto_connect - [1;0]
 * @property {GUID} site_id - guid
 * @property {string} page_id - page_id
 * @property {string} page_name - FB page name
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} category - category from platform
 * @property {string} platform - platform
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuFbConnectOnSetParams>} LogObject<dashboardMenuFbConnectOnSetParams>
 */
export function dashboardMenuFbConnectOnSet(params) {
    return { evid: 183, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationOwnerAppEditTableModalOpened' event (evid: 1835)
 *
 * Event description: Edit Table modal opened
 *
 * @param {tableReservationOwnerAppEditTableModalOpenedParams} params - The parameters for this event
 * @property {number} minPartySize - -
 * @property {GUID} reservationLocationId - -
 * @property {string} toggle_status - on/ off
 * @property {GUID} locationGuid - -
 * @property {string} tableName - -
 * @property {number} maxPartySize - -
 * @property {string} tableID - -
 * @return {LogObject<tableReservationOwnerAppEditTableModalOpenedParams>} LogObject<tableReservationOwnerAppEditTableModalOpenedParams>
 */
export function tableReservationOwnerAppEditTableModalOpened(params) {
    return { evid: 1835, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationOwnerAppEditTableModalClicks' event (evid: 1836)
 *
 * Event description: Edit Table modal clciks
 *
 * @param {tableReservationOwnerAppEditTableModalClicksParams} params - The parameters for this event
 * @property {number} currentMinPartySize - -
 * @property {number} currentMaxPartySize - -
 * @property {string} toggle_status - on/ off
 * @property {string} button - X/ save
 * @property {GUID} locationGuid - -
 * @property {string} tableID - -
 * @property {string} currentTableName - -
 * @return {LogObject<tableReservationOwnerAppEditTableModalClicksParams>} LogObject<tableReservationOwnerAppEditTableModalClicksParams>
 */
export function tableReservationOwnerAppEditTableModalClicks(params) {
    return { evid: 1836, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuFbConnectUsePreviousPage' event (evid: 184)
 *
 * Event description: User clicked on the page which he already once chose (showed to him as an history below the search box)
 *
 * @param {dashboardMenuFbConnectUsePreviousPageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {string} page_id - page_id
 * @property {string} page_name - FB page name
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuFbConnectUsePreviousPageParams>} LogObject<dashboardMenuFbConnectUsePreviousPageParams>
 */
export function dashboardMenuFbConnectUsePreviousPage(params) {
    return { evid: 184, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'genericErrorData' event (evid: 1840)
 *
 * Event description: Generic error for collecting custom technical issues
 *
 * @param {genericErrorDataParams} params - The parameters for this event
 * @property {string} domain - identifies area of application in which error has occurred
 * @property {string} details - json-formatted. Any details which could be useful for recognize the issue
 * @property {string} message - Error message
 * @return {LogObject<genericErrorDataParams>} LogObject<genericErrorDataParams>
 */
export function genericErrorData(params) {
    return { evid: 1840, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationOwnerAppSettingsPageClickOnLinkToPayment' event (evid: 1841)
 *
 * Event description: when click on link to payment in the table reservations settings page in owner app
 *
 * @param {tableReservationOwnerAppSettingsPageClickOnLinkToPaymentParams} params - The parameters for this event
 * @property {number} numSeats - -
 * @property {number} numTables - -
 * @property {string} reservationLocationId - -
 * @property {string} locationGuid - -
 * @property {string} enabledPremiumCase - 'SELECT_PACKAGE'| 'PRESENT_PACKAGES'
 * @return {LogObject<tableReservationOwnerAppSettingsPageClickOnLinkToPaymentParams>} LogObject<tableReservationOwnerAppSettingsPageClickOnLinkToPaymentParams>
 */
export function tableReservationOwnerAppSettingsPageClickOnLinkToPayment(params) {
    return { evid: 1841, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuFbConnectPageNotFound' event (evid: 185)
 *
 * Event description: User click on page not found in the search box page - direct him to support
 *
 * @param {dashboardMenuFbConnectPageNotFoundParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_auto_connect - [1;0]
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} platform - platform name
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuFbConnectPageNotFoundParams>} LogObject<dashboardMenuFbConnectPageNotFoundParams>
 */
export function dashboardMenuFbConnectPageNotFound(params) {
    return { evid: 185, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsOwnerAppClickOnSettings' event (evid: 1855)
 *
 * Event description: Click on table reservations  settings inside the modal
 *
 * @param {restaurantsTableReservationsOwnerAppClickOnSettingsParams} params - The parameters for this event
 * @property {GUID} locationGuid - -
 * @property {GUID} reservationsLocationId - -
 * @return {LogObject<restaurantsTableReservationsOwnerAppClickOnSettingsParams>} LogObject<restaurantsTableReservationsOwnerAppClickOnSettingsParams>
 */
export function restaurantsTableReservationsOwnerAppClickOnSettings(params) {
    return { evid: 1855, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsOwnerAppClickOnFilterReservationsView' event (evid: 1856)
 *
 * Event description: Click on filter reservations view inside the modal
 *
 * @param {restaurantsTableReservationsOwnerAppClickOnFilterReservationsViewParams} params - The parameters for this event
 * @property {GUID} locationGuid - -
 * @property {GUID} reservationLocationId - -
 * @return {LogObject<restaurantsTableReservationsOwnerAppClickOnFilterReservationsViewParams>} LogObject<restaurantsTableReservationsOwnerAppClickOnFilterReservationsViewParams>
 */
export function restaurantsTableReservationsOwnerAppClickOnFilterReservationsView(params) {
    return { evid: 1856, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsOwnerAppClickOnChangeLocation' event (evid: 1857)
 *
 * Event description: Click on change location inside the modal
 *
 * @param {restaurantsTableReservationsOwnerAppClickOnChangeLocationParams} params - The parameters for this event
 * @property {GUID} locationGuid - -
 * @property {GUID} reservationLocationId - -
 * @return {LogObject<restaurantsTableReservationsOwnerAppClickOnChangeLocationParams>} LogObject<restaurantsTableReservationsOwnerAppClickOnChangeLocationParams>
 */
export function restaurantsTableReservationsOwnerAppClickOnChangeLocation(params) {
    return { evid: 1857, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuFbConnectNotYourPage' event (evid: 186)
 *
 * Event description: User clicked on 'not you page' link - direct him to support
 *
 * @param {dashboardMenuFbConnectNotYourPageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_auto_connect - [1:0]
 * @property {GUID} site_id - guid
 * @property {string} page_id - FB page id
 * @property {string} page_name - FB page name
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} platform - platform
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuFbConnectNotYourPageParams>} LogObject<dashboardMenuFbConnectNotYourPageParams>
 */
export function dashboardMenuFbConnectNotYourPage(params) {
    return { evid: 186, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuFbConnectAddToFb' event (evid: 187)
 *
 * Event description: After page search, user choose to connect to FB
 *
 * @param {dashboardMenuFbConnectAddToFbParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_auto_connect - [1;0]
 * @property {GUID} site_id - guid
 * @property {string} page_id - FB page id
 * @property {string} page_name - FB page name
 * @property {string} facebook_user_id - facebook_user_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} platform - platform
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuFbConnectAddToFbParams>} LogObject<dashboardMenuFbConnectAddToFbParams>
 */
export function dashboardMenuFbConnectAddToFb(params) {
    return { evid: 187, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuFbConnectLinkFbResult' event (evid: 188)
 *
 * Event description: After user clicked to link page to menu->the result
 *
 * @param {dashboardMenuFbConnectLinkFbResultParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_auto_connect - [1;0]
 * @property {GUID} site_id - guid
 * @property {string} result - success / failure
 * @property {string} reason - reason for failure: not_approved/not_logged_in/not_page_admin
 * @property {string} page_id - FB page id
 * @property {string} page_name - FB page name
 * @property {string} facebook_user_id - facebook_user_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} platform - platform
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuFbConnectLinkFbResultParams>} LogObject<dashboardMenuFbConnectLinkFbResultParams>
 */
export function dashboardMenuFbConnectLinkFbResult(params) {
    return { evid: 188, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuFbConnectViewOnFb' event (evid: 189)
 *
 * Event description: after the page connected -> user click on view on FB which leads him to his business page
 *
 * @param {dashboardMenuFbConnectViewOnFbParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_auto_connect - [1;0]
 * @property {GUID} site_id - guid
 * @property {string} page_id - FB page id
 * @property {string} page_name - FB page name
 * @property {string} facebook_user_id - facebook_user_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} platform - platform name
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuFbConnectViewOnFbParams>} LogObject<dashboardMenuFbConnectViewOnFbParams>
 */
export function dashboardMenuFbConnectViewOnFb(params) {
    return { evid: 189, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuFbConnectRemoveFromFbResult' event (evid: 190)
 *
 * Event description: after the page connected -> user click on remove linkage -> this is the request result
 *
 * @param {dashboardMenuFbConnectRemoveFromFbResultParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_auto_connect - [1;0]
 * @property {GUID} site_id - guid
 * @property {string} result - success/failure
 * @property {string} reason - reason for failure: not_approved/not_logged_in/not_page_admin/cancel
 * @property {string} page_id - FB page id
 * @property {string} page_name - FB page name
 * @property {string} facebook_user_id - facebook_user_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} platform - platform
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuFbConnectRemoveFromFbResultParams>} LogObject<dashboardMenuFbConnectRemoveFromFbResultParams>
 */
export function dashboardMenuFbConnectRemoveFromFbResult(params) {
    return { evid: 190, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardUpgradeButtonClicked' event (evid: 191)
 *
 * Event description: User clicked on upgrade button
 *
 * @param {dashboardUpgradeButtonClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_auto_connect - [1;0]
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - from where the user clicked the button (location in BO)
 * @property {string} organization_id - guid
 * @property {string} platform - platform name
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardUpgradeButtonClickedParams>} LogObject<dashboardUpgradeButtonClickedParams>
 */
export function dashboardUpgradeButtonClicked(params) {
    return { evid: 191, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuFbConnectRemoveFromFb' event (evid: 192)
 *
 * Event description: after the page connected -> user click on remove linkage
 *
 * @param {dashboardMenuFbConnectRemoveFromFbParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_auto_connect - [1;0]
 * @property {GUID} site_id - guid
 * @property {string} page_id - FB page_id
 * @property {string} page_name - FB page name
 * @property {string} facebook_user_id - facebook_user_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} platform - platform
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuFbConnectRemoveFromFbParams>} LogObject<dashboardMenuFbConnectRemoveFromFbParams>
 */
export function dashboardMenuFbConnectRemoveFromFb(params) {
    return { evid: 192, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardLeftNavCategoryClick' event (evid: 193)
 *
 * Event description: User clicked on the left nav tab
 *
 * @param {dashboardLeftNavCategoryClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - The tab name to where he navigated
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardLeftNavCategoryClickParams>} LogObject<dashboardLeftNavCategoryClickParams>
 */
export function dashboardLeftNavCategoryClick(params) {
    return { evid: 193, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsResetDesign' event (evid: 197)
 *
 * Event description: click on reset design in the app settings (under design tab)
 *
 * @param {settingsResetDesignParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<settingsResetDesignParams>} LogObject<settingsResetDesignParams>
 */
export function settingsResetDesign(params) {
    return { evid: 197, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsChangeDesign' event (evid: 198)
 *
 * Event description: click on one of the design element in app settings
 *
 * @param {settingsChangeDesignParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {string} valuePicked - The value the user picked
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - guid
 * @property {string} value - the pathway of the chosen value
 * @property {GUID} bi_token - msid
 * @return {LogObject<settingsChangeDesignParams>} LogObject<settingsChangeDesignParams>
 */
export function settingsChangeDesign(params) {
    return { evid: 198, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsOpenBoClick' event (evid: 199)
 *
 * Event description: user clicked on 'manage' button in app settings of OLO or menu CTA: open the app BO
 *
 * @param {settingsOpenBoClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<settingsOpenBoClickParams>} LogObject<settingsOpenBoClickParams>
 */
export function settingsOpenBoClick(params) {
    return { evid: 199, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSettingsSetStyleFont' event (evid: 20)
 *
 * Event description: menus_settings_set_style_font
 *
 * @param {menusSettingsSetStyleFontParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} style - {Titles,Title and Price, Menu body text, ...}
 * @property {string} font - {Noticia Text, American Typewriter... }
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - {guid}
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusSettingsSetStyleFontParams>} LogObject<menusSettingsSetStyleFontParams>
 */
export function menusSettingsSetStyleFont(params) {
    return { evid: 20, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsUpgradeButtonClicked' event (evid: 200)
 *
 * Event description: Click on upgrade from app settings
 *
 * @param {settingsUpgradeButtonClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - location of the button
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - guid
 * @property {string} platform - platform
 * @property {GUID} bi_token - msid
 * @return {LogObject<settingsUpgradeButtonClickedParams>} LogObject<settingsUpgradeButtonClickedParams>
 */
export function settingsUpgradeButtonClicked(params) {
    return { evid: 200, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationCancelationSucceed' event (evid: 2005)
 *
 * Event description: reservation cancelation succeed (uou and owner)
 *
 * @param {tableReservationCancelationSucceedParams} params - The parameters for this event
 * @property {DateTime} duration - the duration of the reservation
 * @property {string} name - -
 * @property {string} phoneNumber - -
 * @property {string} email - -
 * @property {boolean} isTableOverbooked - true/false
 * @property {string} biToken - msid
 * @property {number} numDetailsEmpty - -
 * @property {string} uuid - -
 * @property {string} assignTableName - -
 * @property {DateTime} datetime - -
 * @property {string} addingTableID - json of the additional fields
 * @property {string} reservation__id - -
 * @property {string} additionalDetailsJson - -
 * @property {DateTime} reservationDate - -
 * @property {GUID} meta_site_id - msid
 * @property {string} mailCheckbox - mail_checkbox
 * @property {number} numDetailsMandatory - -
 * @property {string} locationGuid - -
 * @property {string} origin - live_site_mode / preview_mode / bo (back office)
 * @property {string} contactId - contact_id
 * @property {DateTime} creationDate - -
 * @property {boolean} teamMessageEmpty - True if its empty and false if not
 * @property {string} reservationType - owner / uou
 * @property {number} partySize - -
 * @property {string} teamMessage - json of the text
 * @property {number} numDetailsFull - -
 * @property {string} rest_id - --
 * @property {string} areaCode - areacode
 * @return {LogObject<tableReservationCancelationSucceedParams>} LogObject<tableReservationCancelationSucceedParams>
 */
export function tableReservationCancelationSucceed(params) {
    return { evid: 2005, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableReservationCreateReservationSucceed' event (evid: 2006)
 *
 * Event description: create reservation succeeds
 *
 * @param {tableReservationCreateReservationSucceedParams} params - The parameters for this event
 * @property {DateTime} duration - the duration of the reservation
 * @property {string} name - -
 * @property {string} phoneNumber - -
 * @property {string} email - -
 * @property {boolean} isTableOverbooked - true/false
 * @property {string} biToken - msid
 * @property {number} numDetailsEmpty - -
 * @property {GUID} reservationId - -
 * @property {string} uuid - -
 * @property {string} assignTableName - -
 * @property {DateTime} datetime - -
 * @property {string} addingTableID - -
 * @property {string} reservation__id - -
 * @property {DateTime} reservationDate - -
 * @property {string} additionalDetails - json of the additional fields
 * @property {GUID} meta_site_id - msid
 * @property {string} mailCheckbox - when the uou is check/uncheck this checkbox
 * @property {number} numDetailsMandatory - -
 * @property {string} locationGuid - -
 * @property {string} origin - live_site_mode / preview_mode/ bo
 * @property {string} contactId - id its from uou side
 * @property {DateTime} creationDate - -
 * @property {string} areaType - -
 * @property {boolean} teamMessageEmpty - True if its empty and false if not
 * @property {string} correlationId - -
 * @property {string} reservationType - who did the reservation uou or owenr?
 * @property {number} partySize - -
 * @property {string} teamMessage - json of the text
 * @property {number} numDetailsFull - -
 * @property {string} rest_id - --
 * @property {string} saveType - created/edit
 * @return {LogObject<tableReservationCreateReservationSucceedParams>} LogObject<tableReservationCreateReservationSucceedParams>
 */
export function tableReservationCreateReservationSucceed(params) {
    return { evid: 2006, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsTabClick' event (evid: 201)
 *
 * Event description: click on the tab nav in the app settings
 *
 * @param {settingsTabClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - guid
 * @property {string} value - tab name (info / design...)
 * @property {GUID} bi_token - msid
 * @return {LogObject<settingsTabClickParams>} LogObject<settingsTabClickParams>
 */
export function settingsTabClick(params) {
    return { evid: 201, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsUpdateReservationsSrc61Evid2015' event (evid: 2015)
 *
 * Event description: when a reservation is created or edited or deleted or its status is changed
 *
 * @param {restaurantsTableReservationsUpdateReservationsSrc61Evid2015Params} params - The parameters for this event
 * @property {DateTime} endDateTs - -
 * @property {string} source - OFFLINE/ONLINE/WALK_IN/UNKNOWN
 * @property {number} customFieldsFilledLength - -
 * @property {GUID} reservationId - -
 * @property {boolean} isTeamMessageEmpty - -
 * @property {string} tableIds - list of all the tables that reserved in the reservation
 * @property {DateTime} startDateTs - -
 * @property {GUID} meta_site_id - msid
 * @property {GUID} reservationLocationId - -
 * @property {string} statusBefore - (null | “reserved” | “held” | “no_show” | etc.)
 * @property {GUID} locationId - -
 * @property {GUID} reserveeContactId - -
 * @property {number} tableIdsLength - -
 * @property {string} statusCurrent - (“reserved” | “held” | “no_show” | etc.)
 * @property {number} partySize - -
 * @property {DateTime} updatedDate - the time that the action happened on the server
 * @property {boolean} marketingConsent - true/false
 * @property {string} saveType - (“create” (predefine in server autaomatically when user download the app) | “edit”  when user edit settings)
 * @property {DateTime} createdDate - the date when the reservations created for the first time
 * @return {LogObject<restaurantsTableReservationsUpdateReservationsSrc61Evid2015Params>} LogObject<restaurantsTableReservationsUpdateReservationsSrc61Evid2015Params>
 */
export function restaurantsTableReservationsUpdateReservationsSrc61Evid2015(params) {
    return { evid: 2015, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'futureOrdersToggle' event (evid: 202)
 *
 * Event description: Toggle future ordersings
 *
 * @param {futureOrdersToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - guid
 * @property {string} value - on/off
 * @property {GUID} bi_token - msid
 * @return {LogObject<futureOrdersToggleParams>} LogObject<futureOrdersToggleParams>
 */
export function futureOrdersToggle(params) {
    return { evid: 202, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'futureOrdersApply' event (evid: 203)
 *
 * Event description: Edit dialog details
 *
 * @param {futureOrdersApplyParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} orders_time_frame - minutes
 * @property {GUID} site_id - guid
 * @property {string} my_orders_ind - immediately/before_due_date
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<futureOrdersApplyParams>} LogObject<futureOrdersApplyParams>
 */
export function futureOrdersApply(params) {
    return { evid: 203, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSettingsNavigation' event (evid: 204)
 *
 * Event description: User clicked on the navigation buttons
 *
 * @param {dashboardSettingsNavigationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - {left nav bar,breadcrumbs, subcategory}
 * @property {GUID} site_id - guid
 * @property {string} page_name - The tab name where the user navigated to
 * @property {GUID} locationGuid - location ID
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardSettingsNavigationParams>} LogObject<dashboardSettingsNavigationParams>
 */
export function dashboardSettingsNavigation(params) {
    return { evid: 204, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressCheckoutToggle' event (evid: 205)
 *
 * Event description: Toggle express checkout
 *
 * @param {expressCheckoutToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - on/off
 * @property {GUID} bi_token - msid
 * @return {LogObject<expressCheckoutToggleParams>} LogObject<expressCheckoutToggleParams>
 */
export function expressCheckoutToggle(params) {
    return { evid: 205, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'discountCreate' event (evid: 206)
 *
 * Event description: create a discount
 *
 * @param {discountCreateParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} discount_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {number} discountQuantity - How many discounts are in Dashboard discount list before "new discount" click
 * @property {string} organization_id - Rest_id
 * @property {string} type - Create discount click Plus/Button
 * @property {GUID} bi_token - msid
 * @return {LogObject<discountCreateParams>} LogObject<discountCreateParams>
 */
export function discountCreate(params) {
    return { evid: 206, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'discountDuplicate' event (evid: 207)
 *
 * Event description: create a discount
 *
 * @param {discountDuplicateParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} src_discount_id - []
 * @property {GUID} trgt_discount_id - []
 * @property {string} organization_id - {guid}
 * @property {GUID} bi_token - msid
 * @return {LogObject<discountDuplicateParams>} LogObject<discountDuplicateParams>
 */
export function discountDuplicate(params) {
    return { evid: 207, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'discountChangeStatus' event (evid: 208)
 *
 * Event description: create a discount
 *
 * @param {discountChangeStatusParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - discount name
 * @property {GUID} discount_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - {guid}
 * @property {string} value - enabled/disabled/deleted
 * @property {GUID} bi_token - msid
 * @return {LogObject<discountChangeStatusParams>} LogObject<discountChangeStatusParams>
 */
export function discountChangeStatus(params) {
    return { evid: 208, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'discountAction' event (evid: 209)
 *
 * Event description: create a discount
 *
 * @param {discountActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - discount name
 * @property {string} field - []
 * @property {GUID} discount_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - {guid}
 * @property {string} value - []
 * @property {GUID} bi_token - msid
 * @return {LogObject<discountActionParams>} LogObject<discountActionParams>
 */
export function discountAction(params) {
    return { evid: 209, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSettingsSetStyleColor' event (evid: 21)
 *
 * Event description: menus_settings_set_style_color
 *
 * @param {menusSettingsSetStyleColorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} style - {Titles,Title and Price, Menu body text, ...}
 * @property {string} color - {#123456, ...}
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - {guid}
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusSettingsSetStyleColorParams>} LogObject<menusSettingsSetStyleColorParams>
 */
export function menusSettingsSetStyleColor(params) {
    return { evid: 21, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialBarSettingsLoad' event (evid: 210)
 *
 * Event description: social bar settings load
 *
 * @param {socialBarSettingsLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - {guid}
 * @property {GUID} bi_token - msid
 * @return {LogObject<socialBarSettingsLoadParams>} LogObject<socialBarSettingsLoadParams>
 */
export function socialBarSettingsLoad(params) {
    return { evid: 210, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialBarHidePlatforn' event (evid: 211)
 *
 * Event description: social bar hide platform
 *
 * @param {socialBarHidePlatfornParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - {guid}
 * @property {string} platform - []
 * @property {string} value - true/false
 * @property {GUID} bi_token - msid
 * @return {LogObject<socialBarHidePlatfornParams>} LogObject<socialBarHidePlatfornParams>
 */
export function socialBarHidePlatforn(params) {
    return { evid: 211, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialBarLayout' event (evid: 212)
 *
 * Event description: social bar layout settings
 *
 * @param {socialBarLayoutParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - {guid}
 * @property {string} category - spacing/alignment
 * @property {string} value - true/false
 * @property {GUID} bi_token - msid
 * @return {LogObject<socialBarLayoutParams>} LogObject<socialBarLayoutParams>
 */
export function socialBarLayout(params) {
    return { evid: 212, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialBarSetLinksClick' event (evid: 213)
 *
 * Event description: social bar layout settings
 *
 * @param {socialBarSetLinksClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - {guid}
 * @property {GUID} bi_token - msid
 * @return {LogObject<socialBarSetLinksClickParams>} LogObject<socialBarSetLinksClickParams>
 */
export function socialBarSetLinksClick(params) {
    return { evid: 213, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloSocialClick' event (evid: 214)
 *
 * Event description: UoU click on Social bar
 *
 * @param {liveSiteOloSocialClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} visitorId - visitor_id
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} platform - platform name
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloSocialClickParams>} LogObject<liveSiteOloSocialClickParams>
 */
export function liveSiteOloSocialClick(params) {
    return { evid: 214, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageTryToConnect' event (evid: 215)
 *
 * Event description: user tried to connect a payment gateway
 *
 * @param {dashboardOloPaymentPageTryToConnectParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} country - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageTryToConnectParams>} LogObject<dashboardOloPaymentPageTryToConnectParams>
 */
export function dashboardOloPaymentPageTryToConnect(params) {
    return { evid: 215, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageOutcome' event (evid: 216)
 *
 * Event description: user's outcome after trying to connect
 *
 * @param {dashboardOloPaymentPageOutcomeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} outcome - success/failure
 * @property {string} country - []
 * @property {string} reason - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPaymentPageOutcomeParams>} LogObject<dashboardOloPaymentPageOutcomeParams>
 */
export function dashboardOloPaymentPageOutcome(params) {
    return { evid: 216, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAvailabilityOpen' event (evid: 217)
 *
 * Event description: Availability modal opened
 *
 * @param {dashboardAvailabilityOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - what the user clicked on to get to the modal
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAvailabilityOpenParams>} LogObject<dashboardAvailabilityOpenParams>
 */
export function dashboardAvailabilityOpen(params) {
    return { evid: 217, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAvailabilityApply' event (evid: 218)
 *
 * Event description: Availability modal applied
 *
 * @param {dashboardAvailabilityApplyParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} time_from_open - time_from_open
 * @property {number} num_of_time_windows - num_of_time_windows
 * @property {number} num_of_different_lines - num_of_different_lines
 * @property {boolean} is_changed - is_changed
 * @property {GUID} locationGuid - location_guid
 * @property {number} num_of_events - []
 * @property {string} organization_id - organization_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAvailabilityApplyParams>} LogObject<dashboardAvailabilityApplyParams>
 */
export function dashboardAvailabilityApply(params) {
    return { evid: 218, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAvailabilityCancel' event (evid: 219)
 *
 * Event description: Availability modal closed by X or out of modal
 *
 * @param {dashboardAvailabilityCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} time_from_open - time from opening the modal in ms
 * @property {number} num_of_time_windows - number of different time windows
 * @property {number} num_of_different_lines - number of separate lines after changing
 * @property {boolean} is_changed - did the user change anything
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAvailabilityCancelParams>} LogObject<dashboardAvailabilityCancelParams>
 */
export function dashboardAvailabilityCancel(params) {
    return { evid: 219, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSettingsSetStyleOpacity' event (evid: 22)
 *
 * Event description: menus_settings_set_style_opacity
 *
 * @param {menusSettingsSetStyleOpacityParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} style - {Titles,Title and Price, Menu body text, ...}
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - orders app / menu app
 * @property {string} organization_id - {guid}
 * @property {number} opacity - {0,1,...100}
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusSettingsSetStyleOpacityParams>} LogObject<menusSettingsSetStyleOpacityParams>
 */
export function menusSettingsSetStyleOpacity(params) {
    return { evid: 22, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardPageLoad' event (evid: 220)
 *
 * Event description: a page loaded- Dashboard/now also One-App
 *
 * @param {dashboardPageLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isOnline - One app field. Click done online True/False.
 * @property {GUID} reservationLocationId - table reservation id
 * @property {string} page_name - the name of the page
 * @property {GUID} locationGuid - location ID
 * @property {string} origin - For push notifications One App
 * @property {string} organization_id - guid
 * @property {string} httpOrigin - http origin
 * @property {string} category - when its table reservations app = "table_reservations"
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardPageLoadParams>} LogObject<dashboardPageLoadParams>
 */
export function dashboardPageLoad(params) {
    return { evid: 220, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deliveryIntegrationOrderCreated' event (evid: 2202)
 *
 * Event description: the event will be sent each time a delivery integration order is created
 *
 * @param {deliveryIntegrationOrderCreatedParams} params - The parameters for this event
 * @property {string} priceString - price in string format
 * @property {DateTime} pickupTime - pickupTime
 * @property {GUID} configurationId - configuration_id
 * @property {string} orderId - orderId
 * @property {GUID} integrationAppId - appDefId of the delivery partner
 * @property {string} user_agent - user_agent
 * @property {string} providerDeliveryId - providerDeliveryId
 * @property {GUID} estimateId - estimateId
 * @property {GUID} locationGuid - locationGuid
 * @property {string} currency - currency
 * @property {GUID} msid - msid
 * @property {string} deliveryFeeString - delivery Fee in string
 * @return {LogObject<deliveryIntegrationOrderCreatedParams>} LogObject<deliveryIntegrationOrderCreatedParams>
 */
export function deliveryIntegrationOrderCreated(params) {
    return { evid: 2202, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deliveryPartnerEstimation' event (evid: 2203)
 *
 * Event description: Estimation sent by the delivery partner. To map the placing of the estimation we can use client events
 *
 * @param {deliveryPartnerEstimationParams} params - The parameters for this event
 * @property {GUID} configurationId - configuration_id
 * @property {GUID} integrationAppId - Delivery Integration's appId
 * @property {string} user_agent - user_agent
 * @property {GUID} estimateId - estimateId
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} status - Indicates if the estimation was succesful = true or failed = false
 * @property {string} errorDescription - error_description
 * @property {string} currency - currency
 * @property {string} deliveryFeeString - deliveryFeeString
 * @return {LogObject<deliveryPartnerEstimationParams>} LogObject<deliveryPartnerEstimationParams>
 */
export function deliveryPartnerEstimation(params) {
    return { evid: 2203, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardBannerClick' event (evid: 221)
 *
 * Event description: User clicked on the app banner
 *
 * @param {dashboardBannerClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - the click lead to: i.e cashier payments/ Covid-19/LocationSettings/etc.
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - origin
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardBannerClickParams>} LogObject<dashboardBannerClickParams>
 */
export function dashboardBannerClick(params) {
    return { evid: 221, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reseravtionsManageClick' event (evid: 223)
 *
 * Event description: user clicked on "manage reservations"
 *
 * @param {reseravtionsManageClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - []
 * @property {GUID} bi_token - msid
 * @return {LogObject<reseravtionsManageClickParams>} LogObject<reseravtionsManageClickParams>
 */
export function reseravtionsManageClick(params) {
    return { evid: 223, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reseravtionsSettings' event (evid: 224)
 *
 * Event description: user clicked on app settings
 *
 * @param {reseravtionsSettingsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} controller_name - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - []
 * @property {string} category - settings/layout/design
 * @property {string} value - the value the user chose
 * @property {string} customValue - The value the user picked after it pressed on customize design
 * @property {GUID} bi_token - msid
 * @return {LogObject<reseravtionsSettingsParams>} LogObject<reseravtionsSettingsParams>
 */
export function reseravtionsSettings(params) {
    return { evid: 224, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reservationsReserveClick' event (evid: 225)
 *
 * Event description: uou clicked on reserve
 *
 * @param {reservationsReserveClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - location name
 * @property {GUID} visitorId - visitor_id
 * @property {string} hour - hour
 * @property {boolean} isMerchant - is merchant
 * @property {GUID} locationGuid - location ID
 * @property {number} party - party
 * @property {string} date - date
 * @property {string} organization_id - organization_id
 * @property {DateTime} time - time
 * @property {GUID} bi_token - msid
 * @return {LogObject<reservationsReserveClickParams>} LogObject<reservationsReserveClickParams>
 */
export function reservationsReserveClick(params) {
    return { evid: 225, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reservationsBookATableClick' event (evid: 226)
 *
 * Event description: uou clicked on book a table
 *
 * @param {reservationsBookATableClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - location name
 * @property {GUID} visitorId - visitor_id
 * @property {string} hour - hour
 * @property {boolean} isMerchant - is merchant
 * @property {GUID} locationGuid - location_guid
 * @property {number} party - party
 * @property {string} date - date
 * @property {string} organization_id - organization_id
 * @property {DateTime} time - time
 * @property {GUID} bi_token - msid
 * @return {LogObject<reservationsBookATableClickParams>} LogObject<reservationsBookATableClickParams>
 */
export function reservationsBookATableClick(params) {
    return { evid: 226, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reservationsOutcome' event (evid: 227)
 *
 * Event description: the reservation's outcome
 *
 * @param {reservationsOutcomeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - location name
 * @property {GUID} visitorId - visitor_id
 * @property {string} customFields - custom_fields
 * @property {string} outcome - outcome
 * @property {boolean} isMerchant - is reservation made by merchant
 * @property {GUID} locationGuid - location ID
 * @property {string} isConsent - is consent string
 * @property {string} specialRequests - special_requests
 * @property {string} organization_id - organization_id
 * @property {number} partySize - group size
 * @property {boolean} isCheckBox - Checkbox
 * @property {GUID} bi_token - msid
 * @return {LogObject<reservationsOutcomeParams>} LogObject<reservationsOutcomeParams>
 */
export function reservationsOutcome(params) {
    return { evid: 227, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteMenuLoad' event (evid: 228)
 *
 * Event description: menu load time
 *
 * @param {liveSiteMenuLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} visitorId - visitor_id
 * @property {boolean} is_server_side_rendering - for Menus from 26/09 this parameter is for measuring Full JS (True) vs. Simple JS (False)
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - []
 * @property {GUID} bi_token - msid
 * @property {string} product - product
 * @property {number} loading_time - loading_time
 * @return {LogObject<liveSiteMenuLoadParams>} LogObject<liveSiteMenuLoadParams>
 */
export function liveSiteMenuLoad(params) {
    return { evid: 228, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reservationsFormValidation' event (evid: 229)
 *
 * Event description: triggered when book now is clicked
 *
 * @param {reservationsFormValidationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} time_error - []
 * @property {string} date_error - []
 * @property {GUID} visitorId - visitor_id
 * @property {string} phone_number_error - []
 * @property {string} first_name_error - []
 * @property {GUID} locationGuid - location ID
 * @property {string} last_name_error - []
 * @property {string} consentError - terms and conditions/etc.
 * @property {string} email_error - []
 * @property {string} organization_id - []
 * @property {GUID} bi_token - msid
 * @return {LogObject<reservationsFormValidationParams>} LogObject<reservationsFormValidationParams>
 */
export function reservationsFormValidation(params) {
    return { evid: 229, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'usabilityModal' event (evid: 230)
 *
 * Event description: for usability only
 *
 * @param {usabilityModalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - {guid}
 * @property {string} action - close/register
 * @property {GUID} bi_token - msid
 * @return {LogObject<usabilityModalParams>} LogObject<usabilityModalParams>
 */
export function usabilityModal(params) {
    return { evid: 230, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAddProductToSite' event (evid: 231)
 *
 * Event description: Click on add app to site (empty state)
 *
 * @param {dashboardAddProductToSiteParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - click source
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - {guid}
 * @property {string} target - editor/mMA
 * @property {GUID} bi_token - msid
 * @property {string} product - product name
 * @return {LogObject<dashboardAddProductToSiteParams>} LogObject<dashboardAddProductToSiteParams>
 */
export function dashboardAddProductToSite(params) {
    return { evid: 231, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageTipEnable' event (evid: 232)
 *
 * Event description: user change the state of the tip option
 *
 * @param {dashboardOloPaymentPageTipEnableParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - the end state of the check box
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardOloPaymentPageTipEnableParams>} LogObject<dashboardOloPaymentPageTipEnableParams>
 */
export function dashboardOloPaymentPageTipEnable(params) {
    return { evid: 232, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPaymentPageSave' event (evid: 233)
 *
 * Event description: user change the state of the tip option
 *
 * @param {dashboardOloPaymentPageSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardOloPaymentPageSaveParams>} LogObject<dashboardOloPaymentPageSaveParams>
 */
export function dashboardOloPaymentPageSave(params) {
    return { evid: 233, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloMyOrdersTab' event (evid: 234)
 *
 * Event description: user switches between tabs
 *
 * @param {dashboardOloMyOrdersTabParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} tab_name - tab name
 * @property {GUID} locationGuid - loaction ID
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardOloMyOrdersTabParams>} LogObject<dashboardOloMyOrdersTabParams>
 */
export function dashboardOloMyOrdersTab(params) {
    return { evid: 234, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTypeSelectionLoad' event (evid: 235)
 *
 * Event description: restaurants selection screen loaded
 *
 * @param {restaurantsTypeSelectionLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<restaurantsTypeSelectionLoadParams>} LogObject<restaurantsTypeSelectionLoadParams>
 */
export function restaurantsTypeSelectionLoad(params) {
    return { evid: 235, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTypeSelection' event (evid: 236)
 *
 * Event description: restaurants type selected
 *
 * @param {restaurantsTypeSelectionParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} restaurant_type - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<restaurantsTypeSelectionParams>} LogObject<restaurantsTypeSelectionParams>
 */
export function restaurantsTypeSelection(params) {
    return { evid: 236, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingRestTypeSkip' event (evid: 237)
 *
 * Event description: skip on restaurant type select
 *
 * @param {onboardingRestTypeSkipParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<onboardingRestTypeSkipParams>} LogObject<onboardingRestTypeSkipParams>
 */
export function onboardingRestTypeSkip(params) {
    return { evid: 237, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mobileOnlineOrderingFlow' event (evid: 238)
 *
 * Event description: click on online notification
 *
 * @param {mobileOnlineOrderingFlowParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} stage - the stage the use is in
 * @property {GUID} visitorId - []
 * @property {GUID} locationGuid - location_guid
 * @property {number} loadingTime - loading time
 * @property {string} organization_id - guid
 * @property {string} group - A/B Test group name
 * @property {GUID} bi_token - []
 * @return {LogObject<mobileOnlineOrderingFlowParams>} LogObject<mobileOnlineOrderingFlowParams>
 */
export function mobileOnlineOrderingFlow(params) {
    return { evid: 238, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setNotification' event (evid: 239)
 *
 * Event description: notification event -triggered upon successful save per notification
 *
 * @param {setNotificationParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} notification_type - new_order/delayed_order/updated_reservation
 * @property {string} channel - email/sms/phone/fax/webhook/print
 * @property {DateTime} time_modified - time stamp when notifications were modified, same as in set notifications agg
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {number} delay_mins - 0 when new_order
 * @property {string} value - domain/code/number
 * @property {GUID} bi_token - []
 * @property {boolean} active - true/false
 * @return {LogObject<setNotificationParams>} LogObject<setNotificationParams>
 */
export function setNotification(params) {
    return { evid: 239, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnboardingLoad' event (evid: 24)
 *
 * Event description: restaurants_onoarding_load
 *
 * @param {restaurantsOnboardingLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnboardingLoadParams>} LogObject<restaurantsOnboardingLoadParams>
 */
export function restaurantsOnboardingLoad(params) {
    return { evid: 24, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setNotificationError' event (evid: 240)
 *
 * Event description: notification event -triggered upon failed save per notification
 *
 * @param {setNotificationErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} notification_type - new_order/delayed_order/updated_reservation
 * @property {string} channel - email/sms/phone/fax/webhook/print
 * @property {DateTime} time_modified - time stamp when notifications were modified, same as in set notifications agg
 * @property {GUID} locationGuid - location_guid
 * @property {string} errorType - error type
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<setNotificationErrorParams>} LogObject<setNotificationErrorParams>
 */
export function setNotificationError(params) {
    return { evid: 240, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'posPosToggle' event (evid: 2401)
 *
 * Event description: Click on toggle
 *
 * @param {posPosToggleParams} params - The parameters for this event
 * @property {GUID} locationGuid - location
 * @property {string} providerId - /
 * @property {string} lastState - toogle on/off
 * @property {string} providerName - /
 * @property {string} organization_id - {guid}
 * @property {GUID} msid - {guid}
 * @return {LogObject<posPosToggleParams>} LogObject<posPosToggleParams>
 */
export function posPosToggle(params) {
    return { evid: 2401, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'posOrderFailed' event (evid: 2402)
 *
 * Event description: an order was created in Wix but failed in pos
 *
 * @param {posOrderFailedParams} params - The parameters for this event
 * @property {boolean} failedAfterWixCharge - if order failed after the user was charged by wix
 * @property {string} stepName - validate order/create order
 * @property {GUID} locationGuid - location
 * @property {string} providerId - proider id
 * @property {string} errorCode - error code
 * @property {string} failReason - reason
 * @property {string} paymentProvider - payment provider
 * @property {string} providerName - name
 * @property {string} organization_id - {guid}
 * @property {GUID} msid - {guid}
 * @return {LogObject<posOrderFailedParams>} LogObject<posOrderFailedParams>
 */
export function posOrderFailed(params) {
    return { evid: 2402, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'posOrderSuccess' event (evid: 2403)
 *
 * Event description: An order was created in Wix and accepted at POS side
 *
 * @param {posOrderSuccessParams} params - The parameters for this event
 * @property {string} orderId - order id
 * @property {GUID} locationGuid - location
 * @property {string} providerId - proider id
 * @property {string} paymentProvider - payment provider
 * @property {string} providerName - name
 * @property {string} organization_id - {guid}
 * @property {GUID} msid - {guid}
 * @return {LogObject<posOrderSuccessParams>} LogObject<posOrderSuccessParams>
 */
export function posOrderSuccess(params) {
    return { evid: 2403, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'notificationsOnlineClick' event (evid: 241)
 *
 * Event description: click on online notification
 *
 * @param {notificationsOnlineClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} screenName - reservations/orders
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<notificationsOnlineClickParams>} LogObject<notificationsOnlineClickParams>
 */
export function notificationsOnlineClick(params) {
    return { evid: 241, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDuplicateClick' event (evid: 242)
 *
 * Event description: click on duplicate
 *
 * @param {menusDuplicateClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - Duplicate Existing Menu/ Duplicate Button
 * @property {GUID} catalogId - catalog_id
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - guid
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {string} item_type - menu/section/dish
 * @property {GUID} bi_token - []
 * @property {string} level - menus/menu/section/dish
 * @return {LogObject<menusDuplicateClickParams>} LogObject<menusDuplicateClickParams>
 */
export function menusDuplicateClick(params) {
    return { evid: 242, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDuplicate' event (evid: 243)
 *
 * Event description: duplicate an item
 *
 * @param {menusDuplicateParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {number} menusCount - number menus of a dish/section is being duplicated to
 * @property {string} duplicateItemsPaths - catalogId.menuId.sectionId.itemId
 * @property {string} locationIdDestination - the location id’s that were chosen to duplicate into
 * @property {string} errorReason - In case of a failure, send the error reason
 * @property {number} sectionsCount - number sections of a dish is being duplicated to
 * @property {boolean} isSuccess - did the duplicate succeeded
 * @property {string} sectionIdDestination - an Array of sections that the dish being duplicated to is sent to
 * @property {GUID} locationGuid - location ID
 * @property {string} menuIdDestination - an Array of menus that the dish/section being duplicated to is sent to
 * @property {string} origin - Duplicate Existing Menu/ Duplicate Button
 * @property {GUID} catalogId - catalog_id
 * @property {GUID} sectionId - section ID
 * @property {number} locationsCount - the number of chosen locations
 * @property {string} itemId - itemId
 * @property {string} organization_id - guid
 * @property {string} dishId - itemId of the dish
 * @property {boolean} locationIncluded - true / false - true if the locationID is included in the locationIdDestination
 * @property {string} menuId - menu ID
 * @property {string} item_type - menu/section/dish
 * @property {GUID} bi_token - []
 * @return {LogObject<menusDuplicateParams>} LogObject<menusDuplicateParams>
 */
export function menusDuplicate(params) {
    return { evid: 243, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusRestoreClick' event (evid: 244)
 *
 * Event description: click on restore item from archive
 *
 * @param {menusRestoreClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} item_type - menu/section/dish
 * @property {GUID} bi_token - []
 * @return {LogObject<menusRestoreClickParams>} LogObject<menusRestoreClickParams>
 */
export function menusRestoreClick(params) {
    return { evid: 244, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusRestoreFromArchive' event (evid: 245)
 *
 * Event description: restore an item from the archive
 *
 * @param {menusRestoreFromArchiveParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} item_type - menu/section/dish
 * @property {GUID} bi_token - []
 * @return {LogObject<menusRestoreFromArchiveParams>} LogObject<menusRestoreFromArchiveParams>
 */
export function menusRestoreFromArchive(params) {
    return { evid: 245, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusNotificationBarClickOnView' event (evid: 246)
 *
 * Event description: click on view button from notification bar, after restoring an item from the archive
 *
 * @param {menusNotificationBarClickOnViewParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<menusNotificationBarClickOnViewParams>} LogObject<menusNotificationBarClickOnViewParams>
 */
export function menusNotificationBarClickOnView(params) {
    return { evid: 246, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusClickOnAddExisting' event (evid: 247)
 *
 * Event description: click on add an existing item- Dish options
 *
 * @param {menusClickOnAddExistingParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - top/bottom/plus
 * @property {GUID} catalogId - catalog_id
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - guid
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {string} item_type - dish/option
 * @property {GUID} bi_token - []
 * @property {string} level - menus/menu/section/dish
 * @return {LogObject<menusClickOnAddExistingParams>} LogObject<menusClickOnAddExistingParams>
 */
export function menusClickOnAddExisting(params) {
    return { evid: 247, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusAddExisting' event (evid: 248)
 *
 * Event description: add an existing item
 *
 * @param {menusAddExistingParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {number} numberOfChoices - number of choices added from existing as dishes
 * @property {GUID} locationGuid - location_guid
 * @property {number} numberOfPossibleItems - number of possible items to choose from in the modal
 * @property {GUID} catalogId - catalogId
 * @property {string} itemIds - all item ids of dishes added from existing separated by commas
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId
 * @property {string} organization_id - guid
 * @property {number} numOfOptions - The number of option added to the dish
 * @property {string} menuId - menuId
 * @property {number} numberOfDishes - number of dishes added from existing
 * @property {string} item_type - dish/option
 * @property {GUID} bi_token - []
 * @return {LogObject<menusAddExistingParams>} LogObject<menusAddExistingParams>
 */
export function menusAddExisting(params) {
    return { evid: 248, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingLetsGoClick' event (evid: 25)
 *
 * Event description: restaurants_onoarding_lets_go_click
 *
 * @param {restaurantsOnoardingLetsGoClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingLetsGoClickParams>} LogObject<restaurantsOnoardingLetsGoClickParams>
 */
export function restaurantsOnoardingLetsGoClick(params) {
    return { evid: 25, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'discountCouponToggle' event (evid: 250)
 *
 * Event description: Discount coupon Toggle
 *
 * @param {discountCouponToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} discountType - %/fix_item/fix_order
 * @property {string} couponCode - coupon code/null
 * @property {GUID} locationGuid - location_guid
 * @property {string} valueOrigin - On/Off origin
 * @property {string} organization_id - restId
 * @property {string} valueEnd - On/Off end
 * @property {string} rest_id - {guid}
 * @property {GUID} bi_token - []
 * @return {LogObject<discountCouponToggleParams>} LogObject<discountCouponToggleParams>
 */
export function discountCouponToggle(params) {
    return { evid: 250, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'discountSave' event (evid: 251)
 *
 * Event description: Discount coupon Toggle
 *
 * @param {discountSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {number} limitOrigin - Coupon limit uses before
 * @property {string} name - Discount name when saved
 * @property {number} limitAfter - Coupon limit uses after save
 * @property {string} discountTypeBefore - %/fix_item/fix_order
 * @property {boolean} couponAfter - yes/no
 * @property {GUID} discountId - ID
 * @property {number} discountValueBefore - discount value before
 * @property {string} discountTypeAfter - %/fix_item/fix_order
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} couponBefore - yes/no
 * @property {string} sessionId - unique Id for each time user open the Dashboard
 * @property {number} discountValueAfter - discount value after
 * @property {string} organization_id - organization_id
 * @property {string} rest_id - {guid}
 * @property {GUID} bi_token - []
 * @property {boolean} limitUse - limited=1,unlimited=0
 * @return {LogObject<discountSaveParams>} LogObject<discountSaveParams>
 */
export function discountSave(params) {
    return { evid: 251, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPaymentPageAddCouponCode' event (evid: 252)
 *
 * Event description: User clicks on Add Code in the payment page
 *
 * @param {oloPaymentPageAddCouponCodeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization id
 * @property {GUID} msid - msid
 * @property {string} rest_id - organization_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<oloPaymentPageAddCouponCodeParams>} LogObject<oloPaymentPageAddCouponCodeParams>
 */
export function oloPaymentPageAddCouponCode(params) {
    return { evid: 252, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPaymentPageCouponCodeApplyStarted' event (evid: 253)
 *
 * Event description: User clicks on Apply in the coupon code page
 *
 * @param {oloPaymentPageCouponCodeApplyStartedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {string} context - Coupon code context
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization id
 * @property {GUID} msid - msid
 * @property {string} rest_id - organization ID
 * @property {GUID} bi_token - msid
 * @return {LogObject<oloPaymentPageCouponCodeApplyStartedParams>} LogObject<oloPaymentPageCouponCodeApplyStartedParams>
 */
export function oloPaymentPageCouponCodeApplyStarted(params) {
    return { evid: 253, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPaymentPageCouponCodeApplyFinished' event (evid: 254)
 *
 * Event description: User clicks on Add Code in the payment page
 *
 * @param {oloPaymentPageCouponCodeApplyFinishedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {string} context - Coupon code context
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} discount_subtotal - Money- Discount amount
 * @property {number} screen_width - screen width to identify users' platform
 * @property {boolean} isSuccess - Apply succeeded
 * @property {GUID} locationGuid - location_guid
 * @property {string} errorType - Error received when clicks on apply/null
 * @property {string} sessionId - session_id
 * @property {string} organization_id - organization id
 * @property {string} currency - discount currency
 * @property {GUID} msid - msid
 * @property {string} rest_id - organization_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<oloPaymentPageCouponCodeApplyFinishedParams>} LogObject<oloPaymentPageCouponCodeApplyFinishedParams>
 */
export function oloPaymentPageCouponCodeApplyFinished(params) {
    return { evid: 254, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloPaymentPageCouponCodeCancel' event (evid: 255)
 *
 * Event description: User clicks on Add Code in the payment page
 *
 * @param {oloPaymentPageCouponCodeCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} site_id - guid
 * @property {string} couponCode - The coupon code the UoU wrote
 * @property {boolean} is_merchant - rather the user is the restaurant owner
 * @property {number} screen_width - screen width to identify users' platform
 * @property {boolean} isSuccess - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} errorType - error/null
 * @property {string} organization_id - organization id
 * @property {GUID} msid - msid
 * @property {string} rest_id - organization_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<oloPaymentPageCouponCodeCancelParams>} LogObject<oloPaymentPageCouponCodeCancelParams>
 */
export function oloPaymentPageCouponCodeCancel(params) {
    return { evid: 255, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'discountErrror' event (evid: 256)
 *
 * Event description: Discount coupon Toggle
 *
 * @param {discountErrrorParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} discount_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} errorType - error user received
 * @property {string} sessionId - unique Id for each time user open the Dashboard
 * @property {string} organization_id - organization_id
 * @property {GUID} msid - msid
 * @property {string} value - value User wrote
 * @property {string} rest_id - {guid}
 * @property {GUID} bi_token - msid
 * @return {LogObject<discountErrrorParams>} LogObject<discountErrrorParams>
 */
export function discountErrror(params) {
    return { evid: 256, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'discountCancel' event (evid: 257)
 *
 * Event description: Cancel new discount
 *
 * @param {discountCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} discount_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - Rest_id
 * @property {string} type - cancel discount click cancel/leave page
 * @property {GUID} bi_token - []
 * @return {LogObject<discountCancelParams>} LogObject<discountCancelParams>
 */
export function discountCancel(params) {
    return { evid: 257, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAvailabilityLoad' event (evid: 258)
 *
 * Event description: Availability window loaded on Dashboard
 *
 * @param {dashboardAvailabilityLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} source_page - Pickup/orders/reservations/Dish etc.
 * @property {GUID} msid - msid
 * @property {string} type_origin - Origin of window- Open hours/custom hours
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAvailabilityLoadParams>} LogObject<dashboardAvailabilityLoadParams>
 */
export function dashboardAvailabilityLoad(params) {
    return { evid: 258, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAvailabilityNewEvent' event (evid: 259)
 *
 * Event description: Availability window loaded on Dashboard
 *
 * @param {dashboardAvailabilityNewEventParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} source_page - Pickup/orders/reservations/Dish etc.
 * @property {GUID} msid - msid
 * @property {string} rest_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAvailabilityNewEventParams>} LogObject<dashboardAvailabilityNewEventParams>
 */
export function dashboardAvailabilityNewEvent(params) {
    return { evid: 259, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingBasicSet' event (evid: 26)
 *
 * Event description: restaurants_onoarding_basic_set
 *
 * @param {restaurantsOnoardingBasicSetParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} address_ok - {0,1}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} title_ok - {0,1}
 * @property {string} organization_id - guid
 * @property {string} address - '...'
 * @property {string} title - '...'
 * @property {GUID} msid - msid
 * @property {boolean} phone_ok - {0,1}
 * @property {string} phone - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingBasicSetParams>} LogObject<restaurantsOnoardingBasicSetParams>
 */
export function restaurantsOnoardingBasicSet(params) {
    return { evid: 26, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAvailabilityNewCustom' event (evid: 260)
 *
 * Event description: New custom hours row on Availability window (Dashboard)
 *
 * @param {dashboardAvailabilityNewCustomParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} button_name - Plus/Clone
 * @property {GUID} locationGuid - location_guid
 * @property {string} source_page - Pickup/orders/reservations/Dish etc.
 * @property {GUID} msid - msid
 * @property {string} rest_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAvailabilityNewCustomParams>} LogObject<dashboardAvailabilityNewCustomParams>
 */
export function dashboardAvailabilityNewCustom(params) {
    return { evid: 260, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderPacingIfDelayExist' event (evid: 2601)
 *
 * Event description: the event will be sent when the UoU got a delay message
 *
 * @param {orderPacingIfDelayExistParams} params - The parameters for this event
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<orderPacingIfDelayExistParams>} LogObject<orderPacingIfDelayExistParams>
 */
export function orderPacingIfDelayExist(params) {
    return { evid: 2601, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderPacingUouDispatchSettingsFutureOrdersSeeUnavailableTimeSlots' event (evid: 2602)
 *
 * Event description: the event will be sent when the UoU is in the dispatch settings and trying to choose a specific time (for future order) and there are time slots that are unavailable
 *
 * @param {orderPacingUouDispatchSettingsFutureOrdersSeeUnavailableTimeSlotsParams} params - The parameters for this event
 * @property {string} amountOfUnavailableTimes - amount of time slots that the user cant choose
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<orderPacingUouDispatchSettingsFutureOrdersSeeUnavailableTimeSlotsParams>} LogObject<orderPacingUouDispatchSettingsFutureOrdersSeeUnavailableTimeSlotsParams>
 */
export function orderPacingUouDispatchSettingsFutureOrdersSeeUnavailableTimeSlots(params) {
    return { evid: 2602, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderPacingMyOrdersPageRestaurantInARush' event (evid: 2604)
 *
 * Event description: the event will be sent when an alert of " your experiencing a rush based on your settings, new customers will see longer fulfillment times.."
 *
 * @param {orderPacingMyOrdersPageRestaurantInARushParams} params - The parameters for this event
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<orderPacingMyOrdersPageRestaurantInARushParams>} LogObject<orderPacingMyOrdersPageRestaurantInARushParams>
 */
export function orderPacingMyOrdersPageRestaurantInARush(params) {
    return { evid: 2604, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAvailabilityApplySrc61Evid261' event (evid: 261)
 *
 * Event description: New custom hours row on Availability window (Dashboard)
 *
 * @param {dashboardAvailabilityApplySrc61Evid261Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} numberOfCustomHours - Number of Custom hours rows
 * @property {boolean} iserror - whether were collision or not
 * @property {string} button_name - Plus/Clone
 * @property {boolean} numberChanged - Number of Custom hours rows has changed yes/no
 * @property {GUID} locationGuid - location_guid
 * @property {string} type_hours - Apply when custom hours/open hours
 * @property {string} organization_id - rest id
 * @property {string} source_page - Pickup/orders/reservations/Dish etc.
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} type_hours_changed - yes/no
 * @return {LogObject<dashboardAvailabilityApplySrc61Evid261Params>} LogObject<dashboardAvailabilityApplySrc61Evid261Params>
 */
export function dashboardAvailabilityApplySrc61Evid261(params) {
    return { evid: 261, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAvailabilityCancelSrc61Evid262' event (evid: 262)
 *
 * Event description: Availability window loaded on Dashboard
 *
 * @param {dashboardAvailabilityCancelSrc61Evid262Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} buttonType - X/cancel
 * @property {GUID} locationGuid - location_guid
 * @property {string} source_page - Pickup/orders/reservations/Dish etc.
 * @property {GUID} msid - msid
 * @property {string} rest_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAvailabilityCancelSrc61Evid262Params>} LogObject<dashboardAvailabilityCancelSrc61Evid262Params>
 */
export function dashboardAvailabilityCancelSrc61Evid262(params) {
    return { evid: 262, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'availabilityError' event (evid: 266)
 *
 * Event description: Availability click on SMTWTFS, checking if error
 *
 * @param {availabilityErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} iserror - yes/no
 * @property {GUID} locationGuid - location_guid
 * @property {string} originpage - origin page
 * @property {string} organization_id - {guid}
 * @property {string} weekday - weekday
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<availabilityErrorParams>} LogObject<availabilityErrorParams>
 */
export function availabilityError(params) {
    return { evid: 266, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfAvailabilityError24Hours' event (evid: 267)
 *
 * Event description: Availability click on 24 hours, checking if error
 *
 * @param {copyOfAvailabilityError24HoursParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} iserror - yes/no
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} status - click on/off
 * @property {string} originpage - origin page
 * @property {string} organization_id - {guid}
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<copyOfAvailabilityError24HoursParams>} LogObject<copyOfAvailabilityError24HoursParams>
 */
export function copyOfAvailabilityError24Hours(params) {
    return { evid: 267, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfCopyOfAvailabilityErrorSetHours' event (evid: 268)
 *
 * Event description: Availability click on setting hours, checking if error
 *
 * @param {copyOfCopyOfAvailabilityErrorSetHoursParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} iserror - yes/no
 * @property {GUID} locationGuid - location_guid
 * @property {string} originpage - origin page
 * @property {string} organization_id - {guid}
 * @property {string} type - From/to
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<copyOfCopyOfAvailabilityErrorSetHoursParams>} LogObject<copyOfCopyOfAvailabilityErrorSetHoursParams>
 */
export function copyOfCopyOfAvailabilityErrorSetHours(params) {
    return { evid: 268, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterDummyEvent' event (evid: 269)
 *
 * Event description: Dummy first event for testing
 *
 * @param {callCenterDummyEventParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - String value
 * @property {GUID} bi_token - msid
 * @return {LogObject<callCenterDummyEventParams>} LogObject<callCenterDummyEventParams>
 */
export function callCenterDummyEvent(params) {
    return { evid: 269, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingBasicTitleError' event (evid: 27)
 *
 * Event description: restaurants_onoarding_basic_title_error
 *
 * @param {restaurantsOnoardingBasicTitleErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingBasicTitleErrorParams>} LogObject<restaurantsOnoardingBasicTitleErrorParams>
 */
export function restaurantsOnoardingBasicTitleError(params) {
    return { evid: 27, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsOpen' event (evid: 270)
 *
 * Event description: ADI/Editor -> open app settings
 *
 * @param {editorAppSettingsOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - Editor is default, else=ADI
 * @property {string} organization_id - string
 * @property {string} productName - Menu/Olo/Reservations
 * @property {GUID} bi_token - msid
 * @return {LogObject<editorAppSettingsOpenParams>} LogObject<editorAppSettingsOpenParams>
 */
export function editorAppSettingsOpen(params) {
    return { evid: 270, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsChangeElement' event (evid: 271)
 *
 * Event description: ADI/Editor -> change element settings
 *
 * @param {editorAppSettingsChangeElementParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} parameter - parameter name
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - Editor is default, else=ADI
 * @property {string} organization_id - string
 * @property {string} productName - Menu/Olo/Reservations
 * @property {GUID} bi_token - msid
 * @property {string} newValue - Value after the change- if menu visible/not then parameter=menu id, newValeue F/T
 * @return {LogObject<editorAppSettingsChangeElementParams>} LogObject<editorAppSettingsChangeElementParams>
 */
export function editorAppSettingsChangeElement(params) {
    return { evid: 271, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloOrderSent3DsStart' event (evid: 273)
 *
 * Event description: 3DS start Authentication payment
 *
 * @param {liveSiteOloOrderSent3DsStartParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} gatewayId - gatewayId
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloOrderSent3DsStartParams>} LogObject<liveSiteOloOrderSent3DsStartParams>
 */
export function liveSiteOloOrderSent3DsStart(params) {
    return { evid: 273, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloOrderSent3DsComplete' event (evid: 274)
 *
 * Event description: 3DS complete Authentication payment
 *
 * @param {liveSiteOloOrderSent3DsCompleteParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isSuccess - yes- 3ds confirmed
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloOrderSent3DsCompleteParams>} LogObject<liveSiteOloOrderSent3DsCompleteParams>
 */
export function liveSiteOloOrderSent3DsComplete(params) {
    return { evid: 274, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloLoadindScreenIosLoad' event (evid: 275)
 *
 * Event description: loadind_screen_ios loaded (hey, you're on iPhone screen)
 *
 * @param {liveSiteOloLoadindScreenIosLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - []
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloLoadindScreenIosLoadParams>} LogObject<liveSiteOloLoadindScreenIosLoadParams>
 */
export function liveSiteOloLoadindScreenIosLoad(params) {
    return { evid: 275, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppInteraction' event (evid: 277)
 *
 * Event description: User interfaces with the App- Swipe/clickonItem/...
 *
 * @param {oneAppInteractionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isOnline - One app field. Click done online True/False.
 * @property {string} appName - orders/reservation/etc.
 * @property {GUID} locationGuid - locationID
 * @property {string} origin - Place: new/overview/etc.
 * @property {string} type - click/swipe/ClickonPrint/ClickonOrder/etc.
 * @property {GUID} msid - msid
 * @property {string} value - value- Order ID
 * @property {GUID} bi_token - msid
 * @return {LogObject<oneAppInteractionParams>} LogObject<oneAppInteractionParams>
 */
export function oneAppInteraction(params) {
    return { evid: 277, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppMenusAction' event (evid: 278)
 *
 * Event description: User does an action on One app (Instock/out of stock. In the future new menu, etc)
 *
 * @param {oneAppMenusActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isOnline - One app field. Click done online True/False.
 * @property {GUID} locationGuid - location_id
 * @property {string} origin - Place: new/overview/etc.
 * @property {string} type - click/swipe/etc.
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @property {GUID} bi_token - msid
 * @return {LogObject<oneAppMenusActionParams>} LogObject<oneAppMenusActionParams>
 */
export function oneAppMenusAction(params) {
    return { evid: 278, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSearch' event (evid: 279)
 *
 * Event description: User use search bar on One app
 *
 * @param {oneAppSearchParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isOnline - One app field. Click done online True/False.
 * @property {string} searchTerm - search term
 * @property {GUID} locationGuid - location_id
 * @property {number} amountSearch - []
 * @property {string} app - menus/orders
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<oneAppSearchParams>} LogObject<oneAppSearchParams>
 */
export function oneAppSearch(params) {
    return { evid: 279, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingBasicAddressError' event (evid: 28)
 *
 * Event description: restaurants_onoarding_basic_address_error
 *
 * @param {restaurantsOnoardingBasicAddressErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingBasicAddressErrorParams>} LogObject<restaurantsOnoardingBasicAddressErrorParams>
 */
export function restaurantsOnoardingBasicAddressError(params) {
    return { evid: 28, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dishUpdated' event (evid: 2808)
 *
 * Event description: On Any change in a dish
 *
 * @param {dishUpdatedParams} params - The parameters for this event
 * @property {string} requestPayloadJson - the part of the object that is changed in json format
 * @property {GUID} locationGuid - location id
 * @property {string} status - "updated"
 * @property {GUID} catalogId - catalog id
 * @property {string} itemId - dish/variation ID
 * @return {LogObject<dishUpdatedParams>} LogObject<dishUpdatedParams>
 */
export function dishUpdated(params) {
    return { evid: 2808, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dishCreated' event (evid: 2809)
 *
 * Event description: When a dish is created
 *
 * @param {dishCreatedParams} params - The parameters for this event
 * @property {string} dishOptions - Items customers can choose to modify a dish. Can be an extra, selection, or deselection.
 * @property {string} name - item name
 * @property {boolean} visible - is the item visible to customers
 * @property {string} description - item description
 * @property {GUID} locationGuid - location id
 * @property {string} labels - Item labels. For example spicy, hot, vegan, gluten-free, or organic.
 * @property {string} status - "created"
 * @property {GUID} catalogId - catalog id
 * @property {string} sectionId - section id
 * @property {string} itemId - dish/variation ID
 * @property {string} currency - price currency
 * @property {string} type - item type (UNSPECIFIED_ITEM_TYPE, DISH, VARIATION.)
 * @property {string} menuId - menu id
 * @property {string} priceSelection - the item price
 * @return {LogObject<dishCreatedParams>} LogObject<dishCreatedParams>
 */
export function dishCreated(params) {
    return { evid: 2809, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloResAdvancedSettingsPoliciesToggle' event (evid: 281)
 *
 * Event description: activate or disabling the Policies feature with toggle located in the BM
 * OLO/REServations -> Advanced Settings -> Policies toggle
 *
 * @param {dashboardOloResAdvancedSettingsPoliciesToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} appName - Orders/Reservations
 * @property {GUID} locationGuid - location_guid
 * @property {string} value - the end state of the feature (active/paused)
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloResAdvancedSettingsPoliciesToggleParams>} LogObject<dashboardOloResAdvancedSettingsPoliciesToggleParams>
 */
export function dashboardOloResAdvancedSettingsPoliciesToggle(params) {
    return { evid: 281, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dishArchived' event (evid: 2810)
 *
 * Event description: When a dish is archived
 *
 * @param {dishArchivedParams} params - The parameters for this event
 * @property {GUID} locationGuid - location id
 * @property {string} status - "archived"
 * @property {GUID} catalogId - catalog id
 * @property {string} sectionId - section id
 * @property {string} itemId - dish/variation ID
 * @property {string} menuId - menu id
 * @return {LogObject<dishArchivedParams>} LogObject<dishArchivedParams>
 */
export function dishArchived(params) {
    return { evid: 2810, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dishSaveError' event (evid: 2811)
 *
 * Event description: On unsuccessful save dish attempt
 *
 * @param {dishSaveErrorParams} params - The parameters for this event
 * @property {string} errorReason - error reason
 * @property {GUID} locationGuid - location id
 * @property {GUID} catalogId - catalog id
 * @property {string} itemId - dish/variation ID
 * @return {LogObject<dishSaveErrorParams>} LogObject<dishSaveErrorParams>
 */
export function dishSaveError(params) {
    return { evid: 2811, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sectionUpdated' event (evid: 2812)
 *
 * Event description: On Any change in a section
 *
 * @param {sectionUpdatedParams} params - The parameters for this event
 * @property {string} requestPayloadJson - the part of the object that is changed in json format
 * @property {GUID} locationGuid - location id
 * @property {string} status - "updated"
 * @property {GUID} catalogId - catalog id
 * @property {string} sectionId - section id
 * @property {string} menuId - menu id
 * @return {LogObject<sectionUpdatedParams>} LogObject<sectionUpdatedParams>
 */
export function sectionUpdated(params) {
    return { evid: 2812, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sectionCreated' event (evid: 2813)
 *
 * Event description: When a section is created
 *
 * @param {sectionCreatedParams} params - The parameters for this event
 * @property {string} name - section name
 * @property {boolean} visible - is the section visible to customers
 * @property {string} description - section description
 * @property {GUID} locationGuid - location id
 * @property {string} status - "created"
 * @property {GUID} catalogId - catalog id
 * @property {string} sectionId - section id
 * @property {string} menuId - menu id
 * @return {LogObject<sectionCreatedParams>} LogObject<sectionCreatedParams>
 */
export function sectionCreated(params) {
    return { evid: 2813, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sectionArchived' event (evid: 2814)
 *
 * Event description: When a section is archived
 *
 * @param {sectionArchivedParams} params - The parameters for this event
 * @property {GUID} locationGuid - location id
 * @property {string} status - "archived"
 * @property {GUID} catalogId - catalog id
 * @property {string} sectionId - section id
 * @property {string} menuId - menu id
 * @return {LogObject<sectionArchivedParams>} LogObject<sectionArchivedParams>
 */
export function sectionArchived(params) {
    return { evid: 2814, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sectionSaveError' event (evid: 2815)
 *
 * Event description: On unsuccessful save section attempt
 *
 * @param {sectionSaveErrorParams} params - The parameters for this event
 * @property {string} errorReason - error reason
 * @property {GUID} locationGuid - location id
 * @property {GUID} catalogId - catalog id
 * @property {string} sectionId - section id
 * @property {string} menuId - menu id
 * @return {LogObject<sectionSaveErrorParams>} LogObject<sectionSaveErrorParams>
 */
export function sectionSaveError(params) {
    return { evid: 2815, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuUpdated' event (evid: 2816)
 *
 * Event description: On Any change in a menu
 *
 * @param {menuUpdatedParams} params - The parameters for this event
 * @property {string} requestPayloadJson - the part of the object that is changed in json format
 * @property {GUID} locationGuid - location id
 * @property {string} status - "updated"
 * @property {GUID} catalogId - catalog id
 * @property {string} menuId - menu id
 * @return {LogObject<menuUpdatedParams>} LogObject<menuUpdatedParams>
 */
export function menuUpdated(params) {
    return { evid: 2816, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuCreated' event (evid: 2817)
 *
 * Event description: When a menu is created
 *
 * @param {menuCreatedParams} params - The parameters for this event
 * @property {string} name - menu name
 * @property {boolean} visible - is the menu visible to customers
 * @property {string} description - menu description
 * @property {GUID} locationGuid - location id
 * @property {string} status - "created"
 * @property {GUID} catalogId - catalog id
 * @property {string} menuId - menu id
 * @return {LogObject<menuCreatedParams>} LogObject<menuCreatedParams>
 */
export function menuCreated(params) {
    return { evid: 2817, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuArchived' event (evid: 2818)
 *
 * Event description: When a menu is archived
 *
 * @param {menuArchivedParams} params - The parameters for this event
 * @property {GUID} locationGuid - location id
 * @property {string} status - "archived"
 * @property {GUID} catalogId - catalog id
 * @property {string} menuId - menu id
 * @return {LogObject<menuArchivedParams>} LogObject<menuArchivedParams>
 */
export function menuArchived(params) {
    return { evid: 2818, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloResAdvancedSettingsPoliciesClick' event (evid: 282)
 *
 * Event description: BM
 * OLO/REServations -> Advanced Settings -> Policies clicks.
 * policies_click
 *
 * @param {dashboardOloResAdvancedSettingsPoliciesClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} appName - Orders/Reservations / table_reservations
 * @property {GUID} locationGuid - location_guid
 * @property {string} clickName - terms/privacy/checkbox + origin
 * @property {string} value - the end state of the feature (on/off)
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloResAdvancedSettingsPoliciesClickParams>} LogObject<dashboardOloResAdvancedSettingsPoliciesClickParams>
 */
export function dashboardOloResAdvancedSettingsPoliciesClick(params) {
    return { evid: 282, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusNavigation' event (evid: 283)
 *
 * Event description: The user clicks in the Menus BM- action,
 *
 * @param {dashboardMenusNavigationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} clickType - edit/3 points/sidebar, etc.
 * @property {GUID} locationGuid - location_guid
 * @property {string} destinationPage - menu/section/dish ()
 * @property {GUID} catalogId - catalog_id
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - organization id
 * @property {string} dishId - dishId
 * @property {string} pageName - sidebar / main / etc
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - msid
 * @property {string} level - menus/menu/section/dish.  NOTICE - this field represents from the rewrite and forward (sept 2022) the level in which the click happened. In the older version of this event, all the 'clickOnMore' events regard this field as itemType field
 * @return {LogObject<dashboardMenusNavigationParams>} LogObject<dashboardMenusNavigationParams>
 */
export function dashboardMenusNavigation(params) {
    return { evid: 283, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAdvancedSave' event (evid: 284)
 *
 * Event description: user saved the changes in the Advanced page. for information on new future orders (which is scheduling order go to evid 61:555
 *
 * @param {dashboardAdvancedSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} consentDescription - whether policy/box/etc. saved
 * @property {string} roundingOptionChosen - half away from zero / half to even / etc
 * @property {number} futureOrderFrom - from value (minutes).new data on scheduled orders on evid 61:555
 * @property {number} customFieldsCount - number of custom fields existing when saved
 * @property {boolean} isError - yes/no (when click on save)
 * @property {string} defaultDispatchType - delivery/takeout
 * @property {number} customFieldsCountRequired - number of custom fields required existing when saved
 * @property {boolean} orderPacingContactless - true/false
 * @property {string} appName - Olo/Reservations
 * @property {string} futureLongBeforeDueDateType - days/hours/minutes. new data on scheduled orders on evid 61:555
 * @property {boolean} allowCustomTip - true/false
 * @property {string} defaultTip - default value/null if no value
 * @property {string} tipValue1 - tip value 1
 * @property {boolean} futureOrders - on/off when saving.new data on scheduled orders on evid 61:555
 * @property {string} futureOrderFromTo - from-to. new data on scheduled orders on evid 61:555
 * @property {boolean} allow_services_fees - true/false
 * @property {string} orderPacingApplyLimit - order_pacing_apply_limit
 * @property {string} customFieldsNames - Custom fields names
 * @property {GUID} locationGuid - location_guid
 * @property {string} errorType - the reason why the save couldnt be done( when click on save)
 * @property {string} tipValue2 - tip value2
 * @property {boolean} isDefaultDispatchTypeChange - true/false
 * @property {number} orderPacingOrderLimit - the value of order limit field
 * @property {number} feesCount - -
 * @property {string} tipType - currency/percentage
 * @property {boolean} isSmsEnabled - true/false
 * @property {boolean} isTipEnabled - true/false
 * @property {number} futureLongBeforeDueDate - value (minutes) how ling before due date. new data on scheduled orders on evid 61:555
 * @property {string} organization_id - rest id
 * @property {boolean} expressCheckout - on/off when saving
 * @property {string} tipValue3 - tip value3
 * @property {number} futureOrderTo - to value (minutes).new data on scheduled orders on evid 61:555
 * @property {boolean} consent - on/off when saving
 * @property {string} futureWhenAppear - future_when_appear
 * @property {boolean} futureIsCaterer - Are you a caterer? true/false. new data on asap on evid 61:555
 * @property {string} futureOrderToType - days/hours/minutes.new data on scheduled orders on evid 61:555
 * @property {string} futureOrderFromType - days/hours/minutes.new data on scheduled orders on evid 61:555
 * @property {string} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAdvancedSaveParams>} LogObject<dashboardAdvancedSaveParams>
 */
export function dashboardAdvancedSave(params) {
    return { evid: 284, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloConfirmationPageConsent' event (evid: 285)
 *
 * Event description: Live Site -> OLO -> Confirmation Page -> Consent.
 *
 * @param {liveSiteOloConfirmationPageConsentParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} consentDescription - terms and conditions/Privacy policy/etc.
 * @property {string} appName - Orders/Reservations
 * @property {string} clickType - click_type
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloConfirmationPageConsentParams>} LogObject<liveSiteOloConfirmationPageConsentParams>
 */
export function liveSiteOloConfirmationPageConsent(params) {
    return { evid: 285, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSettings' event (evid: 286)
 *
 * Event description: User interfaces with the Settings in the "Restaurant App". (Comment - since there was a mix up with reservations. For reservations toggle on state, from 2022-02-02 use type="ReservationsToggleUpdated" and last_state="on". Before that, use type="ReservationsToggle" and last_state="off".)
 *
 * @param {oneAppSettingsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} configurationId - configuration_id
 * @property {boolean} isOnline - yes-no
 * @property {string} appName - orders/reservation/etc.
 * @property {GUID} locationGuid - location_id
 * @property {string} lastState - final_state
 * @property {string} origin - First time Experience or regular print from settings
 * @property {string} type - Sound/PrintClick/etc.
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @property {GUID} bi_token - msid
 * @return {LogObject<oneAppSettingsParams>} LogObject<oneAppSettingsParams>
 */
export function oneAppSettings(params) {
    return { evid: 286, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppError' event (evid: 287)
 *
 * Event description: Errors sent in the "Restaurant App"
 *
 * @param {oneAppErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isOnline - yes-no
 * @property {string} appName - orders/reservation/etc.
 * @property {string} errorReason - error_reason
 * @property {GUID} locationGuid - location_id
 * @property {string} type - Print/sound/etc.
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<oneAppErrorParams>} LogObject<oneAppErrorParams>
 */
export function oneAppError(params) {
    return { evid: 287, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppSuccess' event (evid: 288)
 *
 * Event description: Successes in OneApp
 *
 * @param {oneAppSuccessParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isOnline - yes-no
 * @property {string} appName - orders/reservation/etc.
 * @property {GUID} locationGuid - location_id
 * @property {string} type - Print/sound/etc.
 * @property {GUID} msid - msid
 * @property {string} value - message value
 * @property {GUID} bi_token - msid
 * @return {LogObject<oneAppSuccessParams>} LogObject<oneAppSuccessParams>
 */
export function oneAppSuccess(params) {
    return { evid: 288, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppPrinterConnectSuccess' event (evid: 289)
 *
 * Event description: Successes connecting printer in OneApp
 *
 * @param {oneAppPrinterConnectSuccessParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isOnline - yes-no
 * @property {string} printerName - printer name
 * @property {GUID} locationGuid - location_id
 * @property {GUID} msid - msid
 * @property {boolean} isAuto - is auto print
 * @property {GUID} bi_token - msid
 * @return {LogObject<oneAppPrinterConnectSuccessParams>} LogObject<oneAppPrinterConnectSuccessParams>
 */
export function oneAppPrinterConnectSuccess(params) {
    return { evid: 289, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingBasicPhoneError' event (evid: 29)
 *
 * Event description: restaurants_onoarding_basic_phone_error
 *
 * @param {restaurantsOnoardingBasicPhoneErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingBasicPhoneErrorParams>} LogObject<restaurantsOnoardingBasicPhoneErrorParams>
 */
export function restaurantsOnoardingBasicPhoneError(params) {
    return { evid: 29, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDragDropMenusSections' event (evid: 290)
 *
 * Event description: Dashboard -> Drag and drop - menus/sections/dishes/options
 *
 * @param {dashboardDragDropMenusSectionsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId of the dish that
 * @property {string} organization_id - {guid}
 * @property {string} menuId - menuId
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @property {string} level - menu/section/dish/option
 * @return {LogObject<dashboardDragDropMenusSectionsParams>} LogObject<dashboardDragDropMenusSectionsParams>
 */
export function dashboardDragDropMenusSections(params) {
    return { evid: 290, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusArchiveNavigation' event (evid: 291)
 *
 * Event description: user switches between tabs
 *
 * @param {dashboardMenusArchiveNavigationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} tab_name - tab name
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusArchiveNavigationParams>} LogObject<dashboardMenusArchiveNavigationParams>
 */
export function dashboardMenusArchiveNavigation(params) {
    return { evid: 291, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOpenInfo' event (evid: 292)
 *
 * Event description: menus_info_open
 *
 * @param {dashboardOpenInfoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalog_id
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - {guid}
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @property {string} level - menu/section/dish
 * @return {LogObject<dashboardOpenInfoParams>} LogObject<dashboardOpenInfoParams>
 */
export function dashboardOpenInfo(params) {
    return { evid: 292, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteOloDeliveryPageUouStartedTypingAddress' event (evid: 294)
 *
 * Event description: UoU started typing the address
 *
 * @param {liveSiteOloDeliveryPageUouStartedTypingAddressParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - <>
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteOloDeliveryPageUouStartedTypingAddressParams>} LogObject<liveSiteOloDeliveryPageUouStartedTypingAddressParams>
 */
export function liveSiteOloDeliveryPageUouStartedTypingAddress(params) {
    return { evid: 294, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOpenSettingsClick' event (evid: 295)
 *
 * Event description: Dashboard -> OLO -> Open Settings Click
 *
 * @param {dashboardOloOpenSettingsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOpenSettingsClickParams>} LogObject<dashboardOloOpenSettingsClickParams>
 */
export function dashboardOloOpenSettingsClick(params) {
    return { evid: 295, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuOpenMenuConstrains' event (evid: 296)
 *
 * Event description: Dashboard -> Menu -> open menu constrains
 * AKA- click on "online ordering" in the menu/section/dish
 *
 * @param {dashboardMenuOpenMenuConstrainsParams} params - The parameters for this event
 * @property {string} organizationId - rest_id
 * @property {GUID} instance_id - instance_id
 * @property {string} editLevel - menu/section/dish
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - edit or out of edit
 * @property {GUID} catalogId - catalog_id
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - rest_id
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuOpenMenuConstrainsParams>} LogObject<dashboardMenuOpenMenuConstrainsParams>
 */
export function dashboardMenuOpenMenuConstrains(params) {
    return { evid: 296, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusClickOnNewOption' event (evid: 297)
 *
 * Event description: click on add a new option item- Dish options
 *
 * @param {menusClickOnNewOptionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - bottom/top
 * @property {GUID} catalogId - catalog_id
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - guid
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusClickOnNewOptionParams>} LogObject<menusClickOnNewOptionParams>
 */
export function menusClickOnNewOption(params) {
    return { evid: 297, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusSaveMenuConstrains' event (evid: 299)
 *
 * Event description: click on add a new option item- Dish options
 *
 * @param {menusSaveMenuConstrainsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isPhoneOrder - Menus are shown in phone orders true/false
 * @property {boolean} isSite - Menus are shown in site true/false
 * @property {boolean} isPickup - pickup on/off
 * @property {boolean} isInStock - in stock on/off
 * @property {GUID} locationGuid - location_guid
 * @property {string} specialHourPeriods - hours in which the item is available/not available
 * @property {GUID} catalogId - catalogId
 * @property {boolean} isDelivery - delivery on/off
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId
 * @property {string} organization_id - guid
 * @property {boolean} isSpecialRequest - special request on/off
 * @property {boolean} isMobileSite - Menus are shown in Mobile site true/false
 * @property {string} openingPeriods - hours in which the item is available regularly
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - msid
 * @property {string} level - menu/section/dish
 * @return {LogObject<menusSaveMenuConstrainsParams>} LogObject<menusSaveMenuConstrainsParams>
 */
export function menusSaveMenuConstrains(params) {
    return { evid: 299, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingBasicSetField' event (evid: 30)
 *
 * Event description: restaurants_onoarding_basic_set_field
 *
 * @param {restaurantsOnoardingBasicSetFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} field - {title,address,phone}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingBasicSetFieldParams>} LogObject<restaurantsOnoardingBasicSetFieldParams>
 */
export function restaurantsOnoardingBasicSetField(params) {
    return { evid: 30, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryEditFieldInDeliveryArea' event (evid: 300)
 *
 * Event description: The user edits a field in a delivery area
 *
 * @param {dashboardOloDeliveryEditFieldInDeliveryAreaParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} areaName - name
 * @property {string} field - name/minimum/etc.
 * @property {GUID} configurationId - configurationId
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - org id
 * @property {string} value - value
 * @property {number} index - index
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryEditFieldInDeliveryAreaParams>} LogObject<dashboardOloDeliveryEditFieldInDeliveryAreaParams>
 */
export function dashboardOloDeliveryEditFieldInDeliveryArea(params) {
    return { evid: 300, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'login' event (evid: 301)
 *
 * Event description: login to the app
 *
 * @param {loginParams} params - The parameters for this event
 * @property {string} mobile_version - []
 * @property {GUID} uuid - []
 * @property {string} appVersion - app version
 * @property {boolean} is_resume - is resumed session
 * @property {number} screen_width - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {number} screen_height - []
 * @property {string} type - device type
 * @property {string} platform - facebook/google/wix
 * @property {string} device - []
 * @return {LogObject<loginParams>} LogObject<loginParams>
 */
export function login(params) {
    return { evid: 301, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pushNotifications' event (evid: 302)
 *
 * Event description: push notifications activate/deactivate
 *
 * @param {pushNotificationsParams} params - The parameters for this event
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} value - yes/no
 * @return {LogObject<pushNotificationsParams>} LogObject<pushNotificationsParams>
 */
export function pushNotifications(params) {
    return { evid: 302, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderAction' event (evid: 303)
 *
 * Event description: user's action with the order
 *
 * @param {orderActionParams} params - The parameters for this event
 * @property {string} source - swipe/button
 * @property {string} orderId - []
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} action - accept/reject/delivered
 * @property {string} rest_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<orderActionParams>} LogObject<orderActionParams>
 */
export function orderAction(params) {
    return { evid: 303, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'undoOrderAction' event (evid: 304)
 *
 * Event description: undo the action
 *
 * @param {undoOrderActionParams} params - The parameters for this event
 * @property {string} orderId - []
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} action - accept / reject / delivered
 * @property {string} rest_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<undoOrderActionParams>} LogObject<undoOrderActionParams>
 */
export function undoOrderAction(params) {
    return { evid: 304, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorReport' event (evid: 306)
 *
 * Event description: error report
 *
 * @param {errorReportParams} params - The parameters for this event
 * @property {string} device_name - []
 * @property {string} device_id - []
 * @property {string} operating_system - []
 * @property {string} model - []
 * @property {GUID} uuid - []
 * @property {string} is_emulator - []
 * @property {string} brand - []
 * @property {string} user_agent - []
 * @property {string} install_id - []
 * @property {string} version - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} error_msg - []
 * @property {string} manufacturer - []
 * @return {LogObject<errorReportParams>} LogObject<errorReportParams>
 */
export function errorReport(params) {
    return { evid: 306, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appActivityStatus' event (evid: 307)
 *
 * Event description: is the app in foreground or background
 *
 * @param {appActivityStatusParams} params - The parameters for this event
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} activity_status - background/foreground
 * @return {LogObject<appActivityStatusParams>} LogObject<appActivityStatusParams>
 */
export function appActivityStatus(params) {
    return { evid: 307, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'soundSettingsChange' event (evid: 308)
 *
 * Event description: sound settings change
 *
 * @param {soundSettingsChangeParams} params - The parameters for this event
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} isActive - true/false
 * @return {LogObject<soundSettingsChangeParams>} LogObject<soundSettingsChangeParams>
 */
export function soundSettingsChange(params) {
    return { evid: 308, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'backgroundSoundSettingsChange' event (evid: 309)
 *
 * Event description: background sound settings change
 *
 * @param {backgroundSoundSettingsChangeParams} params - The parameters for this event
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} isActive - true/false
 * @return {LogObject<backgroundSoundSettingsChangeParams>} LogObject<backgroundSoundSettingsChangeParams>
 */
export function backgroundSoundSettingsChange(params) {
    return { evid: 309, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingBasicOkClick' event (evid: 31)
 *
 * Event description: restaurants_onoarding_basic_ok_click
 *
 * @param {restaurantsOnoardingBasicOkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingBasicOkClickParams>} LogObject<restaurantsOnoardingBasicOkClickParams>
 */
export function restaurantsOnoardingBasicOkClick(params) {
    return { evid: 31, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'localeFallback' event (evid: 310)
 *
 * Event description: user chose an unsupported language, automatic try to choose new language by locale
 *
 * @param {localeFallbackParams} params - The parameters for this event
 * @property {string} install_id - []
 * @property {string} requested_locale - []
 * @property {GUID} uuid - []
 * @property {string} appVersion - app version
 * @property {GUID} visitor_id - []
 * @property {GUID} client_id - client_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} fallback_locale - []
 * @property {string} device - []
 * @return {LogObject<localeFallbackParams>} LogObject<localeFallbackParams>
 */
export function localeFallback(params) {
    return { evid: 310, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'installation' event (evid: 311)
 *
 * Event description: login to the app
 *
 * @param {installationParams} params - The parameters for this event
 * @property {string} install_id - []
 * @property {string} operating_system - []
 * @property {string} appVersion - app version
 * @property {GUID} client_id - client_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} device - []
 * @return {LogObject<installationParams>} LogObject<installationParams>
 */
export function installation(params) {
    return { evid: 311, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appFeedback' event (evid: 312)
 *
 * Event description: when the user gives feedback
 *
 * @param {appFeedbackParams} params - The parameters for this event
 * @property {number} rate - 1-5
 * @property {string} review - text review
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} bi_token - []
 * @return {LogObject<appFeedbackParams>} LogObject<appFeedbackParams>
 */
export function appFeedback(params) {
    return { evid: 312, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appNavigation' event (evid: 313)
 *
 * Event description: user's navigation within the app
 *
 * @param {appNavigationParams} params - The parameters for this event
 * @property {string} orderId - []
 * @property {GUID} uuid - []
 * @property {string} tabName - the tab name
 * @property {string} install_id - []
 * @property {string} page_name - the page name
 * @property {GUID} locationGuid - location_guid
 * @property {string} rest_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<appNavigationParams>} LogObject<appNavigationParams>
 */
export function appNavigation(params) {
    return { evid: 313, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reservationAction' event (evid: 314)
 *
 * Event description: user's action with the reservation
 *
 * @param {reservationActionParams} params - The parameters for this event
 * @property {string} source - swipe/button
 * @property {string} orderId - []
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} action - accept/reject/delivered
 * @property {string} rest_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<reservationActionParams>} LogObject<reservationActionParams>
 */
export function reservationAction(params) {
    return { evid: 314, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'undoReservationAction' event (evid: 315)
 *
 * Event description: undo the reservation action
 *
 * @param {undoReservationActionParams} params - The parameters for this event
 * @property {string} orderId - []
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} action - accept / reject / delivered
 * @property {string} rest_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<undoReservationActionParams>} LogObject<undoReservationActionParams>
 */
export function undoReservationAction(params) {
    return { evid: 315, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reservationDocumentation' event (evid: 316)
 *
 * Event description: reservation documentation
 *
 * @param {reservationDocumentationParams} params - The parameters for this event
 * @property {string} orderId - []
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} action - print / email / fax
 * @property {string} rest_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<reservationDocumentationParams>} LogObject<reservationDocumentationParams>
 */
export function reservationDocumentation(params) {
    return { evid: 316, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuAction' event (evid: 317)
 *
 * Event description: user's action with the menu (out/in of stock)
 *
 * @param {menuActionParams} params - The parameters for this event
 * @property {string} source - swipe/button
 * @property {string} orderId - []
 * @property {GUID} uuid - []
 * @property {string} install_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} action - in stock / out of stock
 * @property {string} rest_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<menuActionParams>} LogObject<menuActionParams>
 */
export function menuAction(params) {
    return { evid: 317, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloNotificationsAddExtraNotification' event (evid: 318)
 *
 * Event description: use click on the add notification button
 *
 * @param {dashboardOloNotificationsAddExtraNotificationParams} params - The parameters for this event
 * @property {string} organizationId - org id
 * @property {GUID} instance_id - instance
 * @property {GUID} site_id - guid
 * @property {string} appName - app_name
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - org id
 * @property {string} orderType - order_type
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloNotificationsAddExtraNotificationParams>} LogObject<dashboardOloNotificationsAddExtraNotificationParams>
 */
export function dashboardOloNotificationsAddExtraNotification(params) {
    return { evid: 318, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloNotificationsDeleteNotifcation' event (evid: 319)
 *
 * Event description: use click on the delete notification button
 *
 * @param {dashboardOloNotificationsDeleteNotifcationParams} params - The parameters for this event
 * @property {string} organizationId - org id
 * @property {GUID} instance_id - instance
 * @property {GUID} site_id - guid
 * @property {string} appName - app_name
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - org id
 * @property {string} orderType - receive/unhandled
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloNotificationsDeleteNotifcationParams>} LogObject<dashboardOloNotificationsDeleteNotifcationParams>
 */
export function dashboardOloNotificationsDeleteNotifcation(params) {
    return { evid: 319, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingBasicSaveClick' event (evid: 32)
 *
 * Event description: restaurants_onoarding_basic_save_click
 *
 * @param {restaurantsOnoardingBasicSaveClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingBasicSaveClickParams>} LogObject<restaurantsOnoardingBasicSaveClickParams>
 */
export function restaurantsOnoardingBasicSaveClick(params) {
    return { evid: 32, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardNotificationsCancel' event (evid: 320)
 *
 * Event description: user cancel the changes made in the page
 *
 * @param {dashboardNotificationsCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} site_id - guid
 * @property {string} appName - orders/reservations
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardNotificationsCancelParams>} LogObject<dashboardNotificationsCancelParams>
 */
export function dashboardNotificationsCancel(params) {
    return { evid: 320, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAdvancedSettingsFutureOrdersClicks' event (evid: 321)
 *
 * Event description: BM
 * Advanced Settings -> future orders clicks
 *
 * @param {dashboardAdvancedSettingsFutureOrdersClicksParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} appName - Orders/Reservations
 * @property {GUID} locationGuid - location_guid
 * @property {string} clickName - careter/from/to
 * @property {string} organization_id - org id
 * @property {string} value - the end state of the feature (on/off/days/or value himself))
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAdvancedSettingsFutureOrdersClicksParams>} LogObject<dashboardAdvancedSettingsFutureOrdersClicksParams>
 */
export function dashboardAdvancedSettingsFutureOrdersClicks(params) {
    return { evid: 321, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsOpenSettingsClick' event (evid: 322)
 *
 * Event description: Dashboard -> Reservations -> Open Settings Click
 *
 * @param {dashboardReservationsOpenSettingsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsOpenSettingsClickParams>} LogObject<dashboardReservationsOpenSettingsClickParams>
 */
export function dashboardReservationsOpenSettingsClick(params) {
    return { evid: 322, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardPosGetStarted' event (evid: 323)
 *
 * Event description: User clicked on the Get Started click on the POS integration
 *
 * @param {dashboardPosGetStartedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} restaurantId - rest id
 * @property {string} variant - b/c
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization_id - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardPosGetStartedParams>} LogObject<dashboardPosGetStartedParams>
 */
export function dashboardPosGetStarted(params) {
    return { evid: 323, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardPosOpenSelectPos' event (evid: 324)
 *
 * Event description: User clicked on the select POS option on the POS integration
 *
 * @param {dashboardPosOpenSelectPosParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} restaurantId - rest id
 * @property {string} variant - b/c
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization_id - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardPosOpenSelectPosParams>} LogObject<dashboardPosOpenSelectPosParams>
 */
export function dashboardPosOpenSelectPos(params) {
    return { evid: 324, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardPosUserStartedTyping' event (evid: 325)
 *
 * Event description: UoU started typing the address
 *
 * @param {dashboardPosUserStartedTypingParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} field - firstName/lastName/Email
 * @property {string} restaurantId - rest_id
 * @property {string} variant - b/c
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization_id - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardPosUserStartedTypingParams>} LogObject<dashboardPosUserStartedTypingParams>
 */
export function dashboardPosUserStartedTyping(params) {
    return { evid: 325, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardPosCancel' event (evid: 326)
 *
 * Event description: UoU clicked on Cancel
 *
 * @param {dashboardPosCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} restaurantId - rest_id
 * @property {string} variant - b/v
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization_id - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardPosCancelParams>} LogObject<dashboardPosCancelParams>
 */
export function dashboardPosCancel(params) {
    return { evid: 326, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardPosSave' event (evid: 327)
 *
 * Event description: User clicked on save in the POS- finished the flow
 *
 * @param {dashboardPosSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} domain - @.com
 * @property {string} restaurantId - rest_id
 * @property {string} pos - Xenial/square/etc.
 * @property {string} variant - b/c
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization_id - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardPosSaveParams>} LogObject<dashboardPosSaveParams>
 */
export function dashboardPosSave(params) {
    return { evid: 327, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingBasicSaveSuccess' event (evid: 33)
 *
 * Event description: restaurants_onoarding_basic_save_success
 *
 * @param {restaurantsOnoardingBasicSaveSuccessParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {number} time_from_save_click - []
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingBasicSaveSuccessParams>} LogObject<restaurantsOnoardingBasicSaveSuccessParams>
 */
export function restaurantsOnoardingBasicSaveSuccess(params) {
    return { evid: 33, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppLocationPicked' event (evid: 330)
 *
 * Event description: User changed location
 *
 * @param {oneAppLocationPickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {boolean} isOnline - One app field. Click done online True/False.
 * @property {string} appName - app name
 * @property {GUID} newLocation - new Location
 * @property {GUID} locationGuid - locationID (old)
 * @property {string} origin - Place: manageOrders/Settings/Widget...
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<oneAppLocationPickedParams>} LogObject<oneAppLocationPickedParams>
 */
export function oneAppLocationPicked(params) {
    return { evid: 330, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOpenVideoTutorial' event (evid: 332)
 *
 * Event description: User clicked on the video tutorial button on the BM
 * (For now the event is for the video tutorial in the BM menus, if we add some entry point, please add here origin parameter)
 *
 * @param {dashboardOpenVideoTutorialParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} screen_name - from which screen (menus/orders/welcome screens..)
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} source_video - menu / olo
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOpenVideoTutorialParams>} LogObject<dashboardOpenVideoTutorialParams>
 */
export function dashboardOpenVideoTutorial(params) {
    return { evid: 332, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardCloseVideoTutorial' event (evid: 333)
 *
 * Event description: User clicked on the video tutorial button on the BM
 * (For now the event is for the video tutorial in the BM menus, if we add some entry point, please add here origin parameter)
 *
 * @param {dashboardCloseVideoTutorialParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} source_video - menu / olo
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardCloseVideoTutorialParams>} LogObject<dashboardCloseVideoTutorialParams>
 */
export function dashboardCloseVideoTutorial(params) {
    return { evid: 333, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuLoadWithVideo' event (evid: 334)
 *
 * Event description: event for Video menu test-
 * the BM (menu) was loaded with the video component.
 *
 * @param {menuLoadWithVideoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - loaded from.
 * @property {string} source_video - menu / olo
 * @property {GUID} bi_token - msid
 * @return {LogObject<menuLoadWithVideoParams>} LogObject<menuLoadWithVideoParams>
 */
export function menuLoadWithVideo(params) {
    return { evid: 334, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationSettingsCustomFields' event (evid: 335)
 *
 * Event description: User click on the custom field plus
 *
 * @param {dashboardReservationSettingsCustomFieldsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - <>
 * @property {string} type - Click Type/New field/Delete, etc..
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationSettingsCustomFieldsParams>} LogObject<dashboardReservationSettingsCustomFieldsParams>
 */
export function dashboardReservationSettingsCustomFields(params) {
    return { evid: 335, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPickupPagePickupToggleCurbsidePickup' event (evid: 339)
 *
 * Event description: Curbside pickup- User choose the Curbside pickup check box / choose additional customer information (of Curbside pickup)
 *
 * @param {dashboardOloPickupPagePickupToggleCurbsidePickupParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} restaurantId - rest id
 * @property {GUID} locationGuid - location_guid
 * @property {string} clickName - check box/ additional customer information
 * @property {string} organizationId - organization id
 * @property {string} type - no information/ require information
 * @property {string} value - on/off
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPickupPagePickupToggleCurbsidePickupParams>} LogObject<dashboardOloPickupPagePickupToggleCurbsidePickupParams>
 */
export function dashboardOloPickupPagePickupToggleCurbsidePickup(params) {
    return { evid: 339, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingBasicSaveError' event (evid: 34)
 *
 * Event description: restaurants_onoarding_basic_save_success
 *
 * @param {restaurantsOnoardingBasicSaveErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {string} code - {conflict,timeout...}
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingBasicSaveErrorParams>} LogObject<restaurantsOnoardingBasicSaveErrorParams>
 */
export function restaurantsOnoardingBasicSaveError(params) {
    return { evid: 34, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardGenericModalLoadSrc61Evid340' event (evid: 340)
 *
 * Event description: User clicked on a button on the BM in old olo
 *
 * @param {dashboardGenericModalLoadSrc61Evid340Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} screenName - from which screen (menus/orders/welcome screens..)
 * @property {string} restaurantId - organization_id
 * @property {string} modal_name - name of the modal
 * @return {LogObject<dashboardGenericModalLoadSrc61Evid340Params>} LogObject<dashboardGenericModalLoadSrc61Evid340Params>
 */
export function dashboardGenericModalLoadSrc61Evid340(params) {
    return { evid: 340, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSetUpLocationClickSrc61Evid341' event (evid: 341)
 *
 * Event description: user saved the changes in the Advanced page
 *
 * @param {dashboardSetUpLocationClickSrc61Evid341Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} defaultDispatchType - delivery/takeout
 * @property {string} appName - Olo/Reservations
 * @property {string} restaurantId - rest id
 * @property {GUID} locationGuid - /
 * @property {boolean} isDefaultDispatchTypeChange - true/false
 * @property {GUID} bi_token - /
 * @return {LogObject<dashboardSetUpLocationClickSrc61Evid341Params>} LogObject<dashboardSetUpLocationClickSrc61Evid341Params>
 */
export function dashboardSetUpLocationClickSrc61Evid341(params) {
    return { evid: 341, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSetUpLocationClick' event (evid: 342)
 *
 * Event description: click on Set up location click
 *
 * @param {dashboardSetUpLocationClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} appName - app name
 * @property {string} clickType - pop up bar / drop down menu
 * @property {GUID} locationGuid - location_guid
 * @property {string} pageName - the name of the page
 * @property {string} type - add new location / set up location
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardSetUpLocationClickParams>} LogObject<dashboardSetUpLocationClickParams>
 */
export function dashboardSetUpLocationClick(params) {
    return { evid: 342, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardLocationPickerInteraction' event (evid: 343)
 *
 * Event description: pick a location from the location dropdown
 *
 * @param {dashboardLocationPickerInteractionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} appName - app name
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - the name of the page
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardLocationPickerInteractionParams>} LogObject<dashboardLocationPickerInteractionParams>
 */
export function dashboardLocationPickerInteraction(params) {
    return { evid: 343, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusMoveToClick' event (evid: 344)
 *
 * Event description: menus --> move to click.
 *
 * @param {menusMoveToClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location ID
 * @property {string} itemType - menu/section/dish
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - section ID
 * @property {string} dishId - Dish ID
 * @property {string} pageName - the name of the page
 * @property {string} menuId - menu ID
 * @property {GUID} bi_token - msid
 * @property {string} level - level at which the click was done at menu/section/dish..
 * @return {LogObject<menusMoveToClickParams>} LogObject<menusMoveToClickParams>
 */
export function menusMoveToClick(params) {
    return { evid: 344, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDuplicateExistingMenuClick' event (evid: 345)
 *
 * Event description: User closed the Set up location pop-up (this will appear if the user did not set any location). The event will be triggered if the user pressed the X button in the pop-up or outside in order to close it.
 *
 * @param {menusDuplicateExistingMenuClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instace
 * @property {string} appName - app name
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - the name of the page
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusDuplicateExistingMenuClickParams>} LogObject<menusDuplicateExistingMenuClickParams>
 */
export function menusDuplicateExistingMenuClick(params) {
    return { evid: 345, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDuplicateExistingMenu' event (evid: 346)
 *
 * Event description: After the user has moved a menu/section/dish a green "Take me there" bar will appear at the top of the page. This event identifies whether the user clicked on the "Take me there" or closed the bar. The item type here is the item that was moved.
 *
 * @param {menusDuplicateExistingMenuParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} locationGuid - location ID
 * @property {string} itemType - menu/section/dish
 * @property {string} pageName - page name
 * @property {string} type - take me there click / close
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusDuplicateExistingMenuParams>} LogObject<menusDuplicateExistingMenuParams>
 */
export function menusDuplicateExistingMenu(params) {
    return { evid: 346, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteMenuLocationPicker' event (evid: 347)
 *
 * Event description: Live Site -> Menu -> Location Picker Interaction.
 *
 * @param {liveSiteMenuLocationPickerParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location ID
 * @property {GUID} bi_token - msid
 * @return {LogObject<liveSiteMenuLocationPickerParams>} LogObject<liveSiteMenuLocationPickerParams>
 */
export function liveSiteMenuLocationPicker(params) {
    return { evid: 347, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDuplicateLocationError' event (evid: 349)
 *
 * Event description: menus duplicate location error
 *
 * @param {menusDuplicateLocationErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} errorReason - location must be chosen
 * @property {GUID} locationGuid - location ID
 * @property {string} itemType - menu/section/dish
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusDuplicateLocationErrorParams>} LogObject<menusDuplicateLocationErrorParams>
 */
export function menusDuplicateLocationError(params) {
    return { evid: 349, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOnoardingTakemethereClick' event (evid: 35)
 *
 * Event description: restaurants_onoarding_takemethere_click
 *
 * @param {restaurantsOnoardingTakemethereClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsOnoardingTakemethereClickParams>} LogObject<restaurantsOnoardingTakemethereClickParams>
 */
export function restaurantsOnoardingTakemethereClick(params) {
    return { evid: 35, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusMoveMenu' event (evid: 350)
 *
 * Event description: move menu location
 *
 * @param {menusMoveMenuParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuidMovedFrom - location ID moved from
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} locationGuidMovedTo - location ID moved to
 * @property {string} menuId - the menu ID that was moved
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusMoveMenuParams>} LogObject<menusMoveMenuParams>
 */
export function menusMoveMenu(params) {
    return { evid: 350, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusMoveSectionSrc61Evid351' event (evid: 351)
 *
 * Event description: move section location
 *
 * @param {menusMoveSectionSrc61Evid351Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuidMovedFrom - location ID moved from
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} menuIdMovedFrom - menu ID moved from
 * @property {GUID} locationGuidMovedTo - location ID moved to
 * @property {string} sectionId - the section ID that was moved
 * @property {GUID} menuIdMovedTo - menu ID moved to
 * @property {GUID} bi_token - msid
 * @return {LogObject<menusMoveSectionSrc61Evid351Params>} LogObject<menusMoveSectionSrc61Evid351Params>
 */
export function menusMoveSectionSrc61Evid351(params) {
    return { evid: 351, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reservationsChooseReservationSettingsClick' event (evid: 352)
 *
 * Event description: uou clicked on any of the reservation settings
 *
 * @param {reservationsChooseReservationSettingsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} locationGuid - location ID
 * @property {string} fieldName - Date/Time/Party Size/Location
 * @property {string} origin - love_site_mode / preview_mode
 * @property {string} organization_id - organization_id
 * @property {boolean} isAddOn - true/ false
 * @property {string} correlationId - -
 * @property {boolean} isMultiLocation - true if the site has more than one location
 * @property {GUID} bi_token - msid
 * @return {LogObject<reservationsChooseReservationSettingsClickParams>} LogObject<reservationsChooseReservationSettingsClickParams>
 */
export function reservationsChooseReservationSettingsClick(params) {
    return { evid: 352, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenuOpenDoItWithMeVideo' event (evid: 353)
 *
 * Event description: Dashboard -> menu-> open do it with me video.
 *
 * @param {dashboardMenuOpenDoItWithMeVideoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - organization_id
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenuOpenDoItWithMeVideoParams>} LogObject<dashboardMenuOpenDoItWithMeVideoParams>
 */
export function dashboardMenuOpenDoItWithMeVideo(params) {
    return { evid: 353, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardBoClickMoreButton' event (evid: 354)
 *
 * Event description: User clicked on the 'More'  button on the BM (next to setting)
 *
 * @param {dashboardBoClickMoreButtonParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} appName - orders/reservations
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardBoClickMoreButtonParams>} LogObject<dashboardBoClickMoreButtonParams>
 */
export function dashboardBoClickMoreButton(params) {
    return { evid: 354, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardBannerView' event (evid: 355)
 *
 * Event description: User viewed the app banner
 *
 * @param {dashboardBannerViewParams} params - The parameters for this event
 * @property {GUID} instance_id - guid
 * @property {string} source - banner subject. i.e cashier payments/ Covid-19/LocationSettings/etc.
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - where is the banner located
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - guid
 * @return {LogObject<dashboardBannerViewParams>} LogObject<dashboardBannerViewParams>
 */
export function dashboardBannerView(params) {
    return { evid: 355, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardButtonClick' event (evid: 356)
 *
 * Event description: User clicked on a button on the BM (for now the event is for the start now click on the welcome screens but can be added for all generic clicks).
 *
 * @param {dashboardButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} screen_name - from which screen (menus/orders/welcome screens..)
 * @property {string} restaurantId - organization_id
 * @property {string} button_name - name of the button
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardButtonClickParams>} LogObject<dashboardButtonClickParams>
 */
export function dashboardButtonClick(params) {
    return { evid: 356, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloContactlessDineInPageToggle' event (evid: 357)
 *
 * Event description: User changed the state of the toggle in the Contactless Dine-In section
 *
 * @param {dashboardOloContactlessDineInPageToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - rest_id
 * @property {string} value - the end state of the feature (active/paused)
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloContactlessDineInPageToggleParams>} LogObject<dashboardOloContactlessDineInPageToggleParams>
 */
export function dashboardOloContactlessDineInPageToggle(params) {
    return { evid: 357, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloContactlessDineInDownloadQrCode' event (evid: 358)
 *
 * Event description: User click on Download QR Code at Contactless Dine-In settings page
 *
 * @param {dashboardOloContactlessDineInDownloadQrCodeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloContactlessDineInDownloadQrCodeParams>} LogObject<dashboardOloContactlessDineInDownloadQrCodeParams>
 */
export function dashboardOloContactlessDineInDownloadQrCode(params) {
    return { evid: 358, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloContactlessDineInCopyLinkClick' event (evid: 359)
 *
 * Event description: Dashboard -> OLO -> Contactless Dine-In -> Copy Link Click
 *
 * @param {dashboardOloContactlessDineInCopyLinkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloContactlessDineInCopyLinkClickParams>} LogObject<dashboardOloContactlessDineInCopyLinkClickParams>
 */
export function dashboardOloContactlessDineInCopyLinkClick(params) {
    return { evid: 359, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingDetailsSkip' event (evid: 36)
 *
 * Event description: restaurants_dashboard_open
 *
 * @param {onboardingDetailsSkipParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} screenName - []
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<onboardingDetailsSkipParams>} LogObject<onboardingDetailsSkipParams>
 */
export function onboardingDetailsSkip(params) {
    return { evid: 36, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloContactlessDineInLearnMoreClick' event (evid: 360)
 *
 * Event description: Dashboard -> OLO -> Contactless Dine-In -> Learn More Click
 *
 * @param {dashboardOloContactlessDineInLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloContactlessDineInLearnMoreClickParams>} LogObject<dashboardOloContactlessDineInLearnMoreClickParams>
 */
export function dashboardOloContactlessDineInLearnMoreClick(params) {
    return { evid: 360, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsChangesChangesOnly' event (evid: 3601)
 *
 * Event description: all changes in the settings of table reservations will be sent in this event. fields that didn't changed will be null.
 *
 * @param {restaurantsTableReservationsSettingsChangesChangesOnlyParams} params - The parameters for this event
 * @property {boolean} manualApproval - true if toggle is on. false if toggle is off.
 * @property {string} privacyPolicyType - url / text/null
 * @property {GUID} seatingMapId - map id is unique for location. Null for no connected seating map
 * @property {boolean} marketingConsentEnabled - true/false/null
 * @property {boolean} partyPacingEnabled - true/false/null
 * @property {string} minReservationNoticeUnit - (minutes / days/hours)
 * @property {number} partyPacing - -
 * @property {number} numSeats - total max seats
 * @property {number} minPartiesSize - -
 * @property {number} seatPacing - (guests pavcng)
 * @property {number} numTables - total
 * @property {GUID} meta_site_id - -
 * @property {boolean} submitMessageExists - True (if its not null ) /false (otherwise)
 * @property {GUID} reservationLocationId - -
 * @property {number} minReservationNoticeNumber - -
 * @property {boolean} seatPacingEnabled - (guests pavcng) true/false/null
 * @property {string} tableCombinations - combinations of more than one table fro reservations. Array of {id, table_ids: string[], seats_min, seats_max}
 * @property {boolean} showPhoneNumber - true/false
 * @property {number} maxPartiesSize - -
 * @property {boolean} policiesEnabled - true/false
 * @property {number} manualApprovalPartySize - the minimum party size that requires manual approval
 * @property {GUID} locationId - -
 * @property {string} termsAndConditionsType - url / text/null
 * @property {number} customFieldsLength - how many custom fields
 * @property {boolean} termsAndConditions - true/false/null. (can be saved as false also when the toggle is off and also can be null if the user never turn on the toggle)
 * @property {boolean} onlineReservationsEnabled - true/false
 * @property {boolean} lastNameRequired - true/false
 * @property {boolean} marketingConsentEnabledByDefault - (it will be false also when the user enabled the marketing for the first time but doesn’t click on the checkbox )
 * @property {boolean} emailRequired - true/false
 * @property {number} defualtTurnoverTime - -
 * @property {string} availabilityType - “opening_hours” | “custom_hours”
 * @property {number} numCombinations - -
 * @property {string} scheduleList - when choosing custom hours -there will be array of such objects  {"openDay":"SUNDAY","openTime":"00:00","closeDay":"MONDAY","closeTime":"00:00"}
 * @property {number} numOnlineTables - -
 * @property {DateTime} updatedDate - the time that the action actually changed on the server side
 * @property {string} tables - -
 * @property {boolean} reservationPrivacyPolicy - true/false/null
 * @property {number} numOnlineCombinations - -
 * @return {LogObject<restaurantsTableReservationsSettingsChangesChangesOnlyParams>} LogObject<restaurantsTableReservationsSettingsChangesChangesOnlyParams>
 */
export function restaurantsTableReservationsSettingsChangesChangesOnly(params) {
    return { evid: 3601, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsSettingsChangesWholePictureOfSettingsSrc61Evid3602' event (evid: 3602)
 *
 * Event description: all changes in the settings of table reservations will be sent in this event and also the whole picture of all the fields event if they didn't changed
 *
 * @param {restaurantsTableReservationsSettingsChangesWholePictureOfSettingsSrc61Evid3602Params} params - The parameters for this event
 * @property {boolean} manualApproval - true if toggle is on. false if toggle is off.
 * @property {string} privacyPolicyType - -
 * @property {GUID} seatingMapId - map id is unique for location. Null for no connected seating map
 * @property {boolean} marketingConsentEnabled - marketing_consent_enabled
 * @property {boolean} partyPacingEnabled - -
 * @property {string} minReservationNoticeUnit - (minutes / days/hours)
 * @property {number} partyPacing - -
 * @property {number} numSeats - total max seats
 * @property {number} minPartiesSize - -
 * @property {number} seatPacing - (guests pacing)
 * @property {number} numTables - total
 * @property {GUID} meta_site_id - -
 * @property {boolean} submitMessageExists - True (if its not null ) /false (otherwise)
 * @property {GUID} reservationLocationId - -
 * @property {number} minReservationNoticeNumber - -
 * @property {boolean} seatPacingEnabled - (guests pavcng) true/false/null
 * @property {string} tableCombinations - combinations of more than one table fro reservations. Array of {id, table_ids: string[], seats_min, seats_max}
 * @property {boolean} showPhoneNumber - true/false
 * @property {number} maxPartiesSize - -
 * @property {boolean} policiesEnabled - true/false
 * @property {number} manualApprovalPartySize - the minimum party size that requires manual approval
 * @property {GUID} locationId - -
 * @property {string} termsAndConditionsType - url / text/null
 * @property {number} customFieldsLength - how many custom fields
 * @property {boolean} termsAndConditions - true/false/null. (can be saved as false also when the toggle is off and also can be null if the user never turn on the toggle)
 * @property {boolean} onlineReservationsEnabled - true/false
 * @property {boolean} lastNameRequired - last_name_required
 * @property {boolean} marketingConsentEnabledByDefault - -
 * @property {boolean} emailRequired - true/false
 * @property {number} defualtTurnoverTime - in minutes
 * @property {string} availabilityType - “opening_hours” | “custom_hours”
 * @property {number} numCombinations - -
 * @property {string} scheduleList - when choosing custom hours - there will be array of such objects  {"openDay":"SUNDAY","openTime":"00:00","closeDay":"MONDAY","closeTime":"00:00"}
 * @property {number} numOnlineTables - -
 * @property {DateTime} updatedDate - the time that the action actually changed on the server side
 * @property {string} tables - -
 * @property {boolean} reservationPrivacyPolicy - true/false/null
 * @property {DateTime} createdDate - the time settings created behind the scene when the user downloded the app
 * @property {number} numOnlineCombinations - -
 * @return {LogObject<restaurantsTableReservationsSettingsChangesWholePictureOfSettingsSrc61Evid3602Params>} LogObject<restaurantsTableReservationsSettingsChangesWholePictureOfSettingsSrc61Evid3602Params>
 */
export function restaurantsTableReservationsSettingsChangesWholePictureOfSettingsSrc61Evid3602(params) {
    return { evid: 3602, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsTableReservationsUpdateReservations' event (evid: 3603)
 *
 * Event description: when a reservation is created or edited or deleted or its status is changed
 *
 * @param {restaurantsTableReservationsUpdateReservationsParams} params - The parameters for this event
 * @property {DateTime} endDateTs - -
 * @property {number} customFieldsFilledLength - -
 * @property {GUID} reservationId - -
 * @property {boolean} isTeamMessageEmpty - -
 * @property {string} tableIds - list of all the tables that reserved in the reservation
 * @property {DateTime} startDateTs - -
 * @property {GUID} meta_site_id - -
 * @property {GUID} reservationLocationId - -
 * @property {string} statusBefore - (null | “reserved” | “held” | “no_show” | etc.)
 * @property {GUID} locationId - -
 * @property {GUID} reserveeContactId - -
 * @property {number} tableIdsLength - -
 * @property {string} statusCurrent - (“reserved” | “held” | “no_show” | etc.)
 * @property {number} partySize - -
 * @property {DateTime} updatedDate - the time that the action happened on the server
 * @property {boolean} marketingConsent - true/false
 * @property {string} saveType - (“create” (predefine in server autaomatically when user download the app) | “edit”  when user edit settings)
 * @property {DateTime} createdDate - the date when the reservations created for the first time
 * @return {LogObject<restaurantsTableReservationsUpdateReservationsParams>} LogObject<restaurantsTableReservationsUpdateReservationsParams>
 */
export function restaurantsTableReservationsUpdateReservations(params) {
    return { evid: 3603, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloContactlessDineInSave' event (evid: 361)
 *
 * Event description: Dashboard -> OLO -> Contactless Dine-In -> Save
 *
 * @param {dashboardOloContactlessDineInSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} lastToggleState - active/paused
 * @property {string} inputLabel - User's input label as being saved
 * @property {string} errorDesc - in case of failure
 * @property {boolean} isSuccess - yes/no
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - rest_id
 * @property {string} dineInLink - User's link for costumers
 * @property {string} instructions - User's instructions as being saved
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloContactlessDineInSaveParams>} LogObject<dashboardOloContactlessDineInSaveParams>
 */
export function dashboardOloContactlessDineInSave(params) {
    return { evid: 361, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloContactlessDineInSettingsCancel' event (evid: 362)
 *
 * Event description: Dashboard -> OLO -> Contactless Dine-In -> Settings Cancel
 *
 * @param {dashboardOloContactlessDineInSettingsCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloContactlessDineInSettingsCancelParams>} LogObject<dashboardOloContactlessDineInSettingsCancelParams>
 */
export function dashboardOloContactlessDineInSettingsCancel(params) {
    return { evid: 362, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloContactlessDineInPickupDependencyModalAction' event (evid: 363)
 *
 * Event description: user make an action in the "pickup must be enabled" modal
 *
 * @param {dashboardOloContactlessDineInPickupDependencyModalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_id
 * @property {string} organization_id - rest_id
 * @property {string} value - cancel / go_to_pickup_settings
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloContactlessDineInPickupDependencyModalActionParams>} LogObject<dashboardOloContactlessDineInPickupDependencyModalActionParams>
 */
export function dashboardOloContactlessDineInPickupDependencyModalAction(params) {
    return { evid: 363, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloPickupSettingsContactlessDineInModalAction' event (evid: 364)
 *
 * Event description: user make an action in the "contactless dine-in will be disabled" modal
 *
 * @param {dashboardOloPickupSettingsContactlessDineInModalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_id
 * @property {string} organization_id - rest_id
 * @property {string} value - cancel / disable_dine_in
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloPickupSettingsContactlessDineInModalActionParams>} LogObject<dashboardOloPickupSettingsContactlessDineInModalActionParams>
 */
export function dashboardOloPickupSettingsContactlessDineInModalAction(params) {
    return { evid: 364, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardToastClick' event (evid: 365)
 *
 * Event description: The user clicked on the section notification in the BM
 *
 * @param {dashboardToastClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} notificationName - notificationName
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - rest_ID
 * @property {string} pageName - the page the Toast is presented, i.e 'myOrders'
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardToastClickParams>} LogObject<dashboardToastClickParams>
 */
export function dashboardToastClick(params) {
    return { evid: 365, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardBannerDismiss' event (evid: 366)
 *
 * Event description: The user clicked on Dismiss on the banner in the BM (Won't see the banner anymore) (i.e, in loyalty the user clicks on the X)
 *
 * @param {dashboardBannerDismissParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - source of banner, aka product like 'loyalty,OOImigration' etc
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - Banner origin page
 * @property {string} organizationId - rest_ID
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardBannerDismissParams>} LogObject<dashboardBannerDismissParams>
 */
export function dashboardBannerDismiss(params) {
    return { evid: 366, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardGenericButtonClickSrc61Evid367' event (evid: 367)
 *
 * Event description: User clicked on a button on the BM in old olo
 *
 * @param {dashboardGenericButtonClickSrc61Evid367Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} screen_name - from which screen (menus/orders/welcome screens..)
 * @property {string} restaurantId - organization_id
 * @property {string} button_name - name of the button
 * @property {string} modal_name - modal_name if click in modal
 * @return {LogObject<dashboardGenericButtonClickSrc61Evid367Params>} LogObject<dashboardGenericButtonClickSrc61Evid367Params>
 */
export function dashboardGenericButtonClickSrc61Evid367(params) {
    return { evid: 367, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardPageStartLoading' event (evid: 369)
 *
 * Event description: Dashboard ->page start loading.
 *
 * @param {dashboardPageStartLoadingParams} params - The parameters for this event
 * @property {GUID} instance_id - .
 * @property {boolean} isOnline - is_online
 * @property {string} page_name - the name of the page
 * @property {GUID} locationGuid - location ID
 * @property {string} organization_id - guid
 * @property {string} httpOrigin - http origin
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardPageStartLoadingParams>} LogObject<dashboardPageStartLoadingParams>
 */
export function dashboardPageStartLoading(params) {
    return { evid: 369, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardLoad' event (evid: 37)
 *
 * Event description: restaurants_dashboard_load
 *
 * @param {restaurantsDashboardLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardLoadParams>} LogObject<restaurantsDashboardLoadParams>
 */
export function restaurantsDashboardLoad(params) {
    return { evid: 37, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAdvancedSettingsTipClicks' event (evid: 370)
 *
 * Event description: BM
 * Advanced Settings -> future orders clicks
 *
 * @param {dashboardAdvancedSettingsTipClicksParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} appName - Orders/Reservations
 * @property {GUID} locationGuid - .
 * @property {string} clickName - tipType/setDefault/enableCustomTip/tipValue
 * @property {string} organization_id - org id
 * @property {string} value - the end state of the feature (on/off/days/or value himself))
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAdvancedSettingsTipClicksParams>} LogObject<dashboardAdvancedSettingsTipClicksParams>
 */
export function dashboardAdvancedSettingsTipClicks(params) {
    return { evid: 370, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardCashierBannerClick' event (evid: 371)
 *
 * Event description: The user clicked on the Cashier migrate banner
 *
 * @param {dashboardCashierBannerClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - []
 * @property {string} content - Content to differentiate the Banner Type- The experiment Name
 * @property {string} rest_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardCashierBannerClickParams>} LogObject<dashboardCashierBannerClickParams>
 */
export function dashboardCashierBannerClick(params) {
    return { evid: 371, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterTipDiscountClicksSrc61Evid372' event (evid: 372)
 *
 * Event description: API Menu Update
 *
 * @param {callCenterTipDiscountClicksSrc61Evid372Params} params - The parameters for this event
 * @property {GUID} instance_id - .
 * @property {string} source - mobile / web
 * @property {GUID} site_id - guid
 * @property {string} callerFunctionName - The action name that triggered the API update
 * @property {GUID} locationGuid - .
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<callCenterTipDiscountClicksSrc61Evid372Params>} LogObject<callCenterTipDiscountClicksSrc61Evid372Params>
 */
export function callCenterTipDiscountClicksSrc61Evid372(params) {
    return { evid: 372, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deliveryIntegrationClick' event (evid: 373)
 *
 * Event description: User clicked on a button related to Delivery Integrations.
 * Use page_name + button_name to find a specific button.
 *
 * @param {deliveryIntegrationClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} clickType - click/external_link/dismiss/etc...
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} buttonName - Name of specific button
 * @property {string} organizationId - rest_id
 * @property {string} pageName - Page's Name
 * @property {GUID} appId - Delivery-Integration's app ID
 * @property {GUID} bi_token - msid
 * @return {LogObject<deliveryIntegrationClickParams>} LogObject<deliveryIntegrationClickParams>
 */
export function deliveryIntegrationClick(params) {
    return { evid: 373, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modalLoad' event (evid: 374)
 *
 * Event description: Modal Loaded in the pos settings page.
 * Use modal_name to find exact modal
 *
 * @param {modalLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} modalName - Name of specific modal
 * @property {GUID} bi_token - msid
 * @return {LogObject<modalLoadParams>} LogObject<modalLoadParams>
 */
export function modalLoad(params) {
    return { evid: 374, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryClickDeleteDeliveryArea' event (evid: 375)
 *
 * Event description: User Clicked on the trash can button in the Delivery&Delivery Partners page
 *
 * @param {dashboardOloDeliveryClickDeleteDeliveryAreaParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} areaName - delivery Area Name
 * @property {string} integrationName - integrationName
 * @property {GUID} configurationId - configuration_id
 * @property {GUID} integrationAppId - Delivery Integration's appId
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} organizationId - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryClickDeleteDeliveryAreaParams>} LogObject<dashboardOloDeliveryClickDeleteDeliveryAreaParams>
 */
export function dashboardOloDeliveryClickDeleteDeliveryArea(params) {
    return { evid: 375, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOrdersCenterRequestTpaDeliveryEditTime' event (evid: 376)
 *
 * Event description: User edited any of the fields in the Request TPA Delivery modal
 *
 * @param {dashboardOloOrdersCenterRequestTpaDeliveryEditTimeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} areaName - delivery Area Name
 * @property {string} integrationName - integrationName
 * @property {string} field - field
 * @property {GUID} configurationId - configuration_id
 * @property {boolean} isOnline - Is operating on owners' app or not
 * @property {GUID} integrationAppId - Delivery Integration's appId
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} organizationId - rest_id
 * @property {string} value - User's Input
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOrdersCenterRequestTpaDeliveryEditTimeParams>} LogObject<dashboardOloOrdersCenterRequestTpaDeliveryEditTimeParams>
 */
export function dashboardOloOrdersCenterRequestTpaDeliveryEditTime(params) {
    return { evid: 376, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrdersSettingsPosViewMenuButtonClick' event (evid: 377)
 *
 * Event description: User clicked on view menu button, after clicking on the 3 dots button
 *
 * @param {dashboardOrdersSettingsPosViewMenuButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} providerAppId - POS provider app ID
 * @property {string} buttonType - 3_dots_button
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} providerName - providerName
 * @property {string} organizationId - rest_id
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardOrdersSettingsPosViewMenuButtonClickParams>} LogObject<dashboardOrdersSettingsPosViewMenuButtonClickParams>
 */
export function dashboardOrdersSettingsPosViewMenuButtonClick(params) {
    return { evid: 377, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSectionNotificationLoad' event (evid: 378)
 *
 * Event description: The user loaded  the section notification in the BM
 *
 * @param {dashboardSectionNotificationLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} notificationName - notificationName
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_ID
 * @property {string} pageName - the page the Toast is presented, i.e 'myOrders'
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardSectionNotificationLoadParams>} LogObject<dashboardSectionNotificationLoadParams>
 */
export function dashboardSectionNotificationLoad(params) {
    return { evid: 378, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterTipDiscountClicks' event (evid: 379)
 *
 * Event description: API Menu Update
 *
 * @param {callCenterTipDiscountClicksParams} params - The parameters for this event
 * @property {string} appName - Orders/Reservations
 * @property {GUID} locationGuid - .
 * @property {string} clickName - Tip/ Discount
 * @property {string} organization_id - guid
 * @property {GUID} instance_id - .
 * @property {string} value - the end state of the feature (on/off/days/or value himself))
 * @property {GUID} bi_token - msid
 * @return {LogObject<callCenterTipDiscountClicksParams>} LogObject<callCenterTipDiscountClicksParams>
 */
export function callCenterTipDiscountClicks(params) {
    return { evid: 379, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardOrdersTeaserClick' event (evid: 38)
 *
 * Event description: restaurants_dashboard_orders_teaser_click
 *
 * @param {restaurantsDashboardOrdersTeaserClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardOrdersTeaserClickParams>} LogObject<restaurantsDashboardOrdersTeaserClickParams>
 */
export function restaurantsDashboardOrdersTeaserClick(params) {
    return { evid: 38, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliveryAddDeliveryPartnerClick' event (evid: 380)
 *
 * Event description: user click on the add delivery partner button.
 *
 * @param {dashboardOloDeliveryAddDeliveryPartnerClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} buttonType - delivery_partner/no_areas_exist/erc..
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - restId
 * @property {string} organizationId - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloDeliveryAddDeliveryPartnerClickParams>} LogObject<dashboardOloDeliveryAddDeliveryPartnerClickParams>
 */
export function dashboardOloDeliveryAddDeliveryPartnerClick(params) {
    return { evid: 380, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsAdvancedNewServiceFeeSavedSuccessServerEvent' event (evid: 3801)
 *
 * Event description: Dashboard- > Order Settings -> Advanced-> ‘New service fee’ server events. will be sent only when clicking on "save".
 *
 * @param {dashboardOrderSettingsAdvancedNewServiceFeeSavedSuccessServerEventParams} params - The parameters for this event
 * @property {GUID} bi_token - -
 * @property {GUID} verticalLocationGuid - in restaurants it's restaurants_location_guid, other verticals can use their location guid or OS location guid. in Restaurants it will fired only when create  and not while edited
 * @property {string} serviceName - -
 * @property {string} feeId - -
 * @property {number} amount - -
 * @property {string} restId - organization id
 * @property {boolean} feeEnable - true/false
 * @property {boolean} enabledStatusChanged - true/false
 * @property {boolean} addSalesTax - -
 * @property {string} feeType - -
 * @property {number} salesTax - -
 * @property {GUID} appId - -
 * @property {GUID} msid - -
 * @property {string} saveType - create / edited
 * @return {LogObject<dashboardOrderSettingsAdvancedNewServiceFeeSavedSuccessServerEventParams>} LogObject<dashboardOrderSettingsAdvancedNewServiceFeeSavedSuccessServerEventParams>
 */
export function dashboardOrderSettingsAdvancedNewServiceFeeSavedSuccessServerEvent(params) {
    return { evid: 3801, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsAdvancedServiceFeeDeleteSuccessServerEvent' event (evid: 3802)
 *
 * Event description: Dashboard- > Order Settings -> Advanced-> Service fee delete dialog cta
 *
 * @param {dashboardOrderSettingsAdvancedServiceFeeDeleteSuccessServerEventParams} params - The parameters for this event
 * @property {GUID} verticalLocationdGuid - -in restaurants is restaurants_location_id, other verticals can use their location guid or OS location guid
 * @property {GUID} verticalLocationGuid - -in restaurants is restaurants_location_id, other verticals can use their location guid or OS location guid
 * @property {string} serviceName - the name of the service
 * @property {string} feeId - -
 * @property {number} amount - -
 * @property {boolean} feeEnable - true/false
 * @property {boolean} enabledStatusChanged - true/false
 * @property {boolean} addSalesTax - -
 * @property {string} feeType - -
 * @property {number} salesTax - -
 * @property {GUID} appId - -
 * @property {GUID} msid - -
 * @return {LogObject<dashboardOrderSettingsAdvancedServiceFeeDeleteSuccessServerEventParams>} LogObject<dashboardOrderSettingsAdvancedServiceFeeDeleteSuccessServerEventParams>
 */
export function dashboardOrderSettingsAdvancedServiceFeeDeleteSuccessServerEvent(params) {
    return { evid: 3802, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deliveryAndDeliveryPartnersNavigation' event (evid: 381)
 *
 * Event description: Delivery and Delivery Partners - Navigation.
 *
 * @param {deliveryAndDeliveryPartnersNavigationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} buttonName - Name of specific button
 * @property {string} organizationId - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<deliveryAndDeliveryPartnersNavigationParams>} LogObject<deliveryAndDeliveryPartnersNavigationParams>
 */
export function deliveryAndDeliveryPartnersNavigation(params) {
    return { evid: 381, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderLoadedFirstOpened' event (evid: 383)
 *
 * Event description: Menu Printing Builder Loaded (first opened).
 *
 * @param {menuPrintingBuilderLoadedFirstOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - []
 * @property {string} origin - origin
 * @property {string} organization_id - {guid}
 * @property {string} menuId - []
 * @property {GUID} bi_token - msid
 * @return {LogObject<menuPrintingBuilderLoadedFirstOpenedParams>} LogObject<menuPrintingBuilderLoadedFirstOpenedParams>
 */
export function menuPrintingBuilderLoadedFirstOpened(params) {
    return { evid: 383, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderSidebarClick' event (evid: 384)
 *
 * Event description: Menu Printing Builder -> Sidebar Click.
 *
 * @param {menuPrintingBuilderSidebarClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} originTabName - User's current tab
 * @property {string} tabName - User's tab click (destination)
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - {guid}
 * @property {string} menuId - menu_id
 * @property {GUID} bi_token - []
 * @return {LogObject<menuPrintingBuilderSidebarClickParams>} LogObject<menuPrintingBuilderSidebarClickParams>
 */
export function menuPrintingBuilderSidebarClick(params) {
    return { evid: 384, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderInsideTabClick' event (evid: 385)
 *
 * Event description: menu printing builder click in Tabs
 *
 * @param {menuPrintingBuilderInsideTabClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} templateName - []
 * @property {string} tabName - tab_name
 * @property {GUID} locationGuid - []
 * @property {string} actionType - User's click type (detailed action)
 * @property {GUID} templateId - []
 * @property {string} organization_id - {guid}
 * @property {string} menuId - []
 * @property {string} value - []
 * @property {GUID} bi_token - []
 * @return {LogObject<menuPrintingBuilderInsideTabClickParams>} LogObject<menuPrintingBuilderInsideTabClickParams>
 */
export function menuPrintingBuilderInsideTabClick(params) {
    return { evid: 385, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderSaveDownloadClick' event (evid: 386)
 *
 * Event description: User clicked on 'save and download'. Including parameters snapshot.
 *
 * @param {menuPrintingBuilderSaveDownloadClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} backgroundColor - []
 * @property {string} symbolsName - symbols_name
 * @property {boolean} isQRCodeAdded - true / false
 * @property {boolean} isSymbolsAdded - true / false
 * @property {GUID} symbolsId - []
 * @property {string} templateName - User's chosen template's name
 * @property {string} tabName - User's tab click (destination)
 * @property {number} pagesCount - final menu pages number
 * @property {GUID} dividersId - []
 * @property {number} sectionsCount - final menu sections number
 * @property {string} printedMenuUrl - user's downloaded menu (to open as pdf)
 * @property {GUID} locationGuid - []
 * @property {GUID} templateId - User's chosen template
 * @property {string} dividersName - dividers_name
 * @property {boolean} isDefaultTemplate - true / false (template has changed?)
 * @property {string} organization_id - {guid}
 * @property {number} dishesCount - final menu dishes number
 * @property {boolean} isDishDescriptionShown - true / false
 * @property {string} menuId - []
 * @property {boolean} isDefault - true / false (any changes?)
 * @property {boolean} isLogoAdded - true / false
 * @property {GUID} bi_token - []
 * @return {LogObject<menuPrintingBuilderSaveDownloadClickParams>} LogObject<menuPrintingBuilderSaveDownloadClickParams>
 */
export function menuPrintingBuilderSaveDownloadClick(params) {
    return { evid: 386, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderBackClick' event (evid: 387)
 *
 * Event description: back click on the menu printing builder
 *
 * @param {menuPrintingBuilderBackClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} originTabName - User's current tab
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - {guid}
 * @property {string} menuId - []
 * @property {GUID} bi_token - []
 * @return {LogObject<menuPrintingBuilderBackClickParams>} LogObject<menuPrintingBuilderBackClickParams>
 */
export function menuPrintingBuilderBackClick(params) {
    return { evid: 387, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderBackModalClick' event (evid: 388)
 *
 * Event description: click on modal that opens after clicking on 'back'  (menu printing builder)
 *
 * @param {menuPrintingBuilderBackModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - []
 * @property {string} actionType - User's Action
 * @property {string} organization_id - {guid}
 * @property {string} menuId - []
 * @property {GUID} bi_token - []
 * @return {LogObject<menuPrintingBuilderBackModalClickParams>} LogObject<menuPrintingBuilderBackModalClickParams>
 */
export function menuPrintingBuilderBackModalClick(params) {
    return { evid: 388, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderBackModalLoad' event (evid: 389)
 *
 * Event description: modal that opens after clicking on 'back'  has loaded (menu printing builder)
 *
 * @param {menuPrintingBuilderBackModalLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - {guid}
 * @property {string} menuId - []
 * @property {GUID} bi_token - []
 * @return {LogObject<menuPrintingBuilderBackModalLoadParams>} LogObject<menuPrintingBuilderBackModalLoadParams>
 */
export function menuPrintingBuilderBackModalLoad(params) {
    return { evid: 389, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderEntryBannerClick' event (evid: 390)
 *
 * Event description: Menu Printing Builder Entry -> Banner Click.
 *
 * @param {menuPrintingBuilderEntryBannerClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - []
 * @property {string} origin - page where the banner was clicked
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<menuPrintingBuilderEntryBannerClickParams>} LogObject<menuPrintingBuilderEntryBannerClickParams>
 */
export function menuPrintingBuilderEntryBannerClick(params) {
    return { evid: 390, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderEntryMenusListClick' event (evid: 391)
 *
 * Event description: User clicked on the list of locations
 *
 * @param {menuPrintingBuilderEntryMenusListClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - origin
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<menuPrintingBuilderEntryMenusListClickParams>} LogObject<menuPrintingBuilderEntryMenusListClickParams>
 */
export function menuPrintingBuilderEntryMenusListClick(params) {
    return { evid: 391, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderEntryMenuSelectFromList' event (evid: 392)
 *
 * Event description: User clicked on one of the menus from the list
 *
 * @param {menuPrintingBuilderEntryMenuSelectFromListParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} menuName - menu_name
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization_id
 * @property {string} menuId - selected menu id
 * @property {GUID} bi_token - []
 * @return {LogObject<menuPrintingBuilderEntryMenuSelectFromListParams>} LogObject<menuPrintingBuilderEntryMenuSelectFromListParams>
 */
export function menuPrintingBuilderEntryMenuSelectFromList(params) {
    return { evid: 392, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuPrintingBuilderEntrySelectMenuModalClick' event (evid: 393)
 *
 * Event description: User clicked on one of the options at the "select menus" modal
 *
 * @param {menuPrintingBuilderEntrySelectMenuModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} clickType - click_type
 * @property {string} menuName - menu_name
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization_id
 * @property {string} menuId - selected menu id / null
 * @property {GUID} bi_token - []
 * @return {LogObject<menuPrintingBuilderEntrySelectMenuModalClickParams>} LogObject<menuPrintingBuilderEntrySelectMenuModalClickParams>
 */
export function menuPrintingBuilderEntrySelectMenuModalClick(params) {
    return { evid: 393, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusDesignPrintableMenuClick' event (evid: 394)
 *
 * Event description: User clicked on one "design printable menu" option
 *
 * @param {menusDesignPrintableMenuClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {string} menuName - menu_name
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - guid
 * @property {string} menuId - selected menu id / null
 * @property {GUID} bi_token - []
 * @return {LogObject<menusDesignPrintableMenuClickParams>} LogObject<menusDesignPrintableMenuClickParams>
 */
export function menusDesignPrintableMenuClick(params) {
    return { evid: 394, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrdersSettingsPosClickOnOpenRestaurantIntegrations' event (evid: 395)
 *
 * Event description: User clicked on "open integration setting" button
 *
 * @param {dashboardOrdersSettingsPosClickOnOpenRestaurantIntegrationsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} buttonType - empty_state_button/ see_more_integration_options
 * @property {GUID} locationGuid - locationGuid
 * @property {string} organizationId - rest_id
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardOrdersSettingsPosClickOnOpenRestaurantIntegrationsParams>} LogObject<dashboardOrdersSettingsPosClickOnOpenRestaurantIntegrationsParams>
 */
export function dashboardOrdersSettingsPosClickOnOpenRestaurantIntegrations(params) {
    return { evid: 395, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsPosTogglePosIntegration' event (evid: 396)
 *
 * Event description: User clicked on toggle button of pos integration
 *
 * @param {dashboardOrderSettingsPosTogglePosIntegrationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} providerAppId - POS provider app ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} restId - rest_id
 * @property {string} providerName - POS provider app name
 * @property {GUID} bi_token - bi_token
 * @property {string} toggleStatus - open_activation_modal / off
 * @return {LogObject<dashboardOrderSettingsPosTogglePosIntegrationParams>} LogObject<dashboardOrderSettingsPosTogglePosIntegrationParams>
 */
export function dashboardOrderSettingsPosTogglePosIntegration(params) {
    return { evid: 396, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsPosActivatePosModalClick' event (evid: 397)
 *
 * Event description: Dashboard -> Order Settings -> POS -> Activate POS Modal Click.
 *
 * @param {dashboardOrderSettingsPosActivatePosModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} providerAppId - POS provider app ID
 * @property {string} buttonType - activate/cancel/x
 * @property {GUID} locationGuid - location_guid
 * @property {string} restId - rest_id
 * @property {string} providerName - provider_name
 * @property {string} organization_id - rest id
 * @property {string} type - activate/cancel
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardOrderSettingsPosActivatePosModalClickParams>} LogObject<dashboardOrderSettingsPosActivatePosModalClickParams>
 */
export function dashboardOrderSettingsPosActivatePosModalClick(params) {
    return { evid: 397, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsPosActivatePosSync' event (evid: 398)
 *
 * Event description: User Tries to activate the pos integration, shows the status of the sync (sync result)
 *
 * @param {dashboardOrderSettingsPosActivatePosSyncParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} providerAppId - provider_app_id
 * @property {string} state - state
 * @property {string} refferalName - resync / activation (by toggle)
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} providerName - POS provider app name
 * @property {GUID} msid - bi_token
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardOrderSettingsPosActivatePosSyncParams>} LogObject<dashboardOrderSettingsPosActivatePosSyncParams>
 */
export function dashboardOrderSettingsPosActivatePosSync(params) {
    return { evid: 398, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsPosClickOnOpenIntegrationSettings' event (evid: 399)
 *
 * Event description: User clicked on button to open integration settings
 *
 * @param {dashboardOrderSettingsPosClickOnOpenIntegrationSettingsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} providerAppId - POS provider app ID
 * @property {string} buttonType - default link/error section notification
 * @property {boolean} isIntegrated - ndicates if the user already had set up his integration
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} providerName - provider_name
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardOrderSettingsPosClickOnOpenIntegrationSettingsParams>} LogObject<dashboardOrderSettingsPosClickOnOpenIntegrationSettingsParams>
 */
export function dashboardOrderSettingsPosClickOnOpenIntegrationSettings(params) {
    return { evid: 399, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardOrdersTeaserReportSuccess' event (evid: 40)
 *
 * Event description: restaurants_dashboard_orders_teaser_report_success
 *
 * @param {restaurantsDashboardOrdersTeaserReportSuccessParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardOrdersTeaserReportSuccessParams>} LogObject<restaurantsDashboardOrdersTeaserReportSuccessParams>
 */
export function restaurantsDashboardOrdersTeaserReportSuccess(params) {
    return { evid: 40, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsOverviewApply' event (evid: 400)
 *
 * Event description: users change the activity of reservations
 *
 * @param {dashboardReservationsOverviewApplyParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} status - the status the user chose
 * @property {string} off_time - []
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsOverviewApplyParams>} LogObject<dashboardReservationsOverviewApplyParams>
 */
export function dashboardReservationsOverviewApply(params) {
    return { evid: 400, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsOverviewToggle' event (evid: 401)
 *
 * Event description: users change the activity of reservations
 *
 * @param {dashboardReservationsOverviewToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location ID
 * @property {string} status - the value the user chose, can get Null
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsOverviewToggleParams>} LogObject<dashboardReservationsOverviewToggleParams>
 */
export function dashboardReservationsOverviewToggle(params) {
    return { evid: 401, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsOverviewCancel' event (evid: 402)
 *
 * Event description: user closes the reservations activation modal
 *
 * @param {dashboardReservationsOverviewCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsOverviewCancelParams>} LogObject<dashboardReservationsOverviewCancelParams>
 */
export function dashboardReservationsOverviewCancel(params) {
    return { evid: 402, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsOverviewEdit' event (evid: 403)
 *
 * Event description: user clicks on edit the reservations
 *
 * @param {dashboardReservationsOverviewEditParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsOverviewEditParams>} LogObject<dashboardReservationsOverviewEditParams>
 */
export function dashboardReservationsOverviewEdit(params) {
    return { evid: 403, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsPartySize' event (evid: 404)
 *
 * Event description: user changes the limited party size
 *
 * @param {dashboardReservationsPartySizeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - where did the user change the limits from
 * @property {string} field - Min or Max
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - []
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsPartySizeParams>} LogObject<dashboardReservationsPartySizeParams>
 */
export function dashboardReservationsPartySize(params) {
    return { evid: 404, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsHandlingEmailEdit' event (evid: 405)
 *
 * Event description: user edits his email
 *
 * @param {dashboardReservationsHandlingEmailEditParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsHandlingEmailEditParams>} LogObject<dashboardReservationsHandlingEmailEditParams>
 */
export function dashboardReservationsHandlingEmailEdit(params) {
    return { evid: 405, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsHandlingEmailApply' event (evid: 406)
 *
 * Event description: user applies his email
 *
 * @param {dashboardReservationsHandlingEmailApplyParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsHandlingEmailApplyParams>} LogObject<dashboardReservationsHandlingEmailApplyParams>
 */
export function dashboardReservationsHandlingEmailApply(params) {
    return { evid: 406, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsHandlingEmailToggles' event (evid: 407)
 *
 * Event description: user toggles the Email option
 *
 * @param {dashboardReservationsHandlingEmailTogglesParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsHandlingEmailTogglesParams>} LogObject<dashboardReservationsHandlingEmailTogglesParams>
 */
export function dashboardReservationsHandlingEmailToggles(params) {
    return { evid: 407, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsHandlingEmailCancel' event (evid: 408)
 *
 * Event description: user closes the Email modal
 *
 * @param {dashboardReservationsHandlingEmailCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsHandlingEmailCancelParams>} LogObject<dashboardReservationsHandlingEmailCancelParams>
 */
export function dashboardReservationsHandlingEmailCancel(params) {
    return { evid: 408, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsHandlingConfirmationToggle' event (evid: 409)
 *
 * Event description: user toggles the confirmation option
 *
 * @param {dashboardReservationsHandlingConfirmationToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} active_status - active/not active
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsHandlingConfirmationToggleParams>} LogObject<dashboardReservationsHandlingConfirmationToggleParams>
 */
export function dashboardReservationsHandlingConfirmationToggle(params) {
    return { evid: 409, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardOrdersTeaserReportError' event (evid: 41)
 *
 * Event description: restaurants_dashboard_orders_teaser_report_error
 *
 * @param {restaurantsDashboardOrdersTeaserReportErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardOrdersTeaserReportErrorParams>} LogObject<restaurantsDashboardOrdersTeaserReportErrorParams>
 */
export function restaurantsDashboardOrdersTeaserReportError(params) {
    return { evid: 41, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsHandlingSmsValidation' event (evid: 410)
 *
 * Event description: user toggles the sms validation option
 *
 * @param {dashboardReservationsHandlingSmsValidationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} active_status - active/not active
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsHandlingSmsValidationParams>} LogObject<dashboardReservationsHandlingSmsValidationParams>
 */
export function dashboardReservationsHandlingSmsValidation(params) {
    return { evid: 410, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsMyReservationsTab' event (evid: 411)
 *
 * Event description: user switches between tabs
 *
 * @param {dashboardReservationsMyReservationsTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} tab_name - tab name
 * @property {GUID} locationGuid - location ID
 * @property {string} origin - origin
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsMyReservationsTabParams>} LogObject<dashboardReservationsMyReservationsTabParams>
 */
export function dashboardReservationsMyReservationsTab(params) {
    return { evid: 411, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsMyReservationsAction' event (evid: 412)
 *
 * Event description: user makes an action on the reservation
 *
 * @param {dashboardReservationsMyReservationsActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} isOnline - One app field. Click done online True/False.
 * @property {string} reservation__id - []
 * @property {GUID} locationGuid - location_id
 * @property {string} origin - origin
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {string} value - details
 * @property {string} action - reject/accept/dismiss
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsMyReservationsActionParams>} LogObject<dashboardReservationsMyReservationsActionParams>
 */
export function dashboardReservationsMyReservationsAction(params) {
    return { evid: 412, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardReservationsMyReservationsReject' event (evid: 414)
 *
 * Event description: user rejects with Reject Modal
 *
 * @param {dashboardReservationsMyReservationsRejectParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_value_null - []
 * @property {string} reservation__id - []
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} action - cancel or reject
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardReservationsMyReservationsRejectParams>} LogObject<dashboardReservationsMyReservationsRejectParams>
 */
export function dashboardReservationsMyReservationsReject(params) {
    return { evid: 414, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloMyOrdersEmptyState' event (evid: 416)
 *
 * Event description: user switches between tabs
 *
 * @param {dashboardOloMyOrdersEmptyStateParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - loaction ID
 * @property {string} clickName - click_name
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardOloMyOrdersEmptyStateParams>} LogObject<dashboardOloMyOrdersEmptyStateParams>
 */
export function dashboardOloMyOrdersEmptyState(params) {
    return { evid: 416, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsPosResyncPos' event (evid: 417)
 *
 * Event description: User Tries to resync the pos integration, shows the state of the sync at the time.
 *
 * @param {dashboardOrderSettingsPosResyncPosParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} providerAppId - provider_app_id
 * @property {string} referral_name - "pos integration page" / "pos banner"
 * @property {string} state - THIS IS PRIOR STATE (SYNCED / FAILED)
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} providerName - POS provider app name
 * @property {GUID} msid - bi_token
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardOrderSettingsPosResyncPosParams>} LogObject<dashboardOrderSettingsPosResyncPosParams>
 */
export function dashboardOrderSettingsPosResyncPos(params) {
    return { evid: 417, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAddDeliveryPartnerAreaLoadEnableTipsModal' event (evid: 418)
 *
 * Event description: User loaded enable tips modal while trying to save a new delivery modal
 *
 * @param {dashboardAddDeliveryPartnerAreaLoadEnableTipsModalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} integrationName - integration_name
 * @property {GUID} configurationId - configuration_id
 * @property {GUID} integrationAppId - Delivery Integration's appId
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} organizationId - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAddDeliveryPartnerAreaLoadEnableTipsModalParams>} LogObject<dashboardAddDeliveryPartnerAreaLoadEnableTipsModalParams>
 */
export function dashboardAddDeliveryPartnerAreaLoadEnableTipsModal(params) {
    return { evid: 418, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAddDeliveryPartnerAreaEnableTipsModalClick' event (evid: 419)
 *
 * Event description: Dashboard -> Add Delivery Partner Area -> Enable Tips Modal Click.
 *
 * @param {dashboardAddDeliveryPartnerAreaEnableTipsModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} buttonType - cancel/enable tips/ x / ?
 * @property {string} integrationName - integrationName
 * @property {GUID} configurationId - configuration_id
 * @property {GUID} integrationAppId - integration_app_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} restId - rest_id
 * @property {string} organizationId - rest_id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAddDeliveryPartnerAreaEnableTipsModalClickParams>} LogObject<dashboardAddDeliveryPartnerAreaEnableTipsModalClickParams>
 */
export function dashboardAddDeliveryPartnerAreaEnableTipsModalClick(params) {
    return { evid: 419, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardTabOpen' event (evid: 42)
 *
 * Event description: restaurants_dashboard_tab_open
 *
 * @param {restaurantsDashboardTabOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {string} tab - {overview,settings,menus}
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {tabs,steps}
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardTabOpenParams>} LogObject<restaurantsDashboardTabOpenParams>
 */
export function restaurantsDashboardTabOpen(params) {
    return { evid: 42, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownersAppBannerClick' event (evid: 420)
 *
 * Event description: User Clicked on a banner in the owners app
 *
 * @param {ownersAppBannerClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - locationID
 * @property {string} organizationId - rest_id
 * @property {GUID} msid - msid
 * @property {string} bannerName - The banner's name
 * @property {GUID} bi_token - msid
 * @return {LogObject<ownersAppBannerClickParams>} LogObject<ownersAppBannerClickParams>
 */
export function ownersAppBannerClick(params) {
    return { evid: 420, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrdersSettingsPos3DotsButtonClick' event (evid: 421)
 *
 * Event description: User clicked on the 3 dots button
 *
 * @param {dashboardOrdersSettingsPos3DotsButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} providerAppId - POS provider app ID
 * @property {GUID} locationGuid - locationGuid
 * @property {string} restId - rest_id
 * @property {string} providerName - providerName
 * @property {string} organizationId - rest_id
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardOrdersSettingsPos3DotsButtonClickParams>} LogObject<dashboardOrdersSettingsPos3DotsButtonClickParams>
 */
export function dashboardOrdersSettingsPos3DotsButtonClick(params) {
    return { evid: 421, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAdvancedSettingsOrderPacingClicks' event (evid: 427)
 *
 * Event description: Dashboard -> Advanced Settings -> order pacing clicks.
 *
 * @param {dashboardAdvancedSettingsOrderPacingClicksParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {string} appName - Orders/Reservations
 * @property {GUID} locationGuid - location
 * @property {string} clickName - careter/from/to
 * @property {string} organization_id - org id
 * @property {string} value - the end state of the feature (on/off/days/or value himself))
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardAdvancedSettingsOrderPacingClicksParams>} LogObject<dashboardAdvancedSettingsOrderPacingClicksParams>
 */
export function dashboardAdvancedSettingsOrderPacingClicks(params) {
    return { evid: 427, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAdvancedSettingsOrderPacingToggle' event (evid: 428)
 *
 * Event description: Dashboard -> Advanced Settings -> order pacing toggle.
 *
 * @param {dashboardAdvancedSettingsOrderPacingToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - organization_id
 * @property {string} value - value
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardAdvancedSettingsOrderPacingToggleParams>} LogObject<dashboardAdvancedSettingsOrderPacingToggleParams>
 */
export function dashboardAdvancedSettingsOrderPacingToggle(params) {
    return { evid: 428, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardHelpClick' event (evid: 43)
 *
 * Event description: restaurants_dashboard_help_click
 *
 * @param {restaurantsDashboardHelpClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {overview,settings,menus}
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardHelpClickParams>} LogObject<restaurantsDashboardHelpClickParams>
 */
export function restaurantsDashboardHelpClick(params) {
    return { evid: 43, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsPosResyncLocationSMenuModalClick' event (evid: 430)
 *
 * Event description: User clicked on a button in the resync modal
 *
 * @param {dashboardOrderSettingsPosResyncLocationSMenuModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} providerAppId - provider_app_id
 * @property {string} buttonType - resync/cancel/x
 * @property {GUID} locationGuid - location_guid
 * @property {string} providerName - providerName
 * @property {string} organization_id - rest id
 * @property {string} type - resync/cancel
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardOrderSettingsPosResyncLocationSMenuModalClickParams>} LogObject<dashboardOrderSettingsPosResyncLocationSMenuModalClickParams>
 */
export function dashboardOrderSettingsPosResyncLocationSMenuModalClick(params) {
    return { evid: 430, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardFeedbackClick' event (evid: 44)
 *
 * Event description: restaurants_dashboard_feedback_click
 *
 * @param {restaurantsDashboardFeedbackClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {overview,settings,menus}
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardFeedbackClickParams>} LogObject<restaurantsDashboardFeedbackClickParams>
 */
export function restaurantsDashboardFeedbackClick(params) {
    return { evid: 44, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardSettingsSetField' event (evid: 45)
 *
 * Event description: restaurants_dashboard_settings_set_field
 *
 * @param {restaurantsDashboardSettingsSetFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} field - {title,description,phone,...}
 * @property {GUID} site_id - guid
 * @property {string} section - {restaurants,contact,...}
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardSettingsSetFieldParams>} LogObject<restaurantsDashboardSettingsSetFieldParams>
 */
export function restaurantsDashboardSettingsSetField(params) {
    return { evid: 45, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'codeVerification' event (evid: 450)
 *
 * Event description: BI Event for developers checks in the Code. Use Origin field.
 *
 * Origin example- menusInAppTip (Dankov@wix.com).
 *
 * @param {codeVerificationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - origin
 * @property {string} currentRoute - currentRoute
 * @property {string} nextRoute - nextRoute
 * @property {GUID} bi_token - msid
 * @return {LogObject<codeVerificationParams>} LogObject<codeVerificationParams>
 */
export function codeVerification(params) {
    return { evid: 450, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardSettingsCancelClick' event (evid: 46)
 *
 * Event description: restaurants_dashboard_settings_cancel_click
 *
 * @param {restaurantsDashboardSettingsCancelClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {string} section - {restaurants,contact,...}
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardSettingsCancelClickParams>} LogObject<restaurantsDashboardSettingsCancelClickParams>
 */
export function restaurantsDashboardSettingsCancelClick(params) {
    return { evid: 46, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardSettingsSaveClick' event (evid: 47)
 *
 * Event description: restaurants_dashboard_settings_save_click
 *
 * @param {restaurantsDashboardSettingsSaveClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {string} section - {restaurants,contact,...}
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardSettingsSaveClickParams>} LogObject<restaurantsDashboardSettingsSaveClickParams>
 */
export function restaurantsDashboardSettingsSaveClick(params) {
    return { evid: 47, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuAddDialogClose' event (evid: 48)
 *
 * Event description: restaurants_dashboard_menus_menu_add_dialog_close
 *
 * @param {restaurantsDashboardMenusMenuAddDialogCloseParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {cancel,x,esc}
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuAddDialogCloseParams>} LogObject<restaurantsDashboardMenusMenuAddDialogCloseParams>
 */
export function restaurantsDashboardMenusMenuAddDialogClose(params) {
    return { evid: 48, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuAddDialogOkClick' event (evid: 49)
 *
 * Event description: restaurants_dashboard_menus_menu_add_dialog_ok_click
 *
 * @param {restaurantsDashboardMenusMenuAddDialogOkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} is_diwm_menu - action made with do it with me menu video
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuAddDialogOkClickParams>} LogObject<restaurantsDashboardMenusMenuAddDialogOkClickParams>
 */
export function restaurantsDashboardMenusMenuAddDialogOkClick(params) {
    return { evid: 49, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuAddDialogFieldError' event (evid: 50)
 *
 * Event description: restaurants_dashboard_menus_menu_add_dialog_field_error
 *
 * @param {restaurantsDashboardMenusMenuAddDialogFieldErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} field - {title}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuAddDialogFieldErrorParams>} LogObject<restaurantsDashboardMenusMenuAddDialogFieldErrorParams>
 */
export function restaurantsDashboardMenusMenuAddDialogFieldError(params) {
    return { evid: 50, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloOrdersCenterCheckPromisedTimeIsUndefined' event (evid: 503)
 *
 * Event description: check when promisedTime is undefined
 *
 * @param {dashboardOloOrdersCenterCheckPromisedTimeIsUndefinedParams} params - The parameters for this event
 * @property {GUID} instance_id - /
 * @property {string} order_id - order_id
 * @property {GUID} locationGuid - location_id
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOloOrdersCenterCheckPromisedTimeIsUndefinedParams>} LogObject<dashboardOloOrdersCenterCheckPromisedTimeIsUndefinedParams>
 */
export function dashboardOloOrdersCenterCheckPromisedTimeIsUndefined(params) {
    return { evid: 503, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloMyOrdersOrderLoad' event (evid: 504)
 *
 * Event description: After User clicked on an order to see more details and it was loaded
 *
 * @param {dashboardOloMyOrdersOrderLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - -
 * @property {string} order_id - order_id
 * @property {string} source - deep-link / my-orders
 * @property {GUID} locationGuid - location_guid
 * @property {string} order_status - new / accepted / rejected / fullfiled
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - -
 * @return {LogObject<dashboardOloMyOrdersOrderLoadParams>} LogObject<dashboardOloMyOrdersOrderLoadParams>
 */
export function dashboardOloMyOrdersOrderLoad(params) {
    return { evid: 504, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloDeliverySettingsEditDeliveryAreaClickOnDeliveryMethod' event (evid: 505)
 *
 * Event description: User clicked on the delivery method button (before picking a value)
 *
 * @param {dashboardOloDeliverySettingsEditDeliveryAreaClickOnDeliveryMethodParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - locationGuid
 * @property {string} organizationId - rest_id
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardOloDeliverySettingsEditDeliveryAreaClickOnDeliveryMethodParams>} LogObject<dashboardOloDeliverySettingsEditDeliveryAreaClickOnDeliveryMethodParams>
 */
export function dashboardOloDeliverySettingsEditDeliveryAreaClickOnDeliveryMethod(params) {
    return { evid: 505, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOloSettingsAdvancedRoundingOptionsClick' event (evid: 506)
 *
 * Event description: user clicked (and chose new method) in order to change rounding option
 *
 * @param {dashboardOloSettingsAdvancedRoundingOptionsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} site_id - guid
 * @property {string} newStatus - the state of the chosen rounding method
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardOloSettingsAdvancedRoundingOptionsClickParams>} LogObject<dashboardOloSettingsAdvancedRoundingOptionsClickParams>
 */
export function dashboardOloSettingsAdvancedRoundingOptionsClick(params) {
    return { evid: 506, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuAddDialogSetField' event (evid: 51)
 *
 * Event description: restaurants_dashboard_menus_menu_add_dialog_set_field
 *
 * @param {restaurantsDashboardMenusMenuAddDialogSetFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} field - {title}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuAddDialogSetFieldParams>} LogObject<restaurantsDashboardMenusMenuAddDialogSetFieldParams>
 */
export function restaurantsDashboardMenusMenuAddDialogSetField(params) {
    return { evid: 51, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageLoad' event (evid: 510)
 *
 * Event description: Dish page loaded
 *
 * @param {dashboardDishPageLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId - unique identifier for catalog (menus)
 * @property {string} sectionId - sectionId - will be sent when the user is inside a specific section
 * @property {string} itemId - dishId  - will be sent when the user is inside a specific Dish
 * @property {string} organization_id - organization id
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId - will be sent when the user is inside a specific menu
 * @property {string} referralSource - Navigation Bar/ Dish item in section page - The button/page that the user got from to the dish page
 * @property {GUID} bi_token - msid
 * @property {string} level - menus/menu/section/dish The level of the page load
 * @return {LogObject<dashboardDishPageLoadParams>} LogObject<dashboardDishPageLoadParams>
 */
export function dashboardDishPageLoad(params) {
    return { evid: 510, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageNewOptionClick' event (evid: 511)
 *
 * Event description: click on new option button (inside the new option collapsable button)
 *
 * @param {dashboardDishPageNewOptionClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - locationGuid
 * @property {string} origin - top/bottom/plus
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - guid
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - []
 * @property {string} level - menus/menu/section/dish
 * @return {LogObject<dashboardDishPageNewOptionClickParams>} LogObject<dashboardDishPageNewOptionClickParams>
 */
export function dashboardDishPageNewOptionClick(params) {
    return { evid: 511, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageEditOptionClick' event (evid: 512)
 *
 * Event description: click on edit button, looks like a pencil when hovering a dish option. can also be clicked directly on the dish option outer button.
 *
 * @param {dashboardDishPageEditOptionClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - locationGuid
 * @property {string} origin - editButton/optionOuter
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - guid
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - []
 * @property {string} level - menus/menu/section/dish
 * @return {LogObject<dashboardDishPageEditOptionClickParams>} LogObject<dashboardDishPageEditOptionClickParams>
 */
export function dashboardDishPageEditOptionClick(params) {
    return { evid: 512, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageRemoveOptionClick' event (evid: 513)
 *
 * Event description: click on remove option button, looks like a trash bin when hovering a dish option.
 *
 * @param {dashboardDishPageRemoveOptionClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {GUID} locationGuid - locationGuid
 * @property {string} origin - binButton
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - guid
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - []
 * @property {string} level - level
 * @return {LogObject<dashboardDishPageRemoveOptionClickParams>} LogObject<dashboardDishPageRemoveOptionClickParams>
 */
export function dashboardDishPageRemoveOptionClick(params) {
    return { evid: 513, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageDishInfoModalLoad' event (evid: 514)
 *
 * Event description: modal loaded, after user clicked on a a referral button
 *
 * @param {dashboardDishPageDishInfoModalLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - organization id
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {string} modalName - The modal that loaded
 * @property {string} referralSource - The referral button : info edit button/olo edit button etc...
 * @property {GUID} bi_token - msid
 * @property {string} level - menus/menu/section/dish - The level the modal was loaded from
 * @return {LogObject<dashboardDishPageDishInfoModalLoadParams>} LogObject<dashboardDishPageDishInfoModalLoadParams>
 */
export function dashboardDishPageDishInfoModalLoad(params) {
    return { evid: 514, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageDishInfoModalCloseClick' event (evid: 515)
 *
 * Event description: User clicked on a close button in modal
 *
 * @param {dashboardDishPageDishInfoModalCloseClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} buttonType - x/cancel
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - organization id
 * @property {string} menuId - menuId
 * @property {string} modalName - The modal closed name i.e 'dish info modal'
 * @property {GUID} bi_token - msid
 * @property {string} level - menus/menu/section/dish
 * @return {LogObject<dashboardDishPageDishInfoModalCloseClickParams>} LogObject<dashboardDishPageDishInfoModalCloseClickParams>
 */
export function dashboardDishPageDishInfoModalCloseClick(params) {
    return { evid: 515, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageDishOptionsModalClick' event (evid: 516)
 *
 * Event description: User clicked/edited any of the fields inside the dish options modal, including the sub modals 'Limit Choices'(can be opened when the type is equal to extras) and 'Select Existing' which opens when clicking on the select existing buttons.
 *
 * @param {dashboardDishPageDishOptionsModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} modalType - new/existing/duplicate
 * @property {string} field - The relevant field we use ie : type,name,new choice, etc...
 * @property {string} variationId - itemId of a variation that the click is relevant to. for example when the user enters a name to a variation, if it has an itemId it will be sent.
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish ID of the dish these options are relevant for
 * @property {string} organization_id - organization id
 * @property {string} menuId - menuId
 * @property {string} value - input value
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardDishPageDishOptionsModalClickParams>} LogObject<dashboardDishPageDishOptionsModalClickParams>
 */
export function dashboardDishPageDishOptionsModalClick(params) {
    return { evid: 516, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageDishOptionsModalSave' event (evid: 517)
 *
 * Event description: User saved the dish options.
 *
 * @param {dashboardDishPageDishOptionsModalSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} modalType - new/existing/duplicate
 * @property {string} optionsJson - A Json containing all the final info on the dish options including (ids, names, prices, etc...)
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish ID of the dish these options are relevant for
 * @property {string} organization_id - organization id
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardDishPageDishOptionsModalSaveParams>} LogObject<dashboardDishPageDishOptionsModalSaveParams>
 */
export function dashboardDishPageDishOptionsModalSave(params) {
    return { evid: 517, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageDishOptionsModalSelectExistingAdd' event (evid: 519)
 *
 * Event description: User added existing dished as options, inside the dish options modal.
 * These options were select in the sub modal 'Select Existing Dishes'
 *
 * @param {dashboardDishPageDishOptionsModalSelectExistingAddParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} errorReason - in case of failure send the error reason
 * @property {number} numberOfChoices - Number of existing choices chosen as variations
 * @property {boolean} isSuccess - was the addition successful
 * @property {string} variationIds - comma sepereated item ids of the variations chosen as options.
 * @property {GUID} locationGuid - location_guid
 * @property {number} numberOfPossibleItems - number of possible items to choose from in the modal
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish ID of the dish these options are relevant for
 * @property {string} organization_id - organization id
 * @property {string} menuId - menuId
 * @property {number} numberOfDishes - Number of existing dishes chosen as variations
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardDishPageDishOptionsModalSelectExistingAddParams>} LogObject<dashboardDishPageDishOptionsModalSelectExistingAddParams>
 */
export function dashboardDishPageDishOptionsModalSelectExistingAdd(params) {
    return { evid: 519, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageOloModalEditClick' event (evid: 520)
 *
 * Event description: User clicked/edited a field inside the dish Online Ordering modal.
 *
 * @param {dashboardDishPageOloModalEditClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} field - The relevant field we use ie : in stock/ delivery/ site/etc...
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish ID of the dish these options are relevant for
 * @property {string} organization_id - organization id
 * @property {string} menuId - menuId
 * @property {string} value - input value
 * @property {GUID} bi_token - msid
 * @property {string} level - The level this modal waas opened in menus/menu/section/dish
 * @return {LogObject<dashboardDishPageOloModalEditClickParams>} LogObject<dashboardDishPageOloModalEditClickParams>
 */
export function dashboardDishPageOloModalEditClick(params) {
    return { evid: 520, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardDishPageSelectExistingOptionsModalClick' event (evid: 522)
 *
 * Event description: User clicked on an option in select existing options modal
 *
 * @param {dashboardDishPageSelectExistingOptionsModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - name of the option
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish ID of the dish these options are relevant for
 * @property {string} organization_id - organization id
 * @property {number} numberOfVariations - number of variations in the chosen option
 * @property {string} type - ‘UNSPECIFIED_DISH_OPTION_TYPE’, ‘SELECTION’,’EXTRAS’, ‘DESELECTION’
 * @property {string} menuId - menuId
 * @property {string} value - on/off
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardDishPageSelectExistingOptionsModalClickParams>} LogObject<dashboardDishPageSelectExistingOptionsModalClickParams>
 */
export function dashboardDishPageSelectExistingOptionsModalClick(params) {
    return { evid: 522, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardCatalogNotificationMessageLoad' event (evid: 524)
 *
 * Event description: A pop up message was loaded in the catalog.
 * for example:
 * messageName = 'save dish successfully'
 * level = 'dish'
 * means that the pop up massage was loaded in the
 *
 * @param {dashboardCatalogNotificationMessageLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} messageName - resembles the pop up message text
 * @property {GUID} locationGuid - locationGuid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId of the dish that
 * @property {string} organization_id - {guid}
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - bi_token
 * @property {string} level - menu/section/dish/option
 * @return {LogObject<dashboardCatalogNotificationMessageLoadParams>} LogObject<dashboardCatalogNotificationMessageLoadParams>
 */
export function dashboardCatalogNotificationMessageLoad(params) {
    return { evid: 524, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardCatalogDuplicateDishModalDestinationChoice' event (evid: 525)
 *
 * Event description: User pressed on a catalog path to duplicate its' dish/section/menu inside the duplicate modal
 *
 * @param {dashboardCatalogDuplicateDishModalDestinationChoiceParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} catalogPath - The duplicate destinatin : ‘catalogId,menuId,sectionId’
 * @property {GUID} locationGuid - locationGuid
 * @property {string} itemType - The item that is being duplicated
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId of the dish that is being duplicated
 * @property {string} organization_id - {guid}
 * @property {string} menuId - menuId
 * @property {string} value - on/off
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardCatalogDuplicateDishModalDestinationChoiceParams>} LogObject<dashboardCatalogDuplicateDishModalDestinationChoiceParams>
 */
export function dashboardCatalogDuplicateDishModalDestinationChoice(params) {
    return { evid: 525, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'catalogsErrors' event (evid: 526)
 *
 * Event description: An error occurred inside the menus product
 *
 * @param {catalogsErrorsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} errorId - The id of the error
 * @property {string} errorReason - errorReason
 * @property {GUID} locationGuid - locationGuid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId of the dish that is being duplicated
 * @property {string} organization_id - {guid}
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - bi_token
 * @property {string} level - menus/menu/section/dish
 * @return {LogObject<catalogsErrorsParams>} LogObject<catalogsErrorsParams>
 */
export function catalogsErrors(params) {
    return { evid: 526, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardCatalogsSectionClickOnAddDishCollapseButton' event (evid: 528)
 *
 * Event description: User clicked on the collapse button of aa dish inside the section page
 *
 * @param {dashboardCatalogsSectionClickOnAddDishCollapseButtonParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - locationGuid
 * @property {string} origin - the button that it was pressed from - bottom/top
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} organization_id - guid
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - msid
 * @property {string} level - The level at which the action happened aka 'dish'/section/menu...
 * @return {LogObject<dashboardCatalogsSectionClickOnAddDishCollapseButtonParams>} LogObject<dashboardCatalogsSectionClickOnAddDishCollapseButtonParams>
 */
export function dashboardCatalogsSectionClickOnAddDishCollapseButton(params) {
    return { evid: 528, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardCatalogsMoveObjectModalModalClick' event (evid: 529)
 *
 * Event description: Move Object modal clicks (move/selection)
 *
 * @param {dashboardCatalogsMoveObjectModalModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} clickType - move/selection
 * @property {string} chosenPath - catalogid.menuid.sectionid
 * @property {GUID} locationGuid - location ID
 * @property {string} itemType - menu/section/dish
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - section ID
 * @property {string} dishId - Dish ID
 * @property {string} menuId - menu ID
 * @property {GUID} bi_token - bi_token
 * @property {string} level - level at which the click was done at menu/section/dish..
 * @return {LogObject<dashboardCatalogsMoveObjectModalModalClickParams>} LogObject<dashboardCatalogsMoveObjectModalModalClickParams>
 */
export function dashboardCatalogsMoveObjectModalModalClick(params) {
    return { evid: 529, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSaveSuccess' event (evid: 53)
 *
 * Event description: restaurants_dashboard_menus_save_success
 *
 * @param {restaurantsDashboardMenusSaveSuccessParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSaveSuccessParams>} LogObject<restaurantsDashboardMenusSaveSuccessParams>
 */
export function restaurantsDashboardMenusSaveSuccess(params) {
    return { evid: 53, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfDashboardDishPageSelectExistingOptionsModalClick' event (evid: 530)
 *
 * Event description: User clicked on a dish/choice in select existing dishes modal
 *
 * @param {copyOfDashboardDishPageSelectExistingOptionsModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - name of the option
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish ID of the dish these options are relevant for
 * @property {string} organization_id - organization id
 * @property {string} menuId - menuId
 * @property {string} value - on/off
 * @property {GUID} bi_token - msid
 * @return {LogObject<copyOfDashboardDishPageSelectExistingOptionsModalClickParams>} LogObject<copyOfDashboardDishPageSelectExistingOptionsModalClickParams>
 */
export function copyOfDashboardDishPageSelectExistingOptionsModalClick(params) {
    return { evid: 530, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardArchiveModalClearArchiveCta' event (evid: 531)
 *
 * Event description: Clear Archive modal clicks 'cancel'/'X'/'clear archive'
 *
 * @param {dashboardArchiveModalClearArchiveCtaParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} clickType - 'cancel'/'X'/'clear archive'
 * @property {GUID} locationGuid - location ID
 * @property {GUID} catalogId - catalogId
 * @property {string} organization_id - organization_id
 * @property {GUID} bi_token - bi_token
 * @property {string} level - level at which the click was done at menu/section/dish..
 * @return {LogObject<dashboardArchiveModalClearArchiveCtaParams>} LogObject<dashboardArchiveModalClearArchiveCtaParams>
 */
export function dashboardArchiveModalClearArchiveCta(params) {
    return { evid: 531, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAppGatesClicked' event (evid: 539)
 *
 * Event description: click on on of the CTA's buttons on the App Gates page
 *
 * @param {dashboardAppGatesClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} clickType - {Get started, Learn more}
 * @property {GUID} locationGuid - locationGuid
 * @property {string} organization_id - guid
 * @property {string} app_id - app_id {menu, reservations,OLO}
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<dashboardAppGatesClickedParams>} LogObject<dashboardAppGatesClickedParams>
 */
export function dashboardAppGatesClicked(params) {
    return { evid: 539, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSaveError' event (evid: 54)
 *
 * Event description: restaurants_dashboard_menus_save_error
 *
 * @param {restaurantsDashboardMenusSaveErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {string} code - {conflict,timeout,...}
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSaveErrorParams>} LogObject<restaurantsDashboardMenusSaveErrorParams>
 */
export function restaurantsDashboardMenusSaveError(params) {
    return { evid: 54, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsOrderSettingsAdvancedClickOnNewServiceFeeButton' event (evid: 540)
 *
 * Event description: modal that opens after clicking on 'Back To Dashboard ' has loaded (phone ordering)
 *
 * @param {settingsOrderSettingsAdvancedClickOnNewServiceFeeButtonParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - locationGuid
 * @property {string} organization_id - guid
 * @property {string} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<settingsOrderSettingsAdvancedClickOnNewServiceFeeButtonParams>} LogObject<settingsOrderSettingsAdvancedClickOnNewServiceFeeButtonParams>
 */
export function settingsOrderSettingsAdvancedClickOnNewServiceFeeButton(params) {
    return { evid: 540, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsAdvancedNewServiceFeeCta' event (evid: 541)
 *
 * Event description: Dashboard- > Order Settings -> Advanced-> ‘New service fee’ CTA. In order to check events without errors always filter by is_error = false
 *
 * @param {dashboardOrderSettingsAdvancedNewServiceFeeCtaParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} add_sales_tax - add_sales_tax
 * @property {boolean} isError - true if there is an error like didn’t fill the name
 * @property {string} click_type - {create,cancel}
 * @property {string} fullfilmet_type - ullfilmet_type
 * @property {GUID} fee_id - fee_id
 * @property {string} applied_to - applied_to
 * @property {number} aboveValue - -
 * @property {string} service_name - service_name
 * @property {number} amount - amount
 * @property {GUID} locationGuid - locationGuid
 * @property {string} appliedToType - all orders , above, between
 * @property {number} belowValue - if is not null so its the between option
 * @property {string} organization_id - guid
 * @property {string} feeType - -
 * @property {number} salesTax - -
 * @property {string} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOrderSettingsAdvancedNewServiceFeeCtaParams>} LogObject<dashboardOrderSettingsAdvancedNewServiceFeeCtaParams>
 */
export function dashboardOrderSettingsAdvancedNewServiceFeeCta(params) {
    return { evid: 541, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsAdvancedServiceFeeEnable' event (evid: 542)
 *
 * Event description: Dashboard- > Order Settings -> Advanced-> Service fee enable
 *
 * @param {dashboardOrderSettingsAdvancedServiceFeeEnableParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} serviceName - -
 * @property {GUID} fee_id - fee_id
 * @property {string} fullfilmetType - fullfilmet_type
 * @property {number} aboveValue - -
 * @property {number} amount - -
 * @property {boolean} isActivated - toggle on or off
 * @property {GUID} locationGuid - locationGuid
 * @property {string} appliedToType - -
 * @property {number} belowValue - if is not null so its the between
 * @property {boolean} addSalesTax - -
 * @property {string} organization_id - guid
 * @property {string} feeType - -
 * @property {number} salesTax - -
 * @property {string} value - (active,paused)
 * @property {string} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOrderSettingsAdvancedServiceFeeEnableParams>} LogObject<dashboardOrderSettingsAdvancedServiceFeeEnableParams>
 */
export function dashboardOrderSettingsAdvancedServiceFeeEnable(params) {
    return { evid: 542, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsAdvancedServiceFeeDeleteEdit' event (evid: 543)
 *
 * Event description: Dashboard- > Order Settings -> Advanced-> Service fee delete/edit
 *
 * @param {dashboardOrderSettingsAdvancedServiceFeeDeleteEditParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} serviceName - -
 * @property {GUID} fee_id - fee_id
 * @property {string} fullfilmetType - -
 * @property {string} clickType - create,cancel, edit_rule , “X button”, click outside
 * @property {number} aboveValue - -
 * @property {number} amount - -
 * @property {GUID} locationGuid - locationGuid
 * @property {string} appliedToType - -
 * @property {number} belowValue - if is not null so its the between above_value
 * @property {boolean} addSalesTax - -
 * @property {string} organization_id - guid
 * @property {string} feeType - -
 * @property {number} salesTax - -
 * @property {string} value - (active,paused)
 * @property {string} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOrderSettingsAdvancedServiceFeeDeleteEditParams>} LogObject<dashboardOrderSettingsAdvancedServiceFeeDeleteEditParams>
 */
export function dashboardOrderSettingsAdvancedServiceFeeDeleteEdit(params) {
    return { evid: 543, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsAdvancedServiceFeeLearnMore' event (evid: 544)
 *
 * Event description: Settings- > Order Settings -> Advanced-> Service fee -> Learn more
 *
 * @param {dashboardOrderSettingsAdvancedServiceFeeLearnMoreParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - locationGuid
 * @property {number} numOfServiceFees - -
 * @property {string} organization_id - guid
 * @property {string} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOrderSettingsAdvancedServiceFeeLearnMoreParams>} LogObject<dashboardOrderSettingsAdvancedServiceFeeLearnMoreParams>
 */
export function dashboardOrderSettingsAdvancedServiceFeeLearnMore(params) {
    return { evid: 544, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsAdvancedServiceFeeDeleteDialogCta' event (evid: 545)
 *
 * Event description: Dashboard- > Order Settings -> Advanced-> Service fee delete dialog cta
 *
 * @param {dashboardOrderSettingsAdvancedServiceFeeDeleteDialogCtaParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} serviceName - delete,cancel
 * @property {GUID} fee_id - fee_id
 * @property {string} fullfilmetType - -
 * @property {string} clickType - (delete,cancel, outdise_click)
 * @property {number} aboveValue - -
 * @property {number} amount - -
 * @property {GUID} locationGuid - locationGuid
 * @property {string} appliedToType - -
 * @property {number} belowValue - if is not null so its the between
 * @property {boolean} addSalesTax - -
 * @property {string} organization_id - guid
 * @property {string} feeType - -
 * @property {number} salesTax - -
 * @property {string} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardOrderSettingsAdvancedServiceFeeDeleteDialogCtaParams>} LogObject<dashboardOrderSettingsAdvancedServiceFeeDeleteDialogCtaParams>
 */
export function dashboardOrderSettingsAdvancedServiceFeeDeleteDialogCta(params) {
    return { evid: 545, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOwnerAppSettingsAdvancedServiceFeeEnable' event (evid: 548)
 *
 * Event description: service fee toggle enable / off  in owner app
 *
 * @param {oloOwnerAppSettingsAdvancedServiceFeeEnableParams} params - The parameters for this event
 * @property {GUID} instance_id - -
 * @property {boolean} success - true./false
 * @property {GUID} fee_id - fee_id
 * @property {string} fullfilmetType - fullfilmet_type
 * @property {string} clickType - create,cancel, edit_rule , “X button”, click outside
 * @property {number} amount - -
 * @property {string} salesTaxes - -
 * @property {GUID} locationGuid - locationGuid
 * @property {string} appliedTo - -
 * @property {boolean} addSalesTax - -
 * @property {string} organization_id - guid
 * @property {string} feeType - -
 * @property {string} feeName - -
 * @property {string} value - (active,paused)
 * @property {string} restaurantsLocationId - restaurants_location_id
 * @property {GUID} bi_token - -
 * @return {LogObject<oloOwnerAppSettingsAdvancedServiceFeeEnableParams>} LogObject<oloOwnerAppSettingsAdvancedServiceFeeEnableParams>
 */
export function oloOwnerAppSettingsAdvancedServiceFeeEnable(params) {
    return { evid: 548, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOwnerAppSettingsAllServiceFeesEnable' event (evid: 549)
 *
 * Event description: all service fees bulk enabled / off
 *
 * @param {oloOwnerAppSettingsAllServiceFeesEnableParams} params - The parameters for this event
 * @property {GUID} instance_id - -
 * @property {number} numFees - num of service fees
 * @property {boolean} success - true/false
 * @property {GUID} fee_ids - fee_id
 * @property {GUID} locationGuid - locationGuid
 * @property {string} organization_id - guid
 * @property {string} value - (active,paused)
 * @property {string} restaurantsLocationId - -
 * @property {GUID} bi_token - -
 * @return {LogObject<oloOwnerAppSettingsAllServiceFeesEnableParams>} LogObject<oloOwnerAppSettingsAllServiceFeesEnableParams>
 */
export function oloOwnerAppSettingsAllServiceFeesEnable(params) {
    return { evid: 549, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuOpen' event (evid: 55)
 *
 * Event description: restaurants_dashboard_menus_menu_open
 *
 * @param {restaurantsDashboardMenusMenuOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuOpenParams>} LogObject<restaurantsDashboardMenusMenuOpenParams>
 */
export function restaurantsDashboardMenusMenuOpen(params) {
    return { evid: 55, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOwnerAppSettingsServiceFeesWereLoaded' event (evid: 550)
 *
 * Event description: fired when all service fees were loaded
 *
 * @param {oloOwnerAppSettingsServiceFeesWereLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - -
 * @property {number} numFees - num of service fees
 * @property {string} fee_ids - fee_id
 * @property {GUID} locationGuid - locationGuid
 * @property {string} status - empty (when no bug, just no services), error, success
 * @property {string} organization_id - organization_id
 * @property {string} value - value
 * @property {string} restaurantsLocationId - -
 * @property {GUID} bi_token - -
 * @return {LogObject<oloOwnerAppSettingsServiceFeesWereLoadedParams>} LogObject<oloOwnerAppSettingsServiceFeesWereLoadedParams>
 */
export function oloOwnerAppSettingsServiceFeesWereLoaded(params) {
    return { evid: 550, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloWebSettingsOrderSchedulingDineInHoverOnAsapToggle' event (evid: 553)
 *
 * Event description: hover on asap toggle when contactless dine in is on, fired when the user put his mouse on the toggle
 *
 * @param {oloWebSettingsOrderSchedulingDineInHoverOnAsapToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} scheduledOrdersToggle - on/off
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<oloWebSettingsOrderSchedulingDineInHoverOnAsapToggleParams>} LogObject<oloWebSettingsOrderSchedulingDineInHoverOnAsapToggleParams>
 */
export function oloWebSettingsOrderSchedulingDineInHoverOnAsapToggle(params) {
    return { evid: 553, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloWebSettingsOrderSchedulingTurnOffBothTogglesErrorMessageIsShowed' event (evid: 554)
 *
 * Event description: when the user is trying to turn off two toggles and error message is showed
 *
 * @param {oloWebSettingsOrderSchedulingTurnOffBothTogglesErrorMessageIsShowedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<oloWebSettingsOrderSchedulingTurnOffBothTogglesErrorMessageIsShowedParams>} LogObject<oloWebSettingsOrderSchedulingTurnOffBothTogglesErrorMessageIsShowedParams>
 */
export function oloWebSettingsOrderSchedulingTurnOffBothTogglesErrorMessageIsShowed(params) {
    return { evid: 554, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloWebSettingsOrderSchedulingSave' event (evid: 555)
 *
 * Event description: save scheduling orders settings
 *
 * @param {oloWebSettingsOrderSchedulingSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} success - true/false
 * @property {string} scheduledOrdersToggle - on/off
 * @property {string} placeOrderToType - minutes
 * @property {number} placeOrderTo - -
 * @property {string} asapToggle - on/off
 * @property {GUID} locationGuid - location_guid
 * @property {string} error - Error - two_toggle_off / other/null if success
 * @property {GUID} locationId - -
 * @property {string} placeOrderFromType - hours/days/minutes
 * @property {number} placeOrderFrom - -
 * @property {GUID} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<oloWebSettingsOrderSchedulingSaveParams>} LogObject<oloWebSettingsOrderSchedulingSaveParams>
 */
export function oloWebSettingsOrderSchedulingSave(params) {
    return { evid: 555, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloOwnerAppSettingsServiceFeeLearnMore' event (evid: 556)
 *
 * Event description: when user clicks on "learn more"
 *
 * @param {oloOwnerAppSettingsServiceFeeLearnMoreParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {number} numOfServiceFees - -
 * @property {GUID} restaurantsLocationId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<oloOwnerAppSettingsServiceFeeLearnMoreParams>} LogObject<oloOwnerAppSettingsServiceFeeLearnMoreParams>
 */
export function oloOwnerAppSettingsServiceFeeLearnMore(params) {
    return { evid: 556, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardOrderSettingsAdvancedServiceFeeSavedSuccess' event (evid: 557)
 *
 * Event description: Dashboard- > Order Settings -> Advanced-> ‘New service fee’ will be sent only when clicking on "save".
 *
 * @param {dashboardOrderSettingsAdvancedServiceFeeSavedSuccessParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} salesTaxCurrent - -
 * @property {string} toggleStatusCurrent - toggle_status_current
 * @property {string} serviceNameBefore - -
 * @property {number} aboveValueBefore - -
 * @property {boolean} add_sales_tax - -
 * @property {string} changedFields - -
 * @property {string} appliedToTypeBefore - -
 * @property {string} feeTypeCurrent - -
 * @property {string} fulfillerTypeBefore - -
 * @property {GUID} fee_id - fee_id
 * @property {number} belowValueBefore - -
 * @property {GUID} restaurantLocationId - -
 * @property {number} aboveValueCurrent - -
 * @property {number} amountBefore - -
 * @property {number} aboveValue - -
 * @property {string} fulfillerType - -
 * @property {string} feeTypeBefore - -
 * @property {boolean} isSuccess - true/false
 * @property {number} salesTaxBefore - -
 * @property {string} serviceNameCurrent - -
 * @property {boolean} addSalesTaxCurrent - -
 * @property {string} toggleStatusBefore - -
 * @property {GUID} locationGuid - location_guid
 * @property {number} belowValueCurrent - -
 * @property {GUID} locationId - -
 * @property {string} organization_id - guid
 * @property {string} currency - -
 * @property {number} amountCurrent - -
 * @property {boolean} addSalesTaxBefore - -
 * @property {string} appliedToTypeCurrent - -
 * @property {GUID} appId - -
 * @property {string} fulfillerTypeCurrent - -
 * @property {string} saveType - create / edited
 * @property {GUID} bi_token - -
 * @return {LogObject<dashboardOrderSettingsAdvancedServiceFeeSavedSuccessParams>} LogObject<dashboardOrderSettingsAdvancedServiceFeeSavedSuccessParams>
 */
export function dashboardOrderSettingsAdvancedServiceFeeSavedSuccess(params) {
    return { evid: 557, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardGatesGatesPageLoad' event (evid: 558)
 *
 * Event description: Dashboard ->Gates-> Gates page load.
 *
 * @param {dashboardGatesGatesPageLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - /
 * @property {string} page_name - the name of the page
 * @property {GUID} locationGuid - location ID
 * @property {string} organization_id - guid
 * @property {string} httpOrigin - http origin
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardGatesGatesPageLoadParams>} LogObject<dashboardGatesGatesPageLoadParams>
 */
export function dashboardGatesGatesPageLoad(params) {
    return { evid: 558, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuDeleteClick' event (evid: 56)
 *
 * Event description: restaurants_dashboard_menus_menu_delete_click
 *
 * @param {restaurantsDashboardMenusMenuDeleteClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuDeleteClickParams>} LogObject<restaurantsDashboardMenusMenuDeleteClickParams>
 */
export function restaurantsDashboardMenusMenuDeleteClick(params) {
    return { evid: 56, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuEdit' event (evid: 57)
 *
 * Event description: restaurants_dashboard_menus_menu_edit
 *
 * @param {restaurantsDashboardMenusMenuEditParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - menu ID
 * @property {GUID} site_id - guid
 * @property {string} editLevel - menu/section/dish
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {button,inline}
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @property {string} level - menus/menu/section
 * @return {LogObject<restaurantsDashboardMenusMenuEditParams>} LogObject<restaurantsDashboardMenusMenuEditParams>
 */
export function restaurantsDashboardMenusMenuEdit(params) {
    return { evid: 57, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuDeleteDialogClose' event (evid: 58)
 *
 * Event description: restaurants_dashboard_menus_menu_delete_dialog_close
 *
 * @param {restaurantsDashboardMenusMenuDeleteDialogCloseParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {cancel,x,esc}
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuDeleteDialogCloseParams>} LogObject<restaurantsDashboardMenusMenuDeleteDialogCloseParams>
 */
export function restaurantsDashboardMenusMenuDeleteDialogClose(params) {
    return { evid: 58, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuDeleteDialogOkClick' event (evid: 59)
 *
 * Event description: restaurants_dashboard_menus_menu_delete_dialog_ok_click
 *
 * @param {restaurantsDashboardMenusMenuDeleteDialogOkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuDeleteDialogOkClickParams>} LogObject<restaurantsDashboardMenusMenuDeleteDialogOkClickParams>
 */
export function restaurantsDashboardMenusMenuDeleteDialogOkClick(params) {
    return { evid: 59, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuEditCancel' event (evid: 60)
 *
 * Event description: restaurants_dashboard_menus_menu_edit_cancel
 *
 * @param {restaurantsDashboardMenusMenuEditCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {button}
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuEditCancelParams>} LogObject<restaurantsDashboardMenusMenuEditCancelParams>
 */
export function restaurantsDashboardMenusMenuEditCancel(params) {
    return { evid: 60, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterDummyEventSrc61Evid601' event (evid: 601)
 *
 * Event description: Dummy first event for testing- New project- CC
 *
 * @param {callCenterDummyEventSrc61Evid601Params} params - The parameters for this event
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - String- Restaurant_ID
 * @property {string} jsonData - json string
 * @property {GUID} msid - msid
 * @property {string} value - Test value
 * @return {LogObject<callCenterDummyEventSrc61Evid601Params>} LogObject<callCenterDummyEventSrc61Evid601Params>
 */
export function callCenterDummyEventSrc61Evid601(params) {
    return { evid: 601, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterCheckoutClickOnPaymentMethodSelection' event (evid: 602)
 *
 * Event description: Click on Payment Method selection
 *
 * @param {callCenterCheckoutClickOnPaymentMethodSelectionParams} params - The parameters for this event
 * @property {string} payment_index - In case of Split Payment- 0 is the first value.
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - String- Restaurant_ID
 * @property {string} pmnt_method - Cash/credit/cibus/etc.
 * @return {LogObject<callCenterCheckoutClickOnPaymentMethodSelectionParams>} LogObject<callCenterCheckoutClickOnPaymentMethodSelectionParams>
 */
export function callCenterCheckoutClickOnPaymentMethodSelection(params) {
    return { evid: 602, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterCheckoutClickOnRemovePaymentMethod' event (evid: 603)
 *
 * Event description: Click on remove payment method- Split the bill removal (click on x)
 *
 * @param {callCenterCheckoutClickOnRemovePaymentMethodParams} params - The parameters for this event
 * @property {number} amount - Price (Cancelled- Divide by 100 to use)
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - String- Restaurant_ID
 * @property {string} pmnt_method - Cash/credit/cibus/etc.
 * @return {LogObject<callCenterCheckoutClickOnRemovePaymentMethodParams>} LogObject<callCenterCheckoutClickOnRemovePaymentMethodParams>
 */
export function callCenterCheckoutClickOnRemovePaymentMethod(params) {
    return { evid: 603, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterCheckoutChooseCheckoutMethod' event (evid: 604)
 *
 * Event description: Click on Choose Checkout Method- Mannually/Pay per dish
 *
 * @param {callCenterCheckoutChooseCheckoutMethodParams} params - The parameters for this event
 * @property {string} checkout_method - Manually/PPD
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - String- Restaurant_ID
 * @return {LogObject<callCenterCheckoutChooseCheckoutMethodParams>} LogObject<callCenterCheckoutChooseCheckoutMethodParams>
 */
export function callCenterCheckoutChooseCheckoutMethod(params) {
    return { evid: 604, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterCartClickOnDish' event (evid: 605)
 *
 * Event description: Click on Choose Cart (Side of the Menu)- Click on dish- In order to edit it.
 *
 * @param {callCenterCartClickOnDishParams} params - The parameters for this event
 * @property {boolean} withFilter - is menu filtered= 1 (when clicking on dish)
 * @property {string} item_id - Dish ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} item_name - Dish name
 * @property {string} origin - Menu/Cart
 * @property {string} organization_id - String- Restaurant_ID
 * @return {LogObject<callCenterCartClickOnDishParams>} LogObject<callCenterCartClickOnDishParams>
 */
export function callCenterCartClickOnDish(params) {
    return { evid: 605, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loadCallCenter' event (evid: 607)
 *
 * Event description: Call center system loaded- Successfully
 *
 * @param {loadCallCenterParams} params - The parameters for this event
 * @property {string} organizationId - Note that the field may be empty
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<loadCallCenterParams>} LogObject<loadCallCenterParams>
 */
export function loadCallCenter(params) {
    return { evid: 607, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'phoneNumberClickContinue' event (evid: 608)
 *
 * Event description: Continue click on the first page- Phone number
 *
 * @param {phoneNumberClickContinueParams} params - The parameters for this event
 * @property {boolean} isError - Yes/no
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - Note that the field may be empty
 * @property {string} phoneError - If error, then the wrong phone number will be sent.
 * @return {LogObject<phoneNumberClickContinueParams>} LogObject<phoneNumberClickContinueParams>
 */
export function phoneNumberClickContinue(params) {
    return { evid: 608, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customerInformationClickContinue' event (evid: 609)
 *
 * Event description: Continue click on the Customer Information  page- with error type
 *
 * @param {customerInformationClickContinueParams} params - The parameters for this event
 * @property {boolean} isError - Yes/no
 * @property {boolean} isNewCustomer - yes/no
 * @property {string} errorField - e-mail/name/etc.
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - string
 * @return {LogObject<customerInformationClickContinueParams>} LogObject<customerInformationClickContinueParams>
 */
export function customerInformationClickContinue(params) {
    return { evid: 609, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuEditSave' event (evid: 61)
 *
 * Event description: restaurants_dashboard_menus_menu_edit_save
 *
 * @param {restaurantsDashboardMenusMenuEditSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} isVisible - "menu visible for customers" true/false
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuEditSaveParams>} LogObject<restaurantsDashboardMenusMenuEditSaveParams>
 */
export function restaurantsDashboardMenusMenuEditSave(params) {
    return { evid: 61, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addressInformationChangeDeliveryType' event (evid: 610)
 *
 * Event description: Click delivery/pickup
 *
 * @param {addressInformationChangeDeliveryTypeParams} params - The parameters for this event
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} curbsidePickupToggle - true/ false
 * @property {string} deliveryType - Pickup/Delivery
 * @property {string} curbsidePickupContent - content/ null
 * @property {string} organizationId - string
 * @return {LogObject<addressInformationChangeDeliveryTypeParams>} LogObject<addressInformationChangeDeliveryTypeParams>
 */
export function addressInformationChangeDeliveryType(params) {
    return { evid: 610, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addressInformationFillChangeAddress' event (evid: 611)
 *
 * Event description: Fill/change Address
 *
 * @param {addressInformationFillChangeAddressParams} params - The parameters for this event
 * @property {boolean} isNewAddress - yes/no
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} isInDeliveryArea - =Warning on address (Error)
 * @property {string} organizationId - string
 * @return {LogObject<addressInformationFillChangeAddressParams>} LogObject<addressInformationFillChangeAddressParams>
 */
export function addressInformationFillChangeAddress(params) {
    return { evid: 611, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'navigationPage' event (evid: 613)
 *
 * Event description: navigation page
 *
 * @param {navigationPageParams} params - The parameters for this event
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - Should be String
 * @property {string} pageName - will be sent when navigating between pages.
 * @return {LogObject<navigationPageParams>} LogObject<navigationPageParams>
 */
export function navigationPage(params) {
    return { evid: 613, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelOrderClick' event (evid: 615)
 *
 * Event description: Cancel Order click- in some stage of the order
 *
 * @param {cancelOrderClickParams} params - The parameters for this event
 * @property {string} organizationId - New org_ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<cancelOrderClickParams>} LogObject<cancelOrderClickParams>
 */
export function cancelOrderClick(params) {
    return { evid: 615, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuFilter' event (evid: 619)
 *
 * Event description: Click On filter in the menu
 *
 * @param {menuFilterParams} params - The parameters for this event
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - Could be string
 * @property {boolean} isOpen - is open after the click=1 (New State)
 * @return {LogObject<menuFilterParams>} LogObject<menuFilterParams>
 */
export function menuFilter(params) {
    return { evid: 619, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusMenuEditSetField' event (evid: 62)
 *
 * Event description: restaurants_dashboard_menus_menu_edit_set_field
 *
 * @param {restaurantsDashboardMenusMenuEditSetFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {string} field - {title,description}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusMenuEditSetFieldParams>} LogObject<restaurantsDashboardMenusMenuEditSetFieldParams>
 */
export function restaurantsDashboardMenusMenuEditSetField(params) {
    return { evid: 62, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menuFilterOptions' event (evid: 620)
 *
 * Event description: Click On some option into the filter menu
 *
 * @param {menuFilterOptionsParams} params - The parameters for this event
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - Could be string
 * @property {string} value - Click on which option (vegan, etc..). The result is a list with all the filters clicked. (Vegan, vegetarian, etc..)
 * @return {LogObject<menuFilterOptionsParams>} LogObject<menuFilterOptionsParams>
 */
export function menuFilterOptions(params) {
    return { evid: 620, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterEmptyState' event (evid: 623)
 *
 * Event description: CC opened via BO- No able to start (Don't accept payments, no Olo, etc.)
 *
 * @param {callCenterEmptyStateParams} params - The parameters for this event
 * @property {GUID} locationGuid - location_guid
 * @property {string} errorType - Error
 * @property {string} organizationId - String- Restaurant_ID
 * @property {GUID} msid - msid
 * @return {LogObject<callCenterEmptyStateParams>} LogObject<callCenterEmptyStateParams>
 */
export function callCenterEmptyState(params) {
    return { evid: 623, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitOrderRequest' event (evid: 624)
 *
 * Event description: Click on submit order- request to server has been sent.
 *
 * @param {submitOrderRequestParams} params - The parameters for this event
 * @property {GUID} idRequest - same value as next event
 * @property {GUID} locationGuid - location_guid
 * @property {string} organizationId - Could be string
 * @property {GUID} msid - msid
 * @return {LogObject<submitOrderRequestParams>} LogObject<submitOrderRequestParams>
 */
export function submitOrderRequest(params) {
    return { evid: 624, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitOrderResponse' event (evid: 625)
 *
 * Event description: User click on confirm order
 *
 * @param {submitOrderResponseParams} params - The parameters for this event
 * @property {string} orderId - Olo Order ID- use is with the server
 * @property {string} feeIds - -
 * @property {number} grandTotal - the total amount of the order multiple by 100 (in cents)
 * @property {GUID} idRequest - Same value as last event
 * @property {boolean} isSuccess - true/false
 * @property {number} numDiscounts - num of discounts
 * @property {number} taxAmount - tax_amount
 * @property {GUID} locationGuid - location_guid
 * @property {string} orderMethod - delivery / pickup
 * @property {string} tipType - Currency/ Percentage
 * @property {string} errorDescription - if false, which error
 * @property {number} tipValue - if percentage than % value and if currency than total tip
 * @property {string} currency - 3 letters currency
 * @property {number} deliveryCharges - delivery charges amount in cents (multiple by 100)
 * @property {string} organizationId - guid
 * @property {number} feeCount - -
 * @property {number} taxAndFeesAmount - -
 * @property {number} numItems - number of items in the cart
 * @property {number} feesAmount - -
 * @property {GUID} msid - msid
 * @property {number} totalTip - total tip currency
 * @return {LogObject<submitOrderResponseParams>} LogObject<submitOrderResponseParams>
 */
export function submitOrderResponse(params) {
    return { evid: 625, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterLocationPickerInteraction' event (evid: 626)
 *
 * Event description: pick a location from the location dropdown
 *
 * @param {callCenterLocationPickerInteractionParams} params - The parameters for this event
 * @property {string} deliveryType - Delivery/Pickup
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<callCenterLocationPickerInteractionParams>} LogObject<callCenterLocationPickerInteractionParams>
 */
export function callCenterLocationPickerInteraction(params) {
    return { evid: 626, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfDashboardOloBackToDashboardModalLoad' event (evid: 627)
 *
 * Event description: modal that opens after clicking on 'Back To Dashboard ' has loaded (phone ordering)
 *
 * @param {copyOfDashboardOloBackToDashboardModalLoadParams} params - The parameters for this event
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - locationGuid
 * @property {string} origin - orders/newOrder
 * @property {string} organization_id - guid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<copyOfDashboardOloBackToDashboardModalLoadParams>} LogObject<copyOfDashboardOloBackToDashboardModalLoadParams>
 */
export function copyOfDashboardOloBackToDashboardModalLoad(params) {
    return { evid: 627, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfDashboardOloBackToDashboardModalClick' event (evid: 628)
 *
 * Event description: click on modal that opens after clicking on 'back to dashboard' (phone ordering)
 *
 * @param {copyOfDashboardOloBackToDashboardModalClickParams} params - The parameters for this event
 * @property {GUID} site_id - guid
 * @property {string} clickType - User's Action (cancel,exit)
 * @property {GUID} locationGuid - locationGuid
 * @property {string} origin - origin
 * @property {string} organization_id - guid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} bi_token - bi_token
 * @return {LogObject<copyOfDashboardOloBackToDashboardModalClickParams>} LogObject<copyOfDashboardOloBackToDashboardModalClickParams>
 */
export function copyOfDashboardOloBackToDashboardModalClick(params) {
    return { evid: 628, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSectionAddClick' event (evid: 63)
 *
 * Event description: restaurants_dashboard_menus_section_add_click
 *
 * @param {restaurantsDashboardMenusSectionAddClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} is_diwm_menu - action made with do it with me menu video
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSectionAddClickParams>} LogObject<restaurantsDashboardMenusSectionAddClickParams>
 */
export function restaurantsDashboardMenusSectionAddClick(params) {
    return { evid: 63, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSectionDeleteClick' event (evid: 64)
 *
 * Event description: restaurants_dashboard_menus_section_delete_click
 *
 * @param {restaurantsDashboardMenusSectionDeleteClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {string} section - {section ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSectionDeleteClickParams>} LogObject<restaurantsDashboardMenusSectionDeleteClickParams>
 */
export function restaurantsDashboardMenusSectionDeleteClick(params) {
    return { evid: 64, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSectionDeleteDialogClose' event (evid: 65)
 *
 * Event description: restaurants_dashboard_menus_section_delete_dialog_close
 *
 * @param {restaurantsDashboardMenusSectionDeleteDialogCloseParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {cancel,x,esc}
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSectionDeleteDialogCloseParams>} LogObject<restaurantsDashboardMenusSectionDeleteDialogCloseParams>
 */
export function restaurantsDashboardMenusSectionDeleteDialogClose(params) {
    return { evid: 65, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSectionDeleteDialogOkClick' event (evid: 66)
 *
 * Event description: restaurants_dashboard_menus_section_delete_dialog_ok_click
 *
 * @param {restaurantsDashboardMenusSectionDeleteDialogOkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSectionDeleteDialogOkClickParams>} LogObject<restaurantsDashboardMenusSectionDeleteDialogOkClickParams>
 */
export function restaurantsDashboardMenusSectionDeleteDialogOkClick(params) {
    return { evid: 66, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSectionEdit' event (evid: 67)
 *
 * Event description: restaurants_dashboard_menus_section_edit
 *
 * @param {restaurantsDashboardMenusSectionEditParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {string} section - {section ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {button,inline}
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSectionEditParams>} LogObject<restaurantsDashboardMenusSectionEditParams>
 */
export function restaurantsDashboardMenusSectionEdit(params) {
    return { evid: 67, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSectionEditAddDialogOkClick' event (evid: 68)
 *
 * Event description: restaurants_dashboard_menus_section_edit_cancel
 *
 * @param {restaurantsDashboardMenusSectionEditAddDialogOkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {string} section - {section ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {button,inline}
 * @property {boolean} is_diwm_menu - action made with do it with me menu video
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSectionEditAddDialogOkClickParams>} LogObject<restaurantsDashboardMenusSectionEditAddDialogOkClickParams>
 */
export function restaurantsDashboardMenusSectionEditAddDialogOkClick(params) {
    return { evid: 68, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSectionEditSave' event (evid: 69)
 *
 * Event description: restaurants_dashboard_menus_section_edit_save
 *
 * @param {restaurantsDashboardMenusSectionEditSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - name
 * @property {string} menu - {menu ID? title?}
 * @property {string} modalType - ‘new section’/’duplicate section’/’edit section info’
 * @property {GUID} site_id - guid
 * @property {string} description - description
 * @property {string} section - {section ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {boolean} isVisible - "show to customers" true/false
 * @property {string} organization_id - guid
 * @property {string} menuId - menuId
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSectionEditSaveParams>} LogObject<restaurantsDashboardMenusSectionEditSaveParams>
 */
export function restaurantsDashboardMenusSectionEditSave(params) {
    return { evid: 69, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSectionEditSetField' event (evid: 70)
 *
 * Event description: restaurants_dashboard_menus_section_edit_set_field
 *
 * @param {restaurantsDashboardMenusSectionEditSetFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {string} modalType - ‘new section’/‘duplicate section’/’edit section info’
 * @property {string} field - {title,description}
 * @property {GUID} site_id - guid
 * @property {string} section - {section ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} organization_id - guid
 * @property {string} menuId - menuId
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSectionEditSetFieldParams>} LogObject<restaurantsDashboardMenusSectionEditSetFieldParams>
 */
export function restaurantsDashboardMenusSectionEditSetField(params) {
    return { evid: 70, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'testEvent' event (evid: 700)
 *
 * Event description: test_event.
 *
 * @param {testEventParams} params - The parameters for this event
 * @property {string} testName - test string
 * @return {LogObject<testEventParams>} LogObject<testEventParams>
 */
export function testEvent(params) {
    return { evid: 700, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusSectionReorder' event (evid: 71)
 *
 * Event description: restaurants_dashboard_menus_section_reorder
 *
 * @param {restaurantsDashboardMenusSectionReorderParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} position_after - 0-based position in the menu (after)
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {string} position_before - 0-based position in the menu (before)
 * @property {string} section - {section ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusSectionReorderParams>} LogObject<restaurantsDashboardMenusSectionReorderParams>
 */
export function restaurantsDashboardMenusSectionReorder(params) {
    return { evid: 71, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishAddClick' event (evid: 72)
 *
 * Event description: restaurants_dashboard_menus_dish_add_click
 *
 * @param {restaurantsDashboardMenusDishAddClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - added from plus/new dish
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {boolean} is_diwm_menu - action made with do it with me menu video
 * @property {string} organization_id - guid
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @property {string} level - The level at which the action happened aka 'dish'/section/menu...
 * @return {LogObject<restaurantsDashboardMenusDishAddClickParams>} LogObject<restaurantsDashboardMenusDishAddClickParams>
 */
export function restaurantsDashboardMenusDishAddClick(params) {
    return { evid: 72, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishAddDialogClose' event (evid: 73)
 *
 * Event description: restaurants_dashboard_menus_dish_add_dialog_close
 *
 * @param {restaurantsDashboardMenusDishAddDialogCloseParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {cancel,x,esc}
 * @property {string} organization_id - guid
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishAddDialogCloseParams>} LogObject<restaurantsDashboardMenusDishAddDialogCloseParams>
 */
export function restaurantsDashboardMenusDishAddDialogClose(params) {
    return { evid: 73, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishAddDialogOkClick' event (evid: 74)
 *
 * Event description: restaurants_dashboard_menus_dish_add_dialog_ok_click
 *
 * @param {restaurantsDashboardMenusDishAddDialogOkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} modalType - ‘new dish’/‘duplicate’/’edit dish info’/ ‘online ordering modal’
 * @property {boolean} isSpicy - saved dish with spicy label (Any)
 * @property {GUID} site_id - guid
 * @property {string} description - user's final input
 * @property {string} duplicateItemsPaths - an array of item paths. I.e [catalogId,menuId,sectionId,itemId, catalogId,menuId,sectionId,itemId]
 * @property {number} price - price
 * @property {boolean} isVegan - saved dish with vegan label
 * @property {boolean} isVegetarian - saved dish with vegetarian label
 * @property {boolean} isInStock - saved dish with in/out of stock label
 * @property {boolean} isSuccess - success while adding dish
 * @property {boolean} isDuplicate - dish created while clicking on duplicate menu/section/dish
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} isOrganic - saved dish with organic label
 * @property {boolean} isNew - new dish or existing (Click on add or save)
 * @property {number} spicyLevel - 1/2/3 (as the number of peppers in the spicy label)
 * @property {GUID} catalogId - catalog_id
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {boolean} is_diwm_menu - action made with do it with me menu video
 * @property {string} organization_id - guid
 * @property {string} currency - currency
 * @property {string} dishId - dish ID
 * @property {string} template - {simple,sizes,...}
 * @property {boolean} isShown - saved dish with visibility show to customers
 * @property {string} title - title
 * @property {boolean} isSpecial - saved dish with special label
 * @property {string} menuId - menuId
 * @property {boolean} isGlutenFree - saved dish with gluten free label
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishAddDialogOkClickParams>} LogObject<restaurantsDashboardMenusDishAddDialogOkClickParams>
 */
export function restaurantsDashboardMenusDishAddDialogOkClick(params) {
    return { evid: 74, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishAddDialogTemplateClick' event (evid: 77)
 *
 * Event description: restaurants_dashboard_menus_dish_add_dialog_template_click
 *
 * @param {restaurantsDashboardMenusDishAddDialogTemplateClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} template - {simple,sizes,...}
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishAddDialogTemplateClickParams>} LogObject<restaurantsDashboardMenusDishAddDialogTemplateClickParams>
 */
export function restaurantsDashboardMenusDishAddDialogTemplateClick(params) {
    return { evid: 77, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'initSession' event (evid: 800)
 *
 * Event description: OLO- UoU started session- Page load
 *
 * @param {initSessionParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} uouTestId - optional field- if UOU test  is running then test ID, if not null
 * @property {string} uouTestLabel - optional field- if UOU test  is running then UOU label (a/b/c), if not null
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location ID
 * @return {LogObject<initSessionParams>} LogObject<initSessionParams>
 */
export function initSession(params) {
    return { evid: 800, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openDishModal' event (evid: 801)
 *
 * Event description: OLO- UoU opened dish modal (Click on dish, dish modal has been opened)
 *
 * @param {openDishModalParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - menu/cart
 * @property {string} dishId - dish ID
 * @return {LogObject<openDishModalParams>} LogObject<openDishModalParams>
 */
export function openDishModal(params) {
    return { evid: 801, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addToCartSrc61Evid802' event (evid: 802)
 *
 * Event description: OLO- UoU added dish to cart
 *
 * @param {addToCartSrc61Evid802Params} params - The parameters for this event
 * @property {string} fee_type - (percentage, amount)
 * @property {string} viewMode - Preview/editor
 * @property {number} quantity - item count
 * @property {string} restaurantId - organisation ID
 * @property {GUID} fee_id - fee_id
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} dishId - dish ID
 * @return {LogObject<addToCartSrc61Evid802Params>} LogObject<addToCartSrc61Evid802Params>
 */
export function addToCartSrc61Evid802(params) {
    return { evid: 802, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewCartSrc61Evid803' event (evid: 803)
 *
 * Event description: OLO- UoU clicked on View cart
 *
 * @param {viewCartSrc61Evid803Params} params - The parameters for this event
 * @property {string} dispatchType - pickup/ delivery
 * @property {string} viewMode - Preview/site
 * @property {number} abTestSum - always 1
 * @property {string} restaurantId - organisation ID
 * @property {number} totalItemsCount - total items count- the number of items in the cart when clicked
 * @property {GUID} oloSessionId - session ID
 * @property {number} totalLoyaltyPoints - Total points, the member has
 * @property {number} loyaltyPoints - loyalty points to be redeemed
 * @property {GUID} rewardId - reward id
 * @property {GUID} locationGuid - location_guid
 * @property {number} loyaltyEstimatedEarend - Estimated points about to be earned
 * @property {number} loyaltyPrice - loyalty points to be redeemed in local currency
 * @return {LogObject<viewCartSrc61Evid803Params>} LogObject<viewCartSrc61Evid803Params>
 */
export function viewCartSrc61Evid803(params) {
    return { evid: 803, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'goToCheckout' event (evid: 804)
 *
 * Event description: OLO- UoU clicked on Go to Checkout
 *
 * @param {goToCheckoutParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {number} abTestSum - always 1
 * @property {string} restaurantId - organisation ID
 * @property {number} totalItemsCount - total items count
 * @property {GUID} oloSessionId - session ID
 * @property {number} taxAmount - -
 * @property {GUID} locationGuid - location_guid
 * @property {string} currency - -
 * @property {number} taxAndFeesAmount - -
 * @property {number} feesAmount - -
 * @property {string} feeids - all service fee ids
 * @property {string} restaurantsLocationId - -
 * @return {LogObject<goToCheckoutParams>} LogObject<goToCheckoutParams>
 */
export function goToCheckout(params) {
    return { evid: 804, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitOrder' event (evid: 805)
 *
 * Event description: OLO- UoU clicked on Submit Order
 *
 * @param {submitOrderParams} params - The parameters for this event
 * @property {string} fee_type - (percentage, amount)
 * @property {string} dispatchType - contaclessDineIn/pickup/delivery
 * @property {string} viewMode - Preview/editor
 * @property {number} deliveryFee - deliveryFee in local currency
 * @property {number} abTestSum - always 1
 * @property {string} integrationName - doordash/uber_eats/etc...
 * @property {GUID} configurationId - configurationId
 * @property {string} contactlessDineInUOUInput - UoU's input / null
 * @property {string} feeIds - all service fees ids
 * @property {string} restaurantId - organisation ID
 * @property {boolean} isDeliveryPartner - States if the order was fulfilled by a delivery partner
 * @property {number} discount_subtotal - Total discount
 * @property {GUID} integrationAppId - integrationAppId
 * @property {string} tipValue1 - tip_value1
 * @property {boolean} isConsentCheckboxChecked - Wether the order done with check box or not
 * @property {boolean} changeTimedueToDelay - true if the user changed the time due to a delay alert
 * @property {boolean} isContactless - true/false
 * @property {number} totalItemsCount - total items count
 * @property {GUID} oloSessionId - session ID
 * @property {number} totalLoyaltyPoints - The total points after the order was submitted(estimated)
 * @property {number} total - Order price total (actual price, without /100)
 * @property {number} loyaltyPoints - Number of Loyalty points redeemed
 * @property {boolean} isMember - order done by a member
 * @property {GUID} rewardId - RewardID
 * @property {boolean} isPos - true if the order is with POS
 * @property {number} taxAmount - -
 * @property {GUID} locationGuid - location_guid
 * @property {number} feesCount - -
 * @property {string} tipType - % or $
 * @property {GUID} contactId - contact_id
 * @property {number} loyaltyEstimatedEarend - Loyalty points earned(or could have been if not member) from this order
 * @property {string} currency - currency
 * @property {boolean} isConsentRequired - order submited with/without some type of consent (Terms/policy/etc)
 * @property {number} estimatedDeliveryTime - Estimated delivery time in minutes(ASAP orders only)
 * @property {number} taxAndFeesAmount - -
 * @property {number} loyaltyPrice - Actual local currency value of the points redeemed
 * @property {number} tipSubtotal - total tip
 * @property {number} feesAmount - -
 * @property {boolean} delayAlertShown - .true  if delay alert shown (order pacing)
 * @property {string} contactlessDineInInputLabel - User's input label as defined at the settings / null
 * @property {string} posProviderId - if the restaurants location connected to POS then send provider id, if not null
 * @property {string} restaurantsLocationId - -
 * @property {GUID} oloRequestId - In order to track submit order, success order, failure
 * @return {LogObject<submitOrderParams>} LogObject<submitOrderParams>
 */
export function submitOrder(params) {
    return { evid: 805, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitOrderSuccess' event (evid: 806)
 *
 * Event description: OLO- order submitted successfully, payment method charged.
 *
 * @param {submitOrderSuccessParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} orderId - Order ID
 * @property {string} restaurantId - organisation ID
 * @property {boolean} isDeliveryPartner - provided by a delivery partner
 * @property {GUID} oloSessionId - session ID
 * @property {boolean} isPos - true if order was created with POS
 * @property {GUID} locationGuid - location_guid
 * @property {string} posProviderId - true if the order is with POS
 * @property {GUID} oloRequestId - In order to track submit order, success order, failure
 * @return {LogObject<submitOrderSuccessParams>} LogObject<submitOrderSuccessParams>
 */
export function submitOrderSuccess(params) {
    return { evid: 806, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitOrderFailure' event (evid: 807)
 *
 * Event description: OLO- order submitted and failed, payment method --not-- charged.
 *
 * @param {submitOrderFailureParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} rejectReason - failure reason
 * @property {string} restaurantId - organisation ID
 * @property {boolean} isDeliveryPartner - provided by a delivery partner
 * @property {GUID} oloSessionId - session ID
 * @property {boolean} isPos - true if order was created with POS
 * @property {GUID} locationGuid - location_guid
 * @property {number} errorCode - error code
 * @property {string} errorCodeString - new field for error code (replacing the old one- errorCode) since POS error is sending as a string
 * @property {number} fee_count - -
 * @property {string} posProviderId - true if the order is with POS
 * @property {GUID} oloRequestId - In order to track submit order, success order, failure
 * @return {LogObject<submitOrderFailureParams>} LogObject<submitOrderFailureParams>
 */
export function submitOrderFailure(params) {
    return { evid: 807, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'navigateToMenu' event (evid: 808)
 *
 * Event description: OLO- UoU clicked on menu in the navigation header- (i.e dinner menu, lunch menu, etc.)
 *
 * @param {navigateToMenuParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {string} menuName - menu name
 * @property {GUID} locationGuid - location_guid
 * @property {string} menuId - menu ID
 * @return {LogObject<navigateToMenuParams>} LogObject<navigateToMenuParams>
 */
export function navigateToMenu(params) {
    return { evid: 808, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'navigateToSection' event (evid: 809)
 *
 * Event description: OLO- UoU clicked on section in the navigation header- (i.e main, desserts, etc.)
 *
 * @param {navigateToSectionParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {string} sectionName - section name
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} sectionId - Section ID
 * @return {LogObject<navigateToSectionParams>} LogObject<navigateToSectionParams>
 */
export function navigateToSection(params) {
    return { evid: 809, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openDispatchSettingsSrc61Evid810' event (evid: 810)
 *
 * Event description: OLO- UoU clicked on the dispatch settings - i.e delivery instead of pick-up, etc.
 *
 * @param {openDispatchSettingsSrc61Evid810Params} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} openReason - click on dish / click on dispatch
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<openDispatchSettingsSrc61Evid810Params>} LogObject<openDispatchSettingsSrc61Evid810Params>
 */
export function openDispatchSettingsSrc61Evid810(params) {
    return { evid: 810, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dispatchSettingsUpdateSrc61Evid811' event (evid: 811)
 *
 * Event description: OLO- UoU clicked on the "SAVE" button in the dispatch settings -AKA dispatch settings updated
 *
 * @param {dispatchSettingsUpdateSrc61Evid811Params} params - The parameters for this event
 * @property {string} dispatchType - delivery/pickup/dine-in
 * @property {string} viewMode - Preview/editor
 * @property {string} integrationName - doordasg/uber_eats/etc...
 * @property {GUID} configurationId - configurationId
 * @property {string} curbsideAdditionalInformationContent - string/null
 * @property {string} contactlessDineInUOUInput - UoU input / null
 * @property {string} restaurantId - organisation ID
 * @property {GUID} integrationAppId - integrationAppId
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} dispatchTimeOption - asap/later
 * @property {boolean} curbsidePickupToggle - true/false
 * @property {number} estimatedDeliveryTime - Estimated delivery time in minutes(ASAP orders only)
 * @property {DateTime} dispatchTime - delivery/pickup hour (In UTC+0 time)
 * @property {string} validationError - Outfit Description / location-changed
 * @property {string} contactlessDineInInputLabel - User's input label as defined at the settings / null
 * @return {LogObject<dispatchSettingsUpdateSrc61Evid811Params>} LogObject<dispatchSettingsUpdateSrc61Evid811Params>
 */
export function dispatchSettingsUpdateSrc61Evid811(params) {
    return { evid: 811, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addressInformationContinue' event (evid: 812)
 *
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from address information (CONTINUE WITH SUCCESS- AKA no errors while clicking on the Continue)
 *
 * @param {addressInformationContinueParams} params - The parameters for this event
 * @property {string} dispatchType - delivery/pickup/dine-in
 * @property {string} viewMode - Preview/editor
 * @property {string} curbsideAdditionalInformationContent - string/null
 * @property {string} contactlessDineInUOUInput - UoU's input / null
 * @property {boolean} isSaved - wether the continue clicked by a saved member
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} dispatchTimeOption - asap/later
 * @property {boolean} curbsidePickupToggle - true/false
 * @property {string} comment - comment
 * @property {DateTime} dispatchTime - delivery/pickup hour
 * @property {boolean} delayAlertShown - true if delay alert is shown (order pacing)
 * @property {string} contactlessDineInInputLabel - User's input label as defined at the settings / null
 * @property {DateTime} futureOrderTime - Specified future order time
 * @return {LogObject<addressInformationContinueParams>} LogObject<addressInformationContinueParams>
 */
export function addressInformationContinue(params) {
    return { evid: 812, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addressInformationContinueValidationError' event (evid: 813)
 *
 * Event description: OLO- UoU clicked on the continue button - continue from address information (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue). (the page_name column was added in Aug 21)
 *
 * @param {addressInformationContinueValidationErrorParams} params - The parameters for this event
 * @property {string} dispatchType - delivery/pickup/dine-in
 * @property {string} viewMode - Preview/editor
 * @property {string} integrationName - doordash/uber_eats/etc...
 * @property {GUID} configurationId - configurationId
 * @property {string} restaurantId - organisation ID
 * @property {GUID} integrationAppId - integrationAppId
 * @property {boolean} isContactless - true/false
 * @property {string} errorReason - deliveryAddress/apt/floor/entrance/
 * contactlessDineInInputLabel concat between them
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} dispatchTimeOption - asap/later
 * @property {string} comment - comment
 * @property {string} pageName - checkout/ dispatch modal
 * @property {DateTime} dispatchTime - delivery/pickup hour
 * @return {LogObject<addressInformationContinueValidationErrorParams>} LogObject<addressInformationContinueValidationErrorParams>
 */
export function addressInformationContinueValidationError(params) {
    return { evid: 813, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'contactInformationContinue' event (evid: 814)
 *
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from Contact information (CONTINUE WITH SUCCESS- AKA no errors while clicking on the Continue)
 *
 * @param {contactInformationContinueParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {boolean} isSaved - wether the continue clicked by a saved member
 * @property {string} restaurantId - organisation ID
 * @property {boolean} isOverridden - wether the member overrided the contact info
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} emailDomain - @wix.com/@gmail.com
 * @return {LogObject<contactInformationContinueParams>} LogObject<contactInformationContinueParams>
 */
export function contactInformationContinue(params) {
    return { evid: 814, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'contactInformationContinueValidationError' event (evid: 815)
 *
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from Contact information (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue)
 *
 * @param {contactInformationContinueValidationErrorParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {string} errorReason - FirstName/lastName/Email/phone concat between them
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<contactInformationContinueValidationErrorParams>} LogObject<contactInformationContinueValidationErrorParams>
 */
export function contactInformationContinueValidationError(params) {
    return { evid: 815, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentsInformationContinue' event (evid: 816)
 *
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from Payments information (CONTINUE WITH SUCCESS- AKA no errors while clicking on the Continue)
 *
 * @param {paymentsInformationContinueParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {string} tipValue1 - tip value
 * @property {string} paymentType - CC/Paypal/Offline
 * @property {GUID} oloSessionId - session ID
 * @property {boolean} isCustomTip - true/fasle
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} isDefaultTip - true/false
 * @property {number} totalOrderValue - the total amount paid for the order in original currency- including tip, delivery
 * @property {string} currency - currency
 * @property {string} tip_type - currency/percentage
 * @property {number} totalTip - tip
 * @return {LogObject<paymentsInformationContinueParams>} LogObject<paymentsInformationContinueParams>
 */
export function paymentsInformationContinue(params) {
    return { evid: 816, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentsInformationContinueValidationError' event (evid: 817)
 *
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from Payments information (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue)
 *
 * @param {paymentsInformationContinueValidationErrorParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {string} paymentType - manual/paypal/CC
 * @property {string} errorReason - Error reason
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<paymentsInformationContinueValidationErrorParams>} LogObject<paymentsInformationContinueValidationErrorParams>
 */
export function paymentsInformationContinueValidationError(params) {
    return { evid: 817, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dishModalDiscard' event (evid: 818)
 *
 * Event description: OLO- UoU closed the dish modal without adding the dish to the cart ( either click on X/click outside/cancel/esc)
 *
 * @param {dishModalDiscardParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - menu/cart
 * @property {string} dishId - dish ID
 * @return {LogObject<dishModalDiscardParams>} LogObject<dishModalDiscardParams>
 */
export function dishModalDiscard(params) {
    return { evid: 818, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addToCartValidationError' event (evid: 819)
 *
 * Event description: OLO- UoU clicked on the button - "Add to my Order" in the Dish Modal-  (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue)
 *
 * @param {addToCartValidationErrorParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {string} errorReason - variation error
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {number} errorsCount - number of errors (In the variations)
 * @property {string} dishId - dish ID
 * @return {LogObject<addToCartValidationErrorParams>} LogObject<addToCartValidationErrorParams>
 */
export function addToCartValidationError(params) {
    return { evid: 819, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishEdit' event (evid: 82)
 *
 * Event description: restaurants_dashboard_menus_dish_edit
 *
 * @param {restaurantsDashboardMenusDishEditParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {string} dish - {dish ID? title?}
 * @property {string} section - {section ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - --
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishEditParams>} LogObject<restaurantsDashboardMenusDishEditParams>
 */
export function restaurantsDashboardMenusDishEdit(params) {
    return { evid: 82, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutBackToMenu' event (evid: 820)
 *
 * Event description: OLO- During the checkout, the UoU clicked on "Back to Menu" button in order to continue the order
 *
 * @param {checkoutBackToMenuParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @return {LogObject<checkoutBackToMenuParams>} LogObject<checkoutBackToMenuParams>
 */
export function checkoutBackToMenu(params) {
    return { evid: 820, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartDishQuantitiesUpdate' event (evid: 821)
 *
 * Event description: OLO- In the Cart, the UoU clicked on +/- to add/remove the dish' quantity.
 *
 * @param {cartDishQuantitiesUpdateParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {number} quantity - item count (after the update)
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} dishId - dish ID
 * @property {string} action - increase (+)/decrease (-)
 * @return {LogObject<cartDishQuantitiesUpdateParams>} LogObject<cartDishQuantitiesUpdateParams>
 */
export function cartDishQuantitiesUpdate(params) {
    return { evid: 821, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartRemoveDish' event (evid: 822)
 *
 * Event description: OLO- In the Cart, the UoU clicked on "remove" under the dish name
 *
 * @param {cartRemoveDishParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} dishId - dish ID
 * @return {LogObject<cartRemoveDishParams>} LogObject<cartRemoveDishParams>
 */
export function cartRemoveDish(params) {
    return { evid: 822, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartDiscardSrc61Evid823' event (evid: 823)
 *
 * Event description: OLO- In the Cart, the UoU closed the cart- without continuing the Checkout.
 * clicked on X/Click Outside/esc
 *
 * @param {cartDiscardSrc61Evid823Params} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<cartDiscardSrc61Evid823Params>} LogObject<cartDiscardSrc61Evid823Params>
 */
export function cartDiscardSrc61Evid823(params) {
    return { evid: 823, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartDiscountDetails' event (evid: 824)
 *
 * Event description: OLO- In the Cart, the UoU clicked on "show/hide details" under the discounts (Promo code/discounts).
 *
 * @param {cartDiscountDetailsParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} type - discount/promo code
 * @property {string} action - show/hide
 * @return {LogObject<cartDiscountDetailsParams>} LogObject<cartDiscountDetailsParams>
 */
export function cartDiscountDetails(params) {
    return { evid: 824, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartAddPromoCode' event (evid: 825)
 *
 * Event description: OLO- In the Cart, the UoU clicked on "Add promo code "- AKA the UoU will add the promo code (Not yet added)
 *
 * @param {cartAddPromoCodeParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<cartAddPromoCodeParams>} LogObject<cartAddPromoCodeParams>
 */
export function cartAddPromoCode(params) {
    return { evid: 825, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartPromoCodeApplySuccess' event (evid: 826)
 *
 * Event description: OLO- In the Cart, the UoU Added promo code (clicked on Apply) with success
 *
 * @param {cartPromoCodeApplySuccessParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} promoCode - promo code added with success
 * @return {LogObject<cartPromoCodeApplySuccessParams>} LogObject<cartPromoCodeApplySuccessParams>
 */
export function cartPromoCodeApplySuccess(params) {
    return { evid: 826, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartPromoCodeApplyFailure' event (evid: 827)
 *
 * Event description: OLO- In the Cart, the UoU Added promo code (clicked on Apply) with Failure
 *
 * @param {cartPromoCodeApplyFailureParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {string} errorReason - The error as it's presented to the UoU
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} promoCode - promo code added with success
 * @return {LogObject<cartPromoCodeApplyFailureParams>} LogObject<cartPromoCodeApplyFailureParams>
 */
export function cartPromoCodeApplyFailure(params) {
    return { evid: 827, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartPromoCodeRemove' event (evid: 828)
 *
 * Event description: OLO- In the Cart, the UoU clicked on "remove" after adding a promo code
 *
 * @param {cartPromoCodeRemoveParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} promoCode - Promo Code that was removed
 * @return {LogObject<cartPromoCodeRemoveParams>} LogObject<cartPromoCodeRemoveParams>
 */
export function cartPromoCodeRemove(params) {
    return { evid: 828, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartAddOrderNotes' event (evid: 829)
 *
 * Event description: OLO- In the Cart, the UoU clicked on "Add Order Notes "- AKA the UoU will add a comment (Not yet added)
 *
 * @param {cartAddOrderNotesParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<cartAddOrderNotesParams>} LogObject<cartAddOrderNotesParams>
 */
export function cartAddOrderNotes(params) {
    return { evid: 829, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishEditCancel' event (evid: 83)
 *
 * Event description: restaurants_dashboard_menus_dish_edit_cancel
 *
 * @param {restaurantsDashboardMenusDishEditCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {GUID} site_id - guid
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - {cancel}
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishEditCancelParams>} LogObject<restaurantsDashboardMenusDishEditCancelParams>
 */
export function restaurantsDashboardMenusDishEditCancel(params) {
    return { evid: 83, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addToCartFailure' event (evid: 830)
 *
 * Event description: UoU changed dispatch option in the checkout, while in the address information
 *
 * @param {addToCartFailureParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} lastState - delivery/pickup/dine-in
 * @return {LogObject<addToCartFailureParams>} LogObject<addToCartFailureParams>
 */
export function addToCartFailure(params) {
    return { evid: 830, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartOrderNotesAddedSrc61Evid831' event (evid: 831)
 *
 * Event description: OLO- In the Cart, the UoU Added Order Notes- AKA the UoU finished adding a comment.
 *
 * @param {cartOrderNotesAddedSrc61Evid831Params} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} comment - comment
 * @return {LogObject<cartOrderNotesAddedSrc61Evid831Params>} LogObject<cartOrderNotesAddedSrc61Evid831Params>
 */
export function cartOrderNotesAddedSrc61Evid831(params) {
    return { evid: 831, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutReviewPolicies' event (evid: 832)
 *
 * Event description: UoU clicked on the termsAndConditions/privacyPolicy in the "Review and Place Order" stage in the checkout.
 *
 * @param {checkoutReviewPoliciesParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} type - privacyPolicy/termsAndConditions
 * @return {LogObject<checkoutReviewPoliciesParams>} LogObject<checkoutReviewPoliciesParams>
 */
export function checkoutReviewPolicies(params) {
    return { evid: 832, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutReviewCheckbox' event (evid: 833)
 *
 * Event description: UoU clicked on the Checkbox in the "Review and Place Order" stage in the checkout.
 *
 * @param {checkoutReviewCheckboxParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} lastState - true/false
 * @return {LogObject<checkoutReviewCheckboxParams>} LogObject<checkoutReviewCheckboxParams>
 */
export function checkoutReviewCheckbox(params) {
    return { evid: 833, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutEdit' event (evid: 834)
 *
 * Event description: OLO- During the checkout, the UoU clicked on the "edit" button in one of the Checkout Stages- AKA Delivery Method/Contact Information/Payments
 *
 * @param {checkoutEditParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} type - Delivery/Contact/Payments
 * @return {LogObject<checkoutEditParams>} LogObject<checkoutEditParams>
 */
export function checkoutEdit(params) {
    return { evid: 834, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsValidationDisplay' event (evid: 835)
 *
 * Event description: OLO- During the checkout, the UoU clicked on the "Submit Order" button and get the SMS validation Modal (Modal loaded)
 *
 * @param {smsValidationDisplayParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<smsValidationDisplayParams>} LogObject<smsValidationDisplayParams>
 */
export function smsValidationDisplay(params) {
    return { evid: 835, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsValidationSuccess' event (evid: 836)
 *
 * Event description: OLO- During the checkout, the UoU clicked on the "Submit Order" button and get the SMS validation Modal (Modal loaded)-
 * added the code with success
 *
 * @param {smsValidationSuccessParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<smsValidationSuccessParams>} LogObject<smsValidationSuccessParams>
 */
export function smsValidationSuccess(params) {
    return { evid: 836, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsValidationFailure' event (evid: 837)
 *
 * Event description: OLO- During the checkout, the UoU clicked on the "Submit Order" button and get the SMS validation Modal (Modal loaded)-
 * added the code without success- Failure
 *
 * @param {smsValidationFailureParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<smsValidationFailureParams>} LogObject<smsValidationFailureParams>
 */
export function smsValidationFailure(params) {
    return { evid: 837, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'futureOrdersError' event (evid: 838)
 *
 * Event description: UoU future Orders Error- hedge case let's say it is now 4pm, and I want to place a future order for 4:30pm and the prep time for pickup is 30 min. I start filling out my cart at 4pm and then I went to the kitchen to wash dishes, and came back at 4:15pm to place my order. I will be able to proceed until final checkout step - and then get a "something went wrong error".
 *
 * @param {futureOrdersErrorParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} details - details
 * @return {LogObject<futureOrdersErrorParams>} LogObject<futureOrdersErrorParams>
 */
export function futureOrdersError(params) {
    return { evid: 838, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsValidationCancel' event (evid: 839)
 *
 * Event description: OLO- During the checkout, the UoU clicked on the "Submit Order" button and get the SMS validation Modal (Modal loaded)-
 * then clicks on cancel/out of the modal in order to go back to the order.
 *
 * @param {smsValidationCancelParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - cancel/X/outside
 * @return {LogObject<smsValidationCancelParams>} LogObject<smsValidationCancelParams>
 */
export function smsValidationCancel(params) {
    return { evid: 839, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishEditSetField' event (evid: 84)
 *
 * Event description: restaurants_dashboard_menus_dish_edit_set_field
 *
 * @param {restaurantsDashboardMenusDishEditSetFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} firstsuggestion - --
 * @property {string} modalType - new dish/ duplicate/ edit dish info
 * @property {string} field - {title,description,price}
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location ID
 * @property {GUID} catalogId - catalog_id
 * @property {string} sectionId - sectionId
 * @property {string} itemId - dish/variation ID
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {string} dishId - dishId
 * @property {string} menuId - menuId
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishEditSetFieldParams>} LogObject<restaurantsDashboardMenusDishEditSetFieldParams>
 */
export function restaurantsDashboardMenusDishEditSetField(params) {
    return { evid: 84, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dishModalDishQuantitiesUpdate' event (evid: 841)
 *
 * Event description: OLO- In the Dish modal, the UoU clicked on +/- to add/remove the dish' quantity.
 *
 * @param {dishModalDishQuantitiesUpdateParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {number} quantity - item count (after the update)
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} dishId - dish ID
 * @property {string} action - increase (+)/decrease (-)
 * @return {LogObject<dishModalDishQuantitiesUpdateParams>} LogObject<dishModalDishQuantitiesUpdateParams>
 */
export function dishModalDishQuantitiesUpdate(params) {
    return { evid: 841, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorUpgradeToPremium' event (evid: 842)
 *
 * Event description: 3 New entry points to premium upgrade in the Editor (app settings, modals):
 * Footer, modal (after trying to continue to Checkout without Premium ) and tab.
 *
 * @param {editorUpgradeToPremiumParams} params - The parameters for this event
 * @property {string} viewMode - preview/live site
 * @property {string} appName - olo/menus/reservations
 * @property {string} restaurantId - rest_id
 * @property {GUID} oloSessionId - olo_session_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - footer/tab/modal
 * @property {GUID} instance_id - {}
 * @property {GUID} bi_token - {}
 * @return {LogObject<editorUpgradeToPremiumParams>} LogObject<editorUpgradeToPremiumParams>
 */
export function editorUpgradeToPremium(params) {
    return { evid: 842, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorConnectPaymentCta' event (evid: 843)
 *
 * Event description: New entry point to connect payment in the Editor Preview.
 * It will be trigger when trying to continue to Checkout, premium is connected, but no payments.
 *
 * @param {editorConnectPaymentCtaParams} params - The parameters for this event
 * @property {string} viewMode - preview/live site
 * @property {string} restaurantId - rest_id
 * @property {GUID} oloSessionId - olo_session_id
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} instance_id - {}
 * @property {GUID} bi_token - {}
 * @return {LogObject<editorConnectPaymentCtaParams>} LogObject<editorConnectPaymentCtaParams>
 */
export function editorConnectPaymentCta(params) {
    return { evid: 843, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'previewOnboardingModalLoad' event (evid: 845)
 *
 * Event description: After trying to continue to Checkout without Premium, or Payments a modal will be shown to the user in order to connect (Premium, or Payments)
 *
 * @param {previewOnboardingModalLoadParams} params - The parameters for this event
 * @property {string} viewMode - preview/live site
 * @property {string} restaurantId - rest_id
 * @property {GUID} oloSessionId - olo_session_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} type - Payments/Premium
 * @property {GUID} instance_id - {}
 * @property {GUID} bi_token - {}
 * @return {LogObject<previewOnboardingModalLoadParams>} LogObject<previewOnboardingModalLoadParams>
 */
export function previewOnboardingModalLoad(params) {
    return { evid: 845, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'locationPicked' event (evid: 846)
 *
 * Event description: UoU picks a location in dispatch settings
 *
 * @param {locationPickedParams} params - The parameters for this event
 * @property {string} dispatchType - delivery/pickup
 * @property {string} viewMode - preview/live site
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - menus / checkout
 * @property {string} validationError - choosing a new location will empty your cart
 * @return {LogObject<locationPickedParams>} LogObject<locationPickedParams>
 */
export function locationPicked(params) {
    return { evid: 846, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logInRequest' event (evid: 847)
 *
 * Event description: OLO- UoU clicked on the log in banner in the Checkout page
 *
 * @param {logInRequestParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location ID
 * @property {string} origin - Origin page, i.e Cart/Checkout/ThankYouPage
 * @property {GUID} requestid - request Id to join with log in success
 * @return {LogObject<logInRequestParams>} LogObject<logInRequestParams>
 */
export function logInRequest(params) {
    return { evid: 847, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishEditFieldError' event (evid: 85)
 *
 * Event description: restaurants_dashboard_menus_dish_edit_field_error
 *
 * @param {restaurantsDashboardMenusDishEditFieldErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} field - {title,description,price}
 * @property {GUID} site_id - guid
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishEditFieldErrorParams>} LogObject<restaurantsDashboardMenusDishEditFieldErrorParams>
 */
export function restaurantsDashboardMenusDishEditFieldError(params) {
    return { evid: 85, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkboxSaveAddressForFutureOrders' event (evid: 852)
 *
 * Event description: OLO- UoU clicked on the checkbox during the checkout (In the delivery method section)
 *
 * @param {checkboxSaveAddressForFutureOrdersParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location ID
 * @property {string} value - on/off
 * @return {LogObject<checkboxSaveAddressForFutureOrdersParams>} LogObject<checkboxSaveAddressForFutureOrdersParams>
 */
export function checkboxSaveAddressForFutureOrders(params) {
    return { evid: 852, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkboxSaveContactForFutureOrders' event (evid: 853)
 *
 * Event description: OLO- UoU clicked on the checkbox during the checkout (In the Contact info section)
 *
 * @param {checkboxSaveContactForFutureOrdersParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location ID
 * @property {string} value - on/off
 * @return {LogObject<checkboxSaveContactForFutureOrdersParams>} LogObject<checkboxSaveContactForFutureOrdersParams>
 */
export function checkboxSaveContactForFutureOrders(params) {
    return { evid: 853, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openAddressSelectionModal' event (evid: 854)
 *
 * Event description: OLO- UoU clicked on the change while begin on the Delivery Method section in the Checkout
 *
 * @param {openAddressSelectionModalParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location ID
 * @return {LogObject<openAddressSelectionModalParams>} LogObject<openAddressSelectionModalParams>
 */
export function openAddressSelectionModal(params) {
    return { evid: 854, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saveAddressSelectionModal' event (evid: 855)
 *
 * Event description: OLO- UoU clicked on the save after clicking on the change on the Delivery Method section in the Checkout (Choose/add delivery address title)
 *
 * @param {saveAddressSelectionModalParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {boolean} isSuccess - true/false
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - ‘list’,’edit’,’new’
 * @property {boolean} isDefault - true/false (Make this my default address)
 * @return {LogObject<saveAddressSelectionModalParams>} LogObject<saveAddressSelectionModalParams>
 */
export function saveAddressSelectionModal(params) {
    return { evid: 855, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editAddressSelectionModal' event (evid: 856)
 *
 * Event description: OLO- UoU clicked on the edit  while Choosing delivery address (Wants to edit one of the addresses)
 *
 * @param {editAddressSelectionModalParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location ID
 * @return {LogObject<editAddressSelectionModalParams>} LogObject<editAddressSelectionModalParams>
 */
export function editAddressSelectionModal(params) {
    return { evid: 856, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addNewAddressSelectionModal' event (evid: 857)
 *
 * Event description: OLO- UoU clicked on the Add New Address while Choosing delivery address (Wants to add a new address)
 *
 * @param {addNewAddressSelectionModalParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location ID
 * @return {LogObject<addNewAddressSelectionModalParams>} LogObject<addNewAddressSelectionModalParams>
 */
export function addNewAddressSelectionModal(params) {
    return { evid: 857, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMigratedToOoi' event (evid: 858)
 *
 * Event description: OLO- user migrated to OOI
 *
 * @param {siteMigratedToOoiParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<siteMigratedToOoiParams>} LogObject<siteMigratedToOoiParams>
 */
export function siteMigratedToOoi(params) {
    return { evid: 858, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsEdit' event (evid: 859)
 *
 * Event description: User edited something inside the app settings
 *
 * @param {editorAppSettingsEditParams} params - The parameters for this event
 * @property {string} viewMode - View Mode
 * @property {string} subCategory - [sub category, can contain the whole path of sub categories
 * @property {string} appName - App name
 * @property {string} restaurantId - rest id
 * @property {GUID} oloSessionId - oloSessionid
 * @property {GUID} locationGuid - location_guid
 * @property {string} category - display/layout/design/info
 * @property {string} value - the value the user chose
 * @return {LogObject<editorAppSettingsEditParams>} LogObject<editorAppSettingsEditParams>
 */
export function editorAppSettingsEdit(params) {
    return { evid: 859, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishEditNewChoiceClick' event (evid: 86)
 *
 * Event description: restaurants_dashboard_menus_dish_edit_new_choice_click
 *
 * @param {restaurantsDashboardMenusDishEditNewChoiceClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {GUID} site_id - guid
 * @property {string} option - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishEditNewChoiceClickParams>} LogObject<restaurantsDashboardMenusDishEditNewChoiceClickParams>
 */
export function restaurantsDashboardMenusDishEditNewChoiceClick(params) {
    return { evid: 86, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ooiBannerClick' event (evid: 860)
 *
 * Event description: User clicked on the OOI banner for migration
 *
 * @param {ooiBannerClickParams} params - The parameters for this event
 * @property {string} restaurantId - rest_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} type - banner name
 * @return {LogObject<ooiBannerClickParams>} LogObject<ooiBannerClickParams>
 */
export function ooiBannerClick(params) {
    return { evid: 860, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteMinimumOrderError' event (evid: 861)
 *
 * Event description: OLO- UoU clicked on the continue button in the checkout- continue from address information (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue)
 *
 * @param {liveSiteMinimumOrderErrorParams} params - The parameters for this event
 * @property {string} dispatchType - delivery/pickup
 * @property {number} minimumOrder - minimum defined for pickup/delivery *100
 * @property {string} restaurantId - organisation ID
 * @property {number} price - current order price
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - .
 * @property {string} pageName - view cart/ Checkout
 * @return {LogObject<liveSiteMinimumOrderErrorParams>} LogObject<liveSiteMinimumOrderErrorParams>
 */
export function liveSiteMinimumOrderError(params) {
    return { evid: 861, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'removeLoyaltyReward' event (evid: 862)
 *
 * Event description: OLO- the UoU clicked on "remove" under the Loyalty Reward
 *
 * @param {removeLoyaltyRewardParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} rewardId - Reward ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - Origin page, i.e Cart/Checkout
 * @return {LogObject<removeLoyaltyRewardParams>} LogObject<removeLoyaltyRewardParams>
 */
export function removeLoyaltyReward(params) {
    return { evid: 862, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyViewMyRewards' event (evid: 863)
 *
 * Event description: OLO- the UoU clicked on "view my rewards" at the members view of the Thank You page
 *
 * @param {loyaltyViewMyRewardsParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} rewardId - Reward ID
 * @property {GUID} locationGuid - location_guid
 * @return {LogObject<loyaltyViewMyRewardsParams>} LogObject<loyaltyViewMyRewardsParams>
 */
export function loyaltyViewMyRewards(params) {
    return { evid: 863, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyEditPoints' event (evid: 864)
 *
 * Event description: OLO- the UoU clicked on "edit" under the Loyalty Reward and opened a drop down list containing the point options
 *
 * @param {loyaltyEditPointsParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {number} loyaltyPoints - Loyalty points about to be redeemed
 * @property {GUID} rewardId - Reward ID
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - Origin page, i.e Cart/Checkout
 * @property {number} numOfOptions - Number of options in the dropdown list
 * @return {LogObject<loyaltyEditPointsParams>} LogObject<loyaltyEditPointsParams>
 */
export function loyaltyEditPoints(params) {
    return { evid: 864, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redeemLoyaltyReward' event (evid: 865)
 *
 * Event description: OLO-  the UoU clicked on Redeem Loyalty Reward
 *
 * @param {redeemLoyaltyRewardParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {number} loyaltyPoints - Loyalty points about to be redeemed
 * @property {GUID} rewardId - reward_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - Origin page, i.e Cart/Checkout
 * @return {LogObject<redeemLoyaltyRewardParams>} LogObject<redeemLoyaltyRewardParams>
 */
export function redeemLoyaltyReward(params) {
    return { evid: 865, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsInteraction' event (evid: 866)
 *
 * Event description: User clicked a button inside app settings
 *
 * @param {editorAppSettingsInteractionParams} params - The parameters for this event
 * @property {string} viewMode - View Mode
 * @property {string} subCategory - [sub category, can contain the whole path of sub categories
 * @property {string} appName - App name
 * @property {string} restaurantId - rest id
 * @property {GUID} oloSessionId - oloSessionid
 * @property {GUID} locationGuid - location_guid
 * @property {string} category - display/layout/design/info
 * @property {string} editMode - desktop / mobile
 * @return {LogObject<editorAppSettingsInteractionParams>} LogObject<editorAppSettingsInteractionParams>
 */
export function editorAppSettingsInteraction(params) {
    return { evid: 866, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fetchOrganizationData' event (evid: 867)
 *
 * Event description: OLO- Editor - fetch organization data on system load
 *
 * @param {fetchOrganizationDataParams} params - The parameters for this event
 * @property {string} viewMode - preview/editor/etc.
 * @property {string} restaurantId - organisation ID (might be empty in case of retry)
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {number} retryNumber - Retry count (zero based)
 * @property {GUID} locationGuid - location ID
 * @property {number} timestampMs - Timestamp
 * @return {LogObject<fetchOrganizationDataParams>} LogObject<fetchOrganizationDataParams>
 */
export function fetchOrganizationData(params) {
    return { evid: 867, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorOpenBoClick' event (evid: 868)
 *
 * Event description: user clicked on one of the manage button linking to the app's BO
 *
 * @param {editorOpenBoClickParams} params - The parameters for this event
 * @property {string} viewMode - View Mode
 * @property {string} appName - App name
 * @property {string} restaurantId - rest id
 * @property {GUID} oloSessionId - oloSessionid
 * @property {GUID} locationGuid - location_guid
 * @property {string} type - toggledOn/ toggledOff
 * @return {LogObject<editorOpenBoClickParams>} LogObject<editorOpenBoClickParams>
 */
export function editorOpenBoClick(params) {
    return { evid: 868, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyEditPointsSave' event (evid: 869)
 *
 * Event description: OLO- the UoU clicked on "save" under the Loyalty Reward after clicking on edit
 *
 * @param {loyaltyEditPointsSaveParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - .
 * @property {number} loyaltyPoints - Loyalty points about to be redeemed after change
 * @property {GUID} rewardId - Reward ID
 * @property {GUID} locationGuid - locationGuid
 * @property {string} origin - Origin page, i.e Cart/Checkout
 * @return {LogObject<loyaltyEditPointsSaveParams>} LogObject<loyaltyEditPointsSaveParams>
 */
export function loyaltyEditPointsSave(params) {
    return { evid: 869, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishEditChoiceSetField' event (evid: 87)
 *
 * Event description: restaurants_dashboard_menus_dish_edit_choice_set_field
 *
 * @param {restaurantsDashboardMenusDishEditChoiceSetFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} firstsuggestion - --
 * @property {string} menu - --
 * @property {string} field - {title,description,price}
 * @property {GUID} site_id - guid
 * @property {string} option - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} choice - {0,1,...}
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishEditChoiceSetFieldParams>} LogObject<restaurantsDashboardMenusDishEditChoiceSetFieldParams>
 */
export function restaurantsDashboardMenusDishEditChoiceSetField(params) {
    return { evid: 87, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loyaltyEditPointsChangeValue' event (evid: 870)
 *
 * Event description: OLO- the UoU clicked on a value in the dropdown list, under the Loyalty Reward, after clicking on edit
 *
 * @param {loyaltyEditPointsChangeValueParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - .
 * @property {number} loyaltyPoints - Loyalty points about to be redeemed after change
 * @property {GUID} rewardId - Reward ID
 * @property {GUID} locationGuid - locationGuid
 * @property {string} origin - Origin page, i.e Cart/Checkout
 * @return {LogObject<loyaltyEditPointsChangeValueParams>} LogObject<loyaltyEditPointsChangeValueParams>
 */
export function loyaltyEditPointsChangeValue(params) {
    return { evid: 870, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsLoad' event (evid: 873)
 *
 * Event description: App's settings loaded
 *
 * @param {editorAppSettingsLoadParams} params - The parameters for this event
 * @property {string} viewMode - View Mode
 * @property {string} appName - App name
 * @property {string} restaurantId - rest id
 * @property {GUID} oloSessionId - oloSessionid
 * @property {GUID} locationGuid - location_guid
 * @property {string} editMode - desktop / mobile
 * @return {LogObject<editorAppSettingsLoadParams>} LogObject<editorAppSettingsLoadParams>
 */
export function editorAppSettingsLoad(params) {
    return { evid: 873, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pickupShowOnMapClick' event (evid: 874)
 *
 * Event description: OLO- UoU clicked on the "Show on map"  in the pickup dispatch settings
 *
 * @param {pickupShowOnMapClickParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - dispatch settings / checkout
 * @return {LogObject<pickupShowOnMapClickParams>} LogObject<pickupShowOnMapClickParams>
 */
export function pickupShowOnMapClick(params) {
    return { evid: 874, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dispatchChangeClick' event (evid: 875)
 *
 * Event description: OLO- UoU clicked on to change the dispatch
 *
 * @param {dispatchChangeClickParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - menus / checkout
 * @return {LogObject<dispatchChangeClickParams>} LogObject<dispatchChangeClickParams>
 */
export function dispatchChangeClick(params) {
    return { evid: 875, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closeDispatchSettings' event (evid: 876)
 *
 * Event description: OLO- UoU clicked on cancel/exit dispatch settings or esc (clicked outside the dispatch setting box)
 *
 * @param {closeDispatchSettingsParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} restaurantId - organisation ID
 * @property {string} close_type - cancel/exit/esc
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location guid
 * @return {LogObject<closeDispatchSettingsParams>} LogObject<closeDispatchSettingsParams>
 */
export function closeDispatchSettings(params) {
    return { evid: 876, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorSettingsMobileView' event (evid: 877)
 *
 * Event description: User event for Editor settings opened through 'Mobile' view.
 *
 * @param {editorSettingsMobileViewParams} params - The parameters for this event
 * @property {string} section - layout / design
 * @property {string} button - varies
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - {guid}
 * @property {string} header - section_navigation / general / display / layout
 * @property {string} sub_section - general / dish
 * @property {GUID} msid - {guid}
 * @property {string} value - active / paused
 * @return {LogObject<editorSettingsMobileViewParams>} LogObject<editorSettingsMobileViewParams>
 */
export function editorSettingsMobileView(params) {
    return { evid: 877, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsNetworkPerf' event (evid: 878)
 *
 * Event description: Check performance
 *
 * @param {restaurantsNetworkPerfParams} params - The parameters for this event
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location_guid
 * @property {string} methodType - nodejs, v2.1, v2.1-location-first
 * @property {boolean} isSsr - .
 * @property {number} totalTime - ms
 * @return {LogObject<restaurantsNetworkPerfParams>} LogObject<restaurantsNetworkPerfParams>
 */
export function restaurantsNetworkPerf(params) {
    return { evid: 878, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveSiteDeliveryPartnerEstimations' event (evid: 879)
 *
 * Event description: An estimation for the availability and delivery fee from a delivery partner.
 * Can be sent in three different points:
 * dispatch settings
 * delivery method (after continue click)
 * submit order
 *
 * @param {liveSiteDeliveryPartnerEstimationsParams} params - The parameters for this event
 * @property {string} viewMode - Preview/editor
 * @property {string} stage - dispatch settings/delivery method/submit order
 * @property {number} deliveryFee - The delivery fee in the local currency
 * @property {string} integrationName - doordash/uber_eats/etc...
 * @property {GUID} configurationId - configurationId
 * @property {string} restaurantId - organisation ID
 * @property {string} integrationAppId - integrationAppId
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} estimateId - estimateId
 * @property {GUID} locationGuid - locationGuid
 * @property {boolean} status - true = success, false = error
 * @property {string} errorDescription - errorDescription
 * @property {string} currency - currency
 * @return {LogObject<liveSiteDeliveryPartnerEstimationsParams>} LogObject<liveSiteDeliveryPartnerEstimationsParams>
 */
export function liveSiteDeliveryPartnerEstimations(params) {
    return { evid: 879, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishEditChoiceAutocompleteClick' event (evid: 88)
 *
 * Event description: restaurants_dashboard_menus_dish_edit_choice_autocomplete_click
 *
 * @param {restaurantsDashboardMenusDishEditChoiceAutocompleteClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {GUID} site_id - guid
 * @property {string} option - --
 * @property {string} text - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} selection - --
 * @property {string} organization_id - guid
 * @property {string} choice - --
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {string} value - '...'
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishEditChoiceAutocompleteClickParams>} LogObject<restaurantsDashboardMenusDishEditChoiceAutocompleteClickParams>
 */
export function restaurantsDashboardMenusDishEditChoiceAutocompleteClick(params) {
    return { evid: 88, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorOoiMigrationPublishModalClick' event (evid: 881)
 *
 * Event description: user clicked on the modal, after it asked him to publish site.
 *
 * @param {editorOoiMigrationPublishModalClickParams} params - The parameters for this event
 * @property {GUID} locationGuid - []
 * @property {string} actionName - 'got_it'
 * @property {string} organizationId - rest_id
 * @return {LogObject<editorOoiMigrationPublishModalClickParams>} LogObject<editorOoiMigrationPublishModalClickParams>
 */
export function editorOoiMigrationPublishModalClick(params) {
    return { evid: 881, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutInformativeMessage' event (evid: 882)
 *
 * Event description: OLO-  Checkout page load after UoU clicked on Go to Checkout
 *
 * @param {checkoutInformativeMessageParams} params - The parameters for this event
 * @property {string} viewMode - Preview/liveSite
 * @property {string} checkoutStep - delivery method/contact/ payment..
 * @property {string} restaurantId - rest_id
 * @property {GUID} oloSessionId - session ID
 * @property {string} messageValue - The content of the message
 * @property {string} messageType - which feature this message belongs to
 * @property {GUID} locationGuid - .
 * @return {LogObject<checkoutInformativeMessageParams>} LogObject<checkoutInformativeMessageParams>
 */
export function checkoutInformativeMessage(params) {
    return { evid: 882, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dispatchSettingsClick' event (evid: 883)
 *
 * Event description: Dispatch settings click.
 *
 * @param {dispatchSettingsClickParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} clickName - click_name
 * @property {number} amountTimeSlotDisable - Amount of time slot disabled due to order pacing
 * @property {string} clickValue - deivery/pickup/day/time
 * @property {string} pageName - page_name
 * @return {LogObject<dispatchSettingsClickParams>} LogObject<dispatchSettingsClickParams>
 */
export function dispatchSettingsClick(params) {
    return { evid: 883, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAutopilotOloMigrationStart' event (evid: 886)
 *
 * Event description: Autopilot started (iframe to ooi) migration
 *
 * @param {dashboardAutopilotOloMigrationStartParams} params - The parameters for this event
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - guid
 * @property {GUID} instance_id - []
 * @property {string} statusBeforeMigration - iframe / ooi
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardAutopilotOloMigrationStartParams>} LogObject<dashboardAutopilotOloMigrationStartParams>
 */
export function dashboardAutopilotOloMigrationStart(params) {
    return { evid: 886, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAutopilotOloMigrationEnd' event (evid: 887)
 *
 * Event description: Autopilot finished (iframe to ooi) migration
 *
 * @param {dashboardAutopilotOloMigrationEndParams} params - The parameters for this event
 * @property {GUID} site_id - guid
 * @property {boolean} isSuccess - true / false
 * @property {GUID} locationGuid - []
 * @property {string} organization_id - guid
 * @property {string} statusAfterMigration - iframe / ooi
 * @property {GUID} instance_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardAutopilotOloMigrationEndParams>} LogObject<dashboardAutopilotOloMigrationEndParams>
 */
export function dashboardAutopilotOloMigrationEnd(params) {
    return { evid: 887, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAutopilotOloMigrationError' event (evid: 888)
 *
 * Event description: Autopilot encountered an error while trying to migrate (iframe to ooi)
 *
 * @param {dashboardAutopilotOloMigrationErrorParams} params - The parameters for this event
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - []
 * @property {string} errorDescription - err description
 * @property {string} organization_id - guid
 * @property {GUID} instance_id - []
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardAutopilotOloMigrationErrorParams>} LogObject<dashboardAutopilotOloMigrationErrorParams>
 */
export function dashboardAutopilotOloMigrationError(params) {
    return { evid: 888, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardAutopilotOloLogMigration' event (evid: 889)
 *
 * Event description: Autopilots logs in the migration
 *
 * @param {dashboardAutopilotOloLogMigrationParams} params - The parameters for this event
 * @property {GUID} site_id - guid
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} instance_id - []
 * @property {string} log - free text
 * @property {GUID} bi_token - []
 * @return {LogObject<dashboardAutopilotOloLogMigrationParams>} LogObject<dashboardAutopilotOloLogMigrationParams>
 */
export function dashboardAutopilotOloLogMigration(params) {
    return { evid: 889, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishEditChoiceDelete' event (evid: 89)
 *
 * Event description: restaurants_dashboard_menus_dish_edit_choice_delete
 *
 * @param {restaurantsDashboardMenusDishEditChoiceDeleteParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {GUID} site_id - guid
 * @property {string} option - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} choice - {0,1,...}
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishEditChoiceDeleteParams>} LogObject<restaurantsDashboardMenusDishEditChoiceDeleteParams>
 */
export function restaurantsDashboardMenusDishEditChoiceDelete(params) {
    return { evid: 89, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloAutoCompleteEventsForMonitorBugs' event (evid: 890)
 *
 * Event description: when the data of the chosen location from auto-complete  is returned
 *
 * @param {oloAutoCompleteEventsForMonitorBugsParams} params - The parameters for this event
 * @property {string} subdivisions - -
 * @property {string} city - -
 * @property {string} placeId - -
 * @property {string} streetAddress - -
 * @property {string} formattedAddress - -
 * @property {string} country - -
 * @property {string} postalCode - -
 * @property {string} geocode - geo_code
 * @property {GUID} locationGuid - location_guid
 * @property {string} address - -
 * @return {LogObject<oloAutoCompleteEventsForMonitorBugsParams>} LogObject<oloAutoCompleteEventsForMonitorBugsParams>
 */
export function oloAutoCompleteEventsForMonitorBugs(params) {
    return { evid: 890, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloUouServiceFeeFailureWebSrc61Evid892' event (evid: 892)
 *
 * Event description: when service fees calculations are failing
 *
 * @param {restaurantsOloUouServiceFeeFailureWebSrc61Evid892Params} params - The parameters for this event
 * @property {string} requestName - "listRules" | "calculateServiceFees" | "listRestaurantLocations"
 * @property {GUID} locationGuid - location_guid
 * @property {string} error - -
 * @return {LogObject<restaurantsOloUouServiceFeeFailureWebSrc61Evid892Params>} LogObject<restaurantsOloUouServiceFeeFailureWebSrc61Evid892Params>
 */
export function restaurantsOloUouServiceFeeFailureWebSrc61Evid892(params) {
    return { evid: 892, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishSetImage' event (evid: 90)
 *
 * Event description: restaurants_dashboard_menus_dish_set_image
 *
 * @param {restaurantsDashboardMenusDishSetImageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {string} dish - {dish ID? title?}
 * @property {string} section - {section ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {string} value - URL or empty
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishSetImageParams>} LogObject<restaurantsDashboardMenusDishSetImageParams>
 */
export function restaurantsDashboardMenusDishSetImage(params) {
    return { evid: 90, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'initSessionSrc61Evid901' event (evid: 901)
 *
 * Event description: OLO- UoU started session- Page load
 *
 * @param {initSessionSrc61Evid901Params} params - The parameters for this event
 * @property {GUID} instanceId - instanceId
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {boolean} restaurantAcceptsOrders - true/false
 * @property {GUID} locationGuid - location ID
 * @property {string} alertBanner - which type of banner the user see (the rest doesn't deliver to the address/requires address/currently closed
 * @property {boolean} isMultiLocation - is_multi_location
 * @property {GUID} msid - msid
 * @return {LogObject<initSessionSrc61Evid901Params>} LogObject<initSessionSrc61Evid901Params>
 */
export function initSessionSrc61Evid901(params) {
    return { evid: 901, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openDishModalSrc61Evid902' event (evid: 902)
 *
 * Event description: OLO- UoU opened dish modal (Click on dish, dish modal has been opened)
 *
 * @param {openDishModalSrc61Evid902Params} params - The parameters for this event
 * @property {GUID} instanceId - instance
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} origin - menu/cart
 * @property {string} dishId - dish ID
 * @property {GUID} msid - msid
 * @return {LogObject<openDishModalSrc61Evid902Params>} LogObject<openDishModalSrc61Evid902Params>
 */
export function openDishModalSrc61Evid902(params) {
    return { evid: 902, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openDispatchSettings' event (evid: 903)
 *
 * Event description: OLO- UoU clicked on the dispatch settings - i.e delivery instead of pick-up, etc.
 *
 * @param {openDispatchSettingsParams} params - The parameters for this event
 * @property {GUID} instanceId - instance
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - Location ID
 * @property {GUID} msid - msid
 * @return {LogObject<openDispatchSettingsParams>} LogObject<openDispatchSettingsParams>
 */
export function openDispatchSettings(params) {
    return { evid: 903, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addToCart' event (evid: 904)
 *
 * Event description: OLO- UoU added dish to cart
 *
 * @param {addToCartParams} params - The parameters for this event
 * @property {GUID} instanceId - instance
 * @property {string} fee_type - (percentage, amount)
 * @property {number} quantity - item count
 * @property {string} restaurantId - organisation ID
 * @property {GUID} fee_id - fee_id
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} dishId - dish ID
 * @property {string} type - click/swipe
 * @property {GUID} msid - msid
 * @property {number} fee_count - fee_count
 * @return {LogObject<addToCartParams>} LogObject<addToCartParams>
 */
export function addToCart(params) {
    return { evid: 904, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitOrderFailureSrc61Evid905' event (evid: 905)
 *
 * Event description: OLO- order submitted and failed, payment method --not-- charged.
 *
 * @param {submitOrderFailureSrc61Evid905Params} params - The parameters for this event
 * @property {GUID} instanceId - instance
 * @property {string} rejectReason - failure reason
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - locationId
 * @property {GUID} msid - msid
 * @property {GUID} oloRequestId - In order to track submit order, success order, failure
 * @return {LogObject<submitOrderFailureSrc61Evid905Params>} LogObject<submitOrderFailureSrc61Evid905Params>
 */
export function submitOrderFailureSrc61Evid905(params) {
    return { evid: 905, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitOrderSuccessSrc61Evid906' event (evid: 906)
 *
 * Event description: OLO- order submitted successfully, payment method charged.
 *
 * @param {submitOrderSuccessSrc61Evid906Params} params - The parameters for this event
 * @property {GUID} instanceId - instance
 * @property {string} orderId - Order ID
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @property {GUID} oloRequestId - In order to track submit order, success order, failure
 * @return {LogObject<submitOrderSuccessSrc61Evid906Params>} LogObject<submitOrderSuccessSrc61Evid906Params>
 */
export function submitOrderSuccessSrc61Evid906(params) {
    return { evid: 906, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitOrderSrc61Evid907' event (evid: 907)
 *
 * Event description: OLO- UoU clicked on Submit Order
 *
 * @param {submitOrderSrc61Evid907Params} params - The parameters for this event
 * @property {GUID} instanceId - instance
 * @property {string} fee_type - (percentage, amount)
 * @property {number} deliveryFee - delivery fee - restaurants covered
 * @property {number} loyaltyEstimatedEarned - estimated loyalty points earned in this order
 * @property {string} feeIds - service fees ids
 * @property {string} restaurantId - organisation ID
 * @property {number} discount_subtotal - Total discount
 * @property {boolean} isContactless - true/false
 * @property {number} totalItemsCount - total items count
 * @property {GUID} oloSessionId - session ID
 * @property {number} totalLoyaltyPoints - Total points the user has after submit
 * @property {number} total - Order price total (actual price, without /100)
 * @property {number} loyaltyPoints - Number of loyalty points
 * @property {boolean} isMember - order done by a member
 * @property {boolean} isCustomTip - true/false. true if the UoU wrote a specific amount of tip. false if the UoU chose a tip out of the defined options
 * @property {GUID} rewardId - reward Id
 * @property {number} taxAmount - -
 * @property {GUID} locationGuid - locationID
 * @property {boolean} isConsent - order submitted with/without some type of consent (Terms/policy/etc)
 * @property {boolean} isDefaultTip - true/false. true if the UoU chose the tip that the user defined as default
 * @property {string} tipType - % or $
 * @property {string} currency - currency
 * @property {number} feeCount - how many service fees are in this calculate
 * @property {number} taxAndFeesAmount - -
 * @property {number} loyaltyPrice - Actual local currency value of the points
 * @property {number} tipSubtotal - total tip
 * @property {number} feesAmount - -
 * @property {GUID} msid - msid
 * @property {DateTime} futureOrderTime - Specified future order time
 * @property {string} restaurantsLocationId - -
 * @property {GUID} oloRequestId - In order to track submit order, success order, failure
 * @return {LogObject<submitOrderSrc61Evid907Params>} LogObject<submitOrderSrc61Evid907Params>
 */
export function submitOrderSrc61Evid907(params) {
    return { evid: 907, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnButtonInOrderDetailsScreen' event (evid: 908)
 *
 * Event description: Member pressed on button in order details screen
 *
 * @param {clickOnButtonInOrderDetailsScreenParams} params - The parameters for this event
 * @property {GUID} instanceId - instanceId
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} locationGuid - location ID
 * @property {string} buttonName - Navigate/Call
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnButtonInOrderDetailsScreenParams>} LogObject<clickOnButtonInOrderDetailsScreenParams>
 */
export function clickOnButtonInOrderDetailsScreen(params) {
    return { evid: 908, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartDishQuantitiesUpdateSrc61Evid909' event (evid: 909)
 *
 * Event description: OLO- In the Cart, the UoU clicked on +/- to add/remove the dish' quantity.
 *
 * @param {cartDishQuantitiesUpdateSrc61Evid909Params} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} dishId - dish ID
 * @property {GUID} msid - msid
 * @property {string} action - increase (+)/decrease (-)
 * @return {LogObject<cartDishQuantitiesUpdateSrc61Evid909Params>} LogObject<cartDishQuantitiesUpdateSrc61Evid909Params>
 */
export function cartDishQuantitiesUpdateSrc61Evid909(params) {
    return { evid: 909, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishDeleteImage' event (evid: 91)
 *
 * Event description: restaurants_dashboard_menus_dish_delete_image
 *
 * @param {restaurantsDashboardMenusDishDeleteImageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - {menu ID? title?}
 * @property {GUID} site_id - guid
 * @property {string} dish - {dish ID? title?}
 * @property {string} section - {section ID? title?}
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishDeleteImageParams>} LogObject<restaurantsDashboardMenusDishDeleteImageParams>
 */
export function restaurantsDashboardMenusDishDeleteImage(params) {
    return { evid: 91, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartRemoveDishSrc61Evid910' event (evid: 910)
 *
 * Event description: OLO- In the Cart, the UoU clicked on "remove" under the dish name
 *
 * @param {cartRemoveDishSrc61Evid910Params} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} dishId - dish ID
 * @property {GUID} msid - msid
 * @return {LogObject<cartRemoveDishSrc61Evid910Params>} LogObject<cartRemoveDishSrc61Evid910Params>
 */
export function cartRemoveDishSrc61Evid910(params) {
    return { evid: 910, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartAddPromoCodeSrc61Evid911' event (evid: 911)
 *
 * Event description: OLO- In the Cart, the UoU clicked on "Add promo code "- AKA the UoU will add the promo code (Not yet added)
 *
 * @param {cartAddPromoCodeSrc61Evid911Params} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - My Order / Checkout
 * @property {GUID} msid - msid
 * @return {LogObject<cartAddPromoCodeSrc61Evid911Params>} LogObject<cartAddPromoCodeSrc61Evid911Params>
 */
export function cartAddPromoCodeSrc61Evid911(params) {
    return { evid: 911, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartPromoCodeApplySuccessSrc61Evid912' event (evid: 912)
 *
 * Event description: OLO- In the Cart, the UoU Added promo code (clicked on Apply) with success
 *
 * @param {cartPromoCodeApplySuccessSrc61Evid912Params} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - My Order / Checkout
 * @property {GUID} msid - msid
 * @property {string} promoCode - promo code added with success
 * @return {LogObject<cartPromoCodeApplySuccessSrc61Evid912Params>} LogObject<cartPromoCodeApplySuccessSrc61Evid912Params>
 */
export function cartPromoCodeApplySuccessSrc61Evid912(params) {
    return { evid: 912, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartPromoCodeApplyFailureSrc61Evid913' event (evid: 913)
 *
 * Event description: OLO- In the Cart, the UoU Added promo code (clicked on Apply) with Failure
 *
 * @param {cartPromoCodeApplyFailureSrc61Evid913Params} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {string} errorReason - The error as it's presented to the UoU
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - My Order / Checkout
 * @property {GUID} msid - msid
 * @property {string} promoCode - promo code added with success
 * @return {LogObject<cartPromoCodeApplyFailureSrc61Evid913Params>} LogObject<cartPromoCodeApplyFailureSrc61Evid913Params>
 */
export function cartPromoCodeApplyFailureSrc61Evid913(params) {
    return { evid: 913, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'goToCheckoutSrc61Evid914' event (evid: 914)
 *
 * Event description: OLO- UoU clicked on Go to Checkout
 *
 * @param {goToCheckoutSrc61Evid914Params} params - The parameters for this event
 * @property {string} feeIds - all service fees ids
 * @property {string} restaurantId - rest_id
 * @property {number} totalItemsCount - total items count
 * @property {GUID} oloSessionId - session ID
 * @property {number} taxAmount - -
 * @property {GUID} locationGuid - location_guid
 * @property {string} currency - -
 * @property {number} feeCount - how many service fees included?
 * @property {number} taxAndFeesAmount - -
 * @property {number} feesAmount - fees_amount
 * @property {GUID} msid - msid
 * @property {string} restaurantsLocationId - -
 * @return {LogObject<goToCheckoutSrc61Evid914Params>} LogObject<goToCheckoutSrc61Evid914Params>
 */
export function goToCheckoutSrc61Evid914(params) {
    return { evid: 914, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartDiscountDetailsSrc61Evid915' event (evid: 915)
 *
 * Event description: OLO- In the Cart, the UoU clicked on "show/hide details" under the discounts (Promo code/discounts).
 *
 * @param {cartDiscountDetailsSrc61Evid915Params} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - My Order / Checkout
 * @property {string} type - discount/promo code
 * @property {GUID} msid - msid
 * @property {string} action - show/hide
 * @return {LogObject<cartDiscountDetailsSrc61Evid915Params>} LogObject<cartDiscountDetailsSrc61Evid915Params>
 */
export function cartDiscountDetailsSrc61Evid915(params) {
    return { evid: 915, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartPromoCodeRemoveSrc61Evid916' event (evid: 916)
 *
 * Event description: OLO- In the Cart, the UoU clicked on "remove" after adding a promo code
 *
 * @param {cartPromoCodeRemoveSrc61Evid916Params} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} pageName - My Order / Checkout
 * @property {GUID} msid - msid
 * @property {string} promoCode - Promo Code that was removed
 * @return {LogObject<cartPromoCodeRemoveSrc61Evid916Params>} LogObject<cartPromoCodeRemoveSrc61Evid916Params>
 */
export function cartPromoCodeRemoveSrc61Evid916(params) {
    return { evid: 916, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutDispatchUpdate' event (evid: 917)
 *
 * Event description: UoU changed dispatch option in the checkout, while in the address information
 *
 * @param {checkoutDispatchUpdateParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} lastState - delivery/pickup
 * @property {GUID} msid - msid
 * @return {LogObject<checkoutDispatchUpdateParams>} LogObject<checkoutDispatchUpdateParams>
 */
export function checkoutDispatchUpdate(params) {
    return { evid: 917, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewCart' event (evid: 918)
 *
 * Event description: OLO- UoU clicked on View Order
 *
 * @param {viewCartParams} params - The parameters for this event
 * @property {number} minimumOrder - the minimum order size
 * @property {string} restaurantId - organisation ID
 * @property {number} totalItemsCount - total items count- the number of items in the cart when clicked
 * @property {GUID} oloSessionId - olo_session_id
 * @property {number} totalLoyaltyPoints - Total points the member has at the moment of the event
 * @property {number} loyaltyPoints - loyalty_points
 * @property {GUID} rewardId - rewardId
 * @property {GUID} locationGuid - location ID
 * @property {string} origin - top bar/button
 * @property {number} loyaltyEstimatedEarend - loyalty_estimated_earned
 * @property {number} loyaltyPrice - loyalty_price
 * @property {GUID} msid - msid
 * @return {LogObject<viewCartParams>} LogObject<viewCartParams>
 */
export function viewCart(params) {
    return { evid: 918, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'navigateToMenuSrc61Evid919' event (evid: 919)
 *
 * Event description: OLO- UoU clicked on menu in the navigation header- (i.e dinner menu, lunch menu, etc.)
 *
 * @param {navigateToMenuSrc61Evid919Params} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {string} menuName - menu name
 * @property {GUID} locationGuid - location ID
 * @property {string} menuId - menu ID
 * @return {LogObject<navigateToMenuSrc61Evid919Params>} LogObject<navigateToMenuSrc61Evid919Params>
 */
export function navigateToMenuSrc61Evid919(params) {
    return { evid: 919, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDashboardMenusDishEditSave' event (evid: 92)
 *
 * Event description: restaurants_dashboard_menus_dish_edit_save
 *
 * @param {restaurantsDashboardMenusDishEditSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {GUID} site_id - guid
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - --
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} msid - msid
 * @property {GUID} bi_token - msid
 * @return {LogObject<restaurantsDashboardMenusDishEditSaveParams>} LogObject<restaurantsDashboardMenusDishEditSaveParams>
 */
export function restaurantsDashboardMenusDishEditSave(params) {
    return { evid: 92, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addToCartValidationErrorSrc61Evid920' event (evid: 920)
 *
 * Event description: OLO- UoU clicked on the button - "Add to Order" in the Dish Modal-  (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue)
 *
 * @param {addToCartValidationErrorSrc61Evid920Params} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {string} errorReason - variation error
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {number} errorsCount - number of errors (In the variations)
 * @property {string} dishId - dish ID
 * @property {GUID} msid - msid
 * @return {LogObject<addToCartValidationErrorSrc61Evid920Params>} LogObject<addToCartValidationErrorSrc61Evid920Params>
 */
export function addToCartValidationErrorSrc61Evid920(params) {
    return { evid: 920, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutContactInformationContinueValidationError' event (evid: 921)
 *
 * Event description: OLO- UoU has a problem with the Contact information (CONTINUE WITHOUT SUCCESS- AKA errors while clicking on the Continue)
 *
 * @param {checkoutContactInformationContinueValidationErrorParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {string} errorReason - FirstName/lastName/Email/phone concat between them
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<checkoutContactInformationContinueValidationErrorParams>} LogObject<checkoutContactInformationContinueValidationErrorParams>
 */
export function checkoutContactInformationContinueValidationError(params) {
    return { evid: 921, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutAddOrderNotes' event (evid: 922)
 *
 * Event description: Checkout -> Add Order Notes.
 *
 * @param {checkoutAddOrderNotesParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<checkoutAddOrderNotesParams>} LogObject<checkoutAddOrderNotesParams>
 */
export function checkoutAddOrderNotes(params) {
    return { evid: 922, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dispatchSettingsUpdate' event (evid: 923)
 *
 * Event description: OLO- UoU clicked on the "SAVE" button in the dispatch settings -AKA dispatch settings updated
 *
 * @param {dispatchSettingsUpdateParams} params - The parameters for this event
 * @property {string} dispatchType - delivery/pickup
 * @property {string} curbsideAdditionalInformationContent - string/null
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} dispatchTimeOption - asap/later
 * @property {boolean} curbsidePickupToggle - true/false
 * @property {DateTime} dispatchTime - delivery/pickup hour (In UTC+0 time)
 * @property {string} validationError - Outfit Description
 * @property {GUID} msid - msid
 * @return {LogObject<dispatchSettingsUpdateParams>} LogObject<dispatchSettingsUpdateParams>
 */
export function dispatchSettingsUpdate(params) {
    return { evid: 923, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartDiscard' event (evid: 924)
 *
 * Event description: OLO- In the Cart, the UoU closed the cart- without continuing the Checkout.
 * clicked Leave order screen
 *
 * @param {cartDiscardParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<cartDiscardParams>} LogObject<cartDiscardParams>
 */
export function cartDiscard(params) {
    return { evid: 924, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartOrderNotesAdded' event (evid: 925)
 *
 * Event description: OLO- In the Checkout, the UoU Added Order Notes- AKA the UoU finished adding a comment.
 *
 * @param {cartOrderNotesAddedParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} comment - comment
 * @property {GUID} msid - msid
 * @return {LogObject<cartOrderNotesAddedParams>} LogObject<cartOrderNotesAddedParams>
 */
export function cartOrderNotesAdded(params) {
    return { evid: 925, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutReviewPoliciesSrc61Evid926' event (evid: 926)
 *
 * Event description: UoU clicked on the termsAndConditions/privacyPolicy in the "Review and Place Order" stage in the checkout.
 *
 * @param {checkoutReviewPoliciesSrc61Evid926Params} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} type - privacyPolicy/termsAndConditions
 * @property {GUID} msid - msid
 * @return {LogObject<checkoutReviewPoliciesSrc61Evid926Params>} LogObject<checkoutReviewPoliciesSrc61Evid926Params>
 */
export function checkoutReviewPoliciesSrc61Evid926(params) {
    return { evid: 926, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutLeaveOrderOutsideMyDoorToggle' event (evid: 927)
 *
 * Event description: Toggle "Leave order outside my door' in the checkout
 *
 * @param {checkoutLeaveOrderOutsideMyDoorToggleParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @property {string} value - on/off
 * @return {LogObject<checkoutLeaveOrderOutsideMyDoorToggleParams>} LogObject<checkoutLeaveOrderOutsideMyDoorToggleParams>
 */
export function checkoutLeaveOrderOutsideMyDoorToggle(params) {
    return { evid: 927, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartAddDeliveryInstructions' event (evid: 928)
 *
 * Event description: OLO- In the checkout, the UoU clicked on "Add delivery instructions "- AKA the UoU will add a comment (Not yet added)
 *
 * @param {cartAddDeliveryInstructionsParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<cartAddDeliveryInstructionsParams>} LogObject<cartAddDeliveryInstructionsParams>
 */
export function cartAddDeliveryInstructions(params) {
    return { evid: 928, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartDeliveryInstructionsAdded' event (evid: 929)
 *
 * Event description: OLO- In the Checkout, the UoU Added Order Notes- AKA the UoU finished adding delivery instructions.
 *
 * @param {cartDeliveryInstructionsAddedParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} comment - comment
 * @property {GUID} msid - msid
 * @return {LogObject<cartDeliveryInstructionsAddedParams>} LogObject<cartDeliveryInstructionsAddedParams>
 */
export function cartDeliveryInstructionsAdded(params) {
    return { evid: 929, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusAddMenuClick' event (evid: 93)
 *
 * Event description: dashboard_menus_add_menu_click
 *
 * @param {dashboardMenusAddMenuClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - new menu/plus
 * @property {boolean} is_diwm_menu - action made with do it with me menu video
 * @property {string} organization_id - guid
 * @property {string} menuId - Menu id
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusAddMenuClickParams>} LogObject<dashboardMenusAddMenuClickParams>
 */
export function dashboardMenusAddMenuClick(params) {
    return { evid: 93, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dispatchSettingsOpenAddAddress' event (evid: 930)
 *
 * Event description: OLO- UoU clicked on the Add Address Button at dispatch settings
 *
 * @param {dispatchSettingsOpenAddAddressParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {string} editReason - Missing required info /  Address not saved
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - Location ID
 * @property {string} type - Add / Change / Edit
 * @property {GUID} msid - msid
 * @return {LogObject<dispatchSettingsOpenAddAddressParams>} LogObject<dispatchSettingsOpenAddAddressParams>
 */
export function dispatchSettingsOpenAddAddress(params) {
    return { evid: 930, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saveChangeLoyaltyReward' event (evid: 932)
 *
 * Event description: Member Saved the change after pressing on change loyalty reward
 *
 * @param {saveChangeLoyaltyRewardParams} params - The parameters for this event
 * @property {GUID} instanceId - instanceId
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {number} loyaltyPoints - Points user is about to use(after edit)
 * @property {GUID} rewardId - rewardid
 * @property {GUID} locationGuid - location ID
 * @property {string} origin - Origin page - i.e Cart/Checkout
 * @return {LogObject<saveChangeLoyaltyRewardParams>} LogObject<saveChangeLoyaltyRewardParams>
 */
export function saveChangeLoyaltyReward(params) {
    return { evid: 932, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cartClickOnDish' event (evid: 933)
 *
 * Event description: OLO- In the Cart, the UoU clicked on the dish. This afterwards enables the user to edit the specific dish quantity or remove it.
 *
 * @param {cartClickOnDishParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {string} dishId - dish ID
 * @property {GUID} msid - msid
 * @return {LogObject<cartClickOnDishParams>} LogObject<cartClickOnDishParams>
 */
export function cartClickOnDish(params) {
    return { evid: 933, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutProceedToPayment' event (evid: 934)
 *
 * Event description: UoU clicked on the "Proceed to Payment" in the checkout
 *
 * @param {checkoutProceedToPaymentParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {number} totalLoyaltyPoints - otal points the member has at the moment of the event
 * @property {number} loyaltyPoints - loyalty_points
 * @property {GUID} rewardId - rewardId
 * @property {GUID} locationGuid - location ID
 * @property {number} loyaltyEstimatedEarend - loyalty_estimated_earned
 * @property {number} loyaltyPrice - loyaltyPrice
 * @property {GUID} msid - msid
 * @return {LogObject<checkoutProceedToPaymentParams>} LogObject<checkoutProceedToPaymentParams>
 */
export function checkoutProceedToPayment(params) {
    return { evid: 934, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutTip' event (evid: 935)
 *
 * Event description: OLO- UoU clicked on Submit Order
 *
 * @param {checkoutTipParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - session ID
 * @property {boolean} isCustomTip - true/false. true if the UoU wrote a specific amount of tip. false if the UoU chose a tip out of the defined options
 * @property {GUID} locationGuid - locationID
 * @property {boolean} isDefaultTip - true/false. true if the UoU chose the tip that the user defined as default
 * @property {number} tipValue - the number of tip the UoU chose
 * @property {string} currency - currency
 * @property {number} tipSubtotal - total tip
 * @property {GUID} msid - msid
 * @return {LogObject<checkoutTipParams>} LogObject<checkoutTipParams>
 */
export function checkoutTip(params) {
    return { evid: 935, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'removeLoyaltyRewardSrc61Evid937' event (evid: 937)
 *
 * Event description: Member pressed on remove loyalty reward
 *
 * @param {removeLoyaltyRewardSrc61Evid937Params} params - The parameters for this event
 * @property {GUID} instanceId - instanceId
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} rewardId - rewardid
 * @property {GUID} locationGuid - location ID
 * @property {string} origin - Origin page - i.e Cart/Checkout
 * @property {GUID} msid - msid
 * @return {LogObject<removeLoyaltyRewardSrc61Evid937Params>} LogObject<removeLoyaltyRewardSrc61Evid937Params>
 */
export function removeLoyaltyRewardSrc61Evid937(params) {
    return { evid: 937, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeLoyaltyReward' event (evid: 938)
 *
 * Event description: Member pressed on change loyalty reward
 *
 * @param {changeLoyaltyRewardParams} params - The parameters for this event
 * @property {GUID} instanceId - instanceId
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {number} loyaltyPoints - Points user is about to use(before edit)
 * @property {GUID} rewardId - rewardid
 * @property {GUID} locationGuid - location ID
 * @property {string} origin - Origin page - i.e Cart/Checkout
 * @property {number} numOfOptions - Number of options in the dropdown list
 * @property {GUID} msid - msid
 * @return {LogObject<changeLoyaltyRewardParams>} LogObject<changeLoyaltyRewardParams>
 */
export function changeLoyaltyReward(params) {
    return { evid: 938, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redeemLoyaltyRewardSrc61Evid939' event (evid: 939)
 *
 * Event description: Member pressed on redeem loyalty reward
 *
 * @param {redeemLoyaltyRewardSrc61Evid939Params} params - The parameters for this event
 * @property {GUID} instanceId - instanceId
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {number} loyaltyPoints - points user is about to use
 * @property {GUID} rewardId - rewardid
 * @property {GUID} locationGuid - location ID
 * @property {string} origin - Origin page - i.e Cart/Checkout
 * @property {GUID} msid - msid
 * @return {LogObject<redeemLoyaltyRewardSrc61Evid939Params>} LogObject<redeemLoyaltyRewardSrc61Evid939Params>
 */
export function redeemLoyaltyRewardSrc61Evid939(params) {
    return { evid: 939, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusMenuEditFieldError' event (evid: 94)
 *
 * Event description: dashboard_menus_menu_edit_field_error
 *
 * @param {dashboardMenusMenuEditFieldErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} field - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} value - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusMenuEditFieldErrorParams>} LogObject<dashboardMenusMenuEditFieldErrorParams>
 */
export function dashboardMenusMenuEditFieldError(params) {
    return { evid: 94, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewOrderDetailes' event (evid: 940)
 *
 * Event description: Member pressed on view order details
 *
 * @param {viewOrderDetailesParams} params - The parameters for this event
 * @property {GUID} instanceId - instanceId
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - Session ID- unique for visitor and session- changes every time this event is triggered (Load OLO)
 * @property {GUID} rewardId - rewardid
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<viewOrderDetailesParams>} LogObject<viewOrderDetailesParams>
 */
export function viewOrderDetailes(params) {
    return { evid: 940, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deliveryIntegrationMethodShown' event (evid: 941)
 *
 * Event description: UoU got indication that the delivery will be sent by integration company
 *
 * @param {deliveryIntegrationMethodShownParams} params - The parameters for this event
 * @property {string} integrationName - integration_name
 * @property {string} screenName - checkout or filters
 * @property {GUID} integrationAppId - guid
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - location ID
 * @property {GUID} msid - msid
 * @return {LogObject<deliveryIntegrationMethodShownParams>} LogObject<deliveryIntegrationMethodShownParams>
 */
export function deliveryIntegrationMethodShown(params) {
    return { evid: 941, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderFlowBlockerError' event (evid: 943)
 *
 * Event description: There was an error that prevented UoU from proceeding
 *
 * @param {orderFlowBlockerErrorParams} params - The parameters for this event
 * @property {string} screenName - cart/checkout/menu
 * @property {string} restaurantId - rest id
 * @property {string} errorReason - the error
 * @property {GUID} oloSessionId - session ID
 * @property {GUID} locationGuid - guid
 * @property {GUID} msid - msid
 * @return {LogObject<orderFlowBlockerErrorParams>} LogObject<orderFlowBlockerErrorParams>
 */
export function orderFlowBlockerError(params) {
    return { evid: 943, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutShowHideOrderDetails' event (evid: 944)
 *
 * Event description: UoU clicked on hide/show order details
 *
 * @param {checkoutShowHideOrderDetailsParams} params - The parameters for this event
 * @property {string} restaurantId - organisation ID
 * @property {GUID} oloSessionId - olo_session_id
 * @property {GUID} locationGuid - location ID
 * @property {string} buttonName - hide/show
 * @property {GUID} msid - msid
 * @return {LogObject<checkoutShowHideOrderDetailsParams>} LogObject<checkoutShowHideOrderDetailsParams>
 */
export function checkoutShowHideOrderDetails(params) {
    return { evid: 944, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deliveryPartnerEstimations' event (evid: 945)
 *
 * Event description: An estimation for the availability and delivery fee from a delivery partner. Can be sent in three different points: dispatch settings delivery method (after continue click)  and checkout
 *
 * @param {deliveryPartnerEstimationsParams} params - The parameters for this event
 * @property {string} stage - dispatch settings/delivery method/submit order
 * @property {number} deliveryFee - The delivery fee in the local currency
 * @property {string} integrationName - doordash...
 * @property {GUID} oloSessionId - olo session id
 * @property {GUID} estimateId - estimateId
 * @property {GUID} locationGuid - location ID
 * @property {boolean} status - true = success, false = error
 * @property {string} errorDescription - error_description
 * @property {string} currency - currency
 * @property {GUID} msid - msid
 * @return {LogObject<deliveryPartnerEstimationsParams>} LogObject<deliveryPartnerEstimationsParams>
 */
export function deliveryPartnerEstimations(params) {
    return { evid: 945, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aNewOrderCreationAlertIsDisplayed' event (evid: 946)
 *
 * Event description: When the user has filled his cart with dishes and tries to add dishes from another restaurant
 *
 * @param {aNewOrderCreationAlertIsDisplayedParams} params - The parameters for this event
 * @property {GUID} oloSessionId - olo session id
 * @property {GUID} locationGuid - location ID
 * @return {LogObject<aNewOrderCreationAlertIsDisplayedParams>} LogObject<aNewOrderCreationAlertIsDisplayedParams>
 */
export function aNewOrderCreationAlertIsDisplayed(params) {
    return { evid: 946, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aNewOrderCreationAlertIsClicked' event (evid: 947)
 *
 * Event description: user clicks on continue or cancel when he try to add dishes to his cart from another restaurant
 *
 * @param {aNewOrderCreationAlertIsClickedParams} params - The parameters for this event
 * @property {GUID} oloSessionId - olo session id
 * @property {GUID} locationGuid - location
 * @property {string} buttonName - cancel or continue
 * @return {LogObject<aNewOrderCreationAlertIsClickedParams>} LogObject<aNewOrderCreationAlertIsClickedParams>
 */
export function aNewOrderCreationAlertIsClicked(params) {
    return { evid: 947, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsDineUouOpenServiceFeeExplanationsHalfScreen' event (evid: 949)
 *
 * Event description: when the user clicks on "!" of  service fees in Dine
 *
 * @param {restaurantsDineUouOpenServiceFeeExplanationsHalfScreenParams} params - The parameters for this event
 * @property {string} feeIds - -
 * @property {GUID} oloSessionId - -
 * @property {number} taxAmount - -
 * @property {GUID} locationGuid - location_guid
 * @property {string} currency - -
 * @property {number} feeCount - -
 * @property {number} taxAndFeesAmount - -
 * @property {number} feesAmount - -
 * @return {LogObject<restaurantsDineUouOpenServiceFeeExplanationsHalfScreenParams>} LogObject<restaurantsDineUouOpenServiceFeeExplanationsHalfScreenParams>
 */
export function restaurantsDineUouOpenServiceFeeExplanationsHalfScreen(params) {
    return { evid: 949, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restaurantsOloUouServiceFeeFailureWeb' event (evid: 950)
 *
 * Event description: when service fees calculations are failing
 *
 * @param {restaurantsOloUouServiceFeeFailureWebParams} params - The parameters for this event
 * @property {string} requestName - "listRules" | "calculateServiceFees" | "listRestaurantLocations"
 * @property {GUID} locationGuid - location_guid
 * @property {string} error - -
 * @return {LogObject<restaurantsOloUouServiceFeeFailureWebParams>} LogObject<restaurantsOloUouServiceFeeFailureWebParams>
 */
export function restaurantsOloUouServiceFeeFailureWeb(params) {
    return { evid: 950, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oloMigrationComputabilityCheckerServerSrc61Evid951' event (evid: 951)
 *
 * Event description: Elad bi events for migration
 *
 * @param {oloMigrationComputabilityCheckerServerSrc61Evid951Params} params - The parameters for this event
 * @property {string} msid - -
 * @property {string} computabilityStatus - -
 * @property {string} PickupPrepTimeAboveLimit - pickup prep time is above new app limit
 * @property {number} PickupPrepTimeMaxMinutes - pickup prep time old app
 * @property {string} DeliveryTimeAboveLimit - delivery prep time is above new app limit
 * @property {number} DeliveryTimeMaxMinutes - delivery prep time old app
 * @property {string} MenuItemsCountAboveLimit - number of menu items in the site above limit
 * @property {number} MenuItemsCount - number of menu items in the site
 * @property {string} webhookUrls - webhook urls
 * @property {string} asapPreOrderEarliestOrderTime - -
 * @property {string} asapPreOrderLatestOrderTime - -
 * @property {string} automaticPrintingNewOrderNotification - -
 * @property {string} automaticPrintingDelayedOrderNotification - -
 * @property {string} automaticDiscountAvailabilityExceptions - -
 * @property {string} pickUpAndDeliverySameLocation - -
 * @property {string} availabilityPositiveEvents - -
 * @property {string} availabilityNegativeEvents - -
 * @property {string} curbsidePickUpAdditionalInfo - -
 * @property {string} dineInFulfillment - -
 * @property {string} itemsAvailableFulfillmentTypes - -
 * @property {string} itemsAvailablePlatforms - -
 * @property {string} itemsAvailabilityExceptions - -
 * @property {string} itemsAvailabilityCustomHours - -
 * @property {string} localDeliveryConfiguration - -
 * @property {string} menusAvailableFulfillmentTypes - -
 * @property {string} menusAvailablePlatforms - -
 * @property {string} menusAvailabilityExceptions - -
 * @property {string} newOrderNotificationChannel - -
 * @property {string} delayedOrderNotificationChannel - -
 * @property {string} invalidUsagesNewOrderNotificationChannel - -
 * @property {string} invalidUsagesDelayedOrderNotificationChannel - -
 * @property {string} numberOfActiveLocations - -
 * @property {string} onlineOrderingDisabled - -
 * @property {string} onlineOrderingAvailabilityEventsUsed - -
 * @property {string} approximateAddress - -
 * @property {string} orderPacingPolicy - -
 * @property {string} termsAndConditionsURL - -
 * @property {string} privacyPolicyURL - -
 * @property {string} posConfiguration - -
 * @property {string} fraudPrevention - -
 * @property {string} sectionsAvailableFulfillmentTypes - -
 * @property {string} sectionsAvailablePlatforms - -
 * @property {string} sectionsAvailabilityExceptions - -
 * @property {string} sectionsAvailabilityCustomHours - -
 * @property {string} textDirection - -
 * @property {string} brandedAppOnAppStore - -
 * @property {string} brandedAppOnPlayStore - -
 * @property {string} discountsAvailabilityWeeklyPattern - -
 * @property {string} discountsAvailabilityPlatform - -
 * @property {string} discountsDescription - -
 * @property {string} couponsAvailabilityUnavailableExceptions - -
 * @property {string} discountsAvailableAvailabilityExceptions - -
 * @property {string} tips - -
 * @property {string} menusAppNotInstalled - -
 * @property {string} ordersAppInstalled - -
 * @property {string} deselectionModifierGroup - -
 * @property {string} numOfModifierGroupsExceedsLimit - -
 * @property {string} numOfModifiersPerGroupsExceedsLimit - -
 * @property {string} itemAsModifier - -
 * @property {string} numOfSectionsPerMenuExceedsLimit - -
 * @property {string} numOfItemsPerSectionExceedsLimit - -
 * @property {string} maxSelectionsExceedsLimit - instead of one with typo.
 * @property {string} menusAppVisiblePages - menusAppVisiblePages
 * @property {string} AvailabilityOvernightPeriods - Some availability periods span overnight, which is not supported in the new system. in the new product its not supported, so if there is a period, its incompatible, else competible.
 *
 * @return {LogObject<oloMigrationComputabilityCheckerServerSrc61Evid951Params>} LogObject<oloMigrationComputabilityCheckerServerSrc61Evid951Params>
 */
export function oloMigrationComputabilityCheckerServerSrc61Evid951(params) {
    return { evid: 951, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'menusMenusMigrationCompatibilityCheckerSrc61Evid952' event (evid: 952)
 *
 * Event description: BI event for migration from the old menus product to the new one.
 *
 * @param {menusMenusMigrationCompatibilityCheckerSrc61Evid952Params} params - The parameters for this event
 * @property {string} menusAppInstalled - -
 * @property {string} ordersAppMissing - -
 * @property {string} noModifierGroups - -
 * @property {string} sectionImageExists - -
 * @property {string} numOfItemsPerSectionExceedsLimit - -
 * @property {string} numOfSectionsPerMenuExceedsLimit - -
 * @property {string} numberOfActiveLocations - -
 * @property {string} menusShowcaseAppInstalled - -
 * @property {number} maxNumOfItemsPerSection - -
 * @property {number} maxNumOfSectionsPerMenu - -
 * @property {number} numOfMenus - -
 * @property {string} numOfMenusExceedsLimit - -
 * @property {string} menusCountExceedsLimit - -
 * @property {number} maxTotalItemCountPerMenu - -
 * @property {number} maxTotalEntityCountPerMenu - -
 * @property {string} maxTotalEntityCountPerMenuMenuId - -
 * @property {number} maxNumOfVariantsPerItem - -
 * @property {number} maxNumOfModifierGroupsPerItem - -
 * @property {number} maxNumOfModifiersPerGroup - -
 * @property {string} compatibilityStatus - -
 * @property {number} numberOfLocations - -
 * @property {string} multiLocationCompatiable - COMPATIABLE / INCOMPATIBLE
 * @return {LogObject<menusMenusMigrationCompatibilityCheckerSrc61Evid952Params>} LogObject<menusMenusMigrationCompatibilityCheckerSrc61Evid952Params>
 */
export function menusMenusMigrationCompatibilityCheckerSrc61Evid952(params) {
    return { evid: 952, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishDeleteClick' event (evid: 96)
 *
 * Event description: dashboard_menus_dish_delete_click
 *
 * @param {dashboardMenusDishDeleteClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} locationGuid - location_guid
 * @property {GUID} catalogId - catalogId
 * @property {string} sectionId - sectionId
 * @property {string} itemId - itemId
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {string} menuId - menuId
 * @property {GUID} bi_token - msid
 * @property {string} level - section
 * @return {LogObject<dashboardMenusDishDeleteClickParams>} LogObject<dashboardMenusDishDeleteClickParams>
 */
export function dashboardMenusDishDeleteClick(params) {
    return { evid: 96, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishDeleteDialogClose' event (evid: 97)
 *
 * Event description: dashboard_menus_dish_delete_dialog_close
 *
 * @param {dashboardMenusDishDeleteDialogCloseParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} origin - --
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishDeleteDialogCloseParams>} LogObject<dashboardMenusDishDeleteDialogCloseParams>
 */
export function dashboardMenusDishDeleteDialogClose(params) {
    return { evid: 97, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishDeleteDialogOkClick' event (evid: 98)
 *
 * Event description: dashboard_menus_dish_delete_dialog_ok_click
 *
 * @param {dashboardMenusDishDeleteDialogOkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} menu - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {string} mode - --
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishDeleteDialogOkClickParams>} LogObject<dashboardMenusDishDeleteDialogOkClickParams>
 */
export function dashboardMenusDishDeleteDialogOkClick(params) {
    return { evid: 98, src: 61, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMenusDishReorder' event (evid: 99)
 *
 * Event description: dashboard_menus_dish_reorder
 *
 * @param {dashboardMenusDishReorderParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} position_after - --
 * @property {string} menu - --
 * @property {string} position_before - --
 * @property {string} dish - --
 * @property {string} section - --
 * @property {GUID} locationGuid - location_guid
 * @property {string} organization_id - guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<dashboardMenusDishReorderParams>} LogObject<dashboardMenusDishReorderParams>
 */
export function dashboardMenusDishReorder(params) {
    return { evid: 99, src: 61, endpoint: '', params };
}
//# sourceMappingURL=index.js.map